
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("hWHpM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "BoardsDirectory", () => $5724cac708447f2a$export$84679aba0137274);
$parcel$export(module.exports, "default", () => $5724cac708447f2a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
parcelRequire("3avtZ");

var $6DYmE = parcelRequire("6DYmE");

var $hVCgF = parcelRequire("hVCgF");

var $dFtHW = parcelRequire("dFtHW");

var $6UU7v = parcelRequire("6UU7v");

var $WCxDe = parcelRequire("WCxDe");

var $fmhfo = parcelRequire("fmhfo");

var $9apWN = parcelRequire("9apWN");

var $aV23b = parcelRequire("aV23b");

var $iYKap = parcelRequire("iYKap");

var $iEXnd = parcelRequire("iEXnd");

var $koAZ4 = parcelRequire("koAZ4");

var $4EKqI = parcelRequire("4EKqI");

var $eJrcF = parcelRequire("eJrcF");
var $jJaSe = parcelRequire("jJaSe");

var $fH7mW = parcelRequire("fH7mW");
// eslint-disable-next-line jira/react/no-usage-of-hooks-outside-components
const $5724cac708447f2a$var$useBoardsDirectoryResource = (0, $6UU7v.withSuspense)(()=>(0, $eJrcF.useResource)((0, $WCxDe.boardsDirectoryResource)));
const $5724cac708447f2a$export$84679aba0137274 = ({ location: location })=>{
    const state = $5724cac708447f2a$var$useBoardsDirectoryResource();
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const renderContents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6DYmE.default), {
            location: location
        }, ({ query: query, onQueryChanged: onQueryChanged })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFtHW.FavoriteChangeConsumer), null, (favoriteChangeContext)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4EKqI.default), {
                    name: "boards-directory"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fH7mW.default), {
                    tenantContext: tenantContext,
                    prefetchResult: {
                        ...state
                    },
                    favoriteChangeContext: favoriteChangeContext,
                    query: query,
                    onQueryChanged: onQueryChanged
                }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aV23b.AuthenticationCheck), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iYKap.LicenseCheck), {
        type: "software"
    }, ({ result: result })=>result ? renderContents() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9apWN.AsyncNoSoftwareLicense), null)));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5724cac708447f2a$var$RouterWrapper = (0, $jJaSe.withRouter)($5724cac708447f2a$export$84679aba0137274);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5724cac708447f2a$var$BoardsDirectoryType = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iEXnd.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fmhfo.default), {
        id: "spa-app-bootstrap.directories.boards"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hVCgF.default), {
        appNameSuffixForV2Event: "directory.boards",
        appNameForV3OperationalEvent: "boardsDirectory"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($5724cac708447f2a$var$RouterWrapper, props)));
var $5724cac708447f2a$export$2e2bcd8739ae039 = $5724cac708447f2a$var$BoardsDirectoryType;

});
parcelRegister("6DYmE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e75c6fc9e7d852b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dgHVV = parcelRequire("dgHVV");

var $97OFh = parcelRequire("97OFh");

var $cLJvA = parcelRequire("cLJvA");

var $7atmZ = parcelRequire("7atmZ");
const $2e75c6fc9e7d852b$var$QueryParamAdapterWithSortingAndFiltering = ({ location: location, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $97OFh.default), {
        location: location,
        sortFieldToParam: (0, $7atmZ.sortFieldToParam),
        sortFieldFromParam: (0, $7atmZ.sortFieldFromParam),
        filterFromParams: (0, $cLJvA.filterFromParams),
        filterToParams: (0, $cLJvA.filterToParams),
        defaultQuery: (0, $dgHVV.initialQuery)
    }, children);
var $2e75c6fc9e7d852b$export$2e2bcd8739ae039 = $2e75c6fc9e7d852b$var$QueryParamAdapterWithSortingAndFiltering;

});
parcelRegister("dgHVV", function(module, exports) {
$parcel$export(module.exports, "ITEMS_PER_PAGE", () => $0a58caf85865a254$export$ec93a669a20aa982);
$parcel$export(module.exports, "EXPAND_PARAMETERS", () => $0a58caf85865a254$export$ac5ed0fd17aacb1c);
$parcel$export(module.exports, "initialQuery", () => $0a58caf85865a254$export$8af7177c92ae79e3);


var $aETW1 = parcelRequire("aETW1");
const $0a58caf85865a254$export$ec93a669a20aa982 = 25;
const $0a58caf85865a254$export$ac5ed0fd17aacb1c = [
    'admins',
    'permissions',
    'favourite'
];
const $0a58caf85865a254$export$8af7177c92ae79e3 = {
    sortField: (0, $aETW1.NAME),
    sortDirection: (0, $88c5923de10af20c$export$1dee026a19752d6b),
    page: 1,
    filter: {
        text: '',
        project: undefined,
        user: undefined
    }
};

});
const $88c5923de10af20c$export$1dee026a19752d6b = 'ASC';
const $88c5923de10af20c$export$b6abcf7fa1d94f65 = 'DESC';

parcelRegister("aETW1", function(module, exports) {
$parcel$export(module.exports, "NAME", () => $4ce59cf183178e2d$export$3c5e605ca7ade9f2);
const $4ce59cf183178e2d$export$3c5e605ca7ade9f2 = 'name';
const $4ce59cf183178e2d$var$sortFields = [
    $4ce59cf183178e2d$export$3c5e605ca7ade9f2
];
var $4ce59cf183178e2d$export$2e2bcd8739ae039 = $4ce59cf183178e2d$var$sortFields;

});


parcelRegister("97OFh", function(module, exports) {
$parcel$export(module.exports, "default", () => $556c18568dff142c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4cuZm = parcelRequire("4cuZm");

var $4l9z6 = parcelRequire("4l9z6");

var $lg6iR = parcelRequire("lg6iR");
const $556c18568dff142c$var$QueryParamAdapter = ({ location: location, children: children, sortFieldFromParam: sortFieldFromParam, filterFromParams: filterFromParams, sortFieldToParam: sortFieldToParam, filterToParams: filterToParams, defaultQuery: defaultQuery })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4cuZm.default), {
        location: location,
        queryFromUrl: (0, $lg6iR.default)(sortFieldFromParam, filterFromParams),
        queryToUrl: (0, $4l9z6.default)(sortFieldToParam, filterToParams),
        defaultQuery: defaultQuery
    }, children);
var $556c18568dff142c$export$2e2bcd8739ae039 = $556c18568dff142c$var$QueryParamAdapter;

});
parcelRegister("4cuZm", function(module, exports) {
$parcel$export(module.exports, "default", () => $446b3862e19b2a93$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $k4x9q = parcelRequire("k4x9q");

var $12DRg = parcelRequire("12DRg");

var $b5RwB = parcelRequire("b5RwB");

var $lcB5K = parcelRequire("lcB5K");

var $eoPnG = parcelRequire("eoPnG");

var $kuiVs = parcelRequire("kuiVs");
const $446b3862e19b2a93$var$GenericQueryParamAdapter = ({ location: location, children: children, queryToUrl: queryToUrl, queryFromUrl: queryFromUrl, defaultQuery: defaultQuery })=>{
    const toQuery = (search)=>(0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))((0, $eoPnG.default)(queryFromUrl)((0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(search)), defaultQuery);
    const replaceUrl = (// @ts-expect-error - TS2304 - Cannot find name 'Href'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    replace, query, prevParams)=>replace(`?${(0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).stringify({
            ...prevParams,
            ...queryToUrl(query)
        })}`, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ replace: replace })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kuiVs.AdapterWithState), {
            search: location.search,
            toQuery: (search)=>toQuery(search),
            onChange: false ? (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) : (query, prevParams)=>replaceUrl(replace, query, prevParams)
        }, children));
};
var $446b3862e19b2a93$export$2e2bcd8739ae039 = $446b3862e19b2a93$var$GenericQueryParamAdapter;

});
parcelRegister("eoPnG", function(module, exports) {
$parcel$export(module.exports, "default", () => $c36cbf0efe48d029$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $huH03 = parcelRequire("huH03");
const $c36cbf0efe48d029$var$fromUrlTransformerFactory = (transformer)=>(0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>transformer(params)
    ]);
var $c36cbf0efe48d029$export$2e2bcd8739ae039 = $c36cbf0efe48d029$var$fromUrlTransformerFactory;

});
parcelRegister("huH03", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $75Jcs = parcelRequire("75Jcs");

var $1lM9j = parcelRequire("1lM9j");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $cbc697e9f663ba19$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $1lM9j(iteratee, 3);
    $75Jcs(object, function(value, key, object) {
        $iBJlb(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $cbc697e9f663ba19$var$mapValues;

});


parcelRegister("kuiVs", function(module, exports) {
$parcel$export(module.exports, "AdapterWithState", () => $2b09358ce6ec78a3$export$2fcc0cb3ae18b63e);

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $b5RwB = parcelRequire("b5RwB");
class $2b09358ce6ec78a3$export$2fcc0cb3ae18b63e extends (0, $eJOHy.Component) {
    static getDerivedStateFromProps(props, state) {
        if (props.search !== state.prevSearch) return {
            query: props.toQuery(props.search),
            prevSearch: props.search
        };
        return null;
    }
    componentDidUpdate(prevProps, prevState) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevState.query, this.state.query)) {
            const prevParams = (0, (/*@__PURE__*/$parcel$interopDefault($b5RwB))).parse(prevState.prevSearch);
            this.props.onChange(this.state.query, prevParams);
        }
    }
    render() {
        return this.props.children({
            query: this.state.query,
            onQueryChanged: this.onQueryChanged
        });
    }
    constructor(...args){
        super(...args), this.state = {
            query: this.props.toQuery(this.props.search),
            prevSearch: this.props.search
        }, this.onQueryChanged = (query)=>{
            this.setState({
                query: query
            });
        };
    }
}

});


parcelRegister("4l9z6", function(module, exports) {
$parcel$export(module.exports, "default", () => $796340d1cc38288a$export$2e2bcd8739ae039);

var $3zv7S = parcelRequire("3zv7S");

var $fFyRs = parcelRequire("fFyRs");
const $796340d1cc38288a$var$toUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const valueTransformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>({
                page: (0, $fFyRs.number).stringify(page)
            }),
        // @ts-expect-error - TS7006 - Parameter 'dir' implicitly has an 'any' type.
        sortDirection: (dir)=>({
                sortOrder: (0, $fFyRs.string).stringify(dir)
            }),
        // @ts-expect-error - TS7006 - Parameter 'field' implicitly has an 'any' type.
        sortField: (field)=>({
                sortKey: sortFieldTransformer(field)
            }),
        filter: filterTransformer
    };
    return (query)=>(0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(query, (params, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: string; }; sortDirection: (dir: any) => { sortOrder: any; }; sortField: (field: any) => { sortKey: string; }; filter: FilterToParamTransformer<TFilter>; }'.
            valueTransformers[key] ? {
                ...params,
                ...valueTransformers[key](value)
            } : params, {});
};
var $796340d1cc38288a$export$2e2bcd8739ae039 = $796340d1cc38288a$var$toUrlTransformerFactory;

});
parcelRegister("3zv7S", function(module, exports) {

var $2x6Yt = parcelRequire("2x6Yt");

var $c3u3c = parcelRequire("c3u3c");

var $1lM9j = parcelRequire("1lM9j");

var $aiJg7 = parcelRequire("aiJg7");

var $4sprp = parcelRequire("4sprp");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $299cc8f655bd088e$var$reduce(collection, iteratee, accumulator) {
    var func = $4sprp(collection) ? $2x6Yt : $aiJg7, initAccum = arguments.length < 3;
    return func(collection, $1lM9j(iteratee, 4), accumulator, initAccum, $c3u3c);
}
module.exports = $299cc8f655bd088e$var$reduce;

});
parcelRegister("aiJg7", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $77feb151e6770379$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $77feb151e6770379$var$baseReduce;

});



parcelRegister("lg6iR", function(module, exports) {
$parcel$export(module.exports, "default", () => $ba0ec9813bfa2405$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $huH03 = parcelRequire("huH03");

var $3zv7S = parcelRequire("3zv7S");

var $2CrAx = parcelRequire("2CrAx");

var $fFyRs = parcelRequire("fFyRs");
const $ba0ec9813bfa2405$var$fromUrlTransformerFactory = (sortFieldTransformer, filterTransformer)=>{
    const transformers = {
        // @ts-expect-error - TS7006 - Parameter 'page' implicitly has an 'any' type.
        page: (page)=>(0, $2CrAx.validatePageNumber)((0, $fFyRs.number).parse(page)) ? {
                page: (0, $fFyRs.number).parse(page)
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'order' implicitly has an 'any' type.
        sortOrder: (order)=>(0, $2CrAx.validateSortDirection)(order) ? {
                sortDirection: order
            } : {},
        // @ts-expect-error - TS7006 - Parameter 'key' implicitly has an 'any' type.
        sortKey: (key)=>sortFieldTransformer(key) ? {
                sortField: sortFieldTransformer(key)
            } : {}
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))([
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(params, (p)=>Array.isArray(p) ? p[0] : p),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (params)=>(0, (/*@__PURE__*/$parcel$interopDefault($3zv7S)))(params, (query, value, key)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ page: (page: any) => { page: number; } | { page?: undefined; }; sortOrder: (order: any) => { sortDirection: any; } | { sortDirection?: undefined; }; sortKey: (key: any) => { sortField: TSortField | null; } | { ...; }; }'.
                transformers[key] ? {
                    ...query,
                    ...transformers[key](value)
                } : query, {
                filter: filterTransformer(params)
            })
    ]);
};
var $ba0ec9813bfa2405$export$2e2bcd8739ae039 = $ba0ec9813bfa2405$var$fromUrlTransformerFactory;

});
parcelRegister("2CrAx", function(module, exports) {
$parcel$export(module.exports, "calculateTotalPages", () => $e8881310cdd77edc$export$fba88641b8ab6cd8);
$parcel$export(module.exports, "predictPageToRequestAfterItemDeletion", () => $e8881310cdd77edc$export$3179e82a0f1565e1);
$parcel$export(module.exports, "validatePageNumber", () => $e8881310cdd77edc$export$231cde03e0d8b537);
$parcel$export(module.exports, "validateSortDirection", () => $e8881310cdd77edc$export$407c10b4791d7a16);

const $e8881310cdd77edc$export$fba88641b8ab6cd8 = (totalItems, itemsPerPage)=>Math.max(Math.ceil(totalItems / itemsPerPage), 1);
const $e8881310cdd77edc$export$3179e82a0f1565e1 = (itemsPerPage, totalItems, currentPage = 1, itemsRemoved = 1)=>{
    const maxPossiblePage = $e8881310cdd77edc$export$fba88641b8ab6cd8(totalItems - itemsRemoved, itemsPerPage);
    return currentPage > maxPossiblePage ? maxPossiblePage : currentPage;
};
const $e8881310cdd77edc$export$231cde03e0d8b537 = (input)=>typeof input === 'number' && Number.isInteger(input) && input >= 1;
const $e8881310cdd77edc$export$407c10b4791d7a16 = (input)=>[
        (0, $88c5923de10af20c$export$1dee026a19752d6b),
        (0, $88c5923de10af20c$export$b6abcf7fa1d94f65)
    ].includes(input);

});



parcelRegister("cLJvA", function(module, exports) {
$parcel$export(module.exports, "filterToParams", () => $7470f4a20f1d1e93$export$cb128e46cc7ba0f1);
$parcel$export(module.exports, "filterFromParams", () => $7470f4a20f1d1e93$export$f6542f27c27241c6);
const $7470f4a20f1d1e93$export$66074cf594439162 = 'agility';
const $7470f4a20f1d1e93$var$transformSelectedProject = (input)=>input && input !== undefined ? {
        value: input
    } : undefined;
const $7470f4a20f1d1e93$var$transformSelectedUser = (input)=>input && input !== undefined ? {
        accountId: input,
        value: input,
        displayName: ''
    } : undefined;
const $7470f4a20f1d1e93$export$cb128e46cc7ba0f1 = ({ project: project, text: text, user: user } = {})=>({
        contains: text || undefined,
        projectLocation: project?.value || undefined,
        accountIdLocation: user?.accountId || undefined
    });
const $7470f4a20f1d1e93$export$f6542f27c27241c6 = (params)=>({
        text: params.contains || undefined,
        project: $7470f4a20f1d1e93$var$transformSelectedProject(params.projectLocation),
        user: $7470f4a20f1d1e93$var$transformSelectedUser(params.accountIdLocation)
    });

});

parcelRegister("7atmZ", function(module, exports) {
$parcel$export(module.exports, "sortFieldToParam", () => $54edfea60af53cb1$export$9a7ae3517c7d79c2);
$parcel$export(module.exports, "sortFieldFromParam", () => $54edfea60af53cb1$export$307ee63ec20d9c92);

var $aETW1 = parcelRequire("aETW1");
const $54edfea60af53cb1$var$sortFieldMap = {
    [(0, $aETW1.NAME).toLowerCase()]: (0, $aETW1.NAME)
};
const $54edfea60af53cb1$export$9a7ae3517c7d79c2 = (field)=>field.toLowerCase();
const $54edfea60af53cb1$export$307ee63ec20d9c92 = (param)=>$54edfea60af53cb1$var$sortFieldMap[param] ? $54edfea60af53cb1$var$sortFieldMap[param] : null;

});


parcelRegister("hVCgF", function(module, exports) {
$parcel$export(module.exports, "default", () => $aeb7896d17d4ecc0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $kGj4V = parcelRequire("kGj4V");
var $kRgKj = parcelRequire("kRgKj");
var $dFqXL = parcelRequire("dFqXL");
const $aeb7896d17d4ecc0$var$fireGasV2AndGasV3Analytics = (appNameSuffixForV2Event, appNameForV3OperationalEvent)=>(analyticsEvent)=>{
        (0, $kRgKj.fireOperationalAnalytics)(analyticsEvent, `${appNameForV3OperationalEvent} pageInitialised`);
    };
const $aeb7896d17d4ecc0$var$PageAppInitialisationAnalytics = ({ appNameSuffixForV2Event: appNameSuffixForV2Event, appNameForV3OperationalEvent: appNameForV3OperationalEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        sourceType: (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a),
        sourceName: ""
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dFqXL.MountEvent), {
        onMount: $aeb7896d17d4ecc0$var$fireGasV2AndGasV3Analytics(appNameSuffixForV2Event, appNameForV3OperationalEvent)
    }));
var $aeb7896d17d4ecc0$export$2e2bcd8739ae039 = $aeb7896d17d4ecc0$var$PageAppInitialisationAnalytics;

});
// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';


parcelRegister("6UU7v", function(module, exports) {
$parcel$export(module.exports, "withSuspense", () => $d591853152e8b41d$export$a3bce93d4fb4eda6);
const $d591853152e8b41d$var$isDataEmpty = (data)=>data == null;
function $d591853152e8b41d$export$a3bce93d4fb4eda6(theHook) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (...args)=>{
        const result = theHook(...args);
        if (!false && $d591853152e8b41d$var$isDataEmpty(result.data) && result.loading) throw result.promise;
        return result;
    };
}

});

parcelRegister("fmhfo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2682a2794dec76a0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $1qbKn = parcelRequire("1qbKn");

var $3lhVL = parcelRequire("3lhVL");
const $2682a2794dec76a0$var$ErrorBoundaryWithExtraEventData = ({ children: children, id: id })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorBoundaryFlag), {
        id: "spa-apps.error-boundary"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3lhVL.default), null, ({ transitionsCount: transitionsCount = 0, lastTransition: lastTransition = '', navigationStart: navigationStart = '' })=>{
        const extraEventData = {
            transitionsCount: transitionsCount,
            lastTransition: lastTransition,
            navigationStart: navigationStart
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorBoundaryFlag), {
            id: id,
            extraEventData: extraEventData
        }, children);
    }));
const $2682a2794dec76a0$var$SpaErrorBoundary = $2682a2794dec76a0$var$ErrorBoundaryWithExtraEventData;
var $2682a2794dec76a0$export$2e2bcd8739ae039 = $2682a2794dec76a0$var$SpaErrorBoundary;

});

parcelRegister("9apWN", function(module, exports) {
$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $1ee6a8ed2ee6bae7$export$52d8964299339cae);

var $eJOHy = parcelRequire("eJOHy");

var $6OSA0 = parcelRequire("6OSA0");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

const $1ee6a8ed2ee6bae7$var$LazyNoSoftwareLicense = (0, $bQWwW.lazyForPaint)(()=>(parcelRequire("azRQF")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $1ee6a8ed2ee6bae7$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6OSA0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($1ee6a8ed2ee6bae7$var$LazyNoSoftwareLicense, null));

});
parcelRegister("azRQF", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = $ewTvA("hCSGm").then(()=>parcelRequire('jnEJY'));

});


parcelRegister("iEXnd", function(module, exports) {
$parcel$export(module.exports, "PRODUCT_START_MARK", () => $528da7e985f30ee4$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $528da7e985f30ee4$export$2a999c5f84501025);

var $6uWhG = parcelRequire("6uWhG");
const $528da7e985f30ee4$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $528da7e985f30ee4$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($528da7e985f30ee4$export$8e54fca0a680fdfd);
        (0, $6uWhG.setMark)($528da7e985f30ee4$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("fH7mW", function(module, exports) {
$parcel$export(module.exports, "default", () => $60c0a4066586fbd8$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2QUmO = parcelRequire("2QUmO");

var $cZTMg = parcelRequire("cZTMg");

var $5Kun5 = parcelRequire("5Kun5");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $60c0a4066586fbd8$var$Updater = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cZTMg.SubProductUpdater), {
        subProduct: "platform"
    });
var $60c0a4066586fbd8$export$2e2bcd8739ae039 = (0, $2QUmO.default)((0, $5Kun5.default), {
    Updater: $60c0a4066586fbd8$var$Updater
});

});
parcelRegister("5Kun5", function(module, exports) {
$parcel$export(module.exports, "default", () => $aae2daa9750198a6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $fGnU6 = parcelRequire("fGnU6");

var $fdpHV = parcelRequire("fdpHV");

var $jZ1mD = parcelRequire("jZ1mD");

var $1qbKn = parcelRequire("1qbKn");


var $2vBmG = parcelRequire("2vBmG");

var $jUHqr = parcelRequire("jUHqr");

var $iMFdk = parcelRequire("iMFdk");

var $gWu57 = parcelRequire("gWu57");

var $ddqcW = parcelRequire("ddqcW");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $aae2daa9750198a6$var$noop = ()=>{};
function $aae2daa9750198a6$var$BoardsDirectory(props) {
    const { Updater: Updater, tenantContext: tenantContext, prefetchResult: prefetchResult, favoriteChangeContext: favoriteChangeContext, query: query, onQueryChanged: onQueryChanged } = props;
    const { locale: locale, xsrfToken: xsrfToken, atlassianAccountId: atlassianAccountId } = tenantContext;
    const { error: prefetchError, loading: loading, data: data } = prefetchResult;
    if (prefetchError && !loading) // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error)' is not assignable to type 'Error | null'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
        id: "directories-boards",
        error: prefetchError
    });
    if (!data) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $iMFdk.BoardsDirectorySkeleton), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gWu57.PageLayout), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGnU6.ReportErrors), {
        id: "unhandled",
        packageName: "jiraSpaAppsDirectoriesBoards",
        teamName: "keystone"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Updater, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jZ1mD.default), {
        isServer: false,
        accountId: atlassianAccountId || null,
        locale: locale,
        xsrfToken: xsrfToken,
        query: query,
        favoriteChangeContext: favoriteChangeContext,
        prefetchedData: data,
        onQueryChanged: onQueryChanged,
        onUnmount: $aae2daa9750198a6$var$noop,
        withPageReadyMetrics: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jUHqr.default), {
        metricKey: "jira.directories.boards",
        metric: (0, $ddqcW.boardsDirectoryPageLoad),
        isExpectedToHaveSsr: true,
        withMarks: [
            (0, $2vBmG.appBundleReadyMark),
            (0, $2vBmG.prefetchApiReadyMark)
        ]
    })));
}
var $aae2daa9750198a6$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('boards', (0, $aa42ce8e355d58fa$export$f636b5b56f1d624a))($aae2daa9750198a6$var$BoardsDirectory);

});
parcelRegister("jZ1mD", function(module, exports) {
$parcel$export(module.exports, "default", () => $b46da985d4d4f47c$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $j1zAF = parcelRequire("j1zAF");

var $giQZR = parcelRequire("giQZR");

var $jmZ1P = parcelRequire("jmZ1P");

var $idGBm = parcelRequire("idGBm");

var $coT0B = parcelRequire("coT0B");
var $b46da985d4d4f47c$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $idGBm.injectIntlV2), (0, $giQZR.default)({
    CreateButton: $jmZ1P.default,
    BoardsDirectory: $j1zAF.default
}))((0, $coT0B.default));

});
parcelRegister("j1zAF", function(module, exports) {
$parcel$export(module.exports, "default", () => $13629f4c157d978a$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $cSmYj = parcelRequire("cSmYj");

var $12DRg = parcelRequire("12DRg");

var $fGnU6 = parcelRequire("fGnU6");

var $guWba = parcelRequire("guWba");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $gkJdp = parcelRequire("gkJdp");

var $d41c2 = parcelRequire("d41c2");

var $dgHVV = parcelRequire("dgHVV");

var $gTHxT = parcelRequire("gTHxT");

var $1AuA5 = parcelRequire("1AuA5");

var $emPjh = parcelRequire("emPjh");

var $7YHJF = parcelRequire("7YHJF");

var $bRtgQ = parcelRequire("bRtgQ");

var $hW5yn = parcelRequire("hW5yn");

var $5SwWv = parcelRequire("5SwWv");
class $13629f4c157d978a$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            query: undefined,
            prefetchedData: {},
            withPageReadyMetrics: true,
            onQueryChanged: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $bRtgQ.default)((0, $gTHxT.default));
        const { boards: boards } = props.prefetchedData;
        const { dispatch: dispatch } = this.store;
        dispatch((0, $1AuA5.setAppProps)(props));
        dispatch((0, $7YHJF.setQuery)(props.query || (0, $dgHVV.initialQuery)));
        dispatch(boards ? (0, $emPjh.retrieved)(boards) : (0, $emPjh.retrieve)());
    }
    componentDidUpdate(prevProps) {
        const { dispatch: dispatch } = this.store;
        const { query: query } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(prevProps, this.props)) dispatch((0, $1AuA5.setAppProps)(this.props));
        if (query && !(0, (/*@__PURE__*/$parcel$interopDefault($cSmYj)))(query, (0, $hW5yn.getQuery)(this.store.getState()))) {
            dispatch((0, $7YHJF.setQuery)(query));
            dispatch((0, $emPjh.retrieve)());
        }
    }
    componentWillUnmount() {
        this.props.onUnmount();
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGnU6.ReportErrors), {
            id: "unhandled",
            packageName: "jiraBoardsMain",
            teamName: "keystone"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gkJdp.FlagsDispatcher), {
            mapper: (0, $d41c2.default)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5SwWv.default), null))));
    }
}

});
parcelRegister("gkJdp", function(module, exports) {
$parcel$export(module.exports, "FlagsDispatcher", () => $d4954b195b498ec0$export$9e60e3d40b6e758f);

var $eJOHy = parcelRequire("eJOHy");

var $cSXp8 = parcelRequire("cSXp8");

var $1jGda = parcelRequire("1jGda");
const $d4954b195b498ec0$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1jGda.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $cSXp8.showFlag),
        dismissFlag: (0, $cSXp8.dismissFlag)
    });

});
parcelRegister("1jGda", function(module, exports) {
$parcel$export(module.exports, "Dispatcher", () => $fa7452c648b5a8e9$export$ab054a1ef92eeb01);

var $eJOHy = parcelRequire("eJOHy");

var $9M1e4 = parcelRequire("9M1e4");
const $fa7452c648b5a8e9$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $eJOHy.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $eJOHy.useMemo)(()=>(0, $9M1e4.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("9M1e4", function(module, exports) {
$parcel$export(module.exports, "createDispatcher", () => $3e53fcd3a1d0c324$export$7b259d28468da15b);

var $eJOHy = parcelRequire("eJOHy");

var $dyOHn = parcelRequire("dyOHn");

var $cSXp8 = parcelRequire("cSXp8");
const $3e53fcd3a1d0c324$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $3e53fcd3a1d0c324$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $cSXp8.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $cSXp8.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dyOHn.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $3e53fcd3a1d0c324$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $cSXp8.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $3e53fcd3a1d0c324$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $3e53fcd3a1d0c324$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $3e53fcd3a1d0c324$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $eJOHy.useMemo)(()=>$3e53fcd3a1d0c324$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $eJOHy.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $3e53fcd3a1d0c324$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $3e53fcd3a1d0c324$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $dyOHn.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e53fcd3a1d0c324$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $3e53fcd3a1d0c324$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3e53fcd3a1d0c324$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $3e53fcd3a1d0c324$var$Dispatcher8DefaultStore;
};

});



parcelRegister("d41c2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f01f0a2d4b87a72a$export$2e2bcd8739ae039);

var $laVmq = parcelRequire("laVmq");

var $d6NK2 = parcelRequire("d6NK2");

var $7FCY1 = parcelRequire("7FCY1");

var $gXBAL = parcelRequire("gXBAL");

var $iaRMG = parcelRequire("iaRMG");

var $ibDEz = parcelRequire("ibDEz");

var $j0dj7 = parcelRequire("j0dj7");

var $2zXXF = parcelRequire("2zXXF");

var $kHvjT = parcelRequire("kHvjT");
const $f01f0a2d4b87a72a$var$BOARD_NOT_FOUND_REASON = 'board-not-found';
const $f01f0a2d4b87a72a$var$flagsMapper = (action, state)=>{
    switch(action.type){
        case 0, $d6NK2.DELETED:
            return (0, $j0dj7.default)(action.payload.board);
        case 0, $d6NK2.DELETE_FAILED:
            if (action.payload.reason === $f01f0a2d4b87a72a$var$BOARD_NOT_FOUND_REASON) return (0, $laVmq.default)(action.payload.board);
            return (0, $ibDEz.default)(action.payload.board);
        case 0, $d6NK2.COPIED:
            {
                const { board: board, copiedBoardSummary: copiedBoardSummary } = action.payload;
                return (0, $iaRMG.default)(board, copiedBoardSummary, (0, $7FCY1.getRapidBoardUrlForCopiedBoard)(state, copiedBoardSummary.id, copiedBoardSummary.location), (0, $7FCY1.getRapidBoardEditUrlForCopiedBoard)(state, copiedBoardSummary.id, copiedBoardSummary.location));
            }
        case 0, $d6NK2.COPY_FAILED:
            if (action.payload.reason === $f01f0a2d4b87a72a$var$BOARD_NOT_FOUND_REASON) return (0, $laVmq.default)(action.payload.board);
            return (0, $gXBAL.default)(action.payload.board);
        case 0, $d6NK2.MOVED:
            return (0, $kHvjT.default)(action.payload.board);
        case 0, $d6NK2.MOVE_FAILED:
            return (0, $2zXXF.default)(action.payload.board);
        default:
            {
                const _exhaustiveCheck = action;
                return undefined;
            }
    }
};
var $f01f0a2d4b87a72a$export$2e2bcd8739ae039 = $f01f0a2d4b87a72a$var$flagsMapper;

});
parcelRegister("laVmq", function(module, exports) {
$parcel$export(module.exports, "default", () => $57db84f628c962b4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $57db84f628c962b4$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.boards-v2.common.flags.board-not-found.title",
        "defaultMessage": "We can't find {boardName}"
    },
    titlePrivateBoard: {
        "id": "directories.boards-v2.common.flags.board-not-found.title-private-board",
        "defaultMessage": "We can't find this board"
    },
    description: {
        "id": "directories.boards-v2.common.flags.board-not-found.description",
        "defaultMessage": "Someone might've deleted it. Refresh the page and try again."
    }
});
const $57db84f628c962b4$var$boardNotFound = (board)=>{
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) return {
        type: 'error',
        title: $57db84f628c962b4$var$messages.titlePrivateBoard,
        description: $57db84f628c962b4$var$messages.description
    };
    return {
        type: 'error',
        // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
        title: [
            $57db84f628c962b4$var$messages.title,
            {
                boardName: board.name
            }
        ],
        description: $57db84f628c962b4$var$messages.description
    };
};
var $57db84f628c962b4$export$2e2bcd8739ae039 = $57db84f628c962b4$var$boardNotFound;

});

parcelRegister("d6NK2", function(module, exports) {
$parcel$export(module.exports, "DELETED", () => $340ea4dbc5a77229$export$1cc76b53f23597de);
$parcel$export(module.exports, "deleted", () => $340ea4dbc5a77229$export$bccbf0c716f226f4);
$parcel$export(module.exports, "DELETE_FAILED", () => $340ea4dbc5a77229$export$ae082348f4557243);
$parcel$export(module.exports, "deleteFailed", () => $340ea4dbc5a77229$export$8830effd508d9f31);
$parcel$export(module.exports, "COPIED", () => $340ea4dbc5a77229$export$ab06cbdc503432af);
$parcel$export(module.exports, "copied", () => $340ea4dbc5a77229$export$a92b46551664f4e);
$parcel$export(module.exports, "COPY_FAILED", () => $340ea4dbc5a77229$export$9db31c0e010caedf);
$parcel$export(module.exports, "copyFailed", () => $340ea4dbc5a77229$export$5d8d1af388d10413);
$parcel$export(module.exports, "MOVED", () => $340ea4dbc5a77229$export$fdd9e4df1aa8958d);
$parcel$export(module.exports, "moved", () => $340ea4dbc5a77229$export$7e507c9be5c491c1);
$parcel$export(module.exports, "MOVE_FAILED", () => $340ea4dbc5a77229$export$a8fc6f431b735962);
$parcel$export(module.exports, "moveFailed", () => $340ea4dbc5a77229$export$290884bafa3cdcc9);
const $340ea4dbc5a77229$export$1cc76b53f23597de = 'state.actions.operations.DELETED';
const $340ea4dbc5a77229$export$bccbf0c716f226f4 = (board)=>({
        type: $340ea4dbc5a77229$export$1cc76b53f23597de,
        payload: {
            board: board
        }
    });
const $340ea4dbc5a77229$export$ae082348f4557243 = 'state.actions.operations.DELETE_FAILED';
const $340ea4dbc5a77229$export$8830effd508d9f31 = (board, reason)=>({
        type: $340ea4dbc5a77229$export$ae082348f4557243,
        payload: {
            board: board,
            reason: reason
        }
    });
const $340ea4dbc5a77229$export$ab06cbdc503432af = 'state.actions.operations.COPIED';
const $340ea4dbc5a77229$export$a92b46551664f4e = (board, copiedBoardSummary)=>({
        type: $340ea4dbc5a77229$export$ab06cbdc503432af,
        payload: {
            board: board,
            copiedBoardSummary: copiedBoardSummary
        }
    });
const $340ea4dbc5a77229$export$9db31c0e010caedf = 'state.actions.operations.COPY_FAILED';
const $340ea4dbc5a77229$export$5d8d1af388d10413 = (board, reason)=>({
        type: $340ea4dbc5a77229$export$9db31c0e010caedf,
        payload: {
            board: board,
            reason: reason
        }
    });
const $340ea4dbc5a77229$export$fdd9e4df1aa8958d = 'state.actions.operations.MOVED';
const $340ea4dbc5a77229$export$7e507c9be5c491c1 = (board)=>({
        type: $340ea4dbc5a77229$export$fdd9e4df1aa8958d,
        payload: {
            board: board
        }
    });
const $340ea4dbc5a77229$export$a8fc6f431b735962 = 'state.actions.operations.MOVE_FAILED';
const $340ea4dbc5a77229$export$290884bafa3cdcc9 = (board)=>({
        type: $340ea4dbc5a77229$export$a8fc6f431b735962,
        payload: {
            board: board
        }
    });

});

parcelRegister("7FCY1", function(module, exports) {
$parcel$export(module.exports, "getIds", () => $4cf973eee2adabaf$export$24b60fe7179439bc);
$parcel$export(module.exports, "getTotal", () => $4cf973eee2adabaf$export$94860ac4a286a8d9);
$parcel$export(module.exports, "isLoading", () => $4cf973eee2adabaf$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $4cf973eee2adabaf$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getBoard", () => $4cf973eee2adabaf$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "isPrivate", () => $4cf973eee2adabaf$export$1d1349f4eb9a7003);
$parcel$export(module.exports, "getName", () => $4cf973eee2adabaf$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getType", () => $4cf973eee2adabaf$export$e2b5c5db9e2009fd);
$parcel$export(module.exports, "getLocation", () => $4cf973eee2adabaf$export$e7fd20fad3cf4b5f);
$parcel$export(module.exports, "getAdministrators", () => $4cf973eee2adabaf$export$cf06e17ab43f6f66);
$parcel$export(module.exports, "canEdit", () => $4cf973eee2adabaf$export$a261e9b0da701d0e);
$parcel$export(module.exports, "getRapidBoardUrlForCopiedBoard", () => $4cf973eee2adabaf$export$fa187c3e024a70f4);
$parcel$export(module.exports, "getRapidBoardEditUrlForCopiedBoard", () => $4cf973eee2adabaf$export$be2f5135768a781d);
$parcel$export(module.exports, "getRapidBoardUrlForSavedBoard", () => $4cf973eee2adabaf$export$5d7b71422cf0bc36);
$parcel$export(module.exports, "getEditBoardUrl", () => $4cf973eee2adabaf$export$1f52b9d4f45d4d7e);
$parcel$export(module.exports, "isFavorite", () => $4cf973eee2adabaf$export$70b3463aa7e3e514);
$parcel$export(module.exports, "isPending", () => $4cf973eee2adabaf$export$872dec21e9a69476);
$parcel$export(module.exports, "getChangeFavorite", () => $4cf973eee2adabaf$export$85b24bd43a2bd6cf);

var $aTjc7 = parcelRequire("aTjc7");

var $cU3jn = parcelRequire("cU3jn");
const $4cf973eee2adabaf$export$dd1bc94b04021eeb = (state)=>state.boards.order.length === 0;
const $4cf973eee2adabaf$export$24b60fe7179439bc = (state)=>state.boards.order;
const $4cf973eee2adabaf$export$94860ac4a286a8d9 = (state)=>state.boards.total;
const $4cf973eee2adabaf$export$20bb0d907fbbe433 = (state)=>state.boards.isLoading;
const $4cf973eee2adabaf$export$e6127cc7fe7395c3 = (state)=>state.boards.isError;
const $4cf973eee2adabaf$export$2223f2dfcfd77cef = (state, id)=>state.boards.page[id];
const $4cf973eee2adabaf$export$1d1349f4eb9a7003 = (state, id)=>{
    const board = state.boards?.page[id];
    return board ? (0, $aTjc7.isPrivateBoard)(board) : false;
};
const $4cf973eee2adabaf$export$7d9f7e9c1c02b41e = (state, id)=>{
    const board = $4cf973eee2adabaf$export$2223f2dfcfd77cef(state, id);
    if ((0, $aTjc7.isPrivateBoard)(board)) throw new Error('Invalid access to name of private board.');
    return board?.name;
};
const $4cf973eee2adabaf$export$e2b5c5db9e2009fd = (state, id)=>{
    const board = $4cf973eee2adabaf$export$2223f2dfcfd77cef(state, id);
    if ((0, $aTjc7.isPrivateBoard)(board)) throw new Error('Invalid access to type of private board.');
    return board?.type;
};
const $4cf973eee2adabaf$export$e7fd20fad3cf4b5f = (state, id)=>state.boards.page[id]?.location;
const $4cf973eee2adabaf$export$cf06e17ab43f6f66 = (state, id)=>state.boards.page[id]?.admins;
const $4cf973eee2adabaf$export$a261e9b0da701d0e = (state, id)=>state.boards.page[id]?.canEdit || false;
const $4cf973eee2adabaf$export$4777a065506d2787 = (state, id)=>`/secure/RapidBoard.jspa?rapidView=${id}&useStoredSettings=true`;
const $4cf973eee2adabaf$var$getRapidBoardUserBoardUrl = (userAccountId, boardId)=>`/jira/people/${userAccountId}/boards/${boardId}`;
const $4cf973eee2adabaf$var$getRapidBoardProjectBoardUrl = (projectKey, boardId)=>`/jira/software/c/projects/${projectKey}/boards/${boardId}`;
const $4cf973eee2adabaf$export$fa187c3e024a70f4 = (state, id, location)=>{
    if (!location.isValid) return `${$4cf973eee2adabaf$export$4777a065506d2787(state, id)}&locationless=true`;
    if (location.accountId != null) return $4cf973eee2adabaf$var$getRapidBoardUserBoardUrl(location.accountId, id);
    return $4cf973eee2adabaf$var$getRapidBoardProjectBoardUrl(location.locationKey, id);
};
const $4cf973eee2adabaf$export$be2f5135768a781d = (state, id, location)=>{
    const boardSettingsDefaultView = '/settings/filter';
    if (!location.isValid) return `${$4cf973eee2adabaf$export$4777a065506d2787(state, id)}&locationless=true&config=default`;
    if (location.accountId != null) return `${$4cf973eee2adabaf$var$getRapidBoardUserBoardUrl(location.accountId, id)}${boardSettingsDefaultView}`;
    return `${$4cf973eee2adabaf$var$getRapidBoardProjectBoardUrl(location.locationKey, id)}${boardSettingsDefaultView}`;
};
const $4cf973eee2adabaf$export$5d7b71422cf0bc36 = (state, id)=>{
    const location = $4cf973eee2adabaf$export$e7fd20fad3cf4b5f(state, id);
    // @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
    if (location?.projectKey != null) // @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
    return $4cf973eee2adabaf$var$getRapidBoardProjectBoardUrl(location.projectKey, id);
    // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'Location'.
    if (location?.userAccountId != null) // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'Location'.
    return $4cf973eee2adabaf$var$getRapidBoardUserBoardUrl(location.userAccountId, id);
    return `${$4cf973eee2adabaf$export$4777a065506d2787(state, id)}&locationless=true`;
};
const $4cf973eee2adabaf$export$1f52b9d4f45d4d7e = (state, id)=>{
    const location = $4cf973eee2adabaf$export$e7fd20fad3cf4b5f(state, id);
    if (location?.type === 'project') return `${$4cf973eee2adabaf$var$getRapidBoardProjectBoardUrl(location.projectKey, id)}/settings/filter`;
    if (location?.type === 'user') return `${$4cf973eee2adabaf$var$getRapidBoardUserBoardUrl(location.userAccountId, id)}/settings/filter`;
    return `/secure/RapidBoard.jspa?rapidView=${id}&config=default&locationless=true`;
};
const $4cf973eee2adabaf$var$getFavoriteChangeContextItem = (state, id)=>// @ts-expect-error - TS2532 - Object is possibly 'undefined'.
    (0, $cU3jn.getFavoriteChangeContext)(state).items.boards[id];
const $4cf973eee2adabaf$export$70b3463aa7e3e514 = (state, id)=>{
    const board = $4cf973eee2adabaf$export$2223f2dfcfd77cef(state, id);
    if ((0, $aTjc7.isPrivateBoard)(board)) throw new Error("Invalid access to 'favourite' state of private board.");
    const itemChanged = $4cf973eee2adabaf$var$getFavoriteChangeContextItem(state, id);
    return itemChanged?.value ?? board?.favourite;
};
const $4cf973eee2adabaf$export$872dec21e9a69476 = (state, id)=>{
    const item = $4cf973eee2adabaf$var$getFavoriteChangeContextItem(state, id);
    return !!(item && item.pending);
};
const $4cf973eee2adabaf$export$85b24bd43a2bd6cf = (state)=>(0, $cU3jn.getFavoriteChangeContext)(state).changeFavorite;

});
parcelRegister("aTjc7", function(module, exports) {
$parcel$export(module.exports, "isPrivateBoard", () => $2ffc2b260c28ee71$export$24f9c7e9ded1e69b);
const $2ffc2b260c28ee71$export$51ab1b22799aafa = (board)=>board !== undefined && 'isPrivate' in board;
const $2ffc2b260c28ee71$export$24f9c7e9ded1e69b = (board)=>$2ffc2b260c28ee71$export$51ab1b22799aafa(board) && board.isPrivate;
const $2ffc2b260c28ee71$export$184eaec5cc535a29 = (location)=>location !== undefined && 'userAccountId' in location;
const $2ffc2b260c28ee71$export$511ce95363928ab7 = (location)=>location !== undefined && 'projectKey' in location;

});

parcelRegister("cU3jn", function(module, exports) {
$parcel$export(module.exports, "getLoggedInUserAccountId", () => $9e5e3b3ca2dabb75$export$a304ee7b66f5d1e);
$parcel$export(module.exports, "getOnQueryChanged", () => $9e5e3b3ca2dabb75$export$59e4f8ebf6520bf7);
$parcel$export(module.exports, "getFavoriteChangeContext", () => $9e5e3b3ca2dabb75$export$6fa121a48411f085);
$parcel$export(module.exports, "isWithPageReadyMetrics", () => $9e5e3b3ca2dabb75$export$29e8a85166eb4498);
const $9e5e3b3ca2dabb75$export$a304ee7b66f5d1e = (state)=>state.app.props.accountId;
const $9e5e3b3ca2dabb75$export$59e4f8ebf6520bf7 = (state)=>state.app.props.onQueryChanged;
const $9e5e3b3ca2dabb75$export$14407a25c57e1f92 = (state)=>state.app.props.xsrfToken;
const $9e5e3b3ca2dabb75$export$6fa121a48411f085 = (state)=>state.app.props.favoriteChangeContext;
const $9e5e3b3ca2dabb75$export$29e8a85166eb4498 = (state)=>state.app.props.withPageReadyMetrics;

});


parcelRegister("gXBAL", function(module, exports) {
$parcel$export(module.exports, "default", () => $a72df1193418621e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a72df1193418621e$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.copy.failed.title",
        "defaultMessage": "We couldn't copy {boardName}"
    },
    description: {
        "id": "directories.boards-v2.main.flags.copy.failed.description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
const $a72df1193418621e$var$copyFailed = (board)=>({
        type: 'error',
        title: [
            $a72df1193418621e$var$messages.title,
            {
                boardName: board.name
            }
        ],
        description: $a72df1193418621e$var$messages.description
    });
var $a72df1193418621e$export$2e2bcd8739ae039 = $a72df1193418621e$var$copyFailed;

});

parcelRegister("iaRMG", function(module, exports) {
$parcel$export(module.exports, "default", () => $46b91f0e62bdcc71$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $46b91f0e62bdcc71$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.copy.success.title",
        "defaultMessage": "{boardName} copied"
    },
    description: {
        "id": "directories.boards-v2.main.flags.copy.success.description",
        "defaultMessage": "{copiedBoardName} has been created with the same settings and filter as {boardName}"
    },
    viewBoard: {
        "id": "directories.boards-v2.main.flags.copy.success.view-board",
        "defaultMessage": "View board"
    },
    editBoard: {
        "id": "directories.boards-v2.main.flags.copy.success.edit-board",
        "defaultMessage": "Edit settings"
    }
});
const $46b91f0e62bdcc71$var$copied = (board, copiedBoardSummary, copiedBoardUrl, copiedBoardSettingsUrl)=>({
        type: 'success',
        title: [
            $46b91f0e62bdcc71$var$messages.title,
            {
                boardName: board.name
            }
        ],
        description: [
            $46b91f0e62bdcc71$var$messages.description,
            {
                boardName: board.name,
                copiedBoardName: copiedBoardSummary.name
            }
        ],
        actions: [
            {
                content: $46b91f0e62bdcc71$var$messages.viewBoard,
                href: copiedBoardUrl
            },
            {
                content: $46b91f0e62bdcc71$var$messages.editBoard,
                href: copiedBoardSettingsUrl
            }
        ]
    });
var $46b91f0e62bdcc71$export$2e2bcd8739ae039 = $46b91f0e62bdcc71$var$copied;

});

parcelRegister("ibDEz", function(module, exports) {
$parcel$export(module.exports, "default", () => $eec413ceb4af1b49$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $eec413ceb4af1b49$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.delete.failed.title",
        "defaultMessage": "We couldn't delete {boardName}"
    },
    titlePrivateBoard: {
        "id": "directories.boards-v2.main.flags.delete.failed.title-private-board",
        "defaultMessage": "We couldn't delete this board"
    },
    description: {
        "id": "directories.boards-v2.main.flags.delete.failed.description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
const $eec413ceb4af1b49$var$deleteFailed = (board)=>{
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) return {
        type: 'error',
        title: $eec413ceb4af1b49$var$messages.titlePrivateBoard,
        description: $eec413ceb4af1b49$var$messages.description
    };
    return {
        type: 'error',
        // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
        title: [
            $eec413ceb4af1b49$var$messages.title,
            {
                boardName: board.name
            }
        ],
        description: $eec413ceb4af1b49$var$messages.description
    };
};
var $eec413ceb4af1b49$export$2e2bcd8739ae039 = $eec413ceb4af1b49$var$deleteFailed;

});

parcelRegister("j0dj7", function(module, exports) {
$parcel$export(module.exports, "default", () => $bd2ebe84e7ecc5cf$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $bd2ebe84e7ecc5cf$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.delete.success.title",
        "defaultMessage": "{boardName} deleted"
    },
    titlePrivateBoard: {
        "id": "directories.boards-v2.main.flags.delete.success.title-private-board",
        "defaultMessage": "Board deleted"
    }
});
const $bd2ebe84e7ecc5cf$var$deleted = (board)=>{
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) return {
        type: 'success',
        title: $bd2ebe84e7ecc5cf$var$messages.titlePrivateBoard
    };
    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
    return {
        type: 'success',
        title: [
            $bd2ebe84e7ecc5cf$var$messages.title,
            {
                boardName: board.name
            }
        ]
    };
};
var $bd2ebe84e7ecc5cf$export$2e2bcd8739ae039 = $bd2ebe84e7ecc5cf$var$deleted;

});

parcelRegister("2zXXF", function(module, exports) {
$parcel$export(module.exports, "default", () => $8dc68c1522d04104$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $8dc68c1522d04104$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.move.failed.title",
        "defaultMessage": "We couldn't move {boardName}"
    },
    titlePrivateBoard: {
        "id": "directories.boards-v2.main.flags.move.failed.title-private-board",
        "defaultMessage": "We couldn't move this board"
    },
    description: {
        "id": "directories.boards-v2.main.flags.move.failed.description",
        "defaultMessage": "Something went wrong. Try again."
    }
});
const $8dc68c1522d04104$var$moveFailed = (board)=>{
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) return {
        type: 'error',
        title: $8dc68c1522d04104$var$messages.titlePrivateBoard,
        description: $8dc68c1522d04104$var$messages.description
    };
    return {
        type: 'error',
        // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
        title: [
            $8dc68c1522d04104$var$messages.title,
            {
                boardName: board.name
            }
        ],
        description: $8dc68c1522d04104$var$messages.description
    };
};
var $8dc68c1522d04104$export$2e2bcd8739ae039 = $8dc68c1522d04104$var$moveFailed;

});

parcelRegister("kHvjT", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ef1f07fe5ddce1d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $6ef1f07fe5ddce1d$var$messages = (0, $7qGN1.defineMessages)({
    title: {
        "id": "directories.boards-v2.main.flags.move.success.title",
        "defaultMessage": "{boardName} moved"
    },
    titlePrivateBoard: {
        "id": "directories.boards-v2.main.flags.move.success.title-private-board",
        "defaultMessage": "Board moved"
    }
});
const $6ef1f07fe5ddce1d$var$moved = (board)=>{
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) return {
        type: 'success',
        title: $6ef1f07fe5ddce1d$var$messages.titlePrivateBoard
    };
    // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
    return {
        type: 'success',
        title: [
            $6ef1f07fe5ddce1d$var$messages.title,
            {
                boardName: board.name
            }
        ]
    };
};
var $6ef1f07fe5ddce1d$export$2e2bcd8739ae039 = $6ef1f07fe5ddce1d$var$moved;

});


parcelRegister("gTHxT", function(module, exports) {
$parcel$export(module.exports, "default", () => $9f4009d1689cfa10$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $fTW3z = parcelRequire("fTW3z");

var $fd66k = parcelRequire("fd66k");

var $ecIMa = parcelRequire("ecIMa");
var $9f4009d1689cfa10$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $fd66k.default), (0, $ecIMa.default), (0, $fTW3z.default));

});
parcelRegister("fTW3z", function(module, exports) {
$parcel$export(module.exports, "default", () => $976a652241ba8606$export$2e2bcd8739ae039);
parcelRequire("7La6O");
parcelRequire("8yIb3");

var $ihAnM = parcelRequire("ihAnM");

var $1AuA5 = parcelRequire("1AuA5");

var $cU3jn = parcelRequire("cU3jn");
const $976a652241ba8606$var$pageReadyEpic = (action$, store)=>action$.ofType((0, $1AuA5.READY)).do(()=>{
        (0, $cU3jn.isWithPageReadyMetrics)(store.getState()) && (0, $ihAnM.pageReady)();
    }).ignoreElements();
var $976a652241ba8606$export$2e2bcd8739ae039 = $976a652241ba8606$var$pageReadyEpic;

});
parcelRegister("ihAnM", function(module, exports) {
$parcel$export(module.exports, "pageReady", () => $1a8537d86f043dd8$export$674e3a896edcf7c);
const $1a8537d86f043dd8$export$674e3a896edcf7c = ()=>{
// no-op for now, to be properly cleaned up when FFs are removed - KITKAT-1419
};

});

parcelRegister("1AuA5", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $af3ead1edf758c72$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $af3ead1edf758c72$export$cfda7627848a58cd);
$parcel$export(module.exports, "READY", () => $af3ead1edf758c72$export$4bf05b02be91f13a);
$parcel$export(module.exports, "ready", () => $af3ead1edf758c72$export$28ee1007e174a2a6);
const $af3ead1edf758c72$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $af3ead1edf758c72$export$cfda7627848a58cd = (payload)=>({
        type: $af3ead1edf758c72$export$8aefe701a6f431e0,
        payload: payload
    });
const $af3ead1edf758c72$export$4bf05b02be91f13a = 'state.actions.app.READY';
const $af3ead1edf758c72$export$28ee1007e174a2a6 = ()=>({
        type: $af3ead1edf758c72$export$4bf05b02be91f13a
    });

});


parcelRegister("fd66k", function(module, exports) {
$parcel$export(module.exports, "default", () => $1bac7ec6acdc58b0$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $k4x9q = parcelRequire("k4x9q");

var $7kixv = parcelRequire("7kixv");

var $7YHJF = parcelRequire("7YHJF");

var $cU3jn = parcelRequire("cU3jn");

var $hW5yn = parcelRequire("hW5yn");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1bac7ec6acdc58b0$var$querySet = (action$, store)=>action$.ofType((0, $7YHJF.SET_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $cU3jn.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback(payload);
        return (0, $7kixv.Observable).empty();
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1bac7ec6acdc58b0$var$queryPatched = (action$, store)=>action$.ofType((0, $7YHJF.PATCH_QUERY)).mergeMap(({ payload: payload })=>{
        const state = store.getState();
        const callback = (0, $cU3jn.getOnQueryChanged)(state);
        if (typeof callback === 'function') callback((0, (/*@__PURE__*/$parcel$interopDefault($k4x9q)))(payload, (0, $hW5yn.getQuery)(state)));
        return (0, $7kixv.Observable).empty();
    });
var $1bac7ec6acdc58b0$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)($1bac7ec6acdc58b0$var$querySet, $1bac7ec6acdc58b0$var$queryPatched);

});
parcelRegister("7YHJF", function(module, exports) {
$parcel$export(module.exports, "SET_QUERY", () => $26472c625804ee70$export$11bcea24b35a126f);
$parcel$export(module.exports, "setQuery", () => $26472c625804ee70$export$f3b215b0b382f63b);
$parcel$export(module.exports, "PATCH_QUERY", () => $26472c625804ee70$export$403065a1ff0b1663);
$parcel$export(module.exports, "patchQuery", () => $26472c625804ee70$export$8a4e224aafd3a2bf);
const $26472c625804ee70$export$11bcea24b35a126f = 'state.actions.query.SET_QUERY';
const $26472c625804ee70$export$f3b215b0b382f63b = (payload)=>({
        type: $26472c625804ee70$export$11bcea24b35a126f,
        payload: payload
    });
const $26472c625804ee70$export$403065a1ff0b1663 = 'state.actions.query.PATCH_QUERY';
const $26472c625804ee70$export$8a4e224aafd3a2bf = (payload)=>({
        type: $26472c625804ee70$export$403065a1ff0b1663,
        payload: payload
    });

});

parcelRegister("hW5yn", function(module, exports) {
$parcel$export(module.exports, "getQuery", () => $9c16036d288d964d$export$71eec30d9db46a56);
$parcel$export(module.exports, "getSortField", () => $9c16036d288d964d$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $9c16036d288d964d$export$509e2b9937961873);
$parcel$export(module.exports, "getPage", () => $9c16036d288d964d$export$c2a6433281518c91);
$parcel$export(module.exports, "getFilter", () => $9c16036d288d964d$export$61ec8404f465cd36);
$parcel$export(module.exports, "getSearchText", () => $9c16036d288d964d$export$f0fa84cdddf86109);
$parcel$export(module.exports, "getSelectedProject", () => $9c16036d288d964d$export$1ebc7a42c839af66);
$parcel$export(module.exports, "getSelectedUser", () => $9c16036d288d964d$export$6341682f20d2dbb4);
$parcel$export(module.exports, "getLoggedInUserAccountId", () => $9c16036d288d964d$export$a304ee7b66f5d1e);
$parcel$export(module.exports, "isFilterApplied", () => $9c16036d288d964d$export$980aed36f19060a5);

var $ahm5r = parcelRequire("ahm5r");
const $9c16036d288d964d$export$71eec30d9db46a56 = (state)=>state.query;
const $9c16036d288d964d$export$9b753af5a9fb5911 = (state)=>state.query.sortField;
const $9c16036d288d964d$export$509e2b9937961873 = (state)=>state.query.sortDirection;
const $9c16036d288d964d$export$c2a6433281518c91 = (state)=>state.query.page;
const $9c16036d288d964d$export$61ec8404f465cd36 = (state)=>{
    // in our case, we **know** that there is always a filter
    if (!state.query.filter) throw new Error('Invalid state.');
    return state.query.filter;
};
const $9c16036d288d964d$export$f0fa84cdddf86109 = (state)=>$9c16036d288d964d$export$61ec8404f465cd36(state).text || '';
const $9c16036d288d964d$export$1ebc7a42c839af66 = (state)=>$9c16036d288d964d$export$61ec8404f465cd36(state).project;
const $9c16036d288d964d$export$6341682f20d2dbb4 = (state)=>$9c16036d288d964d$export$61ec8404f465cd36(state).user;
const $9c16036d288d964d$export$a304ee7b66f5d1e = (state)=>state.app.props.accountId;
const $9c16036d288d964d$export$980aed36f19060a5 = (0, $ahm5r.createSelector)($9c16036d288d964d$export$f0fa84cdddf86109, $9c16036d288d964d$export$1ebc7a42c839af66, $9c16036d288d964d$export$6341682f20d2dbb4, (textValue, projectValue, user)=>!!textValue || !!projectValue || !!user);

});


parcelRegister("ecIMa", function(module, exports) {
$parcel$export(module.exports, "default", () => $33fe8c4fd8b05a4d$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("hfuHK");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $9pTd3 = parcelRequire("9pTd3");

var $7jIOf = parcelRequire("7jIOf");

var $emPjh = parcelRequire("emPjh");

var $hW5yn = parcelRequire("hW5yn");

var $jL7iY = parcelRequire("jL7iY");
const $33fe8c4fd8b05a4d$var$retrieveBoards = (action$, store)=>{
    const getDashboardsRequestAction$ = action$.ofType((0, $emPjh.RETRIEVE));
    return getDashboardsRequestAction$.mergeMap(()=>{
        const state = store.getState();
        const request = (0, $jL7iY.getServiceRequest)(state);
        const filter = (0, $hW5yn.getFilter)(state);
        return (0, $7kixv.Observable).fromPromise((0, $7jIOf.default)(request, filter)).mergeMap((result)=>(0, $7kixv.Observable).of((0, $emPjh.retrieved)(result))).takeUntil(getDashboardsRequestAction$).catch((error)=>{
            (0, $9pTd3.fireErrorAnalytics)({
                error: error,
                meta: {
                    id: 'retrieveBoards',
                    packageName: 'jiraBoardsMain',
                    teamName: 'keystone'
                }
            });
            return (0, $7kixv.Observable).of((0, $emPjh.retrieveFailed)());
        });
    });
};
var $33fe8c4fd8b05a4d$export$2e2bcd8739ae039 = $33fe8c4fd8b05a4d$var$retrieveBoards;

});
parcelRegister("7jIOf", function(module, exports) {
$parcel$export(module.exports, "default", () => $302e9947b8b4dbdd$export$2e2bcd8739ae039);

var $lxiXL = parcelRequire("lxiXL");

var $6p2KZ = parcelRequire("6p2KZ");
const $302e9947b8b4dbdd$var$getBoards = async (request, filter)=>{
    const restResponse = await (0, $lxiXL.default)(request, filter, true);
    return (0, $6p2KZ.transformBoards)(restResponse.values, restResponse.total);
};
var $302e9947b8b4dbdd$export$2e2bcd8739ae039 = $302e9947b8b4dbdd$var$getBoards;

});
parcelRegister("lxiXL", function(module, exports) {
$parcel$export(module.exports, "default", () => $65a1244f9bc08597$export$2e2bcd8739ae039);

var $8sbs2 = parcelRequire("8sbs2");

var $b5RwB = parcelRequire("b5RwB");

var $k6LT0 = parcelRequire("k6LT0");

var $eBhI6 = parcelRequire("eBhI6");
const $65a1244f9bc08597$export$20e00d0048bb5104 = ()=>'/rest/agile/1.0/board';
const $65a1244f9bc08597$export$920c4ae61fe06896 = (filter)=>({
        name: filter.text || undefined
    });
const $65a1244f9bc08597$var$createProjectFilter = (filter)=>({
        projectLocation: filter.project ? filter.project.value : undefined
    });
const $65a1244f9bc08597$var$createUserFilter = (filter)=>({
        accountIdLocation: filter.user ? filter.user.accountId : undefined
    });
const $65a1244f9bc08597$export$7138c24907de3954 = (request, filter, includePrivate)=>{
    const queryParams = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($8sbs2)))(request, 'startAt', 'maxResults', 'orderBy', 'expand'),
        ...filter.text ? $65a1244f9bc08597$export$920c4ae61fe06896(filter) : undefined,
        ...filter.project ? $65a1244f9bc08597$var$createProjectFilter(filter) : undefined,
        ...filter.user ? $65a1244f9bc08597$var$createUserFilter(filter) : undefined,
        includePrivate: includePrivate,
        overrideFilterPermissions: true
    };
    return `${$65a1244f9bc08597$export$20e00d0048bb5104()}?${(0, $b5RwB.stringify)(queryParams)}`;
};
const $65a1244f9bc08597$var$getDashboards = async (request, filter, includePrivate)=>{
    const url = $65a1244f9bc08597$export$7138c24907de3954(request, filter, includePrivate);
    const response = await fetch(url, (0, $eBhI6.getDefaultOptions)(url));
    if (response.ok) return response.json();
    throw await (0, $k6LT0.getErrorFromResponse)(response, 'Cannot fetch boards');
};
var $65a1244f9bc08597$export$2e2bcd8739ae039 = $65a1244f9bc08597$var$getDashboards;

});
parcelRegister("k6LT0", function(module, exports) {
$parcel$export(module.exports, "getErrorFromResponse", () => $79c4b7796896939e$export$7780d7826aafbede);

var $14RSn = parcelRequire("14RSn");

var $3ugTQ = parcelRequire("3ugTQ");
const $79c4b7796896939e$export$7780d7826aafbede = async (response, defaultMessage)=>{
    let errorMessage = defaultMessage;
    try {
        const json = await response.json();
        const { errors: errors, errorMessages: errorMessages } = json;
        if (errors && Object.keys(errors).length) return (0, $3ugTQ.transformValidationErrorFromServer)(json);
        errorMessage = errorMessages[0];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /**/ }
    return new (0, $14RSn.default)(response.status, errorMessage);
};

});


parcelRegister("6p2KZ", function(module, exports) {
$parcel$export(module.exports, "transformBoards", () => $a45223e7ebeb1eba$export$ff748067a3618e48);

var $9g7yh = parcelRequire("9g7yh");

var $huH03 = parcelRequire("huH03");

var $cf2JP = parcelRequire("cf2JP");
const $a45223e7ebeb1eba$export$ff748067a3618e48 = (boards, total)=>{
    const order = boards.map((i)=>`${i.id}`);
    const responsesById = (0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(boards, (board)=>board.id);
    const page = (0, (/*@__PURE__*/$parcel$interopDefault($huH03)))(responsesById, (response)=>(0, $cf2JP.transformBoard)(response));
    return {
        page: page,
        order: order,
        total: total
    };
};

});
parcelRegister("9g7yh", function(module, exports) {

var $iBJlb = parcelRequire("iBJlb");

var $a9KaZ = parcelRequire("a9KaZ");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var $6bdb775087644ec3$var$keyBy = $a9KaZ(function(result, value, key) {
    $iBJlb(result, key, value);
});
module.exports = $6bdb775087644ec3$var$keyBy;

});

parcelRegister("cf2JP", function(module, exports) {
$parcel$export(module.exports, "transformBoard", () => $e1de489eab805762$export$1a6be520942a4bdd);

var $5DL51 = parcelRequire("5DL51");
const $e1de489eab805762$var$transformAdmins = (item)=>({
        users: item.users.map((user)=>(0, $5DL51.transformUser)(user)),
        groups: item.groups.map(({ name: name })=>({
                name: name
            }))
    });
const $e1de489eab805762$export$c8b75494f8074e15 = (item)=>// @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
    item.projectKey ? {
        displayName: item.displayName,
        avatarURI: item.avatarURI,
        // @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
        projectKey: item.projectKey,
        type: 'project'
    } : {
        displayName: item.displayName,
        avatarURI: item.avatarURI,
        // @ts-expect-error - TS2339 - Property 'userAccountId' does not exist on type 'Location'. | TS2339 - Property 'userAccountId' does not exist on type 'Location'.
        userAccountId: item.userAccountId != null ? item.userAccountId : '',
        type: 'user'
    };
const $e1de489eab805762$var$transformPrivateBoard = (item)=>({
        id: `${item.id}`,
        isPrivate: true,
        admins: $e1de489eab805762$var$transformAdmins(item.admins),
        canEdit: item.canEdit,
        location: item.location && $e1de489eab805762$export$c8b75494f8074e15(item.location)
    });
const $e1de489eab805762$var$transformPublicBoard = (item)=>({
        id: `${item.id}`,
        name: item.name,
        type: item.type,
        favourite: item.favourite,
        admins: $e1de489eab805762$var$transformAdmins(item.admins),
        canEdit: item.canEdit,
        location: item.location && $e1de489eab805762$export$c8b75494f8074e15(item.location)
    });
const $e1de489eab805762$export$1a6be520942a4bdd = (item)=>// @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PrivateBoard'. | TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
    item.isPrivate ? $e1de489eab805762$var$transformPrivateBoard(item) : $e1de489eab805762$var$transformPublicBoard(item);

});
parcelRegister("5DL51", function(module, exports) {
$parcel$export(module.exports, "transformUser", () => $6e6cbad6f60e414e$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformSharePermission", () => $6e6cbad6f60e414e$export$443a799045209d52);
$parcel$export(module.exports, "transformSharePermissionsToServer", () => $6e6cbad6f60e414e$export$e05899da868da914);


var $a62R3 = parcelRequire("a62R3");

var $4cTDP = parcelRequire("4cTDP");

const $6e6cbad6f60e414e$var$assertUnreachable = (_x)=>{
    throw new Error("Didn't expect to get here");
};
const $6e6cbad6f60e414e$export$88dcd5c1adae8021 = (user)=>{
    let profileUrl;
    if ((0, $4cTDP.fg)('jira-adopt-teams-nav-config')) {
        const { href: href } = (0, $a62R3.getNavigateToTeamsApp)({
            type: 'USER',
            payload: {
                userId: user.accountId
            }
        });
        profileUrl = href;
    } else profileUrl = `/jira/people/${user.accountId}`;
    return {
        displayName: user.displayName,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48'],
        accountId: user.accountId,
        profileUrl: profileUrl
    };
};
const $6e6cbad6f60e414e$export$443a799045209d52 = (sharePermission)=>{
    switch(sharePermission.type){
        case 0, $6f7399fe14fedc2b$export$86517eb0163ef745:
            return {
                type: (0, $6f7399fe14fedc2b$export$86517eb0163ef745)
            };
        case 0, $6f7399fe14fedc2b$export$b0a0e62d9b1a8269:
            return {
                type: (0, $6f7399fe14fedc2b$export$b0a0e62d9b1a8269)
            };
        case 0, $6f7399fe14fedc2b$export$b02d7412182d1bce:
            return {
                type: (0, $6f7399fe14fedc2b$export$b02d7412182d1bce),
                group: {
                    ...sharePermission.group
                }
            };
        case 0, $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6:
            {
                const { project: project, role: role } = sharePermission;
                return {
                    type: (0, $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6),
                    project: {
                        id: project.id,
                        name: project.name,
                        avatarUrl: project.avatarUrls['48x48']
                    },
                    role: role && {
                        id: role.id,
                        name: role.name
                    }
                };
            }
        case 0, $6f7399fe14fedc2b$export$487da0972e3459fe:
            return sharePermission;
        case 0, $6f7399fe14fedc2b$export$aea0835048e1c730:
            {
                const { user: user } = sharePermission;
                return {
                    type: (0, $6f7399fe14fedc2b$export$aea0835048e1c730),
                    user: {
                        accountId: user.accountId,
                        displayName: user.displayName,
                        avatarUrl: user.avatarUrls['48x48']
                    }
                };
            }
        default:
            $6e6cbad6f60e414e$var$assertUnreachable(sharePermission);
            return null;
    }
};
const $6e6cbad6f60e414e$export$e05899da868da914 = (sharePermissions, shouldReturnGroupIdForGroupIfAvailable = false)=>sharePermissions.map((sharePermission)=>{
        switch(sharePermission.type){
            case 0, $6f7399fe14fedc2b$export$b02d7412182d1bce:
                {
                    let group = {
                        name: sharePermission.group.name
                    };
                    if (shouldReturnGroupIdForGroupIfAvailable && sharePermission.group.groupId) group = {
                        groupId: sharePermission.group.groupId
                    };
                    return {
                        type: sharePermission.type,
                        group: group
                    };
                }
            case 0, $6f7399fe14fedc2b$export$aea0835048e1c730:
                return {
                    type: sharePermission.type,
                    user: {
                        accountId: sharePermission.user.accountId
                    }
                };
            case 0, $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6:
                {
                    const permission = {
                        type: sharePermission.role ? (0, $72721d8cb7d8a0db$export$4d955b5fb0c1d4d7) : (0, $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6),
                        project: {
                            id: sharePermission.project.id
                        }
                    };
                    if (sharePermission.role) permission.role = {
                        id: sharePermission.role.id
                    };
                    return permission;
                }
            case 0, $6f7399fe14fedc2b$export$487da0972e3459fe:
                return sharePermission;
            case 0, $6f7399fe14fedc2b$export$b0a0e62d9b1a8269:
                return {
                    type: (0, $72721d8cb7d8a0db$export$e2fe9963c33d5918)
                };
            case 0, $6f7399fe14fedc2b$export$86517eb0163ef745:
                return sharePermission;
            default:
                $6e6cbad6f60e414e$var$assertUnreachable(sharePermission);
                return sharePermission;
        }
    });

});
const $6f7399fe14fedc2b$export$b02d7412182d1bce = 'group';
const $6f7399fe14fedc2b$export$5ef95a67b8fd1ff6 = 'project';
const $6f7399fe14fedc2b$export$487da0972e3459fe = 'project-unknown';
const $6f7399fe14fedc2b$export$b0a0e62d9b1a8269 = 'loggedin';
const $6f7399fe14fedc2b$export$86517eb0163ef745 = 'global';
const $6f7399fe14fedc2b$export$aea0835048e1c730 = 'user';
 // this is what can come from backend

const $72721d8cb7d8a0db$export$e2fe9963c33d5918 = 'authenticated';
const $72721d8cb7d8a0db$export$4d955b5fb0c1d4d7 = 'projectRole';





parcelRegister("emPjh", function(module, exports) {
$parcel$export(module.exports, "RETRIEVE", () => $9a51b3b68f87e542$export$7bf2c28a4e08c796);
$parcel$export(module.exports, "retrieve", () => $9a51b3b68f87e542$export$8a4d17b6e8486e66);
$parcel$export(module.exports, "RETRIEVED", () => $9a51b3b68f87e542$export$1a07e8ff5bab976c);
$parcel$export(module.exports, "retrieved", () => $9a51b3b68f87e542$export$4058166ec369dd8);
$parcel$export(module.exports, "RETRIEVE_FAILED", () => $9a51b3b68f87e542$export$26e5d507c83e3d5a);
$parcel$export(module.exports, "retrieveFailed", () => $9a51b3b68f87e542$export$1c9b9c3d8868d26f);
$parcel$export(module.exports, "PATCH", () => $9a51b3b68f87e542$export$54950d96c4d7b0);
$parcel$export(module.exports, "patch", () => $9a51b3b68f87e542$export$b76953f99ab2be78);
const $9a51b3b68f87e542$export$7bf2c28a4e08c796 = 'state.actions.boards.RETRIEVE';
const $9a51b3b68f87e542$export$8a4d17b6e8486e66 = ()=>({
        type: $9a51b3b68f87e542$export$7bf2c28a4e08c796
    });
const $9a51b3b68f87e542$export$1a07e8ff5bab976c = 'state.actions.boards.RETRIEVED';
const $9a51b3b68f87e542$export$4058166ec369dd8 = (payload)=>({
        type: $9a51b3b68f87e542$export$1a07e8ff5bab976c,
        payload: payload
    });
const $9a51b3b68f87e542$export$26e5d507c83e3d5a = 'state.actions.boards.RETRIEVE_FAILED';
const $9a51b3b68f87e542$export$1c9b9c3d8868d26f = ()=>({
        type: $9a51b3b68f87e542$export$26e5d507c83e3d5a
    });
const $9a51b3b68f87e542$export$54950d96c4d7b0 = 'state.actions.boards.PATCH';
const $9a51b3b68f87e542$export$b76953f99ab2be78 = (payload)=>({
        type: $9a51b3b68f87e542$export$54950d96c4d7b0,
        payload: payload
    });

});

parcelRegister("jL7iY", function(module, exports) {
$parcel$export(module.exports, "getServiceRequest", () => $c8cf4e1b973e9218$export$d7889f7cae5c51ff);

var $g6mse = parcelRequire("g6mse");

var $dgHVV = parcelRequire("dgHVV");

var $aETW1 = parcelRequire("aETW1");

var $hW5yn = parcelRequire("hW5yn");
const $c8cf4e1b973e9218$var$SORT_FIELDS = {
    [(0, $aETW1.NAME)]: 'NAME'
};
const $c8cf4e1b973e9218$var$getSort = (state)=>({
        direction: (0, $hW5yn.getSortDirection)(state),
        field: $c8cf4e1b973e9218$var$SORT_FIELDS[(0, $hW5yn.getSortField)(state)]
    });
const $c8cf4e1b973e9218$export$d7889f7cae5c51ff = (state)=>(0, $g6mse.createPageRequest)((0, $hW5yn.getPage)(state), (0, $dgHVV.ITEMS_PER_PAGE), $c8cf4e1b973e9218$var$getSort(state), (0, $dgHVV.EXPAND_PARAMETERS));

});
parcelRegister("g6mse", function(module, exports) {
$parcel$export(module.exports, "createPageRequest", () => $b7650b03bb8c63eb$export$6c268d1798324d1);
const $b7650b03bb8c63eb$export$a2b44ae778ac3391 = (startAt, maxResults, order, expand)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    return pageRequest;
};
const $b7650b03bb8c63eb$export$2db35c6ee4729a76 = (startAt, maxResults, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>{
    const pageRequest = {
        maxResults: maxResults,
        startAt: startAt
    };
    if (order) {
        const orderString = `${order.direction === 'ASC' ? '+' : '-'}${order.field}`;
        pageRequest.orderBy = orderString;
    }
    if (expand && expand.length) pageRequest.expand = expand.join(',');
    if (searchBy && searchBy.length) pageRequest.searchBy = searchBy.join(',');
    return pageRequest;
};
const $b7650b03bb8c63eb$export$6c268d1798324d1 = (page, itemsPerPage, order, expand)=>$b7650b03bb8c63eb$export$a2b44ae778ac3391(itemsPerPage * (page - 1), itemsPerPage, order, expand);
const $b7650b03bb8c63eb$export$98ffd4f2a2fa32d7 = (page, itemsPerPage, order, expand, // @ts-expect-error - TS1016 - A required parameter cannot follow an optional parameter.
searchBy)=>$b7650b03bb8c63eb$export$2db35c6ee4729a76(itemsPerPage * (page - 1), itemsPerPage, order, expand, searchBy);

});




parcelRegister("bRtgQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $69da14d724bbb243$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $gvjd6 = parcelRequire("gvjd6");
const $69da14d724bbb243$var$createStore = (rootEpic, initialState)=>(0, $gs6vs.default)({
        initialState: initialState,
        appName: 'directories/boards-v2',
        rootReducer: $gvjd6.default,
        rootEpic: rootEpic
    });
var $69da14d724bbb243$export$2e2bcd8739ae039 = $69da14d724bbb243$var$createStore;

});
parcelRegister("gvjd6", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc8a7989649a26d8$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $26vkm = parcelRequire("26vkm");

var $3tt76 = parcelRequire("3tt76");

var $1h7tI = parcelRequire("1h7tI");
var $fc8a7989649a26d8$export$2e2bcd8739ae039 = (0, $7HHI1.combineReducers)({
    app: $26vkm.default,
    boards: $3tt76.default,
    query: $1h7tI.default
});

});
parcelRegister("26vkm", function(module, exports) {
$parcel$export(module.exports, "default", () => $4261c6e217343a68$export$2e2bcd8739ae039);

var $jFHCE = parcelRequire("jFHCE");

var $1AuA5 = parcelRequire("1AuA5");
const $4261c6e217343a68$export$d4c72bab9d6cc13a = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
};
const $4261c6e217343a68$var$app = (state = $4261c6e217343a68$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $1AuA5.SET_APP_PROPS:
            return {
                ...state,
                props: (0, (/*@__PURE__*/$parcel$interopDefault($jFHCE)))(action.payload, 'query')
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};
var $4261c6e217343a68$export$2e2bcd8739ae039 = $4261c6e217343a68$var$app;

});

parcelRegister("3tt76", function(module, exports) {
$parcel$export(module.exports, "default", () => $79e385885c950827$export$2e2bcd8739ae039);

var $emPjh = parcelRequire("emPjh");
const $79e385885c950827$export$d4c72bab9d6cc13a = {
    page: {},
    order: [],
    total: 0,
    isLoading: true,
    isError: false
};
const $79e385885c950827$var$boards = (state = $79e385885c950827$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $emPjh.RETRIEVE:
            return {
                ...state,
                isLoading: true
            };
        case 0, $emPjh.RETRIEVED:
            return {
                ...state,
                ...action.payload,
                isLoading: false,
                isError: false
            };
        case 0, $emPjh.RETRIEVE_FAILED:
            return {
                ...state,
                isLoading: false,
                isError: true
            };
        case 0, $emPjh.PATCH:
            return {
                ...state,
                // @ts-expect-error - 2345 - Type 'undefined' is not assignable to type 'string'
                page: {
                    ...state.page,
                    [action.payload.id]: {
                        ...state.page[action.payload.id],
                        ...action.payload.patch
                    }
                }
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $79e385885c950827$export$2e2bcd8739ae039 = $79e385885c950827$var$boards;

});

parcelRegister("1h7tI", function(module, exports) {
$parcel$export(module.exports, "default", () => $34914e1faa6db483$export$2e2bcd8739ae039);

var $dgHVV = parcelRequire("dgHVV");

var $7YHJF = parcelRequire("7YHJF");
const $34914e1faa6db483$export$d4c72bab9d6cc13a = (0, $dgHVV.initialQuery);
const $34914e1faa6db483$var$query = (state = $34914e1faa6db483$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $7YHJF.SET_QUERY:
            return action.payload;
        case 0, $7YHJF.PATCH_QUERY:
            return {
                ...state,
                ...action.payload
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $34914e1faa6db483$export$2e2bcd8739ae039 = $34914e1faa6db483$var$query;

});



parcelRegister("5SwWv", function(module, exports) {
$parcel$export(module.exports, "default", () => $240474f90a551ac6$export$2e2bcd8739ae039);

var $3PAYT = parcelRequire("3PAYT");

var $gnQAk = parcelRequire("gnQAk");

var $dgHVV = parcelRequire("dgHVV");

var $1AuA5 = parcelRequire("1AuA5");

var $emPjh = parcelRequire("emPjh");

var $7YHJF = parcelRequire("7YHJF");

var $7FCY1 = parcelRequire("7FCY1");

var $hW5yn = parcelRequire("hW5yn");

var $jn00M = parcelRequire("jn00M");

var $fSjPj = parcelRequire("fSjPj");

var $a625R = parcelRequire("a625R");

var $lh78g = parcelRequire("lh78g");
const $240474f90a551ac6$var$mapStateToProps = (state)=>({
        // data
        entityIds: (0, $7FCY1.getIds)(state),
        totalItems: (0, $7FCY1.getTotal)(state),
        itemsPerPage: (0, $dgHVV.ITEMS_PER_PAGE),
        isLoading: (0, $7FCY1.isLoading)(state),
        isError: (0, $7FCY1.isError)(state),
        page: (0, $hW5yn.getPage)(state),
        sortField: (0, $hW5yn.getSortField)(state),
        sortDirection: (0, $hW5yn.getSortDirection)(state),
        filter: (0, $hW5yn.isFilterApplied)(state) ? (0, $hW5yn.getFilter)(state) : undefined,
        // ui
        firstColumnHeadingAlignment: 'center',
        FilterView: // views
        $a625R.default,
        tableConfiguration: (0, $lh78g.getTableConfiguration)(state),
        tableLabel: (0, $lh78g.getTableLabel)(),
        resultsAnnouncerMessage: (0, $lh78g.getResultsAnnouncerMessage)(),
        emptyFilterResultConfiguration: $lh78g.emptyFilterResultConfiguration,
        operationModals: $lh78g.operationModals,
        EmptyView: $jn00M.default,
        ErrorView: $fSjPj.default
    });
const $240474f90a551ac6$var$mapDispatchToProps = (dispatch)=>({
        // @ts-expect-error - TS7031 - Binding element 'id' implicitly has an 'any' type. | TS7031 - Binding element 'patch' implicitly has an 'any' type.
        onPatch: ({ id: id, patch: patch })=>dispatch((0, $emPjh.patch)({
                id: id,
                patch: patch
            })),
        onReload: (query)=>{
            dispatch((0, $7YHJF.patchQuery)(query));
            dispatch((0, $emPjh.retrieve)());
        },
        onFirstRender: ()=>dispatch((0, $1AuA5.ready)())
    });
var // @ts-expect-error - TS2345 - Argument of type 'typeof Directory' is not assignable to parameter of type 'Component<{ entityIds: string[]; totalItems: number; itemsPerPage: number; isLoading: boolean; isError: boolean; page: number; sortField: "name"; sortDirection: SortDirection; filter: Filter | undefined; ... 7 more ...; ErrorView: ComponentClass<...> & { ...; }; } & { ...; }>'.
$240474f90a551ac6$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($240474f90a551ac6$var$mapStateToProps, $240474f90a551ac6$var$mapDispatchToProps)((0, $3PAYT.default));

});
parcelRegister("3PAYT", function(module, exports) {
$parcel$export(module.exports, "default", () => $53c8e3e55d4aeb5e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $eSnSE = parcelRequire("eSnSE");

var $cH6Qf = parcelRequire("cH6Qf");

var $5HL8i = parcelRequire("5HL8i");

var $91zZ6 = parcelRequire("91zZ6");

var $f5HHa = parcelRequire("f5HHa");

var $llsfE = parcelRequire("llsfE");

var $jZqH9 = parcelRequire("jZqH9");

var $9UtD0 = parcelRequire("9UtD0");

const $53c8e3e55d4aeb5e$var$defaultEntityIds = [];
class $53c8e3e55d4aeb5e$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isOnboardingEnabled: false,
            headerConfiguration: undefined,
            FilterView: undefined,
            TableMaskView: undefined,
            CreateModal: undefined,
            metrics: {
                tableMounted: undefined
            },
            entityIds: $53c8e3e55d4aeb5e$var$defaultEntityIds,
            dataProvider: undefined,
            renderOnboardingSpotlight: ()=>null,
            tableLabel: undefined,
            onboardingSpotlightTargets: [],
            onFirstRender: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        if (props.entityIds !== $53c8e3e55d4aeb5e$var$defaultEntityIds && props.dataProvider) (0, $eSnSE.default).safeErrorWithoutCustomerData('directory.base', 'Please provide only one of props: [entityIds] or [dataProvider], dataProvider will be used');
        this.store = (0, $jZqH9.default)((0, $f5HHa.default));
        this.store.dispatch((0, $llsfE.setAppProps)(props));
    }
    componentDidUpdate() {
        this.store.dispatch((0, $llsfE.setAppProps)(this.props));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $91zZ6.Provider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5HL8i.default), {
            onFirstMount: this.props.onFirstRender
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9UtD0.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cH6Qf.SpaStatePageReady), null)));
    }
}

});
parcelRegister("5HL8i", function(module, exports) {
$parcel$export(module.exports, "default", () => $651368c8da8f3dac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5yd4l = parcelRequire("5yd4l");
class $651368c8da8f3dac$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    render() {
        const { children: children } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5yd4l.default).Provider, {
            value: {
                reportMount: this.onSubtreeMount
            }
        }, children);
    }
    constructor(...args){
        super(...args), this.onSubtreeMount = ()=>{
            if (!this.hasAnyMounted) {
                this.hasAnyMounted = true;
                this.props.onFirstMount();
            }
        }, this.hasAnyMounted = false;
    }
}

});
parcelRegister("5yd4l", function(module, exports) {
$parcel$export(module.exports, "default", () => $702adc31848c45b7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");
var $702adc31848c45b7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.createContext)({
    reportMount: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
});

});


parcelRegister("91zZ6", function(module, exports) {
$parcel$export(module.exports, "useDirectoryDispatch", () => $8f86e69c8ed7499f$export$98942df89ffbd315);
$parcel$export(module.exports, "storeOptions", () => $8f86e69c8ed7499f$export$12cf63d9f5bd0793);
$parcel$export(module.exports, "Provider", () => $8f86e69c8ed7499f$export$2881499e37b75b9a);
$parcel$export(module.exports, "connect", () => $8f86e69c8ed7499f$export$64605811ab45167f);

var $eJOHy = parcelRequire("eJOHy");

var $dyOHn = parcelRequire("dyOHn");

var $gnQAk = parcelRequire("gnQAk");
const $8f86e69c8ed7499f$var$STORE_KEY = 'project-directories.directory.story';
const $8f86e69c8ed7499f$export$d03cc44e35038f93 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);
const $8f86e69c8ed7499f$export$98942df89ffbd315 = (0, $dyOHn.createDispatchHook)($8f86e69c8ed7499f$export$d03cc44e35038f93);
const $8f86e69c8ed7499f$export$12cf63d9f5bd0793 = {
    storeKey: $8f86e69c8ed7499f$var$STORE_KEY,
    context: $8f86e69c8ed7499f$export$d03cc44e35038f93
};
const $8f86e69c8ed7499f$export$2881499e37b75b9a = (0, $gnQAk.createProvider)($8f86e69c8ed7499f$export$d03cc44e35038f93);
const $8f86e69c8ed7499f$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = Object.freeze({}))=>(0, $gnQAk.connect)(mapStateToProps, mapDispatchToProps, mergeProps, {
        ...options,
        context: $8f86e69c8ed7499f$export$d03cc44e35038f93,
        storeKey: $8f86e69c8ed7499f$var$STORE_KEY
    });

});

parcelRegister("f5HHa", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c081aa275619817$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $hTgaW = parcelRequire("hTgaW");

var $kobzH = parcelRequire("kobzH");
var $2c081aa275619817$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $hTgaW.default), (0, $kobzH.default));

});
parcelRegister("hTgaW", function(module, exports) {
$parcel$export(module.exports, "default", () => $8af2749c3fdf06e7$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");
// flow can't deal with the generics here
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8af2749c3fdf06e7$var$entityCreated = (action$, store)=>action$.ofType((0, $4wOQJ.ENTITY_CREATED)).mergeMap(()=>{
        const state = store.getState();
        const page = (0, $6SY0Q.getPage)(state);
        (0, $6SY0Q.getOnReload)(state)({
            page: page
        });
        return (0, $7kixv.Observable).empty();
    });
var $8af2749c3fdf06e7$export$2e2bcd8739ae039 = $8af2749c3fdf06e7$var$entityCreated;

});
parcelRegister("4wOQJ", function(module, exports) {
$parcel$export(module.exports, "INITIATE", () => $465651927b7e774a$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $465651927b7e774a$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_CREATED", () => $465651927b7e774a$export$61bc72c2b62d14ed);
$parcel$export(module.exports, "entityCreated", () => $465651927b7e774a$export$5e2c0a0dc191dd3e);
$parcel$export(module.exports, "ENTITY_CREATE_FAILED", () => $465651927b7e774a$export$ac0dd97afb285388);
$parcel$export(module.exports, "entityCreateFailed", () => $465651927b7e774a$export$b71626a5d7099742);
$parcel$export(module.exports, "CANCELLED", () => $465651927b7e774a$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $465651927b7e774a$export$b108ea1063c657e3);
const $465651927b7e774a$export$643daa42aa3148d5 = 'state.actions.create.INITIATE';
const $465651927b7e774a$export$b14c4413e822aa8d = ()=>({
        type: $465651927b7e774a$export$643daa42aa3148d5
    });
const $465651927b7e774a$export$61bc72c2b62d14ed = 'state.actions.create.ENTITY_CREATED';
const $465651927b7e774a$export$5e2c0a0dc191dd3e = (payload)=>({
        type: $465651927b7e774a$export$61bc72c2b62d14ed,
        payload: payload
    });
const $465651927b7e774a$export$ac0dd97afb285388 = 'state.actions.create.ENTITY_CREATE_FAILED';
const $465651927b7e774a$export$b71626a5d7099742 = (payload)=>({
        type: $465651927b7e774a$export$ac0dd97afb285388,
        payload: payload
    });
const $465651927b7e774a$export$6b4658081fcf1aed = 'state.actions.create.CANCELLED';
const $465651927b7e774a$export$b108ea1063c657e3 = ()=>({
        type: $465651927b7e774a$export$6b4658081fcf1aed
    });

});

parcelRegister("6SY0Q", function(module, exports) {
$parcel$export(module.exports, "getEntityIds", () => $e7e252b338858314$export$1fe43832be7d1fcb);
$parcel$export(module.exports, "getDataProvider", () => $e7e252b338858314$export$add6bf8e4261fead);
$parcel$export(module.exports, "getTotalItems", () => $e7e252b338858314$export$cbc4bdd6c02fac4d);
$parcel$export(module.exports, "getPage", () => $e7e252b338858314$export$c2a6433281518c91);
$parcel$export(module.exports, "getItemsPerPage", () => $e7e252b338858314$export$347447940701b338);
$parcel$export(module.exports, "getSortField", () => $e7e252b338858314$export$9b753af5a9fb5911);
$parcel$export(module.exports, "getSortDirection", () => $e7e252b338858314$export$509e2b9937961873);
$parcel$export(module.exports, "getFilter", () => $e7e252b338858314$export$61ec8404f465cd36);
$parcel$export(module.exports, "getHeaderConfiguration", () => $e7e252b338858314$export$60b0ef02721854ed);
$parcel$export(module.exports, "getFilterView", () => $e7e252b338858314$export$4a62b01f13af161e);
$parcel$export(module.exports, "getTableConfiguration", () => $e7e252b338858314$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $e7e252b338858314$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $e7e252b338858314$export$64df75861e57fb7f);
$parcel$export(module.exports, "getEmptyView", () => $e7e252b338858314$export$6ad7beec028137c);
$parcel$export(module.exports, "getErrorView", () => $e7e252b338858314$export$67942d5525c28c28);
$parcel$export(module.exports, "getEmptyFilterResultConfiguration", () => $e7e252b338858314$export$dae3c68be4c9569d);
$parcel$export(module.exports, "getTableMaskView", () => $e7e252b338858314$export$7a35128187f8245c);
$parcel$export(module.exports, "getCreateModal", () => $e7e252b338858314$export$be5bc82ccf7ca5ca);
$parcel$export(module.exports, "getOperationModal", () => $e7e252b338858314$export$3f5ae3b2bfec9457);
$parcel$export(module.exports, "getOnReload", () => $e7e252b338858314$export$7158eb69f7a0b59);
$parcel$export(module.exports, "getOnPatch", () => $e7e252b338858314$export$944f52419ab8e737);
$parcel$export(module.exports, "isLoading", () => $e7e252b338858314$export$20bb0d907fbbe433);
$parcel$export(module.exports, "isError", () => $e7e252b338858314$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "getTotalPages", () => $e7e252b338858314$export$652b307566494a6);
$parcel$export(module.exports, "getFirstColumnHeadingAlignment", () => $e7e252b338858314$export$22b039be773dbf63);
$parcel$export(module.exports, "getLastColumnHeadingAlignment", () => $e7e252b338858314$export$affaf5a34a669e16);
$parcel$export(module.exports, "isCreateOpen", () => $e7e252b338858314$export$996a71275221ab9e);
$parcel$export(module.exports, "getOperations", () => $e7e252b338858314$export$acc17f62bededcaf);
$parcel$export(module.exports, "getOperationInitializationStatusPerEntity", () => $e7e252b338858314$export$69a0d9b5be75b55d);
$parcel$export(module.exports, "getIsOnboardingEnabled", () => $e7e252b338858314$export$65890ce3309e3ccf);
$parcel$export(module.exports, "getRenderOnboardingSpotlight", () => $e7e252b338858314$export$98db60f26810390);
$parcel$export(module.exports, "getSpotlightForCell", () => $e7e252b338858314$export$1faee8e10b588885);
$parcel$export(module.exports, "getAvailableSpotlightTargets", () => $e7e252b338858314$export$7eda79d5ce9a0b8b);

var $ahm5r = parcelRequire("ahm5r");

var $9g7yh = parcelRequire("9g7yh");

var $huH03 = parcelRequire("huH03");

var $2CrAx = parcelRequire("2CrAx");
const $e7e252b338858314$export$876089ea65adc54 = (state)=>state.app.props;
const $e7e252b338858314$export$1fe43832be7d1fcb = (state)=>state.app.props.entityIds;
const $e7e252b338858314$export$add6bf8e4261fead = (state)=>state.app.props.dataProvider || undefined;
const $e7e252b338858314$export$cbc4bdd6c02fac4d = (state)=>state.app.props.totalItems;
const $e7e252b338858314$export$c2a6433281518c91 = (state)=>state.app.props.page;
const $e7e252b338858314$export$347447940701b338 = (state)=>state.app.props.itemsPerPage;
const $e7e252b338858314$export$9b753af5a9fb5911 = (state)=>state.app.props.sortField;
const $e7e252b338858314$export$509e2b9937961873 = (state)=>state.app.props.sortDirection;
const $e7e252b338858314$export$61ec8404f465cd36 = (state)=>state.app.props.filter;
const $e7e252b338858314$export$60b0ef02721854ed = (state)=>state.app.props.headerConfiguration;
const $e7e252b338858314$export$4a62b01f13af161e = (state)=>state.app.props.FilterView;
const $e7e252b338858314$export$6847365bea1c5392 = (state)=>state.app.props.tableConfiguration;
const $e7e252b338858314$export$b2d196af18e06ad6 = (state)=>state.app.props.tableLabel;
const $e7e252b338858314$export$64df75861e57fb7f = (state)=>state.app.props.resultsAnnouncerMessage;
const $e7e252b338858314$export$6ad7beec028137c = (state)=>state.app.props.EmptyView;
const $e7e252b338858314$export$67942d5525c28c28 = (state)=>state.app.props.ErrorView;
const $e7e252b338858314$export$dae3c68be4c9569d = (state)=>state.app.props.emptyFilterResultConfiguration;
const $e7e252b338858314$export$7a35128187f8245c = (state)=>state.app.props.TableMaskView;
const $e7e252b338858314$export$be5bc82ccf7ca5ca = (state)=>state.app.props.CreateModal;
const $e7e252b338858314$export$3f5ae3b2bfec9457 = (state, operation)=>state.app.props.operationModals[operation];
const $e7e252b338858314$export$7158eb69f7a0b59 = (state)=>state.app.props.onReload;
const $e7e252b338858314$export$944f52419ab8e737 = (state)=>state.app.props.onPatch;
const $e7e252b338858314$export$20bb0d907fbbe433 = (state)=>state.app.props.isLoading;
const $e7e252b338858314$export$e6127cc7fe7395c3 = (state)=>state.app.props.isError;
const $e7e252b338858314$var$getTotalPagesInternal = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
$e7e252b338858314$export$cbc4bdd6c02fac4d, $e7e252b338858314$export$347447940701b338, (totalItems, itemsOnPage)=>(0, $2CrAx.calculateTotalPages)(totalItems, itemsOnPage));
const $e7e252b338858314$export$652b307566494a6 = (state)=>$e7e252b338858314$var$getTotalPagesInternal(state);
const $e7e252b338858314$export$22b039be773dbf63 = (state)=>state.app.props.firstColumnHeadingAlignment;
const $e7e252b338858314$export$affaf5a34a669e16 = (state)=>state.app.props.lastColumnHeadingAlignment;
const $e7e252b338858314$export$996a71275221ab9e = (state)=>state.create.isOpen;
const $e7e252b338858314$export$acc17f62bededcaf = (state)=>state.operations;
const $e7e252b338858314$var$getOperationInitializationStatusPerEntityInternal = (0, $ahm5r.createSelector)(// @ts-expect-error - TS2571 - Object is of type 'unknown'.
(state)=>state.operations, (operations)=>(0, (/*@__PURE__*/$parcel$interopDefault($huH03)))((0, (/*@__PURE__*/$parcel$interopDefault($9g7yh)))(operations, ({ id: id })=>id), ({ isInitializing: isInitializing })=>isInitializing));
const $e7e252b338858314$export$69a0d9b5be75b55d = (state)=>$e7e252b338858314$var$getOperationInitializationStatusPerEntityInternal(state);
const $e7e252b338858314$export$65890ce3309e3ccf = (state)=>state.app.props.isOnboardingEnabled;
const $e7e252b338858314$export$ee9bc95b4b33fe7b = (state)=>state.app.props.onboardingSpotlightTargets;
const $e7e252b338858314$export$98db60f26810390 = (state)=>state.app.props.renderOnboardingSpotlight;
const $e7e252b338858314$export$1faee8e10b588885 = (state)=>(id, colIndex)=>$e7e252b338858314$export$ee9bc95b4b33fe7b(state).find((c)=>c.entityId === id && c.colIndex === colIndex);
const $e7e252b338858314$export$7eda79d5ce9a0b8b = (state)=>// @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'string[]'.
    (0, $ahm5r.createSelector)(// @ts-expect-error - TS2769 - No overload matches this call.
    $e7e252b338858314$export$6847365bea1c5392, $e7e252b338858314$export$add6bf8e4261fead, $e7e252b338858314$export$1fe43832be7d1fcb, $e7e252b338858314$export$1faee8e10b588885, (tableConfig, dataProvider, entitiesIds, getSpotlightCellTarget)=>{
        const availableSpotlightTargets = [];
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entitiesIds;
        if (ids && tableConfig) ids.forEach((entityId)=>{
            for(let i = 0; i < tableConfig.length; i += 1){
                const cellMatch = getSpotlightCellTarget(entityId, i);
                if (cellMatch && cellMatch.spotlightId) availableSpotlightTargets.push(entityId);
            }
        });
        return availableSpotlightTargets;
    })(state);

});


parcelRegister("kobzH", function(module, exports) {
$parcel$export(module.exports, "default", () => $4eb7e9d263f87a09$export$2e2bcd8739ae039);
parcelRequire("1AyD5");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $2CrAx = parcelRequire("2CrAx");


var $5cBQu = parcelRequire("5cBQu");

var $6SY0Q = parcelRequire("6SY0Q");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4eb7e9d263f87a09$var$entityUpdated = (action$, store)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    action$.ofType((0, $5cBQu.ENTITY_UPDATED)).mergeMap((action)=>{
        const { id: id, operation: operation, patch: patch } = action.payload;
        const state = store.getState();
        const currentPage = (0, $6SY0Q.getPage)(state);
        if (patch) {
            (0, $6SY0Q.getOnPatch)(state)({
                id: id,
                patch: patch
            }); // change page's state with a patch instead of reloading a table's page
            return (0, $7kixv.Observable).empty();
        }
        if (operation === (0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)) {
            const itemsPerPage = (0, $6SY0Q.getItemsPerPage)(state);
            const totalItems = (0, $6SY0Q.getTotalItems)(state);
            const predictedPage = (0, $2CrAx.predictPageToRequestAfterItemDeletion)(itemsPerPage, totalItems, currentPage);
            (0, $6SY0Q.getOnReload)(state)({
                page: predictedPage
            });
        } else (0, $6SY0Q.getOnReload)(state)({
            page: currentPage
        });
        return (0, $7kixv.Observable).empty();
    });
var $4eb7e9d263f87a09$export$2e2bcd8739ae039 = $4eb7e9d263f87a09$var$entityUpdated;

});
const $85bfce414eef38c7$export$250171a898bf7ef = 'EDIT';
const $85bfce414eef38c7$export$4bd2facc4a3e6aa1 = 'DELETE';
const $85bfce414eef38c7$export$257be95a51c84145 = 'DUPLICATE';
const $85bfce414eef38c7$export$a7c1ec142e70d69d = 'ARCHIVE';
const $85bfce414eef38c7$export$92f9e1ed9114d3a6 = 'COPY';
const $85bfce414eef38c7$export$346f08c1f0d0fe41 = 'MOVE';
const $85bfce414eef38c7$export$bbf2495ca7d54c9f = 'SHOW_DETAILS';
const $85bfce414eef38c7$export$39d2a7fb21967424 = 'CHANGE_OWNER';
const $85bfce414eef38c7$export$2b848a0670941e75 = 'TRASH';
const $85bfce414eef38c7$export$aeed50488a8a79d7 = 'RESTORE';

parcelRegister("5cBQu", function(module, exports) {
$parcel$export(module.exports, "INITIATE", () => $2081d7c120cf42cb$export$643daa42aa3148d5);
$parcel$export(module.exports, "initiate", () => $2081d7c120cf42cb$export$b14c4413e822aa8d);
$parcel$export(module.exports, "ENTITY_DATA_RETRIEVE_FAILED", () => $2081d7c120cf42cb$export$d5657bfeb6a06769);
$parcel$export(module.exports, "entityDataRetrieveFailed", () => $2081d7c120cf42cb$export$7771a5f3a1cb2756);
$parcel$export(module.exports, "DIALOG_SHOWN", () => $2081d7c120cf42cb$export$54e32bf20c0b405b);
$parcel$export(module.exports, "dialogShown", () => $2081d7c120cf42cb$export$7aca9ee5930fa3ea);
$parcel$export(module.exports, "ENTITY_UPDATED", () => $2081d7c120cf42cb$export$93e8e914b5b8b20d);
$parcel$export(module.exports, "entityUpdated", () => $2081d7c120cf42cb$export$c0932263cb70e08f);
$parcel$export(module.exports, "ENTITY_UPDATE_FAILED", () => $2081d7c120cf42cb$export$d2d41c22dcb7b1db);
$parcel$export(module.exports, "entityUpdateFailed", () => $2081d7c120cf42cb$export$fbb84be2ae83b4ed);
$parcel$export(module.exports, "CANCELLED", () => $2081d7c120cf42cb$export$6b4658081fcf1aed);
$parcel$export(module.exports, "cancelled", () => $2081d7c120cf42cb$export$b108ea1063c657e3);
// initiate
const $2081d7c120cf42cb$export$643daa42aa3148d5 = 'state.actions.operation.INITIATE';
const $2081d7c120cf42cb$export$b14c4413e822aa8d = (payload)=>({
        type: $2081d7c120cf42cb$export$643daa42aa3148d5,
        payload: payload
    });
const $2081d7c120cf42cb$export$d5657bfeb6a06769 = 'state.actions.operation.ENTITY_DATA_RETRIEVE_FAILED';
const $2081d7c120cf42cb$export$7771a5f3a1cb2756 = (payload)=>({
        type: $2081d7c120cf42cb$export$d5657bfeb6a06769,
        payload: payload
    });
const $2081d7c120cf42cb$export$54e32bf20c0b405b = 'state.actions.operation.DIALOG_SHOWN';
const $2081d7c120cf42cb$export$7aca9ee5930fa3ea = (payload)=>({
        type: $2081d7c120cf42cb$export$54e32bf20c0b405b,
        payload: payload
    });
const $2081d7c120cf42cb$export$93e8e914b5b8b20d = 'state.actions.operation.ENTITY_UPDATED';
const $2081d7c120cf42cb$export$c0932263cb70e08f = (payload)=>({
        type: $2081d7c120cf42cb$export$93e8e914b5b8b20d,
        payload: payload
    });
const $2081d7c120cf42cb$export$d2d41c22dcb7b1db = 'state.actions.operation.ENTITY_UPDATE_FAILED';
const $2081d7c120cf42cb$export$fbb84be2ae83b4ed = (payload)=>({
        type: $2081d7c120cf42cb$export$d2d41c22dcb7b1db,
        payload: payload
    });
const $2081d7c120cf42cb$export$6b4658081fcf1aed = 'state.actions.operation.CANCELLED';
const $2081d7c120cf42cb$export$b108ea1063c657e3 = (payload)=>({
        type: $2081d7c120cf42cb$export$6b4658081fcf1aed,
        payload: payload
    });

});



parcelRegister("llsfE", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $c40c7b4c0b8c00a8$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $c40c7b4c0b8c00a8$export$cfda7627848a58cd);
const $c40c7b4c0b8c00a8$export$8aefe701a6f431e0 = 'state.actions.app.SET_APP_PROPS';
const $c40c7b4c0b8c00a8$export$cfda7627848a58cd = (payload)=>({
        type: $c40c7b4c0b8c00a8$export$8aefe701a6f431e0,
        payload: payload
    });

});

parcelRegister("jZqH9", function(module, exports) {
$parcel$export(module.exports, "default", () => $c497e626334b193e$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $g7VIj = parcelRequire("g7VIj");
const $c497e626334b193e$var$createStore = (rootEpic)=>{
    // @ts-expect-error - TS2322 - Type 'Reducer<unknown>' is not assignable to type 'Reducer<TState>'.
    const fixedTypeRootReducer = (0, $g7VIj.default);
    // @ts-expect-error - TS2344 - Type 'TAction' does not satisfy the constraint '{ type: any; }'.
    return (0, $gs6vs.default)({
        appName: 'directory-base',
        rootReducer: fixedTypeRootReducer,
        rootEpic: rootEpic
    });
};
var $c497e626334b193e$export$2e2bcd8739ae039 = $c497e626334b193e$var$createStore;

});
parcelRegister("g7VIj", function(module, exports) {
$parcel$export(module.exports, "default", () => $3895fd1311d5eb92$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $hLCQ2 = parcelRequire("hLCQ2");

var $4YoOg = parcelRequire("4YoOg");

var $2ReZV = parcelRequire("2ReZV");
var $3895fd1311d5eb92$export$2e2bcd8739ae039 = (0, $7HHI1.combineReducers)({
    app: $hLCQ2.default,
    create: $4YoOg.default,
    operations: $2ReZV.default
});

});
parcelRegister("hLCQ2", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5feebf187192e75$export$2e2bcd8739ae039);

var $llsfE = parcelRequire("llsfE");
const $a5feebf187192e75$var$app = (state = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    props: undefined
}, action)=>{
    switch(action.type){
        case 0, $llsfE.SET_APP_PROPS:
            return {
                ...state,
                props: action.payload
            };
        default:
            {
                const _exhaustiveCheck = action.type;
                return state;
            }
    }
};
var $a5feebf187192e75$export$2e2bcd8739ae039 = $a5feebf187192e75$var$app;

});

parcelRegister("4YoOg", function(module, exports) {
$parcel$export(module.exports, "default", () => $de678fc2cad6993c$export$2e2bcd8739ae039);

var $4wOQJ = parcelRequire("4wOQJ");
const $de678fc2cad6993c$var$initialState = {
    isOpen: false
};
const $de678fc2cad6993c$var$create = (state = $de678fc2cad6993c$var$initialState, action)=>{
    switch(action.type){
        case 0, $4wOQJ.INITIATE:
            return {
                isOpen: true
            };
        case 0, $4wOQJ.ENTITY_CREATED:
        case 0, $4wOQJ.ENTITY_CREATE_FAILED:
        case 0, $4wOQJ.CANCELLED:
            return {
                isOpen: false
            };
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $de678fc2cad6993c$export$2e2bcd8739ae039 = $de678fc2cad6993c$var$create;

});

parcelRegister("2ReZV", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3ec6054d969c464$export$2e2bcd8739ae039);

var $5cBQu = parcelRequire("5cBQu");
const $d3ec6054d969c464$var$reducer = (state = [], action)=>{
    switch(action.type){
        case 0, $5cBQu.INITIATE:
            // adding new operation to array will render new <OperationModal>, showing new dialog/modal in UI
            return [
                ...state,
                {
                    ...action.payload,
                    isInitializing: true
                }
            ];
        case 0, $5cBQu.DIALOG_SHOWN:
            // change isInitializing from true to false
            return [
                ...state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation),
                {
                    ...action.payload,
                    isInitializing: false
                }
            ];
        case 0, $5cBQu.ENTITY_DATA_RETRIEVE_FAILED:
        case 0, $5cBQu.ENTITY_UPDATED:
        case 0, $5cBQu.ENTITY_UPDATE_FAILED:
        case 0, $5cBQu.CANCELLED:
            return state.filter(({ id: id, operation: operation })=>id !== action.payload.id || operation !== action.payload.operation);
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $d3ec6054d969c464$export$2e2bcd8739ae039 = $d3ec6054d969c464$var$reducer;

});



parcelRegister("9UtD0", function(module, exports) {
$parcel$export(module.exports, "default", () => $b32baacdda11dc59$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $adOqF = parcelRequire("adOqF");

var $54lJh = parcelRequire("54lJh");

var $dIYLk = parcelRequire("dIYLk");
var $b32baacdda11dc59$export$2e2bcd8739ae039 = (0, $gnQAk.connect)(()=>({
        Content: $adOqF.default,
        Modals: $54lJh.default
    }), null, null, (0, $91zZ6.storeOptions))((0, $dIYLk.default));

});
parcelRegister("adOqF", function(module, exports) {
$parcel$export(module.exports, "default", () => $eca44ecd751fd778$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $gnQAk = parcelRequire("gnQAk");

var $4MchI = parcelRequire("4MchI");

var $eS6Sp = parcelRequire("eS6Sp");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $6FHTv = parcelRequire("6FHTv");

var $jCVOe = parcelRequire("jCVOe");

var $1YsZU = parcelRequire("1YsZU");

var $lzizg = parcelRequire("lzizg");

var $5FTzj = parcelRequire("5FTzj");

var $bj0qr = parcelRequire("bj0qr");
const $eca44ecd751fd778$var$getEmptyViewSelectorMemoized = ()=>(0, $4MchI.createSelector)((state)=>(0, $eS6Sp.withMountReporting)((0, $6SY0Q.getEmptyView)(state)), (res)=>res);
const $eca44ecd751fd778$var$getErrorViewSelectorMemoized = ()=>(0, $4MchI.createSelector)((state)=>(0, $eS6Sp.withMountReporting)((0, $6SY0Q.getErrorView)(state)), (res)=>res);
const $eca44ecd751fd778$var$getAvailableSpotlightTargetsSelectorMemoized = ()=>(0, $4MchI.createSelector)((state)=>(0, $6SY0Q.getAvailableSpotlightTargets)(state), (res)=>res);
const $eca44ecd751fd778$var$mapStateToPropsFactory = ()=>{
    const getEmptyViewSelectorInstance = $eca44ecd751fd778$var$getEmptyViewSelectorMemoized();
    const getErrorViewSelectorInstance = $eca44ecd751fd778$var$getErrorViewSelectorMemoized();
    const getAvailableSpotlightTargetsSelectorInstance = $eca44ecd751fd778$var$getAvailableSpotlightTargetsSelectorMemoized();
    const onRetryFactory = (0, $LFmXM.default)((state)=>()=>(0, $6SY0Q.getOnReload)(state)({}));
    return (state)=>{
        let Header;
        const FilterView = (0, $6SY0Q.getFilterView)(state);
        if (FilterView) Header = (0, $6FHTv.default);
        else {
            const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
            if (headerConfiguration) {
                // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
                if (headerConfiguration.View) Header = (0, $1YsZU.default);
                else Header = (0, $jCVOe.default);
            }
        }
        return {
            Header: Header,
            Table: $5FTzj.default,
            Paginator: $lzizg.default,
            Empty: getEmptyViewSelectorInstance(state),
            Error: getErrorViewSelectorInstance(state),
            status: (0, $bt4Z6.getStatus)(state),
            onRetry: onRetryFactory(state),
            isOnboardingEnabled: (0, $6SY0Q.getIsOnboardingEnabled)(state),
            renderOnboardingSpotlight: (0, $6SY0Q.getRenderOnboardingSpotlight)(state),
            availableSpotlightTargets: getAvailableSpotlightTargetsSelectorInstance(state)
        };
    };
};
const $eca44ecd751fd778$var$mapDispatchToProps = {
    onAdd: (0, $4wOQJ.initiate)
};
var $eca44ecd751fd778$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($eca44ecd751fd778$var$mapStateToPropsFactory, $eca44ecd751fd778$var$mapDispatchToProps, null, (0, $91zZ6.storeOptions))((0, $bj0qr.default));

});
parcelRegister("eS6Sp", function(module, exports) {
$parcel$export(module.exports, "withMountReporting", () => $ef98fa099ffbdef1$export$95fa4b7a60ebef6);
$parcel$export(module.exports, "default", () => $ef98fa099ffbdef1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eK5AI = parcelRequire("eK5AI");

var $5yd4l = parcelRequire("5yd4l");
// eslint-disable-next-line jira/react/no-class-components
class $ef98fa099ffbdef1$var$Reporter extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            performanceMarkKey: undefined
        };
    }
    componentDidMount() {
        this.props.onMounted();
    }
    render() {
        const { performanceMarkKey: performanceMarkKey } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, performanceMarkKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eK5AI.default), {
            metricKey: performanceMarkKey
        }), this.props.children);
    }
}
function $ef98fa099ffbdef1$export$95fa4b7a60ebef6(Wrapped) {
    return (props)=>{
        const { performanceMarkKey: performanceMarkKey, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5yd4l.default).Consumer, null, ({ reportMount: reportMount })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ef98fa099ffbdef1$var$Reporter, {
                onMounted: reportMount,
                performanceMarkKey: performanceMarkKey
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Wrapped, rest)));
    };
}
const $ef98fa099ffbdef1$var$MountReporter = $ef98fa099ffbdef1$export$95fa4b7a60ebef6(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
var $ef98fa099ffbdef1$export$2e2bcd8739ae039 = $ef98fa099ffbdef1$var$MountReporter;

});

parcelRegister("bt4Z6", function(module, exports) {
$parcel$export(module.exports, "getStatus", () => $efad135e16b62051$export$b70265791d2079d4);

var $6SY0Q = parcelRequire("6SY0Q");
const $efad135e16b62051$export$b70265791d2079d4 = (state)=>{
    if ((0, $6SY0Q.isError)(state)) return 'error';
    if ((0, $6SY0Q.isLoading)(state)) return 'has-entities';
    const dataProvider = (0, $6SY0Q.getDataProvider)(state);
    const elementsCount = dataProvider ? dataProvider.getData().length : (0, $6SY0Q.getEntityIds)(state).length;
    return elementsCount === 0 && (0, $6SY0Q.getFilter)(state) === undefined && (0, $6SY0Q.getPage)(state) === 1 ? 'empty' : 'has-entities';
};

});

parcelRegister("6FHTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0574a56fae741f0$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $cXdYX = parcelRequire("cXdYX");
const $e0574a56fae741f0$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $LFmXM.default)((state)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>({
            FilterView: (0, $6SY0Q.getFilterView)(state),
            onFilter: onFilterFactory(state),
            hasEntities: (0, $bt4Z6.getStatus)(state) === 'has-entities'
        });
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type '<T>(props: Props<T>) => false | Element' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$e0574a56fae741f0$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($e0574a56fae741f0$var$mapStateToPropsFactory, {})((0, $cXdYX.default));

});
parcelRegister("cXdYX", function(module, exports) {
$parcel$export(module.exports, "default", () => $bee0d7cc05606f81$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
function $bee0d7cc05606f81$export$2e2bcd8739ae039(props) {
    const { hasEntities: hasEntities, FilterView: FilterView, onFilter: onFilter } = props;
    return hasEntities ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $bee0d7cc05606f81$var$wrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FilterView, {
        onFilter: onFilter
    })) : null;
}
const $bee0d7cc05606f81$var$wrapperStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.200'
});

});


parcelRegister("jCVOe", function(module, exports) {
$parcel$export(module.exports, "default", () => $caf4a8d1960fcc3c$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $lBd8e = parcelRequire("lBd8e");

var $dbkrW = parcelRequire("dbkrW");

var $bgiMi = parcelRequire("bgiMi");
const $caf4a8d1960fcc3c$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (!headerConfiguration || headerConfiguration.View) throw new Error('Invalid state - Default Header view must not be mounted');
    return {
        Filter: $dbkrW.default,
        // @ts-expect-error - TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
        Actions: headerConfiguration.ActionsView || (0, $lBd8e.default),
        hasEntities: (0, $bt4Z6.getStatus)(state) === 'has-entities',
        // @ts-expect-error - TS2339 - Property 'caption' does not exist on type 'HeaderConfiguration<TFilter>'.
        caption: headerConfiguration.caption || null
    };
};
var // @ts-expect-error - TS2345 - Argument of type 'ComponentType<Diff<Record<any, any> | (Record<any, any> & { children?: ReactNode; }), InjectIntlVoidProps>>' is not assignable to parameter of type 'Component<DispatchProp<any> & { Filter: ComponentClass<Omit<DispatchProp<any>, "dispatch">> & { WrappedComponent: Component<DispatchProp<any>>; }; Actions: any; hasEntities: boolean; caption: any; }>'.
$caf4a8d1960fcc3c$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($caf4a8d1960fcc3c$var$mapStateToProps, null, null, (0, $91zZ6.storeOptions))((0, $bgiMi.default));

});
parcelRegister("lBd8e", function(module, exports) {
$parcel$export(module.exports, "default", () => $35248647e13a4408$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $byghB = parcelRequire("byghB");
const $35248647e13a4408$var$mapStateToProps = (state)=>{
    const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'ActionsView' does not exist on type 'HeaderConfiguration<TFilter>'.
    if (headerConfiguration && !headerConfiguration.View && !headerConfiguration.ActionsView) {
        // @ts-expect-error - TS2339 - Property 'isAddAllowed' does not exist on type 'HeaderConfiguration<TFilter>'. | TS2339 - Property 'addButtonCaption' does not exist on type 'HeaderConfiguration<TFilter>'.
        const { isAddAllowed: isAddAllowed, addButtonCaption: addButtonCaption } = headerConfiguration;
        return {
            canAdd: isAddAllowed,
            caption: addButtonCaption
        };
    }
    return {};
};
const $35248647e13a4408$var$mapDispatchToProps = {
    onAdd: (0, $4wOQJ.initiate)
};
var $35248647e13a4408$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($35248647e13a4408$var$mapStateToProps, $35248647e13a4408$var$mapDispatchToProps, null, (0, $91zZ6.storeOptions))((0, $byghB.default));

});
parcelRegister("byghB", function(module, exports) {
$parcel$export(module.exports, "default", () => $d0b84cb0461ed13a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $lRq8t = parcelRequire("lRq8t");
function $d0b84cb0461ed13a$var$Add(props) {
    const { canAdd: canAdd, caption: caption, onAdd: onAdd } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return canAdd ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "primary",
        onClick: onAdd
    }, caption && formatMessage(caption)) : null;
}
$d0b84cb0461ed13a$var$Add.defaultProps = {
    canAdd: false
};
var $d0b84cb0461ed13a$export$2e2bcd8739ae039 = $d0b84cb0461ed13a$var$Add;

});


parcelRegister("dbkrW", function(module, exports) {
$parcel$export(module.exports, "default", () => $56b26b42f2c579c7$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $181ce = parcelRequire("181ce");
const $56b26b42f2c579c7$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $LFmXM.default)((state)=>(filter)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.FilterView) throw new Error('Invalid state - Filter wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'FilterView' does not exist on type 'HeaderConfiguration<TFilter>'.
            FilterView: headerConfiguration.FilterView,
            onFilter: onFilterFactory(state)
        };
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Filter' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$56b26b42f2c579c7$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($56b26b42f2c579c7$var$mapStateToPropsFactory, {})((0, $181ce.default));

});
parcelRegister("181ce", function(module, exports) {
$parcel$export(module.exports, "default", () => $ee176a642e448aa0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $ee176a642e448aa0$export$2e2bcd8739ae039(props) {
    const { FilterView: FilterView, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(FilterView, {
        onFilter: onFilter
    });
}

});


parcelRegister("bgiMi", function(module, exports) {
$parcel$export(module.exports, "default", () => $206ccb85f3340cfa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gHI4w = parcelRequire("gHI4w");

var $idGBm = parcelRequire("idGBm");
function $206ccb85f3340cfa$var$Default(props) {
    const { Filter: Filter, Actions: Actions, caption: caption, hasEntities: hasEntities, intl: { formatMessage: formatMessage } } = props;
    let searchBar = null;
    let actions = null;
    if (hasEntities) {
        searchBar = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Filter, null);
        actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Actions, null);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
        truncateTitle: true,
        actions: actions,
        bottomBar: searchBar
    }, caption ? formatMessage(caption) : '');
}
var $206ccb85f3340cfa$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($206ccb85f3340cfa$var$Default);

});


parcelRegister("1YsZU", function(module, exports) {
$parcel$export(module.exports, "default", () => $862a891411120bc1$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $bt4Z6 = parcelRequire("bt4Z6");

var $cadFR = parcelRequire("cadFR");
const $862a891411120bc1$var$mapStateToPropsFactory = ()=>{
    const onFilterFactory = (0, $LFmXM.default)((state)=>(filter)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                filter: filter
            }));
    return (state)=>{
        const headerConfiguration = (0, $6SY0Q.getHeaderConfiguration)(state);
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
        if (!headerConfiguration || !headerConfiguration.View) throw new Error('Invalid state - Header wrapper must not be mounted');
        return {
            // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'HeaderConfiguration<TFilter>'.
            HeaderView: headerConfiguration.View,
            hasEntities: (0, $bt4Z6.getStatus)(state) === 'has-entities',
            onFilter: onFilterFactory(state)
        };
    };
};
const $862a891411120bc1$var$mapDispatchToProps = {
    onAdd: (0, $4wOQJ.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Wrapper' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$862a891411120bc1$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($862a891411120bc1$var$mapStateToPropsFactory, $862a891411120bc1$var$mapDispatchToProps)((0, $cadFR.default));

});
parcelRegister("cadFR", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0b6660764944ecf$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $b0b6660764944ecf$export$2e2bcd8739ae039(props) {
    const { HeaderView: HeaderView, hasEntities: hasEntities, onAdd: onAdd, onFilter: onFilter } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderView, {
        hasEntities: hasEntities,
        onAdd: onAdd,
        onFilter: onFilter
    });
}

});


parcelRegister("lzizg", function(module, exports) {
$parcel$export(module.exports, "default", () => $7006066677abaaa5$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $6rNj9 = parcelRequire("6rNj9");
const $7006066677abaaa5$var$mapStateToPropsFactory = ()=>{
    const onPageChangeFactory = (0, $LFmXM.default)(// @ts-expect-error - TS7006 - Parameter 'event' implicitly has an 'any' type. | TS7006 - Parameter 'page' implicitly has an 'any' type.
    (state)=>(event, page)=>(0, $6SY0Q.getOnReload)(state)({
                page: page
            }));
    return (state)=>({
            currentPage: (0, $6SY0Q.getPage)(state),
            totalPages: (0, $6SY0Q.getTotalPages)(state),
            onPageChange: onPageChangeFactory(state)
        });
};
var $7006066677abaaa5$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($7006066677abaaa5$var$mapStateToPropsFactory, {}, null, (0, $91zZ6.storeOptions))((0, $6rNj9.default));

});
parcelRegister("6rNj9", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9bf74b4e5ee6e93$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $tGEEK = parcelRequire("tGEEK");

var $b3eVo = parcelRequire("b3eVo");

var $2sLVw = parcelRequire("2sLVw");

var $idGBm = parcelRequire("idGBm");

var $kRgKj = parcelRequire("kRgKj");

var $6XJko = parcelRequire("6XJko");

var $7NPCc = parcelRequire("7NPCc");
function $c9bf74b4e5ee6e93$var$Paginator(props) {
    const { currentPage: currentPage, totalPages: totalPages, intl: { formatMessage: formatMessage } } = props;
    const onPageChange = (data, event, analyticsEvent)=>{
        props.onPageChange(data, event);
        if (analyticsEvent) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'pagination');
    };
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $b3eVo.default), {
        selectedIndex: currentPage - 1,
        onChange: onPageChange,
        pages: (0, (/*@__PURE__*/$parcel$interopDefault($tGEEK)))(1, totalPages + 1),
        previousLabel: formatMessage((0, $7NPCc.default).previousButton),
        nextLabel: formatMessage((0, $7NPCc.default).nextButton)
    });
    if (totalPages > 1) return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $c9bf74b4e5ee6e93$var$styles.paginationContainer,
        testId: "global-pages.directories.directory-base.content.paginator.container"
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c9bf74b4e5ee6e93$var$Container, {
        "data-testId": "global-pages.directories.directory-base.content.paginator.container"
    }, content);
    return null;
}
var $c9bf74b4e5ee6e93$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($c9bf74b4e5ee6e93$var$Paginator);
const $c9bf74b4e5ee6e93$var$styles = {
    paginationContainer: "_n3td1ejb _18u0xmi2"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c9bf74b4e5ee6e93$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_n3td1ejb _18u0xmi2",
            __cmplp.className
        ])
    });
});

});
parcelRegister("b3eVo", function(module, exports) {
$parcel$export(module.exports, "default", () => $2e9938bbbd4852c0$export$2e2bcd8739ae039);
/* pagination.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");

var $7O2l7 = parcelRequire("7O2l7");

var $a2JSB = parcelRequire("a2JSB");

var $1kTzc = parcelRequire("1kTzc");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");

var $2xCo3 = parcelRequire("2xCo3");

var $6CP4r = parcelRequire("6CP4r");

var $3IiVn = parcelRequire("3IiVn");

var $1CN10 = parcelRequire("1CN10");

var $1hfAD = parcelRequire("1hfAD");
const $2e9938bbbd4852c0$var$styles = {
    paginationMenu: "_ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t",
    paginationMenuItem: "_1pfhze3t _ect41gqc",
    navigatorIconWrapper: "_18zr12x7"
};
const $2e9938bbbd4852c0$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
function $2e9938bbbd4852c0$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($a2JSB))) : (0, (/*@__PURE__*/$parcel$interopDefault($1kTzc)));
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "span",
        xcss: $2e9938bbbd4852c0$var$styles.navigatorIconWrapper,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Chevron, {
            label: "",
            LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
            color: "currentColor",
            size: "small"
        })
    });
}
function $2e9938bbbd4852c0$var$InnerPagination({ components: components = (0, $1CN10.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $1CN10.emptyObject), max: max = 7, onChange: onChange = (0, $3Vuhz.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $3IiVn.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $7O2l7.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$2e9938bbbd4852c0$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
            as: "li",
            xcss: $2e9938bbbd4852c0$var$styles.paginationMenuItem,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6CP4r.default), {
                component: components.Page,
                onClick: (event)=>onChangeWithAnalytics({
                        event: event,
                        selectedPageIndex: currPageIndex
                    }),
                "aria-current": isCurrentPage ? 'page' : undefined,
                "aria-label": pageIndexLabel,
                isSelected: isCurrentPage,
                isDisabled: isDisabled,
                page: page,
                testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`,
                children: getPageLabel ? getPageLabel(page, currPageIndex) : page
            })
        }, `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`);
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
            space: "space.0",
            alignBlock: "center",
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Previous,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue - 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === 0,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "left"
                    }),
                    "aria-label": previousLabel,
                    testId: testId && `${testId}--left-navigator`
                }, "left-navigator"),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6djmC.default), {
                    space: "space.0",
                    alignBlock: "baseline",
                    as: "ul",
                    xcss: $2e9938bbbd4852c0$var$styles.paginationMenu,
                    children: (0, $1hfAD.default)(pages, selectedIndexValue, {
                        max: max,
                        ellipsis: renderEllipsis,
                        transform: transform
                    }, testId)
                }),
                /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2xCo3.default), {
                    component: components.Next,
                    onClick: (event)=>onChangeWithAnalytics({
                            event: event,
                            selectedPageIndex: selectedIndexValue + 1
                        }),
                    isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
                    iconBefore: /*#__PURE__*/ (0, $gt9Am.jsx)($2e9938bbbd4852c0$var$NavigatorIcon, {
                        chevronDirection: "right"
                    }),
                    "aria-label": nextLabel,
                    testId: testId && `${testId}--right-navigator`
                }, "right-navigator")
            ]
        })
    }));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $2e9938bbbd4852c0$var$Pagination = /*#__PURE__*/ (0, $eJOHy.memo)(/*#__PURE__*/ (0, $eJOHy.forwardRef)($2e9938bbbd4852c0$var$InnerPagination));
var $2e9938bbbd4852c0$export$2e2bcd8739ae039 = $2e9938bbbd4852c0$var$Pagination;

});
parcelRegister("a2JSB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8e8ea817ec2fe685ddbf301b825d4978>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $74fdae0df2a41f03$var$_react = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $74fdae0df2a41f03$var$_chevronLeft = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("8PCRQ")));

var $74fdae0df2a41f03$var$_chevronLeftLarge = $74fdae0df2a41f03$var$_interopRequireDefault((parcelRequire("k9ooi")));
function $74fdae0df2a41f03$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $74fdae0df2a41f03$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $74fdae0df2a41f03$var$_react.default.createElement($74fdae0df2a41f03$var$_chevronLeft.default, Object.assign({
        name: "ChevronLeftIcon",
        LEGACY_fallbackIcon: $74fdae0df2a41f03$var$_chevronLeftLarge.default
    }, props));
$74fdae0df2a41f03$var$ChevronLeftIcon.displayName = 'ChevronLeftIconMigration';
var $74fdae0df2a41f03$var$_default = module.exports.default = $74fdae0df2a41f03$var$ChevronLeftIcon;

});
parcelRegister("8PCRQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8ee9ad5072a30451ff7ca2ddc0961d03>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $66e13c6de5d90262$var$_react = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $66e13c6de5d90262$var$_baseNew = $66e13c6de5d90262$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $66e13c6de5d90262$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Navigate back, show previous page of pagination results
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $66e13c6de5d90262$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $66e13c6de5d90262$var$_react.default.createElement($66e13c6de5d90262$var$_baseNew.default, Object.assign({
        name: "ChevronLeftIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$66e13c6de5d90262$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $66e13c6de5d90262$var$_default = module.exports.default = $66e13c6de5d90262$var$ChevronLeftIcon;

});

parcelRegister("k9ooi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eab7917427604e36$var$_react = $eab7917427604e36$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $fL0In = parcelRequire("fL0In");
function $eab7917427604e36$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eab7917427604e36$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $eab7917427604e36$var$_react.default.createElement($fL0In.Icon, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props));
$eab7917427604e36$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $eab7917427604e36$var$_default = module.exports.default = $eab7917427604e36$var$ChevronLeftLargeIcon;

});


parcelRegister("2xCo3", function(module, exports) {
$parcel$export(module.exports, "default", () => $390a465a7b875c7d$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $390a465a7b875c7d$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("6CP4r", function(module, exports) {
$parcel$export(module.exports, "default", () => $a7a0738c73e50f62$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");
function $a7a0738c73e50f62$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goZPP.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("3IiVn", function(module, exports) {
$parcel$export(module.exports, "default", () => $eee95bde3b212432$export$2e2bcd8739ae039);
/* render-ellipsis.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $8IeH1 = parcelRequire("8IeH1");
var $3cMgR = parcelRequire("3cMgR");

var $6fs4r = parcelRequire("6fs4r");
const $eee95bde3b212432$var$styles = {
    container: "_1e0c1txw _kqswh2mm"
};
function $eee95bde3b212432$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        as: "li",
        testId: testId,
        xcss: $eee95bde3b212432$var$styles.container,
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3cMgR.default), {
            testId: testId && `${testId}-text`,
            children: [
                /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6fs4r.default), {
                    children: [
                        "Skipped pages from ",
                        from,
                        " to ",
                        to
                    ]
                }),
                "\u2026"
            ]
        })
    }, key);
}

});

parcelRegister("1CN10", function(module, exports) {
$parcel$export(module.exports, "emptyObject", () => $1b85b3c8ab534085$export$3f860eba1218f8d3);
const $1b85b3c8ab534085$export$3f860eba1218f8d3 = {};

});

parcelRegister("1hfAD", function(module, exports) {
$parcel$export(module.exports, "default", () => $916df7f6e7c50105$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $916df7f6e7c50105$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $LFmXM.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $916df7f6e7c50105$export$2e2bcd8739ae039 = $916df7f6e7c50105$var$collapseRange;

});


parcelRegister("7NPCc", function(module, exports) {
$parcel$export(module.exports, "default", () => $07ec01bbb9ef28ec$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $07ec01bbb9ef28ec$var$messages = (0, $7qGN1.defineMessages)({
    previousButton: {
        "id": "directory-base.content.paginator.previous-button",
        "defaultMessage": "Previous page"
    },
    nextButton: {
        "id": "directory-base.content.paginator.next-button",
        "defaultMessage": "Next page"
    }
});
var $07ec01bbb9ef28ec$export$2e2bcd8739ae039 = $07ec01bbb9ef28ec$var$messages;

});



parcelRegister("5FTzj", function(module, exports) {
$parcel$export(module.exports, "default", () => $a468657d4ef5c51d$export$2e2bcd8739ae039);

var $ahm5r = parcelRequire("ahm5r");

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $5cBQu = parcelRequire("5cBQu");

var $6SY0Q = parcelRequire("6SY0Q");

var $4fI4K = parcelRequire("4fI4K");

var $hd1Pz = parcelRequire("hd1Pz");

var $96vM9 = parcelRequire("96vM9");
const $a468657d4ef5c51d$var$getSpotlightForCellSelectorMemoized = ()=>(0, $ahm5r.createSelector)((state)=>(0, $6SY0Q.getSpotlightForCell)(state), (res)=>res);
const $a468657d4ef5c51d$var$mapStateToPropsFactory = ()=>{
    const getSpotlightForCellSelectorInstance = $a468657d4ef5c51d$var$getSpotlightForCellSelectorMemoized();
    const onSortFactory = (0, $LFmXM.default)(// @ts-expect-error - TS7006 - Parameter 'sort' implicitly has an 'any' type.
    (state)=>(sort)=>(0, $6SY0Q.getOnReload)(state)({
                page: 1,
                ...sort
            }));
    return (state)=>{
        // @ts-expect-error - TS2339 - Property 'View' does not exist on type 'EmptyFilterResultConfiguration'.
        const EmptyView = (0, $6SY0Q.getEmptyFilterResultConfiguration)(state).View || (0, $hd1Pz.default);
        const TableMaskView = (0, $6SY0Q.getTableMaskView)(state);
        const filter = (0, $6SY0Q.getFilter)(state);
        const filterQuery = filter ? filter.query : '';
        return {
            tableConfiguration: (0, $6SY0Q.getTableConfiguration)(state),
            tableLabel: (0, $6SY0Q.getTableLabel)(state),
            resultsAnnouncerMessage: (0, $6SY0Q.getResultsAnnouncerMessage)(state),
            EmptyView: EmptyView,
            TableMaskView: TableMaskView,
            dataProvider: (0, $6SY0Q.getDataProvider)(state),
            entityIds: (0, $6SY0Q.getEntityIds)(state),
            totalItems: (0, $6SY0Q.getTotalItems)(state),
            operationInitializationStatusPerEntity: (0, $6SY0Q.getOperationInitializationStatusPerEntity)(state),
            isLoading: (0, $6SY0Q.isLoading)(state),
            sortField: (0, $6SY0Q.getSortField)(state),
            sortDirection: (0, $6SY0Q.getSortDirection)(state),
            onSort: onSortFactory(state),
            mountMetricKey: (0, $4fI4K.getTableMountedMetricKey)(state),
            getSpotlightForCell: getSpotlightForCellSelectorInstance(state),
            firstColumnHeadingAlignment: (0, $6SY0Q.getFirstColumnHeadingAlignment)(state),
            lastColumnHeadingAlignment: (0, $6SY0Q.getLastColumnHeadingAlignment)(state),
            filterQuery: filterQuery
        };
    };
};
const $a468657d4ef5c51d$var$mapDispatchToProps = {
    onOperationRequested: (0, $5cBQu.initiate)
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2.
$a468657d4ef5c51d$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($a468657d4ef5c51d$var$mapStateToPropsFactory, $a468657d4ef5c51d$var$mapDispatchToProps)((0, $96vM9.default));

});
parcelRegister("4fI4K", function(module, exports) {
$parcel$export(module.exports, "getTableMountedMetricKey", () => $9e43c8fdf7968ae6$export$b6c1493984bb04f9);
const $9e43c8fdf7968ae6$export$b6c1493984bb04f9 = (state)=>state.app.props.metrics.tableMounted;

});

parcelRegister("hd1Pz", function(module, exports) {
$parcel$export(module.exports, "default", () => $ccf583b38e8b01a8$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $46lOx = parcelRequire("46lOx");
const $ccf583b38e8b01a8$var$mapStateToProps = (state)=>{
    const configuration = (0, $6SY0Q.getEmptyFilterResultConfiguration)(state);
    // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
    if (!configuration.message) throw new Error('Invalid state - Default empty view should not be mounted');
    return {
        // @ts-expect-error - TS2339 - Property 'message' does not exist on type 'EmptyFilterResultConfiguration'.
        message: configuration.message
    };
};
var $ccf583b38e8b01a8$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($ccf583b38e8b01a8$var$mapStateToProps, null, null, (0, $91zZ6.storeOptions))((0, $46lOx.default));

});
parcelRegister("46lOx", function(module, exports) {
$parcel$export(module.exports, "default", () => $cdf52a671bcf0851$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $6YFG2 = parcelRequire("6YFG2");

var $hj82Y = parcelRequire("hj82Y");

var $6XJko = parcelRequire("6XJko");

var $87ztG = parcelRequire("87ztG");
function $cdf52a671bcf0851$var$DefaultEmptyView(props) {
    const { message: message } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        "data-testId": "global-pages.directories.directory-base.content.table.default-empty-view.empty-state"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        imageUrl: (0, $6XJko.isVisualRefreshEnabled)() ? (0, (/*@__PURE__*/$parcel$interopDefault($hj82Y))) : (0, (/*@__PURE__*/$parcel$interopDefault($87ztG))),
        header: formatMessage(message),
        width: "narrow",
        headingLevel: 2
    }));
}
var $cdf52a671bcf0851$export$2e2bcd8739ae039 = (0, $6YFG2.default)($cdf52a671bcf0851$var$DefaultEmptyView);

});
parcelRegister("hj82Y", function(module, exports) {
module.exports = new URL("search-no-results.1d478205.svg", import.meta.url).toString();

});

parcelRegister("87ztG", function(module, exports) {
module.exports = new URL("generic-no-results.fb302821.svg", import.meta.url).toString();

});



parcelRegister("96vM9", function(module, exports) {
$parcel$export(module.exports, "default", () => $58d4afddfb7fcf61$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $12DRg = parcelRequire("12DRg");

var $aXKmr = parcelRequire("aXKmr");

var $lOOiG = parcelRequire("lOOiG");

var $guChT = parcelRequire("guChT");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $3cMgR = parcelRequire("3cMgR");

var $8nw3F = parcelRequire("8nw3F");


var $idGBm = parcelRequire("idGBm");

var $kRgKj = parcelRequire("kRgKj");

var $6XJko = parcelRequire("6XJko");

var $eS6Sp = parcelRequire("eS6Sp");

var $8TMMM = parcelRequire("8TMMM");
class $58d4afddfb7fcf61$var$Table extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isLoading: false,
            entityIds: [],
            totalItems: 0,
            sortDirection: (0, $88c5923de10af20c$export$1dee026a19752d6b),
            mountMetricKey: undefined,
            getSpotlightForCell: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            TableMaskView: undefined,
            firstColumnHeadingAlignment: 'left',
            lastColumnHeadingAlignment: 'left',
            filterQuery: '',
            tableLabel: undefined,
            resultsAnnouncerMessage: (0, $8TMMM.default).filterResultsAnnouncement,
            onSort: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onOperationRequested: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    componentDidUpdate(prevProps) {
        if (prevProps.sortDirection !== this.props.sortDirection || prevProps.sortField !== this.props.sortField) this.state.hasSortingChanged = true;
        if (!prevProps.isLoading && this.props.isLoading) this.state.shouldAnnounceResults = !this.state.hasSortingChanged;
        else if (prevProps.isLoading && !this.props.isLoading) this.state.hasSortingChanged = false;
        if (this.state.returnFocusTo) {
            // Find the index of the sort field that we should put focus on, then go through all the headers and find the one that matches the sort field index
            const sortFieldIndex = this.props.tableConfiguration.findIndex((config)=>config.sortField === this.state.returnFocusTo);
            if (sortFieldIndex >= 0) {
                const allHeaders = globalThis.document.querySelectorAll('thead th');
                if (sortFieldIndex < allHeaders.length) {
                    const targetHeader = allHeaders[sortFieldIndex];
                    const sortButton = targetHeader.querySelector('button[aria-roledescription="Sort button"]');
                    if (sortButton instanceof HTMLElement) sortButton.focus();
                }
            }
        }
    }
    render() {
        const { tableConfiguration: tableConfiguration, entityIds: entityIds, totalItems: totalItems, EmptyView: EmptyView, isLoading: isLoading, operationInitializationStatusPerEntity: operationInitializationStatusPerEntity, sortField: sortField, sortDirection: sortDirection, mountMetricKey: mountMetricKey, getSpotlightForCell: getSpotlightForCell, TableMaskView: TableMaskView, dataProvider: dataProvider, firstColumnHeadingAlignment: firstColumnHeadingAlignment, lastColumnHeadingAlignment: lastColumnHeadingAlignment, intl: { formatMessage: formatMessage }, tableLabel: tableLabel, resultsAnnouncerMessage: resultsAnnouncerMessage } = this.props;
        const headCells = tableConfiguration.map(({ title: title, width: width, sortField: cellSortField, dataTestId: dataTestId, isIconOnlyHeader: isIconOnlyHeader, ascendingSortTooltip: ascendingSortTooltip, descendingSortTooltip: descendingSortTooltip })=>{
            let content = '';
            const wrapperProps = dataTestId ? {
                'data-test-id': dataTestId
            } : {};
            if (dataTestId) // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
            content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$NonBreakingCell, wrapperProps);
            if (typeof title === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const HeaderCell = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (()=>{
                    if (!(0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$HeaderWrapper, wrapperProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderCell, null));
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                        xcss: $58d4afddfb7fcf61$var$styles.headerWrapper,
                        testId: dataTestId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(HeaderCell, null));
                })();
            } else if (typeof title !== 'undefined') {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
                const message = title; // @ts-expect-error - TS2322 - Type 'Element' is not assignable to type 'string'.
                content = (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
                    testId: dataTestId,
                    color: "color.text.subtle",
                    maxLines: 1,
                    weight: "bold",
                    size: "small"
                }, formatMessage(message))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$NonBreakingCell, wrapperProps, formatMessage(message));
            }
            return {
                key: cellSortField || (0, $aXKmr.v1)(),
                isSortable: !!cellSortField,
                content: content,
                width: width,
                isIconOnlyHeader: (0, $6XJko.isVisualRefreshEnabled)() ? !!isIconOnlyHeader : undefined,
                ascendingSortTooltip: ascendingSortTooltip && (0, $6XJko.isVisualRefreshEnabled)() ? formatMessage(ascendingSortTooltip) : undefined,
                descendingSortTooltip: descendingSortTooltip && (0, $6XJko.isVisualRefreshEnabled)() ? formatMessage(descendingSortTooltip) : undefined
            };
        });
        const head = {
            cells: headCells
        };
        const ids = dataProvider ? dataProvider.getData().map((entity)=>dataProvider.idSelector(entity)) : entityIds;
        const tableAriaLabel = tableLabel ? formatMessage(tableLabel) : undefined;
        const rowCells = ids.map((entityId, rowIndex)=>{
            // the page is already sorted (by the API), so fake key,
            // so that DynamicTable won't destroy it
            const key = sortDirection === 'DESC' ? -(rowIndex + 1) : rowIndex + 1;
            const entity = dataProvider ? dataProvider.getData()[rowIndex] : undefined;
            const cells = tableConfiguration.map(({ Cell: Cell }, colIndex)=>{
                const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Cell, {
                    id: entityId,
                    entity: entity,
                    isOperationInProgress: !!operationInitializationStatusPerEntity[entityId],
                    onOperationRequested: (operation, operationParams)=>this.props.onOperationRequested({
                            id: entityId,
                            childEntityId: operationParams && operationParams.childEntityId,
                            operation: operation
                        })
                });
                const getVisuallyRefreshedContent = (visuallyRefreshedContent)=>{
                    return visuallyRefreshedContent;
                };
                const cellMatch = getSpotlightForCell(entityId, colIndex);
                if (cellMatch && cellMatch.spotlightId) {
                    const onboardingContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guChT.default), {
                        name: cellMatch.spotlightId
                    }, getVisuallyRefreshedContent(content));
                    return {
                        content: onboardingContent,
                        key: key
                    };
                }
                return {
                    content: getVisuallyRefreshedContent(content),
                    key: key
                };
            });
            return {
                cells: cells
            };
        });
        return(// Note: the data-test-id attribute is used by Pollinator checks in Jalapeno so avoid changing if possible
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$Container, {
            "data-testId": "global-pages.directories.directory-base.content.table.container",
            firstColumnHeadingAlignment: firstColumnHeadingAlignment,
            lastColumnHeadingAlignment: lastColumnHeadingAlignment,
            visualRefreshEnabled: (0, $6XJko.isVisualRefreshEnabled)(),
            visuallyRefreshedHeight: (0, $6XJko.isVisualRefreshEnabled)()
        }, !isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eS6Sp.default), {
            performanceMarkKey: mountMetricKey
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nw3F.AnnouncerV2), {
            message: formatMessage(resultsAnnouncerMessage || (0, $8TMMM.default).filterResultsAnnouncement, {
                itemCount: totalItems
            }),
            shouldAnnounce: !isLoading && this.state.shouldAnnounceResults
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lOOiG.default), {
            isFixedSize: true,
            isLoading: isLoading,
            head: head,
            rows: rowCells,
            onSort: this.onSort,
            sortKey: sortField,
            sortOrder: sortDirection,
            emptyView: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($58d4afddfb7fcf61$var$EmptyLoadingView, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(EmptyView, null),
            label: tableAriaLabel
        }), TableMaskView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(TableMaskView, null)));
    }
    constructor(...args){
        super(...args), this.state = {
            hasSortingChanged: false,
            shouldAnnounceResults: false,
            returnFocusTo: null
        }, /**
   * We very much wish that `attrs` is an object of this type {| key: string, sortOrder: string |}
   * but unfortunately @atlaskit/dynamic-table types do not give any guarantee of that
   * so we should be handling mixed here.
   */ this.onSort = (attrs, analyticsEvent)=>{
            // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'unknown'. | TS2339 - Property 'sortOrder' does not exist on type 'unknown'.
            const { key: key, sortOrder: sortOrder } = attrs;
            const { onSort: onSort } = this.props;
            if (analyticsEvent) (0, $kRgKj.fireUIAnalytics)(analyticsEvent, 'tableHeader', {
                key: key
            });
            onSort({
                sortField: key,
                sortDirection: sortOrder
            });
            this.setState({
                returnFocusTo: key
            });
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof Table' is not assignable to parameter of type 'ComponentType<WithIntlProvided<Props<unknown, string, unknown, unknown>>> & typeof Table'.
$58d4afddfb7fcf61$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($58d4afddfb7fcf61$var$Table);
const $58d4afddfb7fcf61$var$TABLE_ROW_HEIGHT = '40px'; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$NonBreakingCell = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { firstColumnHeadingAlignment: firstColumnHeadingAlignment, visuallyRefreshedHeight: visuallyRefreshedHeight, visualRefreshEnabled: visualRefreshEnabled, lastColumnHeadingAlignment: lastColumnHeadingAlignment, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1bgnkvw": (0, $awdRS.default)(__cmplp.firstColumnHeadingAlignment),
            "--_xer3jx": (0, $awdRS.default)(__cmplp.visuallyRefreshedHeight ? '16px' : '14px'),
            "--_w6gjp2": (0, $awdRS.default)(__cmplp.visualRefreshEnabled ? '16px' : '14px'),
            "--_jlq5ur": (0, $awdRS.default)(__cmplp.lastColumnHeadingAlignment)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqswh2mm _2ws7jp4b _p4liidpf _6autidpf _7dd61ux8 _13jcr73l _496i159m _9yen1pfg _10wbnkob _jwot4jg8",
            __cmplp.visualRefreshEnabled && "_19ib1qi0 _y4woe4h9 _oaa6nqa1 _10ok1l7x _cnoh1vhk _1o7fj0fz _1m2zhfxm _1cuj1ylp _4lbnglyw _1ttwj0fz _qass1qi0 _1g001qi0",
            __cmplp.className
        ])
    });
});
const $58d4afddfb7fcf61$var$styles = {
    headerWrapper: "_19bvu2gc _u5f31b66 _ca0q1b66 _n3td1b66",
    headerWrapperOld: "_18zr1b66 _1rjcu2gc _4cvr1h6o _1bah1h6o _1bsbzwfg"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$EmptyLoadingView = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1w81",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $58d4afddfb7fcf61$var$HeaderWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lOOiG", function(module, exports) {
$parcel$export(module.exports, "default", () => $976d89647138dbc1$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jrFnt = parcelRequire("jrFnt");

var $3Vuhz = parcelRequire("3Vuhz");


var $aXVGO = parcelRequire("aXVGO");

var $khVsD = parcelRequire("khVsD");

var $1NCSA = parcelRequire("1NCSA");

var $bEPjZ = parcelRequire("bEPjZ");

var $04ZiM = parcelRequire("04ZiM");

var $foLeX = parcelRequire("foLeX");

var $goxGh = parcelRequire("goxGh");

var $5hPH6 = parcelRequire("5hPH6");

var $iXYwm = parcelRequire("iXYwm");
function $976d89647138dbc1$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $861def5c205d1816$export$b6abcf7fa1d94f65:
            return 0, $861def5c205d1816$export$1dee026a19752d6b;
        case 0, $861def5c205d1816$export$1dee026a19752d6b:
            return 0, $861def5c205d1816$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $976d89647138dbc1$var$DynamicTable = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $3Vuhz.default), onSort: providedOnSort = (0, $3Vuhz.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $3Vuhz.default), onRankEnd: providedOnRankEnd = (0, $3Vuhz.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous Page',
    next: 'Next Page',
    // eslint-disable-next-line @atlassian/i18n/no-literal-string-in-object
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eJOHy.useState)(false);
    const tableBodyRef = (0, $eJOHy.useRef)(null);
    const onSort = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnSort,
        action: 'sorted',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onRankEnd = (0, $jrFnt.usePlatformLeafEventHandler)({
        fn: providedOnRankEnd,
        action: 'ranked',
        componentName: 'dynamicTable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    (0, $eJOHy.useEffect)(()=>{
        (0, $aXVGO.validateSortKey)(sortKey, head);
        (0, $aXVGO.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $861def5c205d1816$export$1dee026a19752d6b) : $976d89647138dbc1$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $aXVGO.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $861def5c205d1816$export$7b93a10c0fefe3e3) : (0, $861def5c205d1816$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1NCSA.EmptyViewContainer), {
            testId: testId,
            children: emptyView
        });
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $gt9Am.Fragment), {
        children: [
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $goxGh.default), {
                isLoading: isLoading && rowsExist,
                spinnerSize: spinnerSize,
                targetRef: ()=>tableBodyRef.current,
                testId: testId,
                loadingLabel: loadingLabel,
                children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $khVsD.Table), {
                    isFixedSize: isFixedSize,
                    "aria-label": label,
                    hasDataRow: rowsExist,
                    testId: testId,
                    isLoading: isLoading,
                    children: [
                        !!caption && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.Caption), {
                            children: caption
                        }),
                        head && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $iXYwm.default), {
                            head: head,
                            onSort: onSortHandler,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            isRanking: isRanking,
                            isRankable: isRankable,
                            testId: testId
                        }),
                        rowsExist && /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$TableBody, {
                            ref: tableBodyRef,
                            highlightedRowIndex: highlightedRowIndex,
                            rows: rows,
                            head: head,
                            sortKey: sortKey,
                            sortOrder: sortOrder,
                            rowsPerPage: rowsPerPage,
                            page: getPageNumber,
                            isFixedSize: isFixedSize || false,
                            onPageRowsUpdate: onPageRowsUpdate,
                            isTotalPagesControlledExternally: isTotalPagesControlledExternally,
                            testId: testId,
                            isRankable: isRankable,
                            isRanking: isRanking,
                            onRankStart: onRankStartHandler,
                            onRankEnd: onRankEndHandler,
                            isRankingDisabled: isRankingDisabled || isLoading || false
                        })
                    ]
                })
            }),
            totalPages <= 1 ? null : // only show pagination if there's MORE than 1 page
            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $khVsD.PaginationWrapper), {
                testId: testId,
                children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5hPH6.default), {
                    value: getPageNumber,
                    onChange: onSetPageHandler,
                    total: totalPages,
                    i18n: paginationi18n,
                    isDisabled: isLoading,
                    testId: testId
                })
            }),
            !rowsExist && emptyBody && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $foLeX.default), {
                isLoading: isLoading,
                spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
                testId: testId,
                loadingLabel: loadingLabel,
                children: emptyBody
            })
        ]
    });
};

const $976d89647138dbc1$var$RankableTableBody = /*#__PURE__*/ (0, $eJOHy.lazy)(()=>(parcelRequire("itCCG")));
const $976d89647138dbc1$var$TableBody = /*#__PURE__*/ (0, $eJOHy.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eJOHy.useState)(false);
    (0, $eJOHy.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $bEPjZ.default), {
        ref: ref,
        ...bodyProps
    });
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, $04ZiM.ErrorBoundary), {
        fallback: nonRankableBody,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $eJOHy.Suspense), {
            fallback: nonRankableBody,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)($976d89647138dbc1$var$RankableTableBody, {
                ref: ref,
                ...bodyProps,
                isRanking: isRanking,
                onRankStart: onRankStart,
                onRankEnd: onRankEnd,
                isRankingDisabled: isRankingDisabled
            })
        })
    }) : nonRankableBody;
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$976d89647138dbc1$export$2e2bcd8739ae039 = $976d89647138dbc1$var$DynamicTable;

});
const $861def5c205d1816$export$1dee026a19752d6b = 'ASC';
const $861def5c205d1816$export$b6abcf7fa1d94f65 = 'DESC';
const $861def5c205d1816$export$71dd4c8ecd45e95f = 'small';
const $861def5c205d1816$export$7b93a10c0fefe3e3 = 'large';
const $861def5c205d1816$export$3843c586a90b9cbf = 0.22;

parcelRegister("aXVGO", function(module, exports) {
$parcel$export(module.exports, "getPageRows", () => $d0bfac7c95a14ce3$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $d0bfac7c95a14ce3$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $d0bfac7c95a14ce3$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $d0bfac7c95a14ce3$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $d0bfac7c95a14ce3$export$c476bbe5da59992d);
const $d0bfac7c95a14ce3$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $d0bfac7c95a14ce3$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $d0bfac7c95a14ce3$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $d0bfac7c95a14ce3$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $d0bfac7c95a14ce3$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $d0bfac7c95a14ce3$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $d0bfac7c95a14ce3$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("khVsD", function(module, exports) {
$parcel$export(module.exports, "Table", () => $fd7ebbab92fbe669$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $fd7ebbab92fbe669$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $fd7ebbab92fbe669$export$3e5e12dc01f20a43);
/* dynamic-table.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $fd7ebbab92fbe669$var$fixedSizeTableStyles = null;
const $fd7ebbab92fbe669$var$tableStyles = null;
const $fd7ebbab92fbe669$var$bodyBorder = null;
const $fd7ebbab92fbe669$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("table", {
        inert: isLoading ? '' : undefined,
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-bg': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-highlighted-bg': "var(--ds-background-selected, #E9F2FE)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-hover-highlighted-bg': "var(--ds-background-selected-hovered, #CFE1FD)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            '--local-dynamic-table-row-focus-outline': "var(--ds-border-focused, #4688EC)"
        },
        ref: ref,
        ...rest,
        "data-testid": testId && `${testId}--table`,
        className: (0, $hcewu.default)([
            "_1bsb1osq _yq5h18uv _btyzidpf _ect41gqc",
            isFixedSize && "_1kqm1n9t",
            hasDataRow && "_179r1uh4"
        ]),
        children: children
    });
});
const $fd7ebbab92fbe669$var$captionStyles = null;
const $fd7ebbab92fbe669$export$32fbfacc5d962e0c = ({ children: children })=>/*#__PURE__*/ (0, $gt9Am.jsx)("caption", {
        className: (0, $hcewu.default)([
            "_11c8lodh _6rthu2gc _1pfh1ejb _m6k41e03"
        ]),
        children: children
    });
const $fd7ebbab92fbe669$var$paginationWrapperStyles = null;
const $fd7ebbab92fbe669$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--pagination--container`,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bah1h6o"
        ]),
        children: children
    });

});

parcelRegister("1NCSA", function(module, exports) {
$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $b2a7a5f88e6f100c$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $b2a7a5f88e6f100c$export$381ea436de119582);
/* empty-body.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $b2a7a5f88e6f100c$var$fixedHeightStyles = null;
const $b2a7a5f88e6f100c$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`,
        className: (0, $hcewu.default)([
            "_4t3i1jdh"
        ]),
        children: children
    });
const $b2a7a5f88e6f100c$var$emptyViewContainerStyles = null;
const $b2a7a5f88e6f100c$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--empty-view-container`,
        className: (0, $hcewu.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _ca0q19bv _u5f319bv _n3td19bv _19bv19bv _1bsb1ssb _y3gn1h6o"
        ]),
        children: children
    });
};

});

parcelRegister("bEPjZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $2c021f4be43795a4$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $jNhOC = parcelRequire("jNhOC");

var $lW0bH = parcelRequire("lW0bH");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $2c021f4be43795a4$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsx)("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef,
            children: pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $lW0bH.default), {
                    head: head,
                    isFixedSize: isFixedSize,
                    row: row,
                    isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                    testId: testId
                }, row.key || rowIndex))
        });
    }
}
const $2c021f4be43795a4$var$Body = (0, $jNhOC.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)($2c021f4be43795a4$var$BodyComponent, {
        ...props,
        forwardedRef: ref
    });
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$2c021f4be43795a4$export$2e2bcd8739ae039 = $2c021f4be43795a4$var$Body;

});
parcelRegister("jNhOC", function(module, exports) {
$parcel$export(module.exports, "default", () => $835026024c70c744$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");


var $aXVGO = parcelRequire("aXVGO");
const $835026024c70c744$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        if (head.cells[i] && head.cells[i]?.key === sortKey) return cells[i]?.key;
    }
    return undefined;
};
// sort all rows based on sort key and order
const $835026024c70c744$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $835026024c70c744$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $835026024c70c744$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $835026024c70c744$export$2e2bcd8739ae039(WrappedComponent) {
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $aXVGO.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $835026024c70c744$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $aXVGO.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                pageRows: this.state.pageRows,
                head: head,
                ...restProps,
                ref: forwardedRef
            });
        }
        constructor(...args){
            super(...args), this.state = {
                pageRows: []
            };
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).forwardRef((props, ref)=>{
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
        return /*#__PURE__*/ (0, $gt9Am.jsx)(WithSortedPageRows, {
            ...props,
            forwardedRef: ref
        });
    });
}

});

parcelRegister("lW0bH", function(module, exports) {
$parcel$export(module.exports, "default", () => $c4bfc9d23dedd74e$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5ljLr = parcelRequire("5ljLr");

var $268TF = parcelRequire("268TF");
const $c4bfc9d23dedd74e$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $268TF.TableBodyRow), {
        ...restRowProps,
        isHighlighted: isHighlighted,
        ...isHighlighted ? {
            'data-ts--dynamic-table--table-row--highlighted': true
        } : null,
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`,
        children: cells.map((cell, cellIndex)=>{
            const { content: content, testId: cellTestId, ...restCellProps } = cell;
            const { shouldTruncate: shouldTruncate, width: width } = (head || {
                cells: []
            }).cells[cellIndex] || {};
            return /*#__PURE__*/ (0, $eJOHy.createElement)((0, $5ljLr.TableBodyCell), {
                "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`,
                ...restCellProps,
                isFixedSize: isFixedSize,
                key: cellIndex,
                shouldTruncate: shouldTruncate,
                width: width
            }, content);
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c4bfc9d23dedd74e$export$2e2bcd8739ae039 = $c4bfc9d23dedd74e$var$Row;

});
parcelRegister("5ljLr", function(module, exports) {
$parcel$export(module.exports, "TableBodyCell", () => $6d87de66ba7880ae$export$948e91fcef170792);
/* table-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $1eoPo = parcelRequire("1eoPo");
const $6d87de66ba7880ae$var$fixedSizeTruncateStyles = null;
const $6d87de66ba7880ae$var$overflowTruncateStyles = null;
const $6d87de66ba7880ae$var$truncationWidthStyles = null;
const $6d87de66ba7880ae$var$cellStyles = null;
const $6d87de66ba7880ae$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>/*#__PURE__*/ (0, $gt9Am.jsx)("td", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        // HOC withDimensions complains about the types but it is working fine
        // @ts-ignore
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq",
            "_19itglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            props.className
        ]),
        ...props
    });

});
parcelRegister("1eoPo", function(module, exports) {
$parcel$export(module.exports, "getTruncationStyleVars", () => $91687adffdb20f71$export$5e6497a652ae30b5);
const $91687adffdb20f71$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $91687adffdb20f71$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$91687adffdb20f71$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;

});


parcelRegister("268TF", function(module, exports) {
$parcel$export(module.exports, "TableBodyRow", () => $a53c59e604030c6d$export$45f39d9c38b886d5);
/* table-row.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $a53c59e604030c6d$var$rowStyles = null;
const $a53c59e604030c6d$var$rowBackgroundStyles = null;
const $a53c59e604030c6d$var$rowHighlightedBackgroundStyles = null;
const $a53c59e604030c6d$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, className: className, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        /**
   * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
   * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
   */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $hcewu.default)([
            "_bfhk1w7a _1ygbsglb _1ah312gs",
            isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts",
            className
        ]),
        ...rest,
        ref: ref,
        "data-testid": testId,
        children: children
    });
});

});



parcelRegister("04ZiM", function(module, exports) {
$parcel$export(module.exports, "ErrorBoundary", () => $fd6eb2a47216dc9b$export$e926676385687eaf);

var $eJOHy = parcelRequire("eJOHy");
class $fd6eb2a47216dc9b$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("foLeX", function(module, exports) {
$parcel$export(module.exports, "default", () => $7869f2e695a66a65$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $CEHHO = parcelRequire("CEHHO");
class $7869f2e695a66a65$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: (0, $861def5c205d1816$export$3843c586a90b9cbf),
            loadingLabel: 'Loading table'
        };
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $CEHHO.Container), {
            testId: testId,
            children: [
                !isLoading ? children : /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.ContentsContainer), {
                    contentsOpacity: contentsOpacity,
                    testId: testId,
                    children: children
                }),
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $CEHHO.SpinnerContainer), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                        size: spinnerSize,
                        testId: testId && `${testId}--loadingSpinner`,
                        label: loadingLabel
                    })
                })
            ]
        });
    }
}

});
parcelRegister("CEHHO", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dfc2e003c707e1fb$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $dfc2e003c707e1fb$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $dfc2e003c707e1fb$export$a5e06607a5ac6158);
/* loading-container.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dfc2e003c707e1fb$export$c335a80381ec61f5 = '--contents-opacity';
const $dfc2e003c707e1fb$var$containerStyles = null;
const $dfc2e003c707e1fb$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--container`,
        className: (0, $hcewu.default)([
            "_kqswh2mm"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$contentsContainerStyles = null;
const $dfc2e003c707e1fb$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            [$dfc2e003c707e1fb$export$c335a80381ec61f5]: contentsOpacity
        },
        "data-testid": testId && `${testId}--contents--container`,
        className: (0, $hcewu.default)([
            "_tzy4saf5 _lcxvglyw"
        ]),
        children: children
    });
const $dfc2e003c707e1fb$var$spinnerContainerStyles = null;
const $dfc2e003c707e1fb$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner--container`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o"
        ]),
        children: children
    });

});


parcelRegister("goxGh", function(module, exports) {
$parcel$export(module.exports, "default", () => $313fee558443ede2$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/dom-events/no-unsafe-event-listeners */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $7ep4S = parcelRequire("7ep4S");


var $3rtaW = parcelRequire("3rtaW");
class $313fee558443ede2$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    static{
        this.defaultProps = {
            isLoading: true,
            spinnerSize: (0, $861def5c205d1816$export$7b93a10c0fefe3e3),
            contentsOpacity: `var(--ds-opacity-loading, ${`${0, $861def5c205d1816$export$3843c586a90b9cbf}`})`,
            loadingLabel: 'Loading table'
        };
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = this.spinnerRef?.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = this.containerRef?.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $3rtaW.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerBackdrop), {
                    testId: testId,
                    children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3rtaW.SpinnerContainer), {
                        ref: this.spinnerRef,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $7ep4S.default), {
                            size: spinnerSize,
                            testId: testId && `${testId}--loadingSpinner`,
                            label: loadingLabel
                        })
                    })
                })
            ]
        });
    }
    constructor(...args){
        super(...args), this.spinnerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createRef(), this.componentDidMount = ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        }, this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        }, this.componentDidUpdate = ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        }, this.componentWillUnmount = ()=>{
            this.detachListeners();
        }, this.getTargetNode = (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef?.();
            return target || this.containerRef.current;
        }, this.hasTargetNode = (nextProps)=>!!this.getTargetNode(nextProps), this.isVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        }, this.isFullyVerticallyVisible = (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        }, this.handleResize = ()=>{
            this.updateSpinnerPosition();
        }, this.handleScroll = ()=>{
            this.updateSpinnerPosition();
        }, this.translateSpinner = (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        }, this.updateTargetAppearance = ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        };
    }
}

});
parcelRegister("3rtaW", function(module, exports) {
$parcel$export(module.exports, "Container", () => $dcd16b6cedc99af6$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $dcd16b6cedc99af6$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $dcd16b6cedc99af6$export$a5e06607a5ac6158);
/* loading-container-advanced.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $dcd16b6cedc99af6$var$containerStyles = null;
const $dcd16b6cedc99af6$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ...rest,
        "data-testid": testId,
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _6rth1ejb"
        ]),
        children: children
    });
});
const $dcd16b6cedc99af6$var$spinnerBackdropStyles = null;
const $dcd16b6cedc99af6$export$aa207050321b0c53 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId && `${testId}--spinner-backdrop`,
        className: (0, $hcewu.default)([
            "_1r04idpf _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _lcxvglyw"
        ]),
        children: children
    });
const $dcd16b6cedc99af6$var$spinnerContainerStyles = null;
const $dcd16b6cedc99af6$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ children: children }, ref)=>/*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        ref: ref,
        className: (0, $hcewu.default)([
            "_kqswh2mm _152tidpf"
        ]),
        children: children
    }));

});


parcelRegister("5hPH6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d482c3e387def2e8$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $b3eVo = parcelRequire("b3eVo");
class $d482c3e387def2e8$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $b3eVo.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n?.label,
            nextLabel: i18n?.next,
            previousLabel: i18n?.prev,
            pageLabel: i18n?.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
    constructor(...args){
        super(...args), this.onChange = (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        };
    }
}

});

parcelRegister("iXYwm", function(module, exports) {
$parcel$export(module.exports, "default", () => $eab3a1b41c933c64$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $aXVGO = parcelRequire("aXVGO");

var $6d05d = parcelRequire("6d05d");

var $2YodG = parcelRequire("2YodG");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $eab3a1b41c933c64$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    constructor(props){
        super(props);
        this.state = {
            activeSortButtonId: null
        };
    }
    UNSAFE_componentWillMount() {
        (0, $aXVGO.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $aXVGO.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        const { activeSortButtonId: activeSortButtonId } = this.state;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $2YodG.default) : (0, $dYUdf.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.Head), {
            ...rest,
            isRanking: isRanking,
            testId: testId && `${testId}--head`,
            children: /*#__PURE__*/ (0, $gt9Am.jsx)("tr", {
                children: cells.map((cell, index)=>{
                    const { ascendingSortTooltip: ascendingSortTooltip, buttonAriaRoleDescription: buttonAriaRoleDescription, colSpan: colSpan, content: content, descendingSortTooltip: descendingSortTooltip, isIconOnlyHeader: isIconOnlyHeader, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
                    // the API.
                    ...restCellProps } = cell;
                    const headCellId = `head-cell-${index}`;
                    const handleClick = ()=>{
                        this.setState({
                            activeSortButtonId: headCellId
                        });
                        if (isSortable) onSort(cell)();
                    };
                    return /*#__PURE__*/ (0, $gt9Am.jsx)(HeadCellComponent, {
                        colSpan: colSpan,
                        content: content,
                        isFixedSize: isFixedSize,
                        isIconOnlyHeader: isIconOnlyHeader,
                        isSortable: !!isSortable,
                        isRanking: isRanking,
                        headCellId: headCellId,
                        activeSortButtonId: activeSortButtonId,
                        onClick: handleClick,
                        testId: cellTestId || testId,
                        shouldTruncate: shouldTruncate,
                        sortOrder: key === sortKey ? sortOrder : undefined,
                        width: width,
                        ascendingSortTooltip: ascendingSortTooltip,
                        descendingSortTooltip: descendingSortTooltip,
                        buttonAriaRoleDescription: buttonAriaRoleDescription,
                        ...restCellProps
                    }, key || index);
                })
            })
        });
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$eab3a1b41c933c64$export$2e2bcd8739ae039 = $eab3a1b41c933c64$var$TableHead;

});
parcelRegister("6d05d", function(module, exports) {
$parcel$export(module.exports, "Head", () => $8e34007a1dac0529$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $8e34007a1dac0529$export$4e8024263ace498b);
/* table-head.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @repo/internal/react/require-jsdoc */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");


var $1eoPo = parcelRequire("1eoPo");
const $8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $8e34007a1dac0529$var$rankingStyles = null;
const $8e34007a1dac0529$var$headStyles = null;
const $8e34007a1dac0529$var$overflowTruncateStyles = null;
const $8e34007a1dac0529$var$truncationWidthStyles = null;
const $8e34007a1dac0529$var$fixedSizeTruncateStyles = null;
const $8e34007a1dac0529$var$cellStyles = null;
const $8e34007a1dac0529$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)("thead", {
        "data-testid": testId,
        ...props,
        className: (0, $hcewu.default)([
            "_179rglyw",
            isRanking && "_1e0c1ule"
        ])
    });
};
const $8e34007a1dac0529$var$headCellBaseStyles = null;
const $8e34007a1dac0529$export$4e8024263ace498b = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $1eoPo.getTruncationStyleVars)({
            width: width
        }),
        [$8e34007a1dac0529$var$CSS_VAR_TEXT_COLOR]: "var(--ds-text-subtlest, #6B6E76)"
    };
    const isASC = sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $861def5c205d1816$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
        return;
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return /*#__PURE__*/ (0, $gt9Am.jsx)(Component, {
        "aria-sort": getFormattedSortOrder(),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: mergedStyles,
        onClick: undefined,
        ref: ref,
        "data-testid": testId,
        ...rest,
        className: (0, $hcewu.default)([
            "_izbqglyw _h7alglyw _85i51b66 _1q511b66 _y4tiu2gc _bozgu2gc _y3gn1e5h _1s37ze3t _uupyze3t",
            "_11c8dcr7 _179r1uh4 _mqm2glyw _kqswh2mm _syaz34id _k48pmoej _y3gn1e5h _s7n4nkob _1ygbd0i9",
            "_1bsb8a2a",
            isFixedSize && shouldTruncate && "_1bto1l2s _o5721q9c",
            isFixedSize && "_1reo15vq _18m915vq"
        ]),
        children: children
    });
});

});

parcelRegister("2YodG", function(module, exports) {
$parcel$export(module.exports, "default", () => $e8fde9bd86f03325$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fTTHR = parcelRequire("fTTHR");

var $aXVGO = parcelRequire("aXVGO");

var $dYUdf = parcelRequire("dYUdf");
// eslint-disable-next-line @repo/internal/react/no-class-components
class $e8fde9bd86f03325$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $aXVGO.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $dYUdf.default), {
            inlineStyles: inlineStyles,
            ...restProps
        });
    }
}
const $e8fde9bd86f03325$var$RankableTableHeadCell = (0, $fTTHR.default)($e8fde9bd86f03325$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e8fde9bd86f03325$export$2e2bcd8739ae039 = $e8fde9bd86f03325$var$RankableTableHeadCell;

});
parcelRegister("fTTHR", function(module, exports) {
$parcel$export(module.exports, "default", () => $173dc77e0c07b527$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");
function $173dc77e0c07b527$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Component {
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, $gt9Am.jsx)(WrappedComponent, {
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refWidth: refWidth,
                //@ts-expect-error TODO Fix legit TypeScript 3.9.6 improved inference error
                refHeight: refHeight,
                innerRef: this.innerRef,
                ...this.props
            });
        }
        constructor(...args){
            super(...args), this.state = {
                refWidth: 0,
                refHeight: 0
            }, this.innerRef = (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            }, this.updateDimensions = ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            };
        }
    };
}

});

parcelRegister("dYUdf", function(module, exports) {
$parcel$export(module.exports, "default", () => $f5386cb5a0fc1b36$export$2e2bcd8739ae039);
/* table-head-cell.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8Gywp = parcelRequire("8Gywp");

var $aDbql = parcelRequire("aDbql");

var $8IeH1 = parcelRequire("8IeH1");
var $2sLVw = parcelRequire("2sLVw");
var $46R8N = parcelRequire("46R8N");

var $k71qx = parcelRequire("k71qx");


var $6d05d = parcelRequire("6d05d");
const $f5386cb5a0fc1b36$var$styles = {
    buttonWrapper: "_1e0c1txw _bfhk18uv _4cvr1h6o _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _d0altlke",
    sortIconHiddenWrapper: "_1e0c1txw _tzy4idpf _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _1h7hkb7n",
    sortIconVisibleWrapper: "_1e0c1txw _tzy4kb7n _bfhk18uv _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66",
    hideIconHeaderWrapper: "_tzy4idpf _18u010v4",
    visibleHeaderWrapper: "_tzy4kb7n _u5f31b66"
};
const $f5386cb5a0fc1b36$var$headCellStyles = {
    headCellContainer: "_1e0c1txw _4cvr1h6o",
    text: "_11c81o8v _syazazsu _k48pmoej"
};
const $f5386cb5a0fc1b36$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, sortOrder: sortOrder, onClick: onClick, headCellId: headCellId, activeSortButtonId: activeSortButtonId, ascendingSortTooltip: ascendingSortTooltip = 'Sort ascending', descendingSortTooltip: descendingSortTooltip = 'Sort descending', buttonAriaRoleDescription: buttonAriaRoleDescription = 'Sort button', isIconOnlyHeader: isIconOnlyHeader, ...rest })=>{
    const [isHovered, setIsHovered] = (0, $eJOHy.useState)(false);
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const isActive = headCellId === activeSortButtonId || sortOrder !== undefined;
    const isSortIconVisible = isHovered || isActive || isFocused;
    const isVisibleIconOnlyHeader = isSortIconVisible && isIconOnlyHeader;
    const shouldRenderSortIcon = !isIconOnlyHeader || isSortIconVisible || isIconOnlyHeader && !isFocused;
    const handleFocus = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(true);
    }, [
        setIsFocused
    ]);
    const handleBlur = (0, $eJOHy.useCallback)(()=>{
        setIsFocused?.(false);
    }, [
        setIsFocused
    ]);
    const handleMouseEnter = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(true);
    }, [
        setIsHovered
    ]);
    const handleMouseLeave = (0, $eJOHy.useCallback)(()=>{
        setIsHovered(false);
    }, [
        setIsHovered
    ]);
    const visuallyRefreshedButton = /*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
        xcss: $f5386cb5a0fc1b36$var$headCellStyles.headCellContainer,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $k71qx.default), {
            content: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? ascendingSortTooltip : descendingSortTooltip,
            children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $46R8N.default), {
                onClick: onClick,
                xcss: $f5386cb5a0fc1b36$var$styles.buttonWrapper,
                "aria-roledescription": buttonAriaRoleDescription,
                children: [
                    /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isVisibleIconOnlyHeader ? $f5386cb5a0fc1b36$var$styles.hideIconHeaderWrapper : $f5386cb5a0fc1b36$var$styles.visibleHeaderWrapper,
                        children: /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
                            className: (0, $hcewu.default)([
                                $f5386cb5a0fc1b36$var$headCellStyles.text
                            ]),
                            children: content
                        })
                    }),
                    shouldRenderSortIcon && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $2sLVw.default), {
                        xcss: isSortIconVisible ? $f5386cb5a0fc1b36$var$styles.sortIconVisibleWrapper : $f5386cb5a0fc1b36$var$styles.sortIconHiddenWrapper,
                        children: sortOrder === (0, $861def5c205d1816$export$1dee026a19752d6b) ? /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aDbql))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--up--icon`
                        }) : /*#__PURE__*/ (0, $gt9Am.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8Gywp))), {
                            label: "",
                            color: "var(--ds-text-subtle, #505258)",
                            testId: testId && `${testId}--down--icon`
                        })
                    })
                ]
            })
        })
    });
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $6d05d.HeadCell), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null,
        ...rest,
        isSortable: isSortable,
        sortOrder: sortOrder,
        children: isSortable ? visuallyRefreshedButton : content
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f5386cb5a0fc1b36$export$2e2bcd8739ae039 = $f5386cb5a0fc1b36$var$TableHeadCell;

});
parcelRegister("8Gywp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fcfd9fc2877ad309c8a5d6e5d6ea9482>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $652d0645e24346a6$var$_react = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $652d0645e24346a6$var$_baseNew = $652d0645e24346a6$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $652d0645e24346a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Know uses: sorting table headers or Bitbucket code difference.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $652d0645e24346a6$var$ArrowDownIcon = (props)=>/*#__PURE__*/ $652d0645e24346a6$var$_react.default.createElement($652d0645e24346a6$var$_baseNew.default, Object.assign({
        name: "ArrowDownIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 1v11.44l3.72-3.72 1.06 1.06-5 5a.75.75 0 0 1-1.06 0l-5-5 1.06-1.06 3.72 3.72V1z" clip-rule="evenodd"/>`
    }, props));
$652d0645e24346a6$var$ArrowDownIcon.displayName = 'ArrowDownIcon';
var $652d0645e24346a6$var$_default = module.exports.default = $652d0645e24346a6$var$ArrowDownIcon;

});

parcelRegister("aDbql", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be13ec6c7b346b13ffda97746cc85c67>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7bd6687a611ada9e$var$_react = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("eJOHy")));

var $7bd6687a611ada9e$var$_baseNew = $7bd6687a611ada9e$var$_interopRequireDefault((parcelRequire("fGWXz")));
function $7bd6687a611ada9e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7bd6687a611ada9e$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $7bd6687a611ada9e$var$_react.default.createElement($7bd6687a611ada9e$var$_baseNew.default, Object.assign({
        name: "ArrowUpIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 15V3.56l3.72 3.72 1.06-1.06-5-5a.75.75 0 0 0-1.06 0l-5 5 1.06 1.06 3.72-3.72V15z" clip-rule="evenodd"/>`
    }, props));
$7bd6687a611ada9e$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $7bd6687a611ada9e$var$_default = module.exports.default = $7bd6687a611ada9e$var$ArrowUpIcon;

});




parcelRegister("itCCG", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("4aw4p")
]).then(()=>parcelRequire('l7wPr'));

});


parcelRegister("8TMMM", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1b6dcf21e6f1de9$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a1b6dcf21e6f1de9$var$messages = (0, $7qGN1.defineMessages)({
    filterResultAnnounce: {
        "id": "directory-base.content.table.filter-result-announce",
        "defaultMessage": "{itemCount, plural, one {One item was found after filtering.} other {{itemCount} items were found after filtering.}}"
    },
    filterResultsAnnouncement: {
        "id": "directory-base.content.table.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No results were found that match your search} one {{itemCount} result found} other {{itemCount} results found}}"
    }
});
var $a1b6dcf21e6f1de9$export$2e2bcd8739ae039 = $a1b6dcf21e6f1de9$var$messages;

});



parcelRegister("bj0qr", function(module, exports) {
$parcel$export(module.exports, "default", () => $017eecc563c11f26$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $54CI2 = parcelRequire("54CI2");
function $017eecc563c11f26$export$2e2bcd8739ae039(props) {
    const { Header: Header, Table: Table, Paginator: Paginator, Empty: Empty, Error: Error, status: status, onAdd: onAdd, onRetry: onRetry, isOnboardingEnabled: isOnboardingEnabled, renderOnboardingSpotlight: renderOnboardingSpotlight, availableSpotlightTargets: availableSpotlightTargets } = props;
    let main = null;
    let spotlight = null;
    switch(status){
        case 'has-entities':
            main = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Table, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Paginator, null));
            spotlight = isOnboardingEnabled && renderOnboardingSpotlight && renderOnboardingSpotlight(availableSpotlightTargets);
            break;
        case 'empty':
            main = Empty ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Empty, {
                onAdd: onAdd
            }) : null;
            break;
        case 'error':
            main = Error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Error, {
                onRetry: onRetry
            }) : null;
            break;
        default:
            break;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $54CI2.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, spotlight, Header ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Header, null) : null, main));
}
$017eecc563c11f26$export$2e2bcd8739ae039.defaultProps = {
    isOnboardingEnabled: false,
    renderOnboardingSpotlight: ()=>null,
    availableSpotlightTargets: [],
    onAdd: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onRetry: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};

});


parcelRegister("54lJh", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c677f42b9a16635$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $91zZ6 = parcelRequire("91zZ6");

var $6SY0Q = parcelRequire("6SY0Q");

var $ePZvy = parcelRequire("ePZvy");

var $7EfkR = parcelRequire("7EfkR");

var $dZ0bL = parcelRequire("dZ0bL");
const $7c677f42b9a16635$var$mapStateToProps = (state)=>({
        isCreateModalShown: (0, $6SY0Q.isCreateOpen)(state),
        CreateModal: $ePZvy.default,
        operations: (0, $6SY0Q.getOperations)(state),
        OperationModal: $7EfkR.default
    });
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Modals' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$7c677f42b9a16635$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($7c677f42b9a16635$var$mapStateToProps, {})((0, $dZ0bL.default));

});
parcelRegister("ePZvy", function(module, exports) {
$parcel$export(module.exports, "default", () => $e85a5d5d8af0cf08$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $91zZ6 = parcelRequire("91zZ6");

var $4wOQJ = parcelRequire("4wOQJ");

var $6SY0Q = parcelRequire("6SY0Q");

var $5kAHG = parcelRequire("5kAHG");
const $e85a5d5d8af0cf08$var$mapStateToProps = (state)=>{
    const CreateModal = (0, $6SY0Q.getCreateModal)(state);
    if (!CreateModal) throw new Error('Invalid state - no Create Modal provided');
    return {
        CreateModal: CreateModal
    };
};
const $e85a5d5d8af0cf08$var$mapDispatchToProps = {
    onCreated: (0, $4wOQJ.entityCreated),
    onCreateFailed: (0, $4wOQJ.entityCreateFailed),
    onCancel: (0, $4wOQJ.cancelled)
};
var $e85a5d5d8af0cf08$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($e85a5d5d8af0cf08$var$mapStateToProps, $e85a5d5d8af0cf08$var$mapDispatchToProps, null, (0, $91zZ6.storeOptions))((0, $5kAHG.default));

});
parcelRegister("5kAHG", function(module, exports) {
$parcel$export(module.exports, "default", () => $b78add7cdc0c3965$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $b78add7cdc0c3965$export$2e2bcd8739ae039(props) {
    const { CreateModal: CreateModal, onCreated: onCreated, onCreateFailed: onCreateFailed, onCancel: onCancel } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateModal, {
        onCreated: onCreated,
        onCreateFailed: onCreateFailed,
        onCancel: onCancel
    });
}

});


parcelRegister("7EfkR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ea54fa0c184bfea$export$2e2bcd8739ae039);

var $LFmXM = parcelRequire("LFmXM");

var $91zZ6 = parcelRequire("91zZ6");

var $5cBQu = parcelRequire("5cBQu");

var $6SY0Q = parcelRequire("6SY0Q");

var $aeXGs = parcelRequire("aeXGs");
const $6ea54fa0c184bfea$var$mapStateToPropsFactory = ()=>{
    const onDataRetrievedFactory = (0, $LFmXM.default)((state, id)=>// @ts-expect-error - TS7031 - Binding element 'patch' implicitly has an 'any' type.
        ({ patch: patch })=>(0, $6SY0Q.getOnPatch)(state)({
                id: id,
                patch: patch
            }));
    return (state, ownProps)=>{
        const { id: id, operation: operation } = ownProps;
        return {
            OperationModal: (0, $6SY0Q.getOperationModal)(state, operation),
            onDataRetrieved: onDataRetrievedFactory(state, id)
        };
    };
};
const $6ea54fa0c184bfea$var$mapDispatchToProps = (dispatch, ownProps)=>{
    const { id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing } = ownProps;
    return {
        entityId: id,
        isInitializing: isInitializing,
        onDialogShown: ()=>dispatch((0, $5cBQu.dialogShown)({
                id: id,
                operation: operation,
                childEntityId: childEntityId
            })),
        onDataRetrieveFailed: ()=>dispatch((0, $5cBQu.entityDataRetrieveFailed)({
                id: id,
                operation: operation
            })),
        // @ts-expect-error - TS2525 - Initializer provides no value for this binding element and the binding element has no default value.
        onUpdated: ({ patch: patch } = {})=>dispatch((0, $5cBQu.entityUpdated)({
                id: id,
                operation: operation,
                patch: patch
            })),
        onUpdateFailed: ()=>dispatch((0, $5cBQu.entityUpdateFailed)({
                id: id,
                operation: operation
            })),
        onCancel: ()=>dispatch((0, $5cBQu.cancelled)({
                id: id,
                operation: operation
            }))
    };
};
var // @ts-expect-error - TS2554 - Expected 3-4 arguments, but got 2. | TS2345 - Argument of type 'typeof Operation' is not assignable to parameter of type 'Component<DispatchProp<any>>'.
$6ea54fa0c184bfea$export$2e2bcd8739ae039 = (0, $91zZ6.connect)($6ea54fa0c184bfea$var$mapStateToPropsFactory, $6ea54fa0c184bfea$var$mapDispatchToProps)((0, $aeXGs.default));

});
parcelRegister("aeXGs", function(module, exports) {
$parcel$export(module.exports, "default", () => $0fff5b41a33d1817$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $0fff5b41a33d1817$export$2e2bcd8739ae039(props) {
    const { OperationModal: OperationModal, ...modalProps } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OperationModal, modalProps);
}

});


parcelRegister("dZ0bL", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3018c586c391011$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $b3018c586c391011$export$2e2bcd8739ae039(props) {
    const { isCreateModalShown: isCreateModalShown, CreateModal: CreateModal, operations: operations, OperationModal: OperationModal } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, isCreateModalShown && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateModal, null), operations.map(({ id: id, operation: operation, childEntityId: childEntityId, isInitializing: isInitializing })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OperationModal, {
            key: id,
            id: id,
            operation: operation,
            childEntityId: childEntityId,
            isInitializing: isInitializing
        })));
}

});


parcelRegister("dIYLk", function(module, exports) {
$parcel$export(module.exports, "default", () => $4d4b3dfd6658db1e$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
function $4d4b3dfd6658db1e$export$2e2bcd8739ae039(props) {
    const { Content: Content, Modals: Modals } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Modals, null));
}

});



parcelRegister("jn00M", function(module, exports) {
$parcel$export(module.exports, "default", () => $10a07ed554224eff$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $giQZR = parcelRequire("giQZR");

var $9pzQA = parcelRequire("9pzQA");

var $4JZ04 = parcelRequire("4JZ04");

var $6YFG2 = parcelRequire("6YFG2");

var $6onCX = parcelRequire("6onCX");
var $10a07ed554224eff$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6YFG2.default), (0, $giQZR.default)({
    CreateDialogLoader: $9pzQA.default,
    CreateButton: $4JZ04.default
}))((0, $6onCX.default));

});
parcelRegister("giQZR", function(module, exports) {
$parcel$export(module.exports, "default", () => $388c753b6a91fb19$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $388c753b6a91fb19$var$isEmpty = (s)=>s === undefined || s === null || s === '';
const $388c753b6a91fb19$var$getDisplayName = (x)=>{
    // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
    if (!$388c753b6a91fb19$var$isEmpty(x.displayName)) return x.displayName;
    if (!$388c753b6a91fb19$var$isEmpty(x.name)) return x.name;
    return 'Component';
};
const $388c753b6a91fb19$export$19c55c6cefb3b57 = (defaults)=>(Component)=>{
        const displayName = $388c753b6a91fb19$var$getDisplayName(Component);
        // @ts-expect-error - TS2698 - Spread types may only be created from object types. | TS2698 - Spread types may only be created from object types.
        const WithProps = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Component, {
                ...defaults,
                ...props
            });
        WithProps.displayName = `WithProps(${displayName})`;
        // @ts-expect-error - TS2322 - Type '{ (props: Partial<A> & B): JSX.Element; displayName: string; }' is not assignable to type 'AbstractComponent<Partial<A> & B, unknown>'.
        return WithProps;
    };
var $388c753b6a91fb19$export$2e2bcd8739ae039 = $388c753b6a91fb19$export$19c55c6cefb3b57;

});

parcelRegister("9pzQA", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f02d4278b6af52b$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eSnSE = parcelRequire("eSnSE");

var $giQZR = parcelRequire("giQZR");

var $4FEgv = parcelRequire("4FEgv");

var $5SFDA = parcelRequire("5SFDA");
const $3f02d4278b6af52b$var$showCreateBoardDialog = ()=>(0, $4FEgv.default)().catch((error)=>(0, $eSnSE.default).safeErrorWithoutCustomerData('directories.boards-v2.create-button.create-dialog-loader', error ? error.message : '', error));
var $3f02d4278b6af52b$export$2e2bcd8739ae039 = (0, $giQZR.default)({
    showCreateBoardDialog: $3f02d4278b6af52b$var$showCreateBoardDialog
})((0, $5SFDA.default));

});
parcelRegister("5SFDA", function(module, exports) {
$parcel$export(module.exports, "default", () => $e6c6eda277e6ab17$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
class $e6c6eda277e6ab17$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    setLoadingState(isLoading) {
        this.setState({
            isLoading: isLoading
        });
    }
    render() {
        const { children: children } = this.props;
        const { isLoading: isLoading } = this.state;
        return children(this.load, isLoading);
    }
    constructor(...args){
        super(...args), this.state = {
            isLoading: false
        }, this.onCreateBoardDialogLoaded = ()=>this.setLoadingState(false), // eslint-disable-next-line jira/react-arrow-function-property-naming
        this.load = ()=>{
            if (this.state.isLoading) return;
            this.setLoadingState(true);
            const { showCreateBoardDialog: showCreateBoardDialog } = this.props;
            showCreateBoardDialog().finally(this.onCreateBoardDialogLoaded);
        };
    }
}

});


parcelRegister("4JZ04", function(module, exports) {
$parcel$export(module.exports, "default", () => $faeec6325b2bd741$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eq3Hf = parcelRequire("eq3Hf");

var $6sjW5 = parcelRequire("6sjW5");

var $idGBm = parcelRequire("idGBm");

var $eqVMP = parcelRequire("eqVMP");
var $faeec6325b2bd741$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onClick: 'createBoard'
}), (0, $idGBm.injectIntlV2))((0, $eqVMP.default));

});
parcelRegister("eqVMP", function(module, exports) {
$parcel$export(module.exports, "default", () => $95f34818b994cbf6$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $goZPP = parcelRequire("goZPP");

var $4iGY3 = parcelRequire("4iGY3");
const $95f34818b994cbf6$var$StatelessButton = (props)=>{
    const { intl: { formatMessage: formatMessage }, onClick: onClick, isDisabled: isDisabled, withSpinner: withSpinner } = props;
    const showSpinner = withSpinner && isDisabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($95f34818b994cbf6$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        onClick: onClick,
        appearance: "primary" // @ts-expect-error - TS2322 - Type '{ children: string; onClick: () => void; appearance: "primary"; externalId: string; isDisabled: boolean; isLoading: boolean; }' is not assignable to type 'IntrinsicAttributes & ButtonProps & RefAttributes<HTMLElement>'.
        ,
        externalId: "directory.boards-v2.create-button.stateless-button",
        isDisabled: isDisabled,
        isLoading: showSpinner
    }, formatMessage((0, $4iGY3.default).createBoard)));
};
$95f34818b994cbf6$var$StatelessButton.defaultProps = {
    withSpinner: true
};
var $95f34818b994cbf6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $95f34818b994cbf6$var$StatelessButton;
const $95f34818b994cbf6$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4iGY3", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c8bf1946b147ce6$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $0c8bf1946b147ce6$var$messages = (0, $7qGN1.defineMessages)({
    createBoard: {
        "id": "directories.boards-v2.create-button.stateless-button.create-board",
        "defaultMessage": "Create board"
    }
});
var $0c8bf1946b147ce6$export$2e2bcd8739ae039 = $0c8bf1946b147ce6$var$messages;

});



parcelRegister("6onCX", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3717bea16124ca9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $6MnLl = parcelRequire("6MnLl");

var $4gAVz = parcelRequire("4gAVz");

var $hDg2i = parcelRequire("hDg2i");
const $a3717bea16124ca9$var$Empty = (props)=>{
    const { intl: { formatMessage: formatMessage }, CreateDialogLoader: CreateDialogLoader, CreateButton: CreateButton } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateDialogLoader, null, (load, isLoading)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
            imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($4gAVz))),
            header: formatMessage((0, $hDg2i.default).header),
            description: formatMessage((0, $hDg2i.default).description),
            isLoading: isLoading,
            primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateButton, {
                onClick: load,
                isDisabled: isLoading,
                withSpinner: false
            })
        }));
};
var $a3717bea16124ca9$export$2e2bcd8739ae039 = $a3717bea16124ca9$var$Empty;

});
parcelRegister("4gAVz", function(module, exports) {
module.exports = new URL("board.a55a3491.svg", import.meta.url).toString();

});

parcelRegister("hDg2i", function(module, exports) {
$parcel$export(module.exports, "default", () => $7349f80c7f9d4f9d$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $7349f80c7f9d4f9d$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "directories.boards-v2.main.content.empty.header",
        "defaultMessage": "You don't have any boards, yet"
    },
    description: {
        "id": "directories.boards-v2.main.content.empty.description",
        "defaultMessage": "Create a board to start tracking your work."
    }
});
var $7349f80c7f9d4f9d$export$2e2bcd8739ae039 = $7349f80c7f9d4f9d$var$messages;

});



parcelRegister("fSjPj", function(module, exports) {
$parcel$export(module.exports, "default", () => $5410229230129bb6$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $7FCY1 = parcelRequire("7FCY1");

var $2OxTv = parcelRequire("2OxTv");
const $5410229230129bb6$var$mapStateToProps = (state)=>({
        isLoading: (0, $7FCY1.isLoading)(state)
    });
var $5410229230129bb6$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($5410229230129bb6$var$mapStateToProps, {})((0, $2OxTv.default));

});
parcelRegister("2OxTv", function(module, exports) {
$parcel$export(module.exports, "default", () => $064689d9538386e7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4sAyo = parcelRequire("4sAyo");

var $lRq8t = parcelRequire("lRq8t");

var $ddZGF = parcelRequire("ddZGF");
function $064689d9538386e7$var$Error(props) {
    const { isLoading: isLoading, onRetry: onRetry } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4sAyo.default), {
        header: formatMessage((0, $ddZGF.default).header),
        description: formatMessage((0, $ddZGF.default).description),
        isLoading: isLoading,
        onRetry: onRetry
    });
}
$064689d9538386e7$var$Error.defaultProps = {
    isLoading: false
};
var $064689d9538386e7$export$2e2bcd8739ae039 = $064689d9538386e7$var$Error;

});
parcelRegister("4sAyo", function(module, exports) {
$parcel$export(module.exports, "default", () => $453bd51fb9ccfc1a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6MnLl = parcelRequire("6MnLl");

var $idGBm = parcelRequire("idGBm");

var $ixx7q = parcelRequire("ixx7q");

var $3Wbl1 = parcelRequire("3Wbl1");

var $ahcp8 = parcelRequire("ahcp8");
function $453bd51fb9ccfc1a$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($ixx7q))) : (0, (/*@__PURE__*/$parcel$interopDefault($3Wbl1)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6MnLl.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$453bd51fb9ccfc1a$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $ahcp8.default).retry
};
var $453bd51fb9ccfc1a$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($453bd51fb9ccfc1a$export$edf27be85e5f6da0);

});
parcelRegister("ixx7q", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("3Wbl1", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("ahcp8", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c9decea4f84155e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $3c9decea4f84155e$var$messages = (0, $7qGN1.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});
var $3c9decea4f84155e$export$2e2bcd8739ae039 = $3c9decea4f84155e$var$messages;

});


parcelRegister("ddZGF", function(module, exports) {
$parcel$export(module.exports, "default", () => $59143993dfa9b42a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $59143993dfa9b42a$var$messages = (0, $7qGN1.defineMessages)({
    header: {
        "id": "directories.boards-v2.main.content.error.header",
        "defaultMessage": "We couldn't load your boards"
    },
    description: {
        "id": "directories.boards-v2.main.content.error.description",
        "defaultMessage": "Give it another try. If you run into more trouble, contact your admin for help."
    }
});
var $59143993dfa9b42a$export$2e2bcd8739ae039 = $59143993dfa9b42a$var$messages;

});



parcelRegister("a625R", function(module, exports) {
$parcel$export(module.exports, "default", () => $38e2f9548cec39d4$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $jjRt1 = parcelRequire("jjRt1");

var $6sjW5 = parcelRequire("6sjW5");

var $k3q7u = parcelRequire("k3q7u");

var $gnQAk = parcelRequire("gnQAk");

var $fucyK = parcelRequire("fucyK");

var $hW5yn = parcelRequire("hW5yn");

var $1opnt = parcelRequire("1opnt");
const $38e2f9548cec39d4$var$FilterSearchWithAnalytics = (0, $6sjW5.default)({
    onChange: 'filterSearch'
})((0, $jjRt1.default));
const $38e2f9548cec39d4$var$ProjectTypePickerWithAnalytics = (0, $6sjW5.default)({
    onChange: 'projectSearch'
})((0, $k3q7u.default));
const $38e2f9548cec39d4$var$UserPickerWithAnalytics = (0, $6sjW5.default)({
    onChange: 'user'
})((0, $fucyK.default));
const $38e2f9548cec39d4$var$renderFilterSearch = (state)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($38e2f9548cec39d4$var$FilterSearchWithAnalytics, {
            ...props,
            value: (0, $hW5yn.getSearchText)(state)
        });
const $38e2f9548cec39d4$var$renderProjectPicker = (state)=>(props)=>/* @ts-expect-error - Type '{ selectedProject: Project | undefined; inputId: string; label?: string | undefined; width?: string | undefined; isDisabled?: boolean | undefined; placeholder?: string | undefined; ... 6 more ...; onChange: (arg1: Project, arg2: UIAnalyticsEvent) => void; }' is not assignable to type 'Omit<{ onChange: (arg1: Project | undefined, args_1: UIAnalyticsEvent) => void; placeholder?: string | undefined; selectedProject: Project | undefined; ... 10 more ...; forwardedRef?: Ref<...> | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($38e2f9548cec39d4$var$ProjectTypePickerWithAnalytics, {
            ...props,
            selectedProject: (0, $hW5yn.getSelectedProject)(state),
            inputId: "board-filters-project-picker-select",
            width: "100%"
        });
const $38e2f9548cec39d4$var$renderUserPicker = (state)=>(props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($38e2f9548cec39d4$var$UserPickerWithAnalytics, {
            ...props,
            selectedUser: (0, $hW5yn.getSelectedUser)(state),
            suggestedAccountId: (0, $hW5yn.getLoggedInUserAccountId)(state) ?? undefined,
            isCompact: true,
            shouldFitContainer: true
        });
    };
const $38e2f9548cec39d4$var$mapStateToPropsFactory = ()=>{
    const renderFilterSearchFactory = (0, $LFmXM.default)($38e2f9548cec39d4$var$renderFilterSearch);
    const renderProjectPickerFactory = (0, $LFmXM.default)($38e2f9548cec39d4$var$renderProjectPicker);
    const renderUserPickerFactory = (0, $LFmXM.default)($38e2f9548cec39d4$var$renderUserPicker);
    return (state, ownProps)=>({
            value: (0, $hW5yn.getFilter)(state),
            onChange: ownProps.onFilter,
            renderFilterSearch: renderFilterSearchFactory(state),
            renderProjectPicker: renderProjectPickerFactory(state),
            renderUserPicker: renderUserPickerFactory(state)
        });
};
var $38e2f9548cec39d4$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($38e2f9548cec39d4$var$mapStateToPropsFactory, {})((0, $1opnt.default));

});
parcelRegister("jjRt1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5a0c664de71f5fe1$export$2e2bcd8739ae039);

var $as6H2 = parcelRequire("as6H2");

var $gPaDt = parcelRequire("gPaDt");
const $5a0c664de71f5fe1$var$FilterSearchWithAnalytics = (0, $as6H2.default)('filterSearch', {
    onChange: 'changed'
})((0, $gPaDt.default));
var $5a0c664de71f5fe1$export$2e2bcd8739ae039 = $5a0c664de71f5fe1$var$FilterSearchWithAnalytics;

});
parcelRegister("gPaDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $ae2458133d2ad358$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $dqc6Z = parcelRequire("dqc6Z");
const $ae2458133d2ad358$export$4c4c11a6ab1f5b09 = 1000;
const $ae2458133d2ad358$var$debouncedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))((value, callback)=>callback(value), $ae2458133d2ad358$export$4c4c11a6ab1f5b09);
// eslint-disable-next-line jira/react/no-class-components
class $ae2458133d2ad358$var$Filter extends (0, $eJOHy.PureComponent) {
    static{
        this.defaultProps = {
            value: '',
            placeholder: '',
            describedById: '',
            hasAutoFocus: false,
            isCompact: true,
            increasedWidth: false,
            placeholderAlwaysVisible: false
        };
    }
    getSearchValue(value) {
        const searchValue = value === this.prevSearchValue ? this.prevQueryValue : value;
        if (value !== this.prevSearchValue) {
            this.prevSearchValue = value;
            this.prevQueryValue = value;
        }
        return searchValue;
    }
    render() {
        const searchValue = this.getSearchValue(this.props.value);
        const { hasAutoFocus: autoFocus, ariaLabelText: ariaLabelText, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dqc6Z.SearchField), {
            ...props,
            autoFocus: autoFocus,
            value: searchValue,
            onChange: this.handleOnChange,
            onEnter: this.handleNewValue,
            ariaLabelText: ariaLabelText,
            showIconBeforeInput: true
        });
    }
    constructor(...args){
        super(...args), this.prevQueryValue = this.props.value, this.prevSearchValue = this.props.value, this.handleNewValue = (newValue)=>{
            $ae2458133d2ad358$var$debouncedSearch.cancel();
            if (newValue !== this.props.value) this.props.onChange(newValue);
        }, this.handleOnChange = (newValue)=>{
            this.prevQueryValue = newValue;
            newValue === '' ? this.handleNewValue(newValue) : $ae2458133d2ad358$var$debouncedSearch(newValue, this.handleNewValue);
        };
    }
}
var $ae2458133d2ad358$export$2e2bcd8739ae039 = $ae2458133d2ad358$var$Filter;

});
parcelRegister("dqc6Z", function(module, exports) {
$parcel$export(module.exports, "SearchField", () => $84caf67c6542222b$export$b94867ecbd698f21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
var $awdRS = parcelRequire("awdRS");

var $6S4l2 = parcelRequire("6S4l2");

var $ftN6c = parcelRequire("ftN6c");

var $sY9BV = parcelRequire("sY9BV");

var $k71qx = parcelRequire("k71qx");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $lRq8t = parcelRequire("lRq8t");

var $bzbsd = parcelRequire("bzbsd");

var $4cTDP = parcelRequire("4cTDP");

var $1uv7v = parcelRequire("1uv7v");

var $kUoGK = parcelRequire("kUoGK");

var $1302Y = parcelRequire("1302Y");

var $7CY7m = parcelRequire("7CY7m");

var $4jrRd = parcelRequire("4jrRd");

var $ixnXK = parcelRequire("ixnXK");
// This class prevents filled in input field causing confirmation dialog
// when user wants to navigate away. This functionality is coming from Jira monolith.
const $84caf67c6542222b$var$className = 'ajs-dirty-warning-exempt';
const $84caf67c6542222b$var$SearchFieldContainer = ({ shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $kUoGK.useSoftwareProjectTheming)();
    return (0, $1302Y.getIsSoftwareThemingM2Enabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: [
            shouldFitContainerWidth && $84caf67c6542222b$var$fitContainerStyles,
            reducedHeight && $84caf67c6542222b$var$reducedHeightStyles,
            isSoftwareFullTheming && $84caf67c6542222b$var$themedBgStyles
        ]
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$Container, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, children);
};
const $84caf67c6542222b$var$STABLE_EMPTY_OBJECT = {};
const $84caf67c6542222b$var$SearchFieldUnmemoized = ({ onEnter: onEnter, onChange: onChange, onFocus: onFocus, onBlur: onBlur, placeholder: placeholder = '', inputRef: inputRef, value: externalValue, autoFocus: autoFocus = false, isCompact: isCompact = false, isDisabled: isDisabled = false, shouldFitContainerWidth: shouldFitContainerWidth = false, isAutocompleteDisabled: isAutocompleteDisabled = false, placeholderAlwaysVisible: placeholderAlwaysVisible = false, searchIconVisible: searchIconVisible = true, isAlwaysExpanded: isAlwaysExpanded = false, increasedWidth: increasedWidth = false, reducedHeight: reducedHeight = false, maxLength: maxLength, describedById: describedById = '', ariaLabelText: ariaLabelText, id: id, renderCustomSearchField: renderCustomSearchField, testId: testId, inputProps: inputProps = $84caf67c6542222b$var$STABLE_EMPTY_OBJECT, isResponsive: isResponsive = false, showIconBeforeInput: showIconBeforeInput = false, renderTooltipContent: renderTooltipContent = null })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    const [isFocused, setIsFocused] = (0, $eJOHy.useState)(false);
    const [value, setValue] = (0, $eJOHy.useState)(externalValue || '');
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const textInput = (0, $eJOHy.useRef)(null);
    const previousValueRef = (0, $eJOHy.useRef)();
    const previousValue = previousValueRef.current;
    if (externalValue !== previousValue && externalValue !== value) // @ts-expect-error - TS2345 - Argument of type 'string | undefined' is not assignable to parameter of type 'SetStateAction<string>'.
    setValue(externalValue);
    previousValueRef.current = externalValue;
    const handleOnFocus = (0, $eJOHy.useCallback)((event)=>{
        setIsFocused(true);
        onFocus && onFocus(event);
    }, [
        onFocus
    ]);
    const handleOnBlur = (0, $eJOHy.useCallback)((event)=>{
        onBlur && onBlur(event);
        setIsFocused(false);
    }, [
        onBlur
    ]);
    const handleOnChange = (0, $eJOHy.useCallback)(({ currentTarget: currentTarget })=>{
        const { value: val } = currentTarget;
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        setValue(val);
        onChange(val, analyticsEvent);
    }, [
        createAnalyticsEvent,
        onChange
    ]);
    const handleKeyDown = (0, $eJOHy.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed'
        });
        if (event.key === 'Escape') {
            setValue('');
            onChange('', analyticsEvent);
        }
        if (onEnter && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($6S4l2)))('enter')) {
            event.preventDefault();
            onEnter(event.currentTarget && event.currentTarget.value);
        }
    }, [
        createAnalyticsEvent,
        onChange,
        onEnter
    ]);
    const handleOnClear = (0, $eJOHy.useCallback)(()=>{
        if (value !== '') {
            const analyticsEvent = createAnalyticsEvent({
                action: 'changed'
            });
            setValue('');
            onChange('', analyticsEvent);
        }
        if (inputRef && inputRef.current !== null) inputRef.current.blur();
        if (textInput.current !== null) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        textInput.current.blur();
    }, [
        createAnalyticsEvent,
        inputRef,
        onChange,
        value
    ]);
    const isExpanded = isFocused || value !== '' || isAlwaysExpanded;
    const textFieldProps = (0, $eJOHy.useMemo)(()=>{
        return {
            ...inputProps,
            'aria-label': ariaLabelText || placeholder || formatMessage((0, $7CY7m.messages).search),
            'aria-describedby': describedById,
            type: 'text',
            'data-test-id': 'searchfield',
            testId: testId ?? 'searchfield',
            name: 'search',
            className: $84caf67c6542222b$var$className,
            placeholder: placeholder,
            onFocus: handleOnFocus,
            onBlur: handleOnBlur,
            width: '120px',
            onChange: handleOnChange,
            onKeyDown: handleKeyDown,
            ref: inputRef || textInput,
            isCompact: isCompact,
            autoFocus: autoFocus,
            autoComplete: isAutocompleteDisabled ? 'off' : 'on',
            value: value,
            maxLength: maxLength,
            isDisabled: isDisabled
        };
    }, [
        ariaLabelText,
        autoFocus,
        describedById,
        formatMessage,
        handleKeyDown,
        handleOnBlur,
        handleOnChange,
        handleOnFocus,
        inputProps,
        inputRef,
        isAutocompleteDisabled,
        isCompact,
        isDisabled,
        maxLength,
        placeholder,
        testId,
        value
    ]);
    const searchIconDynamic = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIconDynamic), {
        onClear: handleOnClear,
        hasValue: value !== '',
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear),
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded,
        ...(0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? {
            inCustomSearchField: renderCustomSearchField !== undefined
        } : {}
    });
    const searchIcon = showIconBeforeInput ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ixnXK.SearchFieldIcon), {
        searchIconVisible: searchIconVisible,
        onlyIconSpacing: isResponsive && !isExpanded
    }) : undefined;
    const clearIcon = showIconBeforeInput && value !== '' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4jrRd.ClearFieldIcon), {
        onClear: handleOnClear,
        clearIconLabel: formatMessage((0, $7CY7m.messages).clear)
    }) : undefined;
    const { onFocus: onFocusTextField, ref: textFieldRef, 'aria-describedby': textfieldAriaDescription, onBlur: onBlurTextField, ...restTextFieldProps } = textFieldProps;
    const showTooltip = (0, $eJOHy.useMemo)(()=>{
        return renderTooltipContent !== null && renderTooltipContent !== undefined && value === '';
    }, [
        renderTooltipContent,
        value
    ]);
    const useShowTooltip = (0, $eJOHy.useCallback)(()=>showTooltip, [
        showTooltip
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$SearchFieldContainer, {
        shouldFitContainerWidth: shouldFitContainerWidth,
        reducedHeight: reducedHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($84caf67c6542222b$var$InputWrapper, {
        isExpanded: isExpanded,
        shouldFitContainerWidth: shouldFitContainerWidth,
        maxWidth: increasedWidth ? 328 : 184,
        placeholderAlwaysVisible: placeholderAlwaysVisible,
        isResponsive: isResponsive
    }, renderCustomSearchField !== undefined ? renderCustomSearchField({
        textFieldProps: textFieldProps,
        searchIcon: searchIconDynamic
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: renderTooltipContent,
        canAppear: useShowTooltip,
        position: "bottom-start",
        hideTooltipOnClick: true,
        ignoreTooltipPointerEvents: true
    }, ({ onFocus: onFocusTooltip, ref: tooltipRef, 'aria-describedby': tooltipAriaDescription, onBlur: onBlurTooltip, ...tooltipProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $sY9BV.default), {
            ...tooltipProps,
            ...restTextFieldProps,
            elemBeforeInput: searchIcon,
            elemAfterInput: !showIconBeforeInput ? searchIconDynamic : clearIcon,
            ...id !== undefined ? {
                id: id
            } : {},
            // eslint-disable-next-line react-hooks/rules-of-hooks
            onFocus: (0, $eJOHy.useCallback)((event)=>{
                onFocusTextField && onFocusTextField(event);
                onFocusTooltip(event);
            }, [
                onFocusTooltip
            ]),
            // eslint-disable-next-line react-hooks/rules-of-hooks
            onBlur: (0, $eJOHy.useCallback)((event)=>{
                onBlurTextField && onBlurTextField(event);
                onBlurTooltip(event);
            }, [
                onBlurTooltip
            ]),
            ref: (0, $bzbsd.mergeRefs)(textFieldRef, tooltipRef),
            "aria-describedby": tooltipAriaDescription || textfieldAriaDescription
        }))));
};
$84caf67c6542222b$var$SearchFieldUnmemoized.displayName = 'Search';
$84caf67c6542222b$var$SearchFieldUnmemoized.whyDidYouRender = true;
const $84caf67c6542222b$export$b94867ecbd698f21 = /*#__PURE__*/ (0, $eJOHy.memo)($84caf67c6542222b$var$SearchFieldUnmemoized);
$84caf67c6542222b$export$b94867ecbd698f21.displayName = 'Search';
const $84caf67c6542222b$var$fitContainerStyles = (0, $1DXK0.xcss)({
    width: '100%'
});
const $84caf67c6542222b$var$reducedHeightStyles = (0, $1DXK0.xcss)({
    height: '32px'
});
const $84caf67c6542222b$var$themedBgStyles = (0, $1DXK0.xcss)({
    // @ts-expect-error - Apply the dominant colour behind the search input for image background themes
    backgroundColor: (0, $1uv7v.Tokens).COLOR_ELEVATION_SURFACE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    borderRadius: "var(--ds-radius-small, 4px)"
}); // Delete when cleaning up getIsSoftwareThemingM2Enabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $84caf67c6542222b$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldFitContainerWidth: shouldFitContainerWidth, reducedHeight: reducedHeight, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.shouldFitContainerWidth && "_1bsb1osq",
            __cmplp.reducedHeight && "_4t3izwfg",
            __cmplp.className
        ])
    });
});
const $84caf67c6542222b$var$InputWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { placeholderAlwaysVisible: placeholderAlwaysVisible, isResponsive: isResponsive, maxWidth: maxWidth, isExpanded: isExpanded, shouldFitContainerWidth: shouldFitContainerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1et2rhb": (0, $awdRS.default)(__cmplp.maxWidth, "px"),
            "--_47juog": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '30px'),
            "--_5cv8rq": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : '32px'),
            "--_jy5l88": (0, $awdRS.default)(__cmplp.isExpanded ? `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}` : "var(--ds-space-0, 0px)"),
            "--_1skyi4s": (0, $awdRS.default)(__cmplp.isExpanded ? 'auto' : 0),
            "--_1qenfck": (0, $awdRS.default)(__cmplp.isExpanded ? 1 : 0),
            "--_1b7586u": (0, $awdRS.default)(__cmplp.isExpanded ? `${__cmplp.maxWidth}px` : '120px'),
            "--_1b72lxu": (0, $awdRS.default)(__cmplp.shouldFitContainerWidth ? '100%' : `${__cmplp.isExpanded ? __cmplp.maxWidth : 120}px`)
        },
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_v564zpk5 _1e0c1txw _166qglyw _101ad2bq _i2ybkb7n",
            __cmplp.placeholderAlwaysVisible ? "_lav0kb7n" : "_lav0idpf",
            __cmplp.isResponsive ? "_1bsb1ayu _1s4pflvl _1kneabdv _odci1sf5 _ffa416hp _5xde1wic _1hr27bcq" : "_1bsb1di6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7CY7m", function(module, exports) {
$parcel$export(module.exports, "messages", () => $1790c56385a948ce$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $1790c56385a948ce$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    clear: {
        "id": "searchfield.clear",
        "defaultMessage": "Clear"
    },
    search: {
        "id": "searchfield.search",
        "defaultMessage": "Search"
    }
});

});

parcelRegister("4jrRd", function(module, exports) {
$parcel$export(module.exports, "ClearFieldIcon", () => $047d370cc11f69d8$export$84038b503874befa);

var $eJOHy = parcelRequire("eJOHy");

var $Ay1uj = parcelRequire("Ay1uj");

var $6zhpo = parcelRequire("6zhpo");

var $a03qM = parcelRequire("a03qM");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $047d370cc11f69d8$export$84038b503874befa = ({ onClear: onClear, clearIconLabel: clearIconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? $047d370cc11f69d8$var$wrapperStylesClearIcon : $047d370cc11f69d8$var$wrapperStylesCloseIcon
        ]
    }, (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $047d370cc11f69d8$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        "aria-label": clearIconLabel,
        testId: "searchfield.ui.clearfield-icon.clear-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
        appearance: "subtle",
        testId: "searchfield.ui.clearfield-icon.clear-button",
        onClick: onClear,
        label: clearIconLabel,
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6zhpo)))
    }));
const $047d370cc11f69d8$var$wrapperStylesCloseIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.025',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.050'
    }
});
const $047d370cc11f69d8$var$wrapperStylesClearIcon = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.050',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.075'
    }
});
const $047d370cc11f69d8$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});

parcelRegister("ixnXK", function(module, exports) {
$parcel$export(module.exports, "SearchFieldIconDynamic", () => $fd1be89cde4ae981$export$9eef03e91cdeba14);
$parcel$export(module.exports, "SearchFieldIcon", () => $fd1be89cde4ae981$export$8a82bff895521bd9);

var $eJOHy = parcelRequire("eJOHy");

var $goZPP = parcelRequire("goZPP");

var $6zhpo = parcelRequire("6zhpo");

var $dt3aG = parcelRequire("dt3aG");

var $8nu6j = parcelRequire("8nu6j");
var $6efFi = parcelRequire("6efFi");
var $bQP4O = parcelRequire("bQP4O");
var $1DXK0 = parcelRequire("1DXK0");

var $a03qM = parcelRequire("a03qM");

var $4cTDP = parcelRequire("4cTDP");
const $fd1be89cde4ae981$export$9eef03e91cdeba14 = ({ onClear: onClear, hasValue: hasValue, searchIconVisible: searchIconVisible, clearIconLabel: clearIconLabel, primaryColor: primaryColor, onlyIconSpacing: onlyIconSpacing = false, inCustomSearchField: inCustomSearchField = false })=>{
    const akSearchIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        label: "",
        LEGACY_primaryColor: primaryColor,
        color: "currentColor"
    });
    const searchIcon = searchIconVisible ? akSearchIcon : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStyles,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStyles,
            inCustomSearchField && (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') && $fd1be89cde4ae981$var$minimalSpacingStyles
        ]
    }, // eslint-disable-next-line no-nested-ternary
    hasValue ? (0, $4cTDP.fg)('jira_jif_jam_clear_text_icon') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bQP4O.default), {
        xcss: $fd1be89cde4ae981$var$iconWrapperStyles,
        onClick: onClear,
        // Clear button should not be focusable
        // see https://hello.atlassian.net/wiki/spaces/A11YKB/pages/3031993460/Clear+options+on+an+input+field
        tabIndex: -1,
        testId: "searchfield.ui.searchfield-icon.clear-button",
        "aria-label": clearIconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a03qM))), {
        label: ""
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle",
        spacing: "none",
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": "searchfield.ui.searchfield-icon.clear-button",
        testId: "searchfield.ui.searchfield-icon.clear-button",
        onClick: onClear,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6zhpo))), {
            label: clearIconLabel,
            LEGACY_primaryColor: primaryColor,
            color: "currentColor"
        })
    }) : searchIcon);
};
const $fd1be89cde4ae981$export$8a82bff895521bd9 = ({ searchIconVisible: searchIconVisible, onlyIconSpacing: onlyIconSpacing = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $fd1be89cde4ae981$var$wrapperStylesBefore,
            onlyIconSpacing && $fd1be89cde4ae981$var$spacingStylesBefore
        ]
    }, searchIconVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dt3aG))), {
        spacing: "none",
        label: "",
        color: "var(--ds-icon, #292A2E)"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null));
const $fd1be89cde4ae981$var$wrapperStyles = (0, $1DXK0.xcss)({
    color: 'color.text.accent.gray',
    marginTop: 'space.0',
    // the wider marginRight is applicable for when the search/clear icon is after the input
    marginRight: 'space.100',
    marginBottom: 'space.0',
    marginLeft: 'space.0',
    height: '16px',
    display: 'flex',
    alignItems: 'center'
});
// if this icon is used in a custom search field, we won't assume any spacing since we don't know where their searchIcon is used
// i.e. before or after the input
// it will be up to the consumers to add spacing where needed
const $fd1be89cde4ae981$var$minimalSpacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.0'
});
const $fd1be89cde4ae981$var$spacingStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginRight: 'space.100'
    }
});
const $fd1be89cde4ae981$var$wrapperStylesBefore = (0, $1DXK0.xcss)({
    display: 'flex',
    marginRight: 'space.0',
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$spacingStylesBefore = (0, $1DXK0.xcss)({
    marginLeft: 'space.075',
    [(0, $6efFi.media).above.md]: {
        marginLeft: 'space.100'
    }
});
const $fd1be89cde4ae981$var$iconWrapperStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    cursor: 'pointer',
    paddingInlineStart: 'space.0',
    paddingInlineEnd: 'space.0',
    paddingBlockStart: 'space.0',
    paddingBlockEnd: 'space.0',
    borderRadius: 'radius.full',
    color: 'color.text.subtlest',
    ':hover': {
        color: 'color.text.accent.gray'
    }
});

});




parcelRegister("k3q7u", function(module, exports) {
$parcel$export(module.exports, "default", () => $993004d92fc3087c$export$2e2bcd8739ae039);

var $as6H2 = parcelRequire("as6H2");

var $2uf1V = parcelRequire("2uf1V");
var $993004d92fc3087c$export$2e2bcd8739ae039 = (0, $as6H2.default)('ProjectPicker', {
    onChange: 'changed'
})((0, $2uf1V.default));

});
parcelRegister("2uf1V", function(module, exports) {
$parcel$export(module.exports, "default", () => $649631acf9dc7036$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $2sHLK = parcelRequire("2sHLK");

var $idGBm = parcelRequire("idGBm");

var $7RIAd = parcelRequire("7RIAd");

var $559oH = parcelRequire("559oH");
class $649631acf9dc7036$export$a4519235a2ef9605 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isCompact: false,
            detailed: false,
            width: '200px',
            requireBrowsePermission: false,
            requireEditPermission: false,
            label: undefined,
            inputId: undefined,
            projectType: undefined,
            filterCallbackFn: undefined
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedProject: this.props.selectedProject,
            projects: [],
            prevSelectedProject: this.props.selectedProject
        }, this.onSelected = (selectedOption)=>{
            this.setState({
                selectedProject: selectedOption
            });
            this.props.onChange(selectedOption);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (project)=>{
            const { avatarUrl: avatarUrl, name: name } = project;
            const avatar = this.props.renderAvatar ? this.props.renderAvatar(avatarUrl) : avatarUrl;
            return {
                avatar: avatar,
                label: name
            };
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.fetchOptions = async (filter)=>{
            let projects = await (0, $7RIAd.requestProjects)(filter, {
                detailed: this.props.detailed,
                requireBrowsePermission: this.props.requireBrowsePermission,
                requireEditPermission: this.props.requireEditPermission,
                projectType: this.props.projectType,
                maxResults: this.props.maxResults
            });
            if (this.props.filterCallbackFn) projects = projects.filter(this.props.filterCallbackFn);
            this.setState({
                projects: projects
            });
            return projects;
        };
        this.projectPickerId = `project-picker.label.id-${(0, $aXKmr.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentProjectId = props.selectedProject && props.selectedProject.value;
        const prevProjectId = state.prevSelectedProject && state.prevSelectedProject.value;
        if (currentProjectId !== prevProjectId) return {
            ...state,
            selectedProject: props.selectedProject,
            prevSelectedProject: props.selectedProject
        };
        return null;
    }
    componentDidMount() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    componentDidUpdate() {
        const { selectedProject: selectedProject } = this.state;
        if (selectedProject && !selectedProject.name) this.fetchProject(selectedProject);
    }
    fetchProject(selectedProject) {
        const projectValue = selectedProject.value;
        // @ts-expect-error - TS7006 - Parameter 'newProject' implicitly has an 'any' type.
        const updateSelectedProject = (newProject)=>{
            const currentProject = this.state.selectedProject;
            const currentProjectValue = currentProject && currentProject.value;
            // Update the state only in case the project wasn't changed
            if (currentProjectValue === projectValue) {
                this.setState({
                    selectedProject: newProject
                });
                this.props.onChange(newProject);
            }
        };
        return (0, $7RIAd.requestProject)(projectValue).then((project)=>updateSelectedProject(project)).catch(()=>updateSelectedProject(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, selectedProject: selectedProject, onChange: onChange, ...props } = this.props;
        const { selectedProject: project, projects: projects } = this.state;
        // the selected option needs to have same object reference to be correctly announced by screen readers
        const selectedOptionWithObjectReference = projects?.find((projectInList)=>projectInList.value === project?.value);
        const selectedOption = selectedOptionWithObjectReference || (project && project.name ? project : null);
        return(// @ts-expect-error - TS2769 - No overload matches this call.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sHLK.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $559oH.default).labelText) : undefined,
            ...props,
            inputId: !this.props.inputId ? this.projectPickerId : this.props.inputId,
            errorMessage: formatMessage((0, $559oH.default).error),
            placeholder: this.props.placeholder || formatMessage((0, $559oH.default).placeholder),
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: selectedOption,
            showFocusedAvatar: true
        }));
    }
}
var $649631acf9dc7036$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($649631acf9dc7036$export$a4519235a2ef9605);

});
parcelRegister("2sHLK", function(module, exports) {
$parcel$export(module.exports, "PickerWithAvatar", () => $3183b99370c8c0ed$export$e6b8a87858f7afd1);
$parcel$export(module.exports, "PickerWithAvatarAndAnalytics", () => $3183b99370c8c0ed$export$3d409af828769e2e);
/**
 * This is the base for Picker that can be used to create any type of component:
 * 1) with a list of predefined options
 * 2) that dynamically fetches its options from external resource.
 */ 
var $as6H2 = parcelRequire("as6H2");

var $fJTOm = parcelRequire("fJTOm");

var $87K62 = parcelRequire("87K62");
const $3183b99370c8c0ed$export$e6b8a87858f7afd1 = (0, $87K62.default);
const $3183b99370c8c0ed$export$3d409af828769e2e = (0, $as6H2.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $87K62.default));
const $3183b99370c8c0ed$export$d8d9f25d80d89b16 = (0, $as6H2.default)('picker', {
    onSelected: 'changed',
    onMultiSelected: 'multi-changed'
})((0, $fJTOm.default));

});
parcelRegister("fJTOm", function(module, exports) {
$parcel$export(module.exports, "getOptionBaseStyles", () => $69685483963d086b$export$cef6e25059b681a);
$parcel$export(module.exports, "Picker", () => $69685483963d086b$export$ba25329847403e11);
$parcel$export(module.exports, "default", () => $69685483963d086b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $3s8bj = parcelRequire("3s8bj");

var $12DRg = parcelRequire("12DRg");

var $4ibbN = parcelRequire("4ibbN");

var $1jVV7 = parcelRequire("1jVV7");

var $goZPP = parcelRequire("goZPP");

var $8IeH1 = parcelRequire("8IeH1");

var $3DNvO = parcelRequire("3DNvO");
var $6UCkD = parcelRequire("6UCkD");
var $6XEne = parcelRequire("6XEne");
var $kVcjU = parcelRequire("kVcjU");
var $c4OV1 = parcelRequire("c4OV1");

var $k71qx = parcelRequire("k71qx");

var $fceQU = parcelRequire("fceQU");

var $4cTDP = parcelRequire("4cTDP");

var $lxUP5 = parcelRequire("lxUP5");

var $6joHJ = parcelRequire("6joHJ");

var $6YFG2 = parcelRequire("6YFG2");

var $6rlhA = parcelRequire("6rlhA");
const $69685483963d086b$export$3a3072dd741f354b = 500;
const $69685483963d086b$export$cef6e25059b681a = (optionState)=>({
        ...optionState.isDisabled ? {
            cursor: 'not-allowed',
            color: "var(--ds-text-subtlest, #6B6E76)",
            '&, :active': {
                backgroundColor: 'transparent'
            }
        } : {
            cursor: 'pointer'
        },
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    });
class $69685483963d086b$export$ba25329847403e11 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: false,
            isCompact: false,
            isCreatable: false,
            isMulti: false,
            noPortal: false,
            isCheckbox: false,
            label: undefined,
            defaultValue: undefined,
            width: 'auto',
            onSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onMultiSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    static getDerivedStateFromProps(props) {
        if (props.menuIsOpen !== undefined) return {
            menuIsOpen: props.menuIsOpen
        };
        return null;
    }
    constructor(props){
        super(props), this.state = {
            validationState: 'default',
            showErrorMessage: false,
            menuWasOpen: false,
            menuIsOpen: false,
            initialFocusHandled: false
        }, this.onSelected = (selection, action, analyticsEvent)=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
            const { isMulti: isMulti } = this.props;
            if (Array.isArray(selection)) {
                if (isMulti) // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                this.props.onMultiSelected(selection, analyticsEvent);
                else // When the selection is cleared in single select mode, selection is an array.
                this.props.onSelected(undefined, analyticsEvent);
            } else // @ts-expect-error - TS2339 - Property 'value' does not exist on type 'SelectOption'.
            selection && selection.value ? this.props.onSelected(selection, analyticsEvent) : this.props.onSelected(undefined, analyticsEvent);
        }, this.onMenuOpen = ()=>{
            this.setState(()=>({
                    menuIsOpen: true,
                    menuWasOpen: true
                }));
        }, this.onMenuClose = ()=>{
            this.setState(()=>({
                    menuIsOpen: false
                }));
        }, this.onBlur = (event)=>{
            this.hideErrorMessage();
            const { onBlur: onBlur } = this.props;
            if (onBlur && typeof onBlur === 'function') onBlur(event);
        }, this.onFocus = (event)=>{
            this.showErrorMessage();
            const { onFocus: onFocus } = this.props;
            if (onFocus && typeof onFocus === 'function') onFocus(event);
        }, this.setErrorState = ()=>{
            this.setState({
                showErrorMessage: true,
                validationState: 'error'
            });
        }, this.showErrorMessage = ()=>this.setState({
                showErrorMessage: true
            }), this.hideErrorMessage = ()=>this.setState({
                showErrorMessage: false
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.loadOptions = (filter, callback)=>{
            this.setState({
                validationState: 'default'
            });
            this.debouncedLoadOptions(filter, callback);
        }, this.renderOption = (props)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const propsData = props.data;
            const disableReason = props.isDisabled && propsData && propsData.disableReason || null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
                position: "right",
                content: disableReason
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).Option // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , props));
        } // Will remove this renderMenuList when clean up FG since it's no longer needed
        , this.renderMenuList = (menuListProps)=>{
            const { isClearable: isClearable, intl: { formatMessage: formatMessage } } = this.props;
            return(// @ts-expect-error - TS2740 - Type '{ children: (Element | ReactNode)[]; hasValue: boolean; clearValue: () => void; }' is missing the following properties from type 'CommonProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>': cx, getStyles, getValue, isMulti, and 6 more.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).MenuList, menuListProps, isClearable && menuListProps.hasValue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $69685483963d086b$var$styles.clearButtonWrapper
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                appearance: "link",
                shouldFitContainer: true,
                onClick: menuListProps.clearValue
            }, formatMessage((0, $6rlhA.default).clearSelected))), menuListProps.children));
        }, this.renderValueContainer = (props)=>{
            const { onValueContainerClick: onValueContainerClick } = props.selectProps;
            return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8IeH1.default), {
                xcss: $69685483963d086b$var$styles.valueContainer,
                onClick: onValueContainerClick,
                testId: "common-components-picker.base.react-dnd-and-select-focus-bug-fix"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6XEne.components).ValueContainer, props)));
        }; // This is initialized in constructor because when it is a class property then flow gets confused about the generic type in callback.
        // That is a known bug: https://github.com/facebook/flow/issues/6978
        this.debouncedLoadOptions = (0, (/*@__PURE__*/$parcel$interopDefault($3s8bj)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (filter, callback)=>{
            // @ts-expect-error - TS2349 - This expression is not callable.
            this.props.options(filter).then(callback, ()=>{
                callback([]);
                this.setErrorState();
            });
        }, $69685483963d086b$export$3a3072dd741f354b); // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
        this.selectRef = /*#__PURE__*/ (0, $eJOHy.createRef)();
    }
    getSelectComponent(isAsync) {
        if (this.props.isCreatable) return isAsync ? (0, $3DNvO.default) : (0, $kVcjU.default);
        if (isAsync) return 0, $4ibbN.AsyncSelectWithAnalytics;
        return this.props.isCheckbox ? (0, $6UCkD.default) : (0, $c4OV1.default);
    }
    getComponentOverrides() {
        const { menuWasOpen: menuWasOpen } = this.state;
        const Option = {
            Option: this.renderOption
        }; // Remove MenuList when clean up FG since we no longer need to override to add `Clear Selected` button
        const MenuList = (0, $4cTDP.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {} : {
            MenuList: this.renderMenuList
        };
        const LoadingIndicator = menuWasOpen ? {} : {
            LoadingIndicator: null
        };
        return {
            ...this.props.components,
            ...Option,
            ...MenuList,
            ...LoadingIndicator
        };
    }
    render() {
        const { showErrorMessage: showErrorMessage, validationState: validationState, menuIsOpen: menuIsOpen } = this.state;
        const { intl: { formatMessage: formatMessage } } = this.props;
        const { label: label, listItemCustomStyles: listItemCustomStyles, placeholder: placeholder = formatMessage((0, $6rlhA.default).defaultPlaceholder), defaultValue: defaultValue, isRequired: isRequired, isDisabled: isDisabled, isCompact: isCompact, isClearableWithCrossIcon: isClearableWithCrossIcon, errorMessage: errorMessage, options: options, width: width, minWidth: minWidth, noPortal: noPortal, isCheckbox: isCheckbox, hasDraggableParentComponent: hasDraggableParentComponent } = this.props;
        const isAsync = typeof options === 'function';
        const SelectComponent = this.getSelectComponent(isAsync);
        const isErrorMessageOpened = showErrorMessage && validationState === 'error';
        let selectParams = {
            placeholder: placeholder,
            isDisabled: isDisabled,
            isClearable: isClearableWithCrossIcon || false,
            defaultValue: defaultValue,
            defaultOptions: true,
            autoFocus: !!this.props.autoFocus,
            loadOptions: isAsync && this.loadOptions,
            options: !isAsync && options,
            onChange: this.onSelected,
            noOptionsMessage: ()=>this.props.noOptionsMessage ?? formatMessage((0, $6rlhA.default).noOptions),
            loadingMessage: ()=>formatMessage((0, $6rlhA.default).loading),
            validationState: this.state.validationState,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            menuPortalTarget: noPortal ? null : (0, $fceQU.getDocument)()?.body,
            spacing: isCompact ? 'compact' : 'default',
            styles: {
                ...this.props.styles,
                // without properly set zIndex value dropdown with options is cut inside modal dialogs
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $1jVV7.layers).modal
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type.
                container: (base)=>({
                        ...base,
                        width: width,
                        minWidth: minWidth
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                option: (base, optionState)=>({
                        ...base,
                        ...$69685483963d086b$export$cef6e25059b681a(optionState),
                        ...listItemCustomStyles
                    }),
                // @ts-expect-error - TS7006 - Parameter 'base' implicitly has an 'any' type. | TS7006 - Parameter 'optionState' implicitly has an 'any' type.
                menu: (base)=>{
                    return {
                        ...base,
                        width: 'max-content',
                        // This makes the menu fit the widest content
                        minWidth: '100%'
                    };
                }
            }
        };
        if (!isCheckbox) selectParams = {
            ...selectParams,
            menuIsOpen: // @ts-expect-error - TS2322 - Type '{ menuIsOpen: boolean; onMenuOpen: () => void; onMenuClose: () => void; components: { LoadingIndicator?: undefined; MenuList: (menuListProps: MenuListProps) => JSX.Element; Option: (props: CommonProps<...> & ... 1 more ... & { ...; }) => JSX.Element; } | { ...; }; ... 16 more ...; styles: { ...; }; }' is not assignable to type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'.
            menuIsOpen,
            onMenuOpen: this.onMenuOpen,
            onMenuClose: this.onMenuClose,
            components: this.getComponentOverrides()
        };
         // When "hasDraggableParentComponent" is true, this means <Select /> is nested inside <Draggable /> from react-beautiful-dnd
        // This relationship prevents the dropdown menu from opening because of bugs in the default focus state and clicking in a particular area of <Select />
        // Context: https://hello.atlassian.net/wiki/spaces/~989411314/pages/2861097485/Investigation+Notes+for+atlaskit+select+react-beautiful-dnd#Temporary-Solution
        if (hasDraggableParentComponent) {
            const { initialFocusHandled: initialFocusHandled } = this.state;
            const handleClick = ()=>{
                if (initialFocusHandled) // As <Select /> is already focused, calling this.selectRef.current.focus() again no longer triggers its own handlers (i.e. onMenuOpen, onMenuClose)
                // We have to manually handle the open and close states of the dropdown menu based on a user's click from this point onwards to prevent the bug
                this.setState((state)=>({
                        menuIsOpen: !state.menuIsOpen
                    }));
                else if (!menuIsOpen) {
                    // Trigger focus state when ValueContainer is clicked for the first time
                    // The focused state will then invoke <Select /> instance's own handlers (e.g. onMenuOpen, onMenuClose)
                    // to manage the state of the dropdown menu
                    // @ts-expect-error - Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                    this.selectRef.current.focus();
                    this.setState(()=>({
                            initialFocusHandled: true
                        }));
                }
            };
            selectParams = {
                ...selectParams,
                // @ts-expect-error - Object literal may only specify known properties, and 'ref' does not exist in type '{ placeholder: string; isDisabled: boolean | undefined; isClearable: boolean; defaultValue: SelectOption | undefined; defaultOptions: boolean; autoFocus: boolean; loadOptions: false | ((filter: string, callback: (arg1: SelectOption[]) => Record<...>) => void); ... 9 more ...; styles: { ...; }; }'
                // + Property 'selectRef' does not exist on type 'Picker<SelectOption>'
                ref: this.selectRef,
                components: {
                    ...this.getComponentOverrides,
                    ValueContainer: this.renderValueContainer
                },
                onValueContainerClick: handleClick,
                openMenuOnFocus: true
            };
        }
        const { isClearable: isClearable } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lxUP5.FieldLabel), {
            htmlFor: this.props.inputId,
            label: label,
            isRequired: isRequired
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6joHJ.JiraInlineDialog), {
            content: errorMessage,
            isOpen: isErrorMessageOpened,
            messageId: `common-components-picker.base.jira-inline-dialog.pickerErrorMessage.${this.props.inputId ?? 'unnamedInputId'}`,
            messageType: "transactional",
            placement: "right"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(SelectComponent, {
            inputId: this.props.inputId,
            ...this.props,
            ...selectParams,
            ...(0, $4cTDP.fg)('jfp-a11y-team_update_legacy_select_clear_fuction') ? {
                isClearable: isClearable
            } : {},
            options: isAsync ? undefined : this.props.options
        })));
    }
}
// @ts-expect-error This is required because of the ratcheted conversion from intlV2 to intl
const $69685483963d086b$var$PickerWithIntl = (0, $6YFG2.default)($69685483963d086b$export$ba25329847403e11);
const $69685483963d086b$var$DefaultPicker = (props)=>{
    // this function exists only to "preserve" generic on the Picker that is lost at injectIntl
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($69685483963d086b$var$PickerWithIntl, props);
};
$69685483963d086b$var$DefaultPicker.defaultProps = $69685483963d086b$export$ba25329847403e11.defaultProps;
var $69685483963d086b$export$2e2bcd8739ae039 = $69685483963d086b$var$DefaultPicker;
const $69685483963d086b$var$styles = {
    clearButtonWrapper: "_n7zlia51",
    valueContainer: "_16jlkb7n"
};

});
parcelRegister("4ibbN", function(module, exports) {
$parcel$export(module.exports, "AsyncSelectWithAnalytics", () => $ff7c32c387190ed2$export$ee664e5add893f9);

var $gWITR = parcelRequire("gWITR");

var $as6H2 = parcelRequire("as6H2");
const $ff7c32c387190ed2$export$ee664e5add893f9 = (0, $as6H2.default)('select', {
    onChange: 'changed'
})((0, $gWITR.default));

});

parcelRegister("3DNvO", function(module, exports) {
$parcel$export(module.exports, "default", () => $35aa8c3d4d43b8a4$export$2e2bcd8739ae039);

var $7pkFT = parcelRequire("7pkFT");

var $dDv66 = parcelRequire("dDv66");
const $35aa8c3d4d43b8a4$var$AsyncCreatableSelect = (0, $dDv66.default)((0, $7pkFT.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$35aa8c3d4d43b8a4$export$2e2bcd8739ae039 = $35aa8c3d4d43b8a4$var$AsyncCreatableSelect;

});
parcelRegister("7pkFT", function(module, exports) {
$parcel$export(module.exports, "default", () => $69fba18f5363b86b$export$2e2bcd8739ae039);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $5tlgh = parcelRequire("5tlgh");

var $iSKoM = parcelRequire("iSKoM");

var $9gNEN = parcelRequire("9gNEN");

var $gVVTN = parcelRequire("gVVTN");
const $69fba18f5363b86b$var$AsyncCreatableSelect = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>{
    const stateManagerProps = (0, $iSKoM.default)(props);
    const creatableProps = (0, $gVVTN.default)(stateManagerProps);
    const selectProps = (0, $9gNEN.default)(creatableProps);
    // @ts-ignore - TS2322: Complex generic type causing issues for help-center local consumption with TS 5.9.2
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $5tlgh.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$69fba18f5363b86b$export$2e2bcd8739ae039 = $69fba18f5363b86b$var$AsyncCreatableSelect;

});


parcelRegister("lxUP5", function(module, exports) {
$parcel$export(module.exports, "FieldLabel", () => $02d61fcf6733b580$export$1acdcf5a973a8414);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $806LH = parcelRequire("806LH");
const $02d61fcf6733b580$export$1acdcf5a973a8414 = ({ label: label, htmlFor: htmlFor, isRequired: isRequired = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($02d61fcf6733b580$var$Label, {
        htmlFor: htmlFor
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $806LH.default), {
        size: "xxsmall",
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz1rpy _1e0c1ule _ca0qv47k _u5f3idpf _n3td1b66 _19bvidpf _ect41gqc"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", null, label), isRequired ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("span", {
        role: "presentation",
        className: (0, $hcewu.default)([
            "_syaz1tmw _19bvv77o _ect41gqc"
        ])
    }, "*") : null)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $02d61fcf6733b580$var$Label = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1ule",
            __cmplp.className
        ])
    });
});
const $02d61fcf6733b580$var$labelStyle = null;
const $02d61fcf6733b580$var$requiredIndicatorStyle = null;

});

parcelRegister("6joHJ", function(module, exports) {
$parcel$export(module.exports, "JiraInlineDialog", () => $765bdfac52a4c302$export$7ab52478615504b3);

var $eJOHy = parcelRequire("eJOHy");

var $cwZBT = parcelRequire("cwZBT");

var $bRMVI = parcelRequire("bRMVI");

var $fYeTG = parcelRequire("fYeTG");

var $1kIuW = parcelRequire("1kIuW");
const $765bdfac52a4c302$export$7ab52478615504b3 = (props)=>{
    if ((0, $bRMVI.shouldBeChoreographed)(props)) {
        if ((0, $fYeTG.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1kIuW.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cwZBT.default), rest);
};

});
parcelRegister("1kIuW", function(module, exports) {
$parcel$export(module.exports, "ChoreographerInlineDialog", () => $7432b934335413bd$export$44a404f218b0e66e);

var $cwZBT = parcelRequire("cwZBT");

var $4GudG = parcelRequire("4GudG");
const $7432b934335413bd$export$44a404f218b0e66e = (0, $4GudG.withChoreographedToggle)((0, $cwZBT.default), 'isOpen', 'content');

});


parcelRegister("6rlhA", function(module, exports) {
$parcel$export(module.exports, "default", () => $742c5e69dae6a49f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $742c5e69dae6a49f$var$messages = (0, $7qGN1.defineMessages)({
    noOptions: {
        "id": "common.components.picker.base.no-options",
        "defaultMessage": "No results"
    },
    loading: {
        "id": "common.components.picker.base.loading",
        "defaultMessage": "Searching..."
    },
    defaultPlaceholder: {
        "id": "common.components.picker.base.default-placeholder",
        "defaultMessage": "Select..."
    },
    clearSelected: {
        "id": "common.components.picker.base.clear-selected",
        "defaultMessage": "Clear selected"
    }
});
var $742c5e69dae6a49f$export$2e2bcd8739ae039 = $742c5e69dae6a49f$var$messages;

});


parcelRegister("87K62", function(module, exports) {
$parcel$export(module.exports, "default", () => $33a231bde2dbcecf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5DgXR = parcelRequire("5DgXR");

var $2sLVw = parcelRequire("2sLVw");

var $fJTOm = parcelRequire("fJTOm");
class $33a231bde2dbcecf$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            showFocusedAvatar: false
        };
    }
    render() {
        const { formatOptionDataTransformer: formatOptionDataTransformer, showFocusedAvatar: showFocusedAvatar, ...props } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fJTOm.default), {
            ...props,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            formatOptionLabel: this.renderOption
        });
    }
    constructor(...args){
        super(...args), this.state = {
            canShowAvatar: true
        }, this.onBlur = (event)=>{
            this.setState(()=>({
                    canShowAvatar: true
                }));
            this.props.onBlur && this.props.onBlur(event);
        }, this.onFocus = (event)=>{
            if (!this.props.showFocusedAvatar) this.setState(()=>({
                    canShowAvatar: false
                }));
            this.props.onFocus && this.props.onFocus(event);
        }, this.renderOption = (option, { context: context // eslint-disable-next-line @typescript-eslint/no-explicit-any
         })=>{
            const { avatar: avatar, label: label } = this.props.formatOptionDataTransformer(option);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33a231bde2dbcecf$var$OptionWrapper, null, typeof avatar !== 'undefined' && (context !== 'value' || this.state.canShowAvatar) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), null, typeof avatar === 'string' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
                src: avatar,
                size: "xsmall"
            }) : avatar) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($33a231bde2dbcecf$var$LabelWrapper, null, label));
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $33a231bde2dbcecf$var$OptionWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_zulpu2gc _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $33a231bde2dbcecf$var$LabelWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});


parcelRegister("7RIAd", function(module, exports) {
$parcel$export(module.exports, "requestProjects", () => $335c617be9654301$export$fd47004f2da106d6);
$parcel$export(module.exports, "requestProject", () => $335c617be9654301$export$5fc96122a11240fa);

var $ki1Cz = parcelRequire("ki1Cz");

var $lN5GE = parcelRequire("lN5GE");
const $335c617be9654301$export$fd47004f2da106d6 = (filter, { detailed: detailed, requireBrowsePermission: requireBrowsePermission, requireEditPermission: requireEditPermission, maxResults: maxResults, projectType: projectType })=>(0, $ki1Cz.getProjects)(filter, detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType).then((0, $lN5GE.transformProjects));
const $335c617be9654301$export$5fc96122a11240fa = (projectId)=>(0, $ki1Cz.getProject)(projectId).then((0, $lN5GE.transformProject));

});
parcelRegister("ki1Cz", function(module, exports) {
$parcel$export(module.exports, "getProjects", () => $48d0e50622956812$export$b00a271f69f3d728);
$parcel$export(module.exports, "getProject", () => $48d0e50622956812$export$637b60a42bb03f06);

var $hgi0g = parcelRequire("hgi0g");
const $48d0e50622956812$var$MAX_PROJECTS = 5;
const $48d0e50622956812$var$VALID_PROJECT_TYPES = [
    'business',
    'service_desk',
    'software'
];
const $48d0e50622956812$export$897983d170945c20 = ()=>'/rest/api/2/project/search';
const $48d0e50622956812$export$40e632ede9793c84 = ()=>'/rest/api/2/project';
const $48d0e50622956812$export$3675f59ca23820db = (filter, detailed, requireBrowsePermission, requireEditPermission, maxResults = $48d0e50622956812$var$MAX_PROJECTS, projectType = '')=>{
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.set('orderBy', 'NAME');
    urlSearchParams.set('startAt', '0');
    urlSearchParams.set('query', filter);
    urlSearchParams.set('maxResults', maxResults.toString());
    if (detailed) urlSearchParams.set('expand', 'lead,issueTypes');
    const actions = [];
    if (requireBrowsePermission) actions.push('browse');
    if (requireEditPermission) actions.push('edit');
    if (actions.length > 0) urlSearchParams.set('action', actions.join(','));
    if ($48d0e50622956812$var$VALID_PROJECT_TYPES.includes(projectType)) urlSearchParams.set('typeKey', projectType);
    const urlParams = `?${urlSearchParams.toString()}`;
    return `${$48d0e50622956812$export$897983d170945c20()}${urlParams}`;
};
const $48d0e50622956812$export$42f2db4bad372151 = (projectId)=>`${$48d0e50622956812$export$40e632ede9793c84()}/${encodeURIComponent(projectId)}`;
const $48d0e50622956812$export$b00a271f69f3d728 = (filter = '', detailed = false, requireBrowsePermission = false, requireEditPermission = false, maxResults = $48d0e50622956812$var$MAX_PROJECTS, projectType = '')=>(0, $hgi0g.default)($48d0e50622956812$export$3675f59ca23820db(filter, detailed, requireBrowsePermission, requireEditPermission, maxResults, projectType));
const $48d0e50622956812$export$637b60a42bb03f06 = (projectId = '')=>(0, $hgi0g.default)($48d0e50622956812$export$42f2db4bad372151(projectId));

});

parcelRegister("lN5GE", function(module, exports) {
$parcel$export(module.exports, "transformProject", () => $a026cc7331d138a2$export$e179869ce707f546);
$parcel$export(module.exports, "transformProjects", () => $a026cc7331d138a2$export$227473965d2e27db);
const $a026cc7331d138a2$var$transformLead = (leadResponse)=>leadResponse && {
        key: leadResponse.key,
        name: leadResponse.name,
        displayName: leadResponse.displayName,
        avatarUrl: leadResponse.avatarUrls['24x24']
    };
const $a026cc7331d138a2$var$transformIssueTypes = (types)=>types.map((t)=>({
            id: t.id,
            name: t.name,
            description: t.description,
            iconUrl: t.iconUrl,
            subtask: t.subtask
        }));
const $a026cc7331d138a2$var$transformDetails = (restResponse)=>({
        id: restResponse.id,
        key: restResponse.key,
        lead: $a026cc7331d138a2$var$transformLead(restResponse.lead),
        issueTypes: restResponse.issueTypes ? $a026cc7331d138a2$var$transformIssueTypes(restResponse.issueTypes) : [],
        projectTypeKey: restResponse.projectTypeKey,
        simplified: restResponse.simplified
    });
const $a026cc7331d138a2$export$e179869ce707f546 = (restResponse)=>restResponse && {
        value: restResponse.id,
        name: restResponse.name,
        label: restResponse.name,
        avatarUrl: restResponse.avatarUrls['24x24'],
        details: $a026cc7331d138a2$var$transformDetails(restResponse)
    };
const $a026cc7331d138a2$export$227473965d2e27db = (restResponse)=>restResponse && restResponse.values && restResponse.values.map($a026cc7331d138a2$export$e179869ce707f546);

});


parcelRegister("559oH", function(module, exports) {
$parcel$export(module.exports, "default", () => $333fdb33476e624f$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $333fdb33476e624f$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "project-picker.error",
        "defaultMessage": "We couldn't retrieve projects"
    },
    placeholder: {
        "id": "project-picker.placeholder",
        "defaultMessage": "Project"
    },
    labelText: {
        "id": "project-picker.label-text",
        "defaultMessage": "Project"
    },
    errorProjectTermRefresh: {
        "id": "project-picker.error-project-term-refresh",
        "defaultMessage": "We couldn't retrieve spaces"
    },
    placeholderProjectTermRefresh: {
        "id": "project-picker.placeholder-project-term-refresh",
        "defaultMessage": "Space"
    },
    labelTextProjectTermRefresh: {
        "id": "project-picker.label-text-project-term-refresh",
        "defaultMessage": "Space"
    }
});
var $333fdb33476e624f$export$2e2bcd8739ae039 = $333fdb33476e624f$var$messages;

});



parcelRegister("fucyK", function(module, exports) {
$parcel$export(module.exports, "default", () => $cace7a5a03fd5f19$export$2e2bcd8739ae039);

var $as6H2 = parcelRequire("as6H2");

var $aPsSO = parcelRequire("aPsSO");
var $cace7a5a03fd5f19$export$2e2bcd8739ae039 = (0, $as6H2.default)('UserPicker', {
    onChange: 'changed'
})((0, $aPsSO.default));

});
parcelRegister("aPsSO", function(module, exports) {
$parcel$export(module.exports, "default", () => $8995af3cbc8e38f3$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $aXKmr = parcelRequire("aXKmr");

var $2sHLK = parcelRequire("2sHLK");

var $eSnSE = parcelRequire("eSnSE");

var $idGBm = parcelRequire("idGBm");

var $2e8aC = parcelRequire("2e8aC");

var $d5dE5 = parcelRequire("d5dE5");
class $8995af3cbc8e38f3$export$83e0c73b09b3a9cd extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isRequired: false,
            isDisabled: false,
            isClearable: true,
            isClearableWithCrossIcon: false,
            isCompact: false,
            shouldFitContainer: false,
            width: '200px'
        };
    }
    constructor(props){
        super(props), this.state = {
            selectedUser: this.props.selectedUser,
            prevSelectedUser: this.props.selectedUser
        }, this.onSelected = (selectedUser)=>{
            this.setState({
                selectedUser: selectedUser
            });
            this.props.onChange(selectedUser);
        }, /* eslint-disable jira/react-arrow-function-property-naming */ this.formatOptionDataTransformer = (user)=>({
                avatar: user.avatarUrl,
                label: user.displayName
            }), this.fetchOptions = (query)=>{
            const { suggestedAccountId: suggestedAccountId } = this.props;
            if (query) return (0, $2e8aC.requestUsers)(query);
            if (suggestedAccountId) return new Promise((resolve)=>{
                (0, $2e8aC.requestUser)(suggestedAccountId).then((user)=>resolve([
                        user
                    ])).catch(()=>resolve([]));
            });
            return Promise.resolve([]);
        };
        this.userPickerId = `group-picker.label.id-${(0, $aXKmr.v4)()}`;
    }
    static getDerivedStateFromProps(props, state) {
        const currentAccountId = props.selectedUser && props.selectedUser.accountId;
        const prevAccountId = state.prevSelectedUser && state.prevSelectedUser.accountId;
        if (currentAccountId !== prevAccountId) return {
            ...state,
            selectedUser: props.selectedUser,
            prevSelectedUser: props.selectedUser
        };
        return null;
    }
    componentDidMount() {
        this.ensureSelectedUserInfoPresent();
    }
    componentDidUpdate(prevProps) {
        this.ensureSelectedUserInfoPresent();
        if (prevProps.suggestedAccountId !== this.props.suggestedAccountId) // Good to know:
        // react-select caches resolved Promise value for an empty filter so
        // there is no way to change the suggestion other then replacing the component with a new one
        (0, $eSnSE.default).safeErrorWithoutCustomerData('user-picker.prop-update', "suggestedAccountId prop change won't be applied, you have to replace the component with a new one");
    }
    ensureSelectedUserInfoPresent() {
        const { selectedUser: selectedUser } = this.state;
        if (!selectedUser || selectedUser.displayName) return;
        const { accountId: accountId } = selectedUser;
        // @ts-expect-error - TS7006 - Parameter 'newUser' implicitly has an 'any' type.
        const updateSelectedUser = (newUser)=>{
            const currentUser = this.state.selectedUser;
            const currentAccountId = currentUser && currentUser.accountId;
            // Update the state only in case the user wasn't changed
            if (currentAccountId === accountId) this.setState({
                selectedUser: newUser
            });
        };
        (0, $2e8aC.requestUser)(accountId).then((user)=>updateSelectedUser(user)).catch(()=>updateSelectedUser(undefined));
    }
    render() {
        const { intl: { formatMessage: formatMessage }, suggestedAccountId: suggestedAccountId, selectedUser: selectedUser, placeholder: placeholder = this.props.placeholder || formatMessage((0, $d5dE5.default).placeholder), onChange: onChange, shouldFitContainer: shouldFitContainer, width: width, isClearableWithCrossIcon: isClearableWithCrossIcon, ...props } = this.props;
        const { selectedUser: user } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sHLK.PickerWithAvatar), {
            "aria-label": !this.props.label ? formatMessage((0, $d5dE5.default).labelText) : undefined,
            inputId: this.userPickerId,
            ...props,
            errorMessage: formatMessage((0, $d5dE5.default).error),
            placeholder: placeholder,
            onSelected: this.onSelected,
            options: this.fetchOptions,
            formatOptionDataTransformer: this.formatOptionDataTransformer,
            value: user && user.displayName ? user : null,
            width: shouldFitContainer ? undefined : width,
            isClearableWithCrossIcon: isClearableWithCrossIcon
        });
    }
}
var $8995af3cbc8e38f3$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($8995af3cbc8e38f3$export$83e0c73b09b3a9cd);

});
parcelRegister("2e8aC", function(module, exports) {
$parcel$export(module.exports, "requestUser", () => $340ce2eca69238dd$export$949646a1c1731536);
$parcel$export(module.exports, "requestUsers", () => $340ce2eca69238dd$export$55b721778f931cc1);

var $37Xqw = parcelRequire("37Xqw");

var $1otmW = parcelRequire("1otmW");
const $340ce2eca69238dd$export$949646a1c1731536 = (accountId)=>(0, $37Xqw.getUser)(accountId).then((0, $1otmW.transformUser));
const $340ce2eca69238dd$export$55b721778f931cc1 = (query)=>(0, $37Xqw.getUsers)(query).then((0, $1otmW.transformUsers));

});
parcelRegister("37Xqw", function(module, exports) {
$parcel$export(module.exports, "getUser", () => $143cc0293437bb25$export$7cbf767827cd68ba);
$parcel$export(module.exports, "getUsers", () => $143cc0293437bb25$export$925a4945a6cd0f3e);

var $hgi0g = parcelRequire("hgi0g");
const $143cc0293437bb25$export$e45b57f6c6c40475 = 5;
const $143cc0293437bb25$export$7eaa662f51e316ae = ()=>'/rest/api/2/user';
const $143cc0293437bb25$export$8df721f926f55c9a = (accountId = '')=>`${$143cc0293437bb25$export$7eaa662f51e316ae()}?accountId=${encodeURIComponent(accountId)}`;
const $143cc0293437bb25$export$715964ba85b11e2b = ()=>'/rest/api/2/user/picker';
const $143cc0293437bb25$export$977bdbd87001f83 = (query = '')=>`${$143cc0293437bb25$export$715964ba85b11e2b()}?showAvatar=true&maxResults=${$143cc0293437bb25$export$e45b57f6c6c40475}&query=${query}`;
const $143cc0293437bb25$export$7cbf767827cd68ba = (accountId = '')=>(0, $hgi0g.default)($143cc0293437bb25$export$8df721f926f55c9a(accountId));
const $143cc0293437bb25$export$925a4945a6cd0f3e = (query = '')=>(0, $hgi0g.default)($143cc0293437bb25$export$977bdbd87001f83(query));

});

parcelRegister("1otmW", function(module, exports) {
$parcel$export(module.exports, "transformUser", () => $19e9ef34e6aae24a$export$88dcd5c1adae8021);
$parcel$export(module.exports, "transformUsers", () => $19e9ef34e6aae24a$export$fb8c90bfc4beaa59);
const $19e9ef34e6aae24a$export$88dcd5c1adae8021 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls })=>({
        accountId: accountId,
        value: accountId,
        displayName: displayName,
        label: displayName,
        avatarUrl: avatarUrls['24x24']
    });
const $19e9ef34e6aae24a$export$fb8c90bfc4beaa59 = (response)=>response.users.map(({ accountId: accountId, avatarUrl: avatarUrl, displayName: displayName })=>({
            accountId: accountId,
            value: accountId,
            displayName: displayName,
            label: displayName,
            avatarUrl: avatarUrl
        }));

});


parcelRegister("d5dE5", function(module, exports) {
$parcel$export(module.exports, "default", () => $61835bca22ccc32e$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $61835bca22ccc32e$var$messages = (0, $7qGN1.defineMessages)({
    error: {
        "id": "user-picker.error",
        "defaultMessage": "We couldn't retrieve users"
    },
    placeholder: {
        "id": "user-picker.placeholder",
        "defaultMessage": "User"
    },
    labelText: {
        "id": "user-picker.label-text",
        "defaultMessage": "User"
    }
});
var $61835bca22ccc32e$export$2e2bcd8739ae039 = $61835bca22ccc32e$var$messages;

});



parcelRegister("1opnt", function(module, exports) {
$parcel$export(module.exports, "default", () => $7e5b13ced445d6f6$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $cxKOj = parcelRequire("cxKOj");

var $lRq8t = parcelRequire("lRq8t");

var $6XJko = parcelRequire("6XJko");

var $9QRvN = parcelRequire("9QRvN");

var $dJEUx = parcelRequire("dJEUx");

var $6tCIA = parcelRequire("6tCIA");
const $7e5b13ced445d6f6$var$Filter = (props)=>{
    const projectPlaceholderOldGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $6tCIA.default).projectPlaceholderOldGalaxia : (0, $6tCIA.default).projectPlaceholderOld;
    const projectPlaceholderGalaxia = (0, $cxKOj.expVal)('project-terminology-refresh', 'isEnabled', false) ? (0, $6tCIA.default).projectPlaceholderGalaxia : (0, $6tCIA.default).projectPlaceholder;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const { renderFilterSearch: renderFilterSearch, onChange: onChange, renderProjectPicker: renderProjectPicker, renderUserPicker: renderUserPicker, value: value } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9QRvN.FilterBar), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $7e5b13ced445d6f6$var$searchWrapperStyles
    }, renderFilterSearch({
        placeholder: formatMessage((0, $6tCIA.default).searchPlaceholder),
        value: '',
        hasAutoFocus: false,
        isCompact: true,
        increasedWidth: false,
        placeholderAlwaysVisible: true,
        isAlwaysExpanded: false,
        shouldFitContainerWidth: true,
        onChange: (text, analyticsEvent)=>{
            onChange({
                ...value,
                text: text
            }, analyticsEvent);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: !(0, $6XJko.isVisualRefreshEnabled)() && $7e5b13ced445d6f6$var$filterLabelStyles
    }, renderProjectPicker({
        onChange: (project, analyticsEvent)=>{
            onChange({
                text: value.text,
                project: project,
                user: undefined
            }, analyticsEvent);
        },
        placeholder: (0, $6XJko.isVisualRefreshEnabled)() ? formatMessage(projectPlaceholderGalaxia) : formatMessage(projectPlaceholderOldGalaxia),
        label: (0, $6XJko.isVisualRefreshEnabled)() ? undefined : formatMessage((0, $6tCIA.default).projectLabel),
        selectedProject: undefined,
        isCompact: true
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dJEUx.FilterItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: !(0, $6XJko.isVisualRefreshEnabled)() && $7e5b13ced445d6f6$var$filterLabelStyles
    }, renderUserPicker({
        onChange: (user, analyticsEvent)=>{
            onChange({
                text: value.text,
                project: undefined,
                user: user
            }, analyticsEvent);
        },
        placeholder: (0, $6XJko.isVisualRefreshEnabled)() ? formatMessage((0, $6tCIA.default).userLocationLabel) : formatMessage((0, $6tCIA.default).userLocationPlaceholder),
        label: (0, $6XJko.isVisualRefreshEnabled)() ? undefined : formatMessage((0, $6tCIA.default).userLocationLabel)
    }))));
};
const $7e5b13ced445d6f6$var$searchWrapperStyles = (0, $1DXK0.xcss)({
    flexBasis: '200px'
});
const $7e5b13ced445d6f6$var$filterLabelStyles = (0, $1DXK0.xcss)({
    marginTop: 'space.negative.250'
});
var $7e5b13ced445d6f6$export$2e2bcd8739ae039 = $7e5b13ced445d6f6$var$Filter;

});
parcelRegister("9QRvN", function(module, exports) {
$parcel$export(module.exports, "FilterBar", () => $3ecd990baea72ae1$export$56a20ec2552ffba2);

var $eJOHy = parcelRequire("eJOHy");

var $6DCNy = parcelRequire("6DCNy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gMRLG = parcelRequire("gMRLG");

var $6XJko = parcelRequire("6XJko");

const $3ecd990baea72ae1$export$56a20ec2552ffba2 = ({ children: children })=>{
    const [containerWidth, setContainerWidth] = (0, $eJOHy.useState)(900);
    const handleWidth = (0, (/*@__PURE__*/$parcel$interopDefault($6DCNy)))(setContainerWidth, 50);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3ecd990baea72ae1$var$relativeWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gMRLG.WidthObserver), {
        setWidth: handleWidth
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: [
            $3ecd990baea72ae1$var$filterBarSharedStyles,
            (0, $6XJko.isVisualRefreshEnabled)() && $3ecd990baea72ae1$var$filterBarSharedStylesVisualRefresh,
            containerWidth > (0, $5b4f651e2b94645c$export$9cc428d7e02a0e8b) && $3ecd990baea72ae1$var$filterBarLargeStyles,
            containerWidth <= (0, $5b4f651e2b94645c$export$9cc428d7e02a0e8b) && containerWidth > (0, $5b4f651e2b94645c$export$99041d531d62aef9) && $3ecd990baea72ae1$var$filterBarMidStyles,
            containerWidth <= (0, $5b4f651e2b94645c$export$99041d531d62aef9) && containerWidth > (0, $5b4f651e2b94645c$export$54280d191a58e9f6) && $3ecd990baea72ae1$var$filterBarSmallStyles
        ]
    }, children));
};
const $3ecd990baea72ae1$var$relativeWrapperStyles = (0, $1DXK0.xcss)({
    position: 'relative'
});
const $3ecd990baea72ae1$var$filterBarSharedStyles = (0, $1DXK0.xcss)({
    width: '100%',
    display: 'grid',
    columnGap: 'space.200',
    rowGap: 'space.100',
    alignItems: 'flex-end'
});
const $3ecd990baea72ae1$var$filterBarSharedStylesVisualRefresh = (0, $1DXK0.xcss)({
    columnGap: 'space.100'
});
const $3ecd990baea72ae1$var$filterBarSmallStyles = (0, $1DXK0.xcss)({
    gridTemplateColumns: 'repeat(2, 1fr)'
});
const $3ecd990baea72ae1$var$filterBarMidStyles = (0, $1DXK0.xcss)({
    gridTemplateColumns: 'repeat(3, 1fr)'
});
const $3ecd990baea72ae1$var$filterBarLargeStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    flexWrap: 'wrap'
});

});
parcelRegister("gMRLG", function(module, exports) {
$parcel$export(module.exports, "WidthObserver", () => $fc07c79ce5b93db8$export$b2ad68b9bc407b80);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $ghv3t = parcelRequire("ghv3t");
const $fc07c79ce5b93db8$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo((props)=>{
    return /*#__PURE__*/ (0, $gt9Am.jsx)((0, $ghv3t.WidthDetectorObserver), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $fc07c79ce5b93db8$export$2e2bcd8739ae039 = $fc07c79ce5b93db8$export$b2ad68b9bc407b80;

});
parcelRegister("ghv3t", function(module, exports) {
$parcel$export(module.exports, "WidthDetectorObserver", () => $8fd70c84fe96dcaa$export$ff983d2a2b6112ea);

var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $fecNP = parcelRequire("fecNP");
const $8fd70c84fe96dcaa$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).memo(({ setWidth: setWidth, offscreen: offscreen })=>{
    const [inViewRef, inView, target] = (0, $fecNP.useInView)({
        /* Optional options */ threshold: 0
    });
    const observer = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef(()=>{
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver((entries)=>{
            if (!Array.isArray(entries) || !entries.length) return;
            const { width: width } = entries[0].contentRect;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        const { current: currentObserver } = observer;
        const resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return ()=>{
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'block',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'absolute'
        },
        ref: inViewRef
    });
});

});
parcelRegister("fecNP", function(module, exports) {
$parcel$export(module.exports, "useInView", () => $838e57da8fce74d2$export$2f62ee6831462844);

var $eJOHy = parcelRequire("eJOHy");
function $838e57da8fce74d2$export$2f62ee6831462844(options = {}) {
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useRef();
    const [state, setState] = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    });
    const { threshold: threshold, root: root, rootMargin: rootMargin } = options;
    const setRef = (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useCallback((node)=>{
        observerInstance.current = new IntersectionObserver((entries)=>{
            if (entries && entries.length) {
                const intersection = entries[0];
                const { isIntersecting: isIntersecting, intersectionRatio: intersectionRatio } = intersection;
                if (intersectionRatio >= 0) {
                    // Note: `0` will be used here when an array of numbers is passed as the threshold, which doesn't feel right
                    const numericThreshold = typeof threshold === 'number' ? threshold : 0;
                    let inView = intersectionRatio >= numericThreshold;
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
	 * Unsubscribe IntersectionObserver before unmounting a component.
	 */ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).useEffect(()=>{
        return ()=>{
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}

});



const $5b4f651e2b94645c$export$54280d191a58e9f6 = 420;
const $5b4f651e2b94645c$export$99041d531d62aef9 = 640;
const $5b4f651e2b94645c$export$9cc428d7e02a0e8b = 850;
const $5b4f651e2b94645c$export$a4477e829bcd1e02 = 200;


parcelRegister("dJEUx", function(module, exports) {
$parcel$export(module.exports, "FilterItem", () => $57ae9b62bc01824b$export$3cf161fcd24b6b4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $57ae9b62bc01824b$export$3cf161fcd24b6b4f = ({ expandOnSmall: expandOnSmall, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: expandOnSmall ? [
            $57ae9b62bc01824b$var$filterItemContainerStyles,
            $57ae9b62bc01824b$var$filterItemContainerExpandedStyles
        ] : $57ae9b62bc01824b$var$filterItemContainerStyles
    }, children);
};
const $57ae9b62bc01824b$var$filterItemContainerStyles = (0, $1DXK0.xcss)({
    // 200px is the width commonly used for directory filters, so including it here helps
    // to ensure consistency with the existing design and gives us predictability for responsive behaviour
    minWidth: '200px'
});
const $57ae9b62bc01824b$var$filterItemContainerExpandedStyles = (0, $1DXK0.xcss)({
    gridColumn: '1 / -1'
});

});

parcelRegister("6tCIA", function(module, exports) {
$parcel$export(module.exports, "default", () => $a22e40251badf268$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $a22e40251badf268$var$messages = (0, $7qGN1.defineMessages)({
    searchPlaceholder: {
        "id": "directories.boards-v2.main.content.filter.search-placeholder",
        "defaultMessage": "Search boards"
    },
    projectPlaceholder: {
        "id": "directories.boards-v2.main.content.filter.project-placeholder",
        "defaultMessage": "Project"
    },
    projectPlaceholderOld: {
        "id": "directories.boards-v2.main.content.filter.project-placeholder-old",
        "defaultMessage": "Select project"
    },
    projectLabel: {
        "id": "directories.boards-v2.main.content.filter.project-label",
        "defaultMessage": "Project"
    },
    userLocationLabel: {
        "id": "directories.boards-v2.main.content.filter.user-label",
        "defaultMessage": "User"
    },
    userLocationPlaceholder: {
        "id": "directories.boards-v2.main.content.filter.user-placeholder",
        "defaultMessage": "Select user"
    },
    projectPlaceholderGalaxia: {
        "id": "directories.boards-v2.main.content.filter.project-placeholder-galaxia",
        "defaultMessage": "Space"
    },
    projectPlaceholderOldGalaxia: {
        "id": "directories.boards-v2.main.content.filter.project-placeholder-old-galaxia",
        "defaultMessage": "Select space"
    }
});
var $a22e40251badf268$export$2e2bcd8739ae039 = $a22e40251badf268$var$messages;

});



parcelRegister("lh78g", function(module, exports) {
$parcel$export(module.exports, "operationModals", () => $b29833f4abe5f822$export$fee8081fa482dfbf);
$parcel$export(module.exports, "emptyFilterResultConfiguration", () => $b29833f4abe5f822$export$972f54d0cb76a888);
$parcel$export(module.exports, "getTableConfiguration", () => $b29833f4abe5f822$export$6847365bea1c5392);
$parcel$export(module.exports, "getTableLabel", () => $b29833f4abe5f822$export$b2d196af18e06ad6);
$parcel$export(module.exports, "getResultsAnnouncerMessage", () => $b29833f4abe5f822$export$64df75861e57fb7f);

var $ahm5r = parcelRequire("ahm5r");

var $20b6k = parcelRequire("20b6k");


var $6XJko = parcelRequire("6XJko");

var $aETW1 = parcelRequire("aETW1");

var $cU3jn = parcelRequire("cU3jn");

var $4Lnyw = parcelRequire("4Lnyw");

var $8rNFA = parcelRequire("8rNFA");

var $4c9l5 = parcelRequire("4c9l5");

var $klPtp = parcelRequire("klPtp");

var $71H9a = parcelRequire("71H9a");

var $2VDXD = parcelRequire("2VDXD");

var $eepkg = parcelRequire("eepkg");

var $iFUx2 = parcelRequire("iFUx2");

var $75BZg = parcelRequire("75BZg");

var $j32Fj = parcelRequire("j32Fj");
const $b29833f4abe5f822$export$fee8081fa482dfbf = {
    [(0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)]: (0, $iFUx2.default),
    [(0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)]: (0, $eepkg.default),
    [(0, $85bfce414eef38c7$export$346f08c1f0d0fe41)]: (0, $j32Fj.default)
};
const $b29833f4abe5f822$export$972f54d0cb76a888 = {
    message: (0, $75BZg.default).emptyFilterResultMessage
};
const $b29833f4abe5f822$export$6847365bea1c5392 = (0, $ahm5r.createSelector)((0, $cU3jn.getLoggedInUserAccountId), (loggedInUserAccountId)=>[
        loggedInUserAccountId !== null ? {
            title: (0, $20b6k.default),
            Cell: (0, $4c9l5.default),
            width: (0, $6XJko.isVisualRefreshEnabled)() ? 2.2 : 3
        } : undefined,
        {
            title: (0, $75BZg.default).name,
            Cell: (0, $2VDXD.default),
            sortField: (0, $aETW1.NAME),
            // eslint-disable-next-line no-nested-ternary
            width: loggedInUserAccountId ? (0, $6XJko.isVisualRefreshEnabled)() ? 49.8 : 49 : 55,
            ascendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $75BZg.default).aToZOrder : undefined,
            descendingSortTooltip: (0, $6XJko.isVisualRefreshEnabled)() ? (0, $75BZg.default).zToAOrder : undefined
        },
        {
            title: (0, $75BZg.default).administrators,
            Cell: (0, $8rNFA.default),
            width: 20
        },
        {
            title: (0, $75BZg.default).location,
            Cell: loggedInUserAccountId !== null && (0, $6XJko.isVisualRefreshEnabled)() ? (0, $klPtp.default) : (0, $71H9a.default),
            width: loggedInUserAccountId !== null && (0, $6XJko.isVisualRefreshEnabled)() ? 28 : 25
        },
        // delete this when cleaning up isVisualRefreshEnabled FG
        loggedInUserAccountId !== null && !(0, $6XJko.isVisualRefreshEnabled)() ? {
            title: (0, $75BZg.default).actions,
            Cell: (0, $4Lnyw.default),
            width: 3,
            dataTestId: 'boards-main.content.headerCell.actions.container'
        } : undefined
    ].filter(Boolean));
const $b29833f4abe5f822$export$b2d196af18e06ad6 = ()=>(0, $75BZg.default).tableAriaLabel;
const $b29833f4abe5f822$export$64df75861e57fb7f = ()=>(0, $75BZg.default).filterResultsAnnouncement;

});
parcelRegister("20b6k", function(module, exports) {
$parcel$export(module.exports, "default", () => $13fe72c3ec28f4da$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $gGgaG = parcelRequire("gGgaG");

var $lRq8t = parcelRequire("lRq8t");

var $fxJiv = parcelRequire("fxJiv");
const $13fe72c3ec28f4da$var$StarTitleCell = ()=>{
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
        label: formatMessage((0, $fxJiv.messages).starred)
    });
};
var $13fe72c3ec28f4da$export$2e2bcd8739ae039 = $13fe72c3ec28f4da$var$StarTitleCell;

});
parcelRegister("fxJiv", function(module, exports) {
$parcel$export(module.exports, "messages", () => $e5142eb9230ff6a4$export$defe85febe8b728c);

var $7qGN1 = parcelRequire("7qGN1");
const $e5142eb9230ff6a4$export$defe85febe8b728c = (0, $7qGN1.defineMessages)({
    starred: {
        "id": "directories.common.components.star-title-cell.starred",
        "defaultMessage": "Starred"
    }
});

});


parcelRegister("4Lnyw", function(module, exports) {
$parcel$export(module.exports, "default", () => $b0aa5d44e979dd25$export$2e2bcd8739ae039);
// delete this entire file when cleaning up isVisualRefreshEnabled FG

var $eq3Hf = parcelRequire("eq3Hf");

var $LFmXM = parcelRequire("LFmXM");

var $6sjW5 = parcelRequire("6sjW5");



var $gnQAk = parcelRequire("gnQAk");

var $7FCY1 = parcelRequire("7FCY1");

var $6SG6z = parcelRequire("6SG6z");
const $b0aa5d44e979dd25$var$mapStateToPropsFactory = ()=>{
    const onDeleteFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)));
    const onCopyFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)));
    const onMoveFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$346f08c1f0d0fe41)));
    return (state, ownProps)=>({
            name: !(0, $7FCY1.isPrivate)(state, ownProps.id) ? (0, $7FCY1.getName)(state, ownProps.id) : undefined,
            isPrivate: (0, $7FCY1.isPrivate)(state, ownProps.id),
            editBoardUrl: (0, $7FCY1.getEditBoardUrl)(state, ownProps.id),
            onDelete: onDeleteFactory(ownProps.onOperationRequested),
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onMove: onMoveFactory(ownProps.onOperationRequested),
            showSpinner: ownProps.isOperationInProgress,
            isSimple: !(0, $7FCY1.isPrivate)(state, ownProps.id) && (0, $7FCY1.getType)(state, ownProps.id) === (0, $987928229d6d4941$export$aca095bc476d426f),
            canEdit: (0, $7FCY1.canEdit)(state, ownProps.id)
        });
};
var $b0aa5d44e979dd25$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onEdit: 'edit',
    onDelete: 'delete',
    onCopy: 'copy',
    onMove: 'move'
}), (0, $gnQAk.connect)($b0aa5d44e979dd25$var$mapStateToPropsFactory, {}))((0, $6SG6z.default));

});
const $987928229d6d4941$export$b75edebf0c64f31e = 'scrum';
const $987928229d6d4941$export$eff0efe8746a33f = 'kanban';
const $987928229d6d4941$export$aca095bc476d426f = 'simple';

parcelRegister("6SG6z", function(module, exports) {
$parcel$export(module.exports, "default", () => $86cef48213801982$export$2e2bcd8739ae039);
// delete this entire file when cleaning up isVisualRefreshEnabled FG

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $NByNW = parcelRequire("NByNW");

var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $as6H2 = parcelRequire("as6H2");

var $9M9Yb = parcelRequire("9M9Yb");

var $6YFG2 = parcelRequire("6YFG2");

var $6XJko = parcelRequire("6XJko");

var $4aSRi = parcelRequire("4aSRi");

var $bzbsd = parcelRequire("bzbsd");

var $gbyoA = parcelRequire("gbyoA");
const $86cef48213801982$var$DropdownMenuWithAnalytics = (0, $as6H2.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $7rjYb.default));
const $86cef48213801982$var$DropdownItemWithAnalytics = (0, $as6H2.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $jYYbf.default));
// eslint-disable-next-line jira/react/no-class-components
class $86cef48213801982$var$ActionsOld extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            name: undefined,
            isPrivate: false,
            isSimple: false,
            canEdit: true,
            defaultOpen: false,
            showSpinner: false,
            editBoardUrl: '',
            onEdit: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCopy: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onMove: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    /**
   * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
   * In its current implementation if we close the menu right away it won't open the focused `href`.
   * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
   * @see https://ecosystem.atlassian.net/browse/AK-4467
   */ delayedClose() {
        setTimeout(()=>this.setState(()=>({
                    isOpen: false
                })));
    }
    renderSettingsAction() {
        const { intl: { formatMessage: formatMessage }, editBoardUrl: editBoardUrl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9Yb.TransitionComponent), {
            href: editBoardUrl,
            onClick: this.onEdit
        }, (props)=>/* @ts-expect-error - Type '{ children: string; href: string; onClick: OnClick; }' is not assignable to type 'Omit<{ children: ReactNode; component?: ComponentType<PropsWithChildren<CustomItemComponentProps>> | undefined; ... 14 more ...; key?: Key | ... 1 more ... | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($86cef48213801982$var$DropdownItemWithAnalytics, props, formatMessage((0, $gbyoA.default).editAction)));
    }
    renderCopyAction() {
        const { intl: { formatMessage: formatMessage }, onCopy: onCopy } = this.props;
        const copyWithAnalytics = (event, arg1)=>{
            onCopy(event, arg1);
            this.props.returnFocus && this.props.returnFocus();
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($86cef48213801982$var$DropdownItemWithAnalytics, {
            /* @ts-expect-error - Type '(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, arg1: AnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ onClick: copyWithAnalytics
        }, formatMessage((0, $gbyoA.default).copyAction));
    }
    renderMoveAction() {
        const { intl: { formatMessage: formatMessage }, onMove: onMove } = this.props;
        return /* @ts-expect-error - Type '(arg1: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($86cef48213801982$var$DropdownItemWithAnalytics, {
            onClick: onMove
        }, formatMessage((0, $gbyoA.default).moveAction));
    }
    renderDeleteAction() {
        const { intl: { formatMessage: formatMessage }, onDelete: onDelete, returnFocus: returnFocus } = this.props;
        const deleteWithAnalytics = (event, arg1)=>{
            onDelete(event, arg1);
            returnFocus && returnFocus();
        };
        return /* @ts-expect-error - Type '(event: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>, arg1: AnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($86cef48213801982$var$DropdownItemWithAnalytics, {
            onClick: deleteWithAnalytics
        }, formatMessage((0, $gbyoA.default).deleteAction));
    }
    render() {
        const { isOpen: isOpen } = this.state;
        const { name: name, showSpinner: showSpinner, intl: { formatMessage: formatMessage }, isSimple: isSimple, isPrivate: isPrivate, canEdit: canEdit } = this.props;
        if (isSimple) return null;
        // legacy logic: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-plugins/jira-agile/greenhopper/src/main/resources/includes/js/rapid/configuration/ManageBoards.soy
        // check boards spec for more informations: https://extranet.atlassian.com/pages/viewpage.action?pageId=3540485825
        // corresponding issue: https://jdog.jira-dev.com/browse/KITKAT-274
        let moveItem = null;
        let deleteItem = null;
        let copyItem = null;
        let settingsItem = null;
        if (isPrivate) {
            if (canEdit) moveItem = this.renderMoveAction();
            deleteItem = this.renderDeleteAction();
        } else {
            if (canEdit) {
                moveItem = this.renderMoveAction();
                deleteItem = this.renderDeleteAction();
            }
            copyItem = this.renderCopyAction();
            settingsItem = this.renderSettingsAction();
        }
        // @ts-expect-error - TS7031 - Binding element 'triggerRef' implicitly has an 'any' type.
        const triggerFunction = ({ triggerRef: triggerRef, ...props })=>{
            const newLabel = isPrivate ? formatMessage((0, $gbyoA.default).tooltipPrivate) : formatMessage((0, $gbyoA.default).tooltipWithName, {
                name: name
            });
            const ref = (0, $bzbsd.mergeRefs)(this.props.moreActionsRef ?? null, triggerRef);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...props,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($NByNW))),
                ref: ref,
                label: name ? newLabel : formatMessage((0, $gbyoA.default).tooltip),
                isLoading: showSpinner
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
            justifyContent: "end",
            xcss: (0, $6XJko.isVisualRefreshEnabled)() ? undefined : $86cef48213801982$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($86cef48213801982$var$DropdownMenuWithAnalytics, {
            placement: "bottom-end",
            isOpen: isOpen,
            onOpenChange: this.onOpenChange,
            trigger: triggerFunction,
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, settingsItem, copyItem, moveItem, deleteItem)));
    }
    constructor(...args){
        super(...args), this.state = {
            isOpen: this.props.defaultOpen
        }, // @ts-expect-error - TS7031 - Binding element 'isOpen' implicitly has an 'any' type.
        this.onOpenChange = ({ isOpen: isOpen })=>{
            this.setState(()=>({
                    isOpen: isOpen
                }));
        }, this.onEdit = (e, analytics)=>{
            this.props.onEdit(analytics);
            this.delayedClose();
        };
    }
}
const $86cef48213801982$var$ActionsOldWrapped = (props)=>{
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    const moreActionsButtonRef = (0, $eJOHy.useRef)(null);
    const returnFocus = (0, $eJOHy.useCallback)(()=>{
        // To get return focus back to More Actions Element
        setReturnFocusTo(moreActionsButtonRef);
    }, [
        setReturnFocusTo
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($86cef48213801982$var$ActionsOld, {
        ...props,
        returnFocus: returnFocus,
        moreActionsRef: moreActionsButtonRef
    });
};
var // @ts-expect-error - TS2769 - No overload matches this call.
$86cef48213801982$export$2e2bcd8739ae039 = (0, $6YFG2.default)($86cef48213801982$var$ActionsOldWrapped);
const $86cef48213801982$var$containerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.050',
    paddingRight: 'space.025',
    paddingBottom: 'space.0',
    paddingLeft: 'space.0'
});

});
parcelRegister("9M9Yb", function(module, exports) {
$parcel$export(module.exports, "TransitionComponent", () => $c8a405d1bfe18777$export$3c61ec5cd62a42f9);

var $eJOHy = parcelRequire("eJOHy");

var $lcB5K = parcelRequire("lcB5K");
const $c8a405d1bfe18777$export$3c61ec5cd62a42f9 = ({ children: children, onClick: onClick, href: href })=>__SPA__ ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lcB5K.RouterActions), null, ({ push: push })=>{
        const clickHandler = (e, analyticsEvent)=>{
            if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey || e.button === 1) return;
            e.preventDefault();
            onClick && onClick(e, analyticsEvent);
            push(href);
        };
        return children({
            href: href,
            onClick: clickHandler
        });
    }) : children({
        href: href,
        onClick: onClick
    });

});

parcelRegister("gbyoA", function(module, exports) {
$parcel$export(module.exports, "default", () => $b5b18b605c235927$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $b5b18b605c235927$var$messages = (0, $7qGN1.defineMessages)({
    editAction: {
        "id": "directories.boards-v2.main.content.cells.actions.edit-action",
        "defaultMessage": "Edit settings"
    },
    deleteAction: {
        "id": "directories.boards-v2.main.content.cells.actions.delete-action",
        "defaultMessage": "Delete"
    },
    copyAction: {
        "id": "directories.boards-v2.main.content.cells.actions.copy-action",
        "defaultMessage": "Copy"
    },
    moveAction: {
        "id": "directories.boards-v2.main.content.cells.actions.move-action",
        "defaultMessage": "Move"
    },
    tooltip: {
        "id": "directories.boards-v2.main.content.cells.actions.tooltip",
        "defaultMessage": "More"
    },
    tooltipPrivate: {
        "id": "directories.boards-v2.main.content.cells.actions.tooltip-private",
        "defaultMessage": "More actions for private board"
    },
    tooltipWithName: {
        "id": "directories.boards-v2.main.content.cells.actions.tooltip-with-name",
        "defaultMessage": "More actions for {name}"
    },
    moreActionsTooltip: {
        "id": "directories.boards-v2.main.content.cells.actions.more-actions-tooltip",
        "defaultMessage": "More actions"
    }
});
var $b5b18b605c235927$export$2e2bcd8739ae039 = $b5b18b605c235927$var$messages;

});



parcelRegister("8rNFA", function(module, exports) {
$parcel$export(module.exports, "default", () => $4bb510437becfc13$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $7FCY1 = parcelRequire("7FCY1");

var $1Mb3h = parcelRequire("1Mb3h");
// @ts-expect-error - 2345 - Type 'undefined' is not assignable to type 'User[]'
const $4bb510437becfc13$var$mapStateToProps = (state, ownProps)=>({
        ...(0, $7FCY1.getAdministrators)(state, ownProps.id)
    });
var $4bb510437becfc13$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($4bb510437becfc13$var$mapStateToProps, {})((0, $1Mb3h.default));

});
parcelRegister("1Mb3h", function(module, exports) {
$parcel$export(module.exports, "default", () => $35e26fce9e2028c7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $umifb = parcelRequire("umifb");

var $gqBnP = parcelRequire("gqBnP");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $98kYt = parcelRequire("98kYt");

var $rIjzv = parcelRequire("rIjzv");

var $266se = parcelRequire("266se");
function $35e26fce9e2028c7$export$2e2bcd8739ae039(props) {
    const { users: users, groups: groups } = props;
    if (users?.length === 0 && groups?.length === 0) return null;
    if (users?.length === 1 && groups?.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $rIjzv.default), {
        user: users[0]
    });
    if (users?.length === 0 && groups?.length === 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $98kYt.default), {
        appearance: "circle",
        displayName: groups[0].name,
        avatarUrl: (0, (/*@__PURE__*/$parcel$interopDefault($266se)))
    });
    const data = (0, (/*@__PURE__*/$parcel$interopDefault($umifb)))(users?.map((user)=>({
            name: user.displayName,
            src: user.avatarUrl
        })), groups?.map((group)=>({
            name: group.name,
            src: (0, (/*@__PURE__*/$parcel$interopDefault($266se)))
        }))).filter(Boolean);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $35e26fce9e2028c7$var$avatarGroupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gqBnP.default), {
        appearance: "stack",
        size: "small",
        data: data
    }));
}
const $35e26fce9e2028c7$var$avatarGroupContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.075',
    paddingBottom: 'space.075'
});

});
parcelRegister("umifb", function(module, exports) {

var $7pKvH = parcelRequire("7pKvH");

var $72Qfa = parcelRequire("72Qfa");

var $k4ZVz = parcelRequire("k4ZVz");

var $4sprp = parcelRequire("4sprp");
/**
 * Creates a new array concatenating `array` with any additional arrays
 * and/or values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to concatenate.
 * @param {...*} [values] The values to concatenate.
 * @returns {Array} Returns the new concatenated array.
 * @example
 *
 * var array = [1];
 * var other = _.concat(array, 2, [3], [[4]]);
 *
 * console.log(other);
 * // => [1, 2, 3, [4]]
 *
 * console.log(array);
 * // => [1]
 */ function $05b4186ecb65c386$var$concat() {
    var length = arguments.length;
    if (!length) return [];
    var args = Array(length - 1), array = arguments[0], index = length;
    while(index--)args[index - 1] = arguments[index];
    return $7pKvH($4sprp(array) ? $k4ZVz(array) : [
        array
    ], $72Qfa(args, 1));
}
module.exports = $05b4186ecb65c386$var$concat;

});

parcelRegister("98kYt", function(module, exports) {
$parcel$export(module.exports, "default", () => $b36214b33d25bdee$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gYvT9 = parcelRequire("gYvT9");

var $5DgXR = parcelRequire("5DgXR");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $3Wh6p = parcelRequire("3Wh6p");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $4cTDP = parcelRequire("4cTDP");

var $6XJko = parcelRequire("6XJko");

var $2wTQj = parcelRequire("2wTQj");
const $b36214b33d25bdee$var$styles = {
    avatarContainer: "_16jlidpf _1o9zidpf _i0dl1wug _u5f3u2gc _vwz4idpf",
    avatarContainerNew: "_4cvr1h6o",
    container: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0q12x7 _n3td12x7 _1e0c1txw",
    contentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _4cvr1h6o _1bsb1osq",
    contentContainerOld: "_16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _4cvr1h6o _1bsb1osq",
    accessibleContentContainer: "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0qu2gc _n3tdu2gc _1e0c1txw _4cvr1h6o _1bsb1osq",
    link: "_1bsb1osq",
    textContainer: "_1reo15vq _18m915vq _slp31hna _o5721q9c _1bto1l2s"
};
function $b36214b33d25bdee$export$2e2bcd8739ae039(props) {
    const { avatarUrl: avatarUrl, displayName: displayName, href: href, appearance: appearance, isDeleting: isDeleting, onClick: onClick } = props;
    // To vertically align the avatar with the text and also change the height of the cell from 44px to 40px -  BLU-7380
    const applyVisualRefreshStyles = (0, $6XJko.isVisualRefreshEnabled)();
    const content = !href ? /*#__PURE__*/ $eJOHy.createElement((0, $lmgo6.default), {
        alignItems: applyVisualRefreshStyles ? 'center' : 'start',
        xcss: applyVisualRefreshStyles ? $b36214b33d25bdee$var$contentWrapperStyles : $b36214b33d25bdee$var$contentWrapperStylesOld
    }, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.avatarContainer,
            applyVisualRefreshStyles && $b36214b33d25bdee$var$styles.avatarContainerNew
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $5DgXR.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ $eJOHy.createElement((0, $3Wh6p.default), {
        xcss: !applyVisualRefreshStyles ? $b36214b33d25bdee$var$inlineTextStyles : undefined
    }, isDeleting && (0, $4cTDP.fg)('hix-6302_project_delete_improvements') ? /*#__PURE__*/ $eJOHy.createElement((0, $2wTQj.default), null, displayName) : displayName)) : /*#__PURE__*/ $eJOHy.createElement($b36214b33d25bdee$var$Content, null, /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.avatarContainer,
            applyVisualRefreshStyles && $b36214b33d25bdee$var$styles.avatarContainerNew
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $5DgXR.default), {
        src: avatarUrl,
        size: "small",
        appearance: appearance
    })), /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.textContainer
        ])
    }, isDeleting && (0, $4cTDP.fg)('hix-6302_project_delete_improvements') ? /*#__PURE__*/ $eJOHy.createElement((0, $2wTQj.default), null, displayName, " ") : displayName));
    if (href) return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.container
        ])
    }, isDeleting && (0, $4cTDP.fg)('hix-6302_project_delete_improvements') ? content : /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.link
        ])
    }, /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: applyVisualRefreshStyles ? $b36214b33d25bdee$var$contentWrapperStyles : $b36214b33d25bdee$var$contentWrapperStylesOld
    }, /*#__PURE__*/ $eJOHy.createElement((0, $k71qx.default), {
        content: displayName,
        isScreenReaderAnnouncementDisabled: true,
        delay: 1000,
        position: "bottom-start"
    }, /*#__PURE__*/ $eJOHy.createElement((0, $gYvT9.default), {
        href: href,
        onClick: onClick
    }, content)))));
    return /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            (0, $6XJko.isVisualRefreshEnabled)() ? $b36214b33d25bdee$var$styles.contentContainer : $b36214b33d25bdee$var$styles.contentContainerOld
        ])
    }, content);
}
$b36214b33d25bdee$export$2e2bcd8739ae039.defaultProps = {
    avatarUrl: undefined,
    href: undefined,
    appearance: 'circle',
    onClick: undefined
};
const $b36214b33d25bdee$var$Content = (props)=>{
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ $eJOHy.createElement((0, $8nu6j.default), {
        xcss: $b36214b33d25bdee$var$accessibleContentContainerStyles
    }, props.children) : /*#__PURE__*/ $eJOHy.createElement("div", {
        className: (0, $hcewu.default)([
            $b36214b33d25bdee$var$styles.accessibleContentContainer
        ])
    }, props.children);
};
const $b36214b33d25bdee$var$contentWrapperStyles = (0, $1DXK0.xcss)({
    maxWidth: '100%',
    paddingBlock: 'space.075'
});
const $b36214b33d25bdee$var$contentWrapperStylesOld = (0, $1DXK0.xcss)({
    maxWidth: '100%',
    paddingBlock: 'space.100'
});
const $b36214b33d25bdee$var$inlineTextStyles = (0, $1DXK0.xcss)({
    paddingBlockStart: 'space.025'
});
const $b36214b33d25bdee$var$accessibleContentContainerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto',
    width: '100%',
    height: '40px'
});

});
parcelRegister("2wTQj", function(module, exports) {
$parcel$export(module.exports, "default", () => $1a72e7a385cd217c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
function $1a72e7a385cd217c$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $1a72e7a385cd217c$var$disabledBoxStyles
    }, children);
}
const $1a72e7a385cd217c$var$disabledBoxStyles = (0, $1DXK0.xcss)({
    display: 'contents',
    color: 'color.text.disabled',
    ':hover': {
        cursor: 'default'
    }
});

});


parcelRegister("rIjzv", function(module, exports) {
$parcel$export(module.exports, "default", () => $4786212b595d5412$export$2e2bcd8739ae039);

var $6sjW5 = parcelRequire("6sjW5");

var $hJq8V = parcelRequire("hJq8V");
var $4786212b595d5412$export$2e2bcd8739ae039 = (0, $6sjW5.default)({
    onClick: 'userProfile'
})((0, $hJq8V.default));

});
parcelRegister("hJq8V", function(module, exports) {
$parcel$export(module.exports, "default", () => $3a0cbec7d37711e3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $faIE0 = parcelRequire("faIE0");

var $98kYt = parcelRequire("98kYt");
function $3a0cbec7d37711e3$export$2e2bcd8739ae039(props) {
    const { user: user, isDeleting: isDeleting } = props;
    if (!user) return null;
    const { accountId: accountId, displayName: displayName, avatarUrl: avatarUrl } = user;
    const content = /*#__PURE__*/ $eJOHy.createElement((0, $98kYt.default), {
        displayName: displayName,
        avatarUrl: avatarUrl,
        isDeleting: isDeleting
    });
    return /*#__PURE__*/ $eJOHy.createElement((0, $faIE0.default), {
        accountId: accountId,
        prepopulatedData: {
            fullName: displayName
        }
    }, content);
}

});
parcelRegister("faIE0", function(module, exports) {
$parcel$export(module.exports, "default", () => $147e70feef199e30$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");


const $147e70feef199e30$var$ConditionalProfileCard = (parcelRequire("h0jdL")).default;
function $147e70feef199e30$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($147e70feef199e30$var$ConditionalProfileCard, props);
}

});
parcelRegister("h0jdL", function(module, exports) {


module.exports = (parcelRequire("g81qY"))('empanada_profilecard_sync_trigger_import_final', function() {
    return parcelRequire('kaujN');
}, function() {
    return parcelRequire('bMaIs');
}, {
    l: (parcelRequire("bbrhz")),
    i: [
        "4yYgJ",
        "6Z32B"
    ]
});

});
parcelRegister("g81qY", function(module, exports) {
"use strict";

var $9VDxJ = parcelRequire("9VDxJ");
var $bbde81794392820b$require$getBundleURL = $9VDxJ.getBundleURL;

var $iTG8W = parcelRequire("iTG8W");
var $bbde81794392820b$require$resolve = $iTG8W.resolve;
module.exports = function loadCond(cond, ifTrue, ifFalse, fallback) {
    let result = globalThis.__MCOND(cond);
    try {
        return result ? ifTrue() : ifFalse();
    } catch (err) {
        if (fallback) {
            globalThis.__ATLASPACK_ERRORS = globalThis.__ATLASPACK_ERRORS || [];
            globalThis.__ATLASPACK_ERRORS.push(new Error(`Sync dependency fallback triggered for condition "${cond}": ${err.message}`));
            for (const id of fallback.i)fallback.l(new URL($bbde81794392820b$require$resolve(id), $bbde81794392820b$require$getBundleURL(id)).toString());
            return result ? ifTrue() : ifFalse();
        } else throw err;
    }
};

});
parcelRegister("9VDxJ", function(module, exports) {
$parcel$export(module.exports, "getBundleURL", () => $73a81c5f1e1fde26$export$bdfd709ae4826697, (v) => $73a81c5f1e1fde26$export$bdfd709ae4826697 = v);
// TODO: convert this file to ESM once HMR issues are resolved
var $73a81c5f1e1fde26$export$5a759dc7a1cfb72a;
var $73a81c5f1e1fde26$export$bdfd709ae4826697;
var $73a81c5f1e1fde26$export$c9e73fbda7da57b6;
"use strict";
const $73a81c5f1e1fde26$var$stackTraceUrlRegexp = /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g;
const $73a81c5f1e1fde26$var$bundleURL = {};
/**
 * Retrieves the cached bundle URL for a given identifier.
 * If the URL is not cached, it computes and stores it in the cache.
 *
 * @param {string} id - The identifier for the bundle.
 * @param {Error?} inputError - An error object to extract the stack trace from
 * (for testing purposes).
 * @returns {string} The URL of the bundle, without file name.
 */ function $73a81c5f1e1fde26$var$getBundleURLCached(id, inputError) {
    let value = $73a81c5f1e1fde26$var$bundleURL[id];
    if (!value) {
        value = $73a81c5f1e1fde26$var$getBundleURL(inputError);
        $73a81c5f1e1fde26$var$bundleURL[id] = value;
    }
    return value;
}
/** Get the URL without the filename (last / segment)
 *
 * @param {string} url
 * @returns {string} The URL with the file name removed
 */ function $73a81c5f1e1fde26$var$getBaseURL(url) {
    return url.slice(0, url.lastIndexOf('/')) + '/';
}
function $73a81c5f1e1fde26$var$getBundleURL(inputError) {
    try {
        throw inputError ?? new Error();
    } catch (err) {
        var matches = ('' + err.stack).match($73a81c5f1e1fde26$var$stackTraceUrlRegexp);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $73a81c5f1e1fde26$var$getBaseURL(matches[2]);
    }
    return '/';
}
/**
 * @param {string} url
 * @returns {string}
 */ function $73a81c5f1e1fde26$var$getOrigin(url) {
    return new URL(url).origin;
}
$73a81c5f1e1fde26$export$5a759dc7a1cfb72a = $73a81c5f1e1fde26$var$getOrigin;
$73a81c5f1e1fde26$export$bdfd709ae4826697 = $73a81c5f1e1fde26$var$getBundleURLCached;
$73a81c5f1e1fde26$export$c9e73fbda7da57b6 = $73a81c5f1e1fde26$var$getBaseURL;

});


parcelRegister("bbrhz", function(module, exports) {
"use strict";
module.exports = function loadJSBundle(bundle) {
    // Don't insert the same script twice (e.g. if it was already in the HTML)
    let existingScripts = document.getElementsByTagName('script');
    let isCurrentBundle = function(script) {
        return script.src === bundle;
    };
    if ([].concat(existingScripts).some(isCurrentBundle)) return;
    // Request using XHR because it's synchronous and we can't use promises here
    // This has extremely poor performance because we're idle during this fetch, so we only use this so that the app won't crash
    const xhr = new XMLHttpRequest();
    xhr.open('GET', bundle, false);
    try {
        xhr.send();
        if (xhr.status === 200) {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = xhr.responseText;
            // Execute the script synchronously
            document.head.appendChild(script);
        } else throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Status: ${xhr.status}`);
    } catch (e) {
        throw new TypeError(`Failed to fetch dynamically imported module: ${bundle}. Error: ${e.message}`);
    }
};

});





parcelRegister("266se", function(module, exports) {
module.exports = new URL("group-avatar.46fc45c1.svg", import.meta.url).toString();

});



parcelRegister("4c9l5", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc70cb94b4a1e1f7$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $f1MUi = parcelRequire("f1MUi");

var $4NIeZ = parcelRequire("4NIeZ");
const $cc70cb94b4a1e1f7$var$FavoriteCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f1MUi.default), props, ({ isPrivate: isPrivate })=>isPrivate ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4NIeZ.default), props));
var $cc70cb94b4a1e1f7$export$2e2bcd8739ae039 = $cc70cb94b4a1e1f7$var$FavoriteCell;

});
parcelRegister("f1MUi", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b22d88cb9ceb8f3$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $7FCY1 = parcelRequire("7FCY1");

var $bia84 = parcelRequire("bia84");
const $4b22d88cb9ceb8f3$var$mapStateToProps = ()=>(state, ownProps)=>({
            isPrivate: (0, $7FCY1.isPrivate)(state, ownProps.id)
        });
var $4b22d88cb9ceb8f3$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($4b22d88cb9ceb8f3$var$mapStateToProps, {})((0, $bia84.default));

});
parcelRegister("bia84", function(module, exports) {
$parcel$export(module.exports, "default", () => $3bc41422631ab4a5$export$2e2bcd8739ae039);
const $3bc41422631ab4a5$var$PublicVsPrivateSwitchCell = (props)=>{
    const { isPrivate: isPrivate, children: children } = props;
    return children({
        isPrivate: isPrivate
    });
};
var $3bc41422631ab4a5$export$2e2bcd8739ae039 = $3bc41422631ab4a5$var$PublicVsPrivateSwitchCell;

});


parcelRegister("4NIeZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $9a8d2065bb674711$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $LFmXM = parcelRequire("LFmXM");

var $fdpHV = parcelRequire("fdpHV");

var $k0CKR = parcelRequire("k0CKR");

var $gnQAk = parcelRequire("gnQAk");

var $7FCY1 = parcelRequire("7FCY1");
const $9a8d2065bb674711$var$mapStateToPropsFactory = ()=>{
    const onClickFactory = (0, $LFmXM.default)((state, id)=>(analyticsEvent)=>{
            const changeFavorite = (0, $7FCY1.getChangeFavorite)(state);
            return changeFavorite({
                id: id,
                type: 'boards',
                value: !(0, $7FCY1.isFavorite)(state, id)
            }, analyticsEvent);
        });
    return (state, ownProps)=>({
            isFavorite: (0, $7FCY1.isFavorite)(state, ownProps.id),
            favoriteItemName: (0, $7FCY1.getName)(state, ownProps.id),
            pending: (0, $7FCY1.isPending)(state, ownProps.id),
            onClick: onClickFactory(state, ownProps.id),
            isShownInList: true
        });
};
var $9a8d2065bb674711$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $fdpHV.AnalyticsSubject)('board'), // @ts-expect-error - TS2589 - Type instantiation is excessively deep and possibly infinite.
(0, $gnQAk.connect)($9a8d2065bb674711$var$mapStateToPropsFactory, {}))((0, $k0CKR.FavoriteCellView));

});
parcelRegister("k0CKR", function(module, exports) {
$parcel$export(module.exports, "FavoriteCellView", () => $c36e74a942f9c7e3$export$7e4dcb8ef4c4afcd);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $fVPN0 = parcelRequire("fVPN0");

var $6XJko = parcelRequire("6XJko");
const $c36e74a942f9c7e3$var$styles = {
    root: "_1e0c1txw _1bah1h6o _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66"
};
function $c36e74a942f9c7e3$export$7e4dcb8ef4c4afcd(props) {
    return (0, $6XJko.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $c36e74a942f9c7e3$var$rootStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
        className: (0, $hcewu.default)([
            $c36e74a942f9c7e3$var$styles.root
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fVPN0.default), props));
}
$c36e74a942f9c7e3$export$7e4dcb8ef4c4afcd.defaultProps = {
    isFavorite: undefined
};
const $c36e74a942f9c7e3$var$rootStyles = (0, $1DXK0.xcss)({
    display: 'flex',
    justifyContent: 'center',
    paddingInline: 'space.050',
    paddingBlock: 'space.100',
    alignItems: 'center',
    height: '40px',
    width: '32px'
});

});
parcelRegister("fVPN0", function(module, exports) {
$parcel$export(module.exports, "FavoriteButtonWrapper", () => $c7558d16e1b4ddea$export$bb1478fee6cd5f0c);
$parcel$export(module.exports, "default", () => $c7558d16e1b4ddea$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $eq3Hf = parcelRequire("eq3Hf");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $gGgaG = parcelRequire("gGgaG");

var $aaIe7 = parcelRequire("aaIe7");

var $dLR8J = parcelRequire("dLR8J");

var $k71qx = parcelRequire("k71qx");

var $6sjW5 = parcelRequire("6sjW5");

var $f2JN3 = parcelRequire("f2JN3");

var $6YFG2 = parcelRequire("6YFG2");

var $6XJko = parcelRequire("6XJko");

var $6urTU = parcelRequire("6urTU");
const $c7558d16e1b4ddea$var$SKELETON_TEST_ID = 'favouriting.favorite-button-stateless.skeleton';
const $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX = 'favouriting.favorite-button-stateless.icon-wrapper';
class $c7558d16e1b4ddea$export$f8ad2acf0ec4860f extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isFavorite: undefined,
            favoriteItemName: undefined,
            isShownInList: false,
            isSmall: false,
            hideTooltip: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            tooltipPosition: 'bottom',
            skipAnimation: false
        };
    }
    componentDidUpdate(prevProps) {
        if (!this.props.skipAnimation && (!prevProps.pending && this.props.pending || !prevProps.isFavorite && this.props.isFavorite)) {
            this.onAnimationStart();
            this.onSettingAnimationEnd();
        }
    }
    onAnimationStart() {
        this.setState({
            isAnimating: !this.state.isAnimating
        });
    }
    onSettingAnimationEnd() {
        setTimeout(()=>{
            this.setState({
                isAnimating: false
            });
        }, $c7558d16e1b4ddea$var$animationTime * 2);
    }
    render() {
        const { isFavorite: isFavorite, favoriteItemName: favoriteItemName, isShownInList: isShownInList, isSmall: isSmall, hideTooltip: hideTooltip, tooltipPosition: tooltipPosition, pending: pending, intl: { formatMessage: formatMessage } } = this.props;
        const { isAnimating: isAnimating } = this.state;
        if (isFavorite === undefined) // show skeleton as a space placeholder (to avoid layout recalculations in browser and visible "jump" when we got data)
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $dLR8J.default), {
            name: "favourite-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$db65185b5889c83, {
            "data-testid": $c7558d16e1b4ddea$var$SKELETON_TEST_ID,
            isSmall: isSmall
        }));
        const iconWrapperTestId = isShownInList ? `${$c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX}-list` : $c7558d16e1b4ddea$var$ICON_WRAPPER_TEST_ID_PREFIX;
        const buttonContentOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, isFavorite ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))), {
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).removeFromStarred)
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aaIe7))), {
            LEGACY_size: isSmall ? 'small' : undefined,
            color: "currentColor",
            label: formatMessage((0, $6urTU.default).addToStarred)
        }));
        const renderIcon = ()=>{
            const label = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
            const StarIconComponent = isFavorite ? (0, (/*@__PURE__*/$parcel$interopDefault($gGgaG))) : (0, (/*@__PURE__*/$parcel$interopDefault($aaIe7)));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StarIconComponent, {
                color: "currentColor",
                label: label,
                size: isSmall ? 'small' : 'medium'
            });
        };
        const buttonContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$var$FavIconWrapper, {
            isFavorite: isFavorite,
            isAnimating: isAnimating,
            "data-testid": iconWrapperTestId,
            isSmall: isSmall
        }, renderIcon());
        const tooltipContent = isFavorite ? formatMessage((0, $6urTU.default).removeFromStarred) : formatMessage((0, $6urTU.default).addToStarred);
        const ariaLabel = favoriteItemName ? formatMessage((0, $6urTU.default).toggleStarredWithItemName, {
            itemName: favoriteItemName
        }) : formatMessage((0, $6urTU.default).toggleStarred);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($c7558d16e1b4ddea$export$bb1478fee6cd5f0c, {
            role: "presentation",
            onClick: this.onBtnClickWrapper,
            onKeyPress: this.onBtnClickWrapper,
            "data-is-favorite": isFavorite
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: !hideTooltip && tooltipContent,
            hideTooltipOnClick: true,
            position: tooltipPosition
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
            appearance: isShownInList ? 'subtle-link' : 'subtle',
            spacing: "none",
            "aria-label": ariaLabel,
            "aria-pressed": isFavorite,
            onClick: !pending ? this.onClick : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        }, (0, $6XJko.isVisualRefreshEnabled)() ? buttonContent : buttonContentOld)));
    }
    constructor(...args){
        super(...args), this.state = {
            isAnimating: false
        }, this.onBtnClickWrapper = (e)=>{
            e.stopPropagation(); // should not let this event get outside of the component, to prevent issue when, for example, star button is clicked in an item or row, which goes somewhere else on onClick handler. Cannot put it in onBtnClick, otherwise hideTooltipOnClick in <Tooltip> will not work
            e.preventDefault(); // same for cases when btn is inside a link - not to go to that link (e.g. in Star Drawer)
        }, this.onClick = (_, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        };
    }
}
var $c7558d16e1b4ddea$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onClick: ()=>({
            name: 'star'
        })
}), (0, $6YFG2.default))($c7558d16e1b4ddea$export$f8ad2acf0ec4860f);
const $c7558d16e1b4ddea$var$animationTime = 500; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$bb1478fee6cd5f0c = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_11vn1rr0 _1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, isAnimating: isAnimating, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.isAnimating && "_1px1fmmq _48hmq7pw _1uvf1e03",
            __cmplp.className
        ])
    });
});
const $c7558d16e1b4ddea$var$FavoriteIconWrapperBase = (0, $f2JN3.componentWithCondition)((0, $6XJko.isVisualRefreshEnabled), $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseNew, $c7558d16e1b4ddea$var$FavoriteIconWrapperBaseOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c7558d16e1b4ddea$var$FavIconWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = $c7558d16e1b4ddea$var$FavoriteIconWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "",
            __cmplp.isFavorite ? "_syaz1oqg" : "_syazdgkc",
            __cmplp.isFavorite ? "_30l31vop" : "_30l31q3r",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $c7558d16e1b4ddea$export$db65185b5889c83 = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSmall: isSmall, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw",
            __cmplp.isSmall ? "_1bsb1tcg" : "_1bsbzwfg",
            __cmplp.isSmall ? "_4t3i1tcg" : "_4t3izwfg",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6urTU", function(module, exports) {
$parcel$export(module.exports, "default", () => $708ae8e1a771b9ca$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $708ae8e1a771b9ca$var$messages = (0, $7qGN1.defineMessages)({
    addToStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.add-to-starred",
        "defaultMessage": "Add to Starred"
    },
    removeFromStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.remove-from-starred",
        "defaultMessage": "Remove from Starred"
    },
    toggleStarred: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred",
        "defaultMessage": "Star"
    },
    toggleStarredWithItemName: {
        "id": "platform.ui.favouriting.favourite-button-stateless.toggle-starred-with-item-name",
        "defaultMessage": "Star {itemName}"
    }
});
var $708ae8e1a771b9ca$export$2e2bcd8739ae039 = $708ae8e1a771b9ca$var$messages;

});





parcelRegister("klPtp", function(module, exports) {
$parcel$export(module.exports, "default", () => $dad88b7b5a242bec$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $LFmXM = parcelRequire("LFmXM");

var $6sjW5 = parcelRequire("6sjW5");



var $gnQAk = parcelRequire("gnQAk");

var $7FCY1 = parcelRequire("7FCY1");

var $clmY2 = parcelRequire("clmY2");
const $dad88b7b5a242bec$var$mapStateToPropsFactory = ()=>{
    const onDeleteFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$4bd2facc4a3e6aa1)));
    const onCopyFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$92f9e1ed9114d3a6)));
    const onMoveFactory = (0, $LFmXM.default)((onOperationRequested)=>()=>// @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onOperationRequested((0, $85bfce414eef38c7$export$346f08c1f0d0fe41)));
    return (state, ownProps)=>({
            name: !(0, $7FCY1.isPrivate)(state, ownProps.id) ? (0, $7FCY1.getName)(state, ownProps.id) : undefined,
            isPrivate: (0, $7FCY1.isPrivate)(state, ownProps.id),
            editBoardUrl: (0, $7FCY1.getEditBoardUrl)(state, ownProps.id),
            onDelete: onDeleteFactory(ownProps.onOperationRequested),
            onCopy: onCopyFactory(ownProps.onOperationRequested),
            onMove: onMoveFactory(ownProps.onOperationRequested),
            showSpinner: ownProps.isOperationInProgress,
            isSimple: !(0, $7FCY1.isPrivate)(state, ownProps.id) && (0, $7FCY1.getType)(state, ownProps.id) === (0, $987928229d6d4941$export$aca095bc476d426f),
            canEdit: (0, $7FCY1.canEdit)(state, ownProps.id),
            location: (0, $7FCY1.getLocation)(state, ownProps.id)
        });
};
var $dad88b7b5a242bec$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $6sjW5.default)({
    onEdit: 'edit',
    onDelete: 'delete',
    onCopy: 'copy',
    onMove: 'move'
}), (0, $gnQAk.connect)($dad88b7b5a242bec$var$mapStateToPropsFactory, {}))((0, $clmY2.default));

});
parcelRegister("clmY2", function(module, exports) {
$parcel$export(module.exports, "default", () => $64db96e40157d7d0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $2sLVw = parcelRequire("2sLVw");

var $98kYt = parcelRequire("98kYt");

var $k65Oi = parcelRequire("k65Oi");
function $64db96e40157d7d0$export$2e2bcd8739ae039(props) {
    const { location: location } = props;
    if (location) {
        const appearance = location.type === 'user' ? 'circle' : 'square';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
            alignItems: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $98kYt.default), {
            displayName: location.displayName,
            avatarUrl: location.avatarURI,
            appearance: appearance
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k65Oi.default), props));
    }
    return null;
}

});
parcelRegister("k65Oi", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8d83ff749884f9c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $Ay1uj = parcelRequire("Ay1uj");

var $7rjYb = parcelRequire("7rjYb");
var $jYYbf = parcelRequire("jYYbf");
var $aLJ1L = parcelRequire("aLJ1L");

var $NByNW = parcelRequire("NByNW");

var $2sLVw = parcelRequire("2sLVw");

var $as6H2 = parcelRequire("as6H2");

var $9M9Yb = parcelRequire("9M9Yb");

var $lRq8t = parcelRequire("lRq8t");

var $4aSRi = parcelRequire("4aSRi");

var $bzbsd = parcelRequire("bzbsd");

var $6XJko = parcelRequire("6XJko");

var $gbyoA = parcelRequire("gbyoA");
const $f8d83ff749884f9c$var$DropdownMenuWithAnalytics = (0, $as6H2.default)('dropdownMenu', {
    onOpenChange: 'open'
})((0, $7rjYb.default));
const $f8d83ff749884f9c$var$DropdownItemWithAnalytics = (0, $as6H2.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $jYYbf.default));
function $f8d83ff749884f9c$export$2e2bcd8739ae039(props) {
    const { name: name, isPrivate: isPrivate = false, isSimple: isSimple = false, canEdit: canEdit = true, defaultOpen: defaultOpen = false, showSpinner: showSpinner = false, editBoardUrl: editBoardUrl = '', onEdit: onEdit = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onDelete: onDelete = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onCopy: onCopy = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))), onMove: onMove = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))) } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $eJOHy.useState)(defaultOpen);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    const moreActionsButtonRef = (0, $eJOHy.useRef)(null);
    const shouldRegainFocus = (0, $eJOHy.useRef)(false);
    const onOpenChange = (0, $eJOHy.useCallback)(({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
    }, []); /**
           * Close the menu with a minimal delay so the inner handlers are able to react on keypress properly.
           * In its current implementation if we close the menu right away it won't open the focused `href`.
           * Ideally we have to get right of this and few more methods when the bug linked below is fixed.
           * @see https://ecosystem.atlassian.net/browse/AK-4467
           */ 
    const delayedClose = (0, $eJOHy.useCallback)(()=>{
        setTimeout(()=>setIsDropdownOpen(false));
    }, []);
    const handleEdit = (0, $eJOHy.useCallback)((e, analytics)=>{
        onEdit(analytics);
        delayedClose();
    }, [
        delayedClose,
        onEdit
    ]);
    const renderSettingsAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9Yb.TransitionComponent), {
            href: editBoardUrl,
            onClick: handleEdit
        }, (dropdownProps)=>/* @ts-expect-error - Type '{ children: string; href: string; onClick: OnClick; }' is not assignable to type 'Omit<{ children: ReactNode; component?: ComponentType<PropsWithChildren<CustomItemComponentProps>> | undefined; ... 14 more ...; key?: Key | ... 1 more ... | undefined; }, keyof WithAnalyticsEventsProps>'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8d83ff749884f9c$var$DropdownItemWithAnalytics, dropdownProps, formatMessage((0, $gbyoA.default).editAction)));
    const renderCopyAction = ()=>{
        const copyWithAnalytics = (event, arg1)=>{
            onCopy(event, arg1);
            setReturnFocusTo(moreActionsButtonRef);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8d83ff749884f9c$var$DropdownItemWithAnalytics, {
            onClick: copyWithAnalytics
        }, formatMessage((0, $gbyoA.default).copyAction));
    };
    const renderMoveAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8d83ff749884f9c$var$DropdownItemWithAnalytics, {
            onClick: onMove
        }, formatMessage((0, $gbyoA.default).moveAction));
    const renderDeleteAction = ()=>{
        const deleteWithAnalytics = (event, arg1)=>{
            onDelete(event, arg1);
            setReturnFocusTo(moreActionsButtonRef);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8d83ff749884f9c$var$DropdownItemWithAnalytics, {
            onClick: deleteWithAnalytics
        }, formatMessage((0, $gbyoA.default).deleteAction));
    };
    const renderActions = ()=>{
        if (isSimple) return null;
         /**
       * legacy logic: https://stash.atlassian.com/projects/JIRACLOUD/repos/jira/browse/jira-components/jira-plugins/jira-agile/greenhopper/src/main/resources/includes/js/rapid/configuration/ManageBoards.soy
       * check boards spec for more informations: https://extranet.atlassian.com/pages/viewpage.action?pageId=3540485825
       * corresponding issue: https://jdog.jira-dev.com/browse/KITKAT-274
       */ 
        let moveItem = null;
        let deleteItem = null;
        let copyItem = null;
        let settingsItem = null;
        if (isPrivate) {
            if (canEdit) moveItem = renderMoveAction();
            deleteItem = renderDeleteAction();
        } else {
            if (canEdit) {
                moveItem = renderMoveAction();
                deleteItem = renderDeleteAction();
            }
            copyItem = renderCopyAction();
            settingsItem = renderSettingsAction();
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const triggerFunction = ({ triggerRef: triggerRef, ...buttonProps })=>{
            const ref = (0, $bzbsd.mergeRefs)(moreActionsButtonRef ?? null, triggerRef);
            if (showSpinner) shouldRegainFocus.current = true;
            if (!showSpinner && shouldRegainFocus.current && moreActionsButtonRef.current) {
                setReturnFocusTo(moreActionsButtonRef);
                shouldRegainFocus.current = false;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $Ay1uj.default), {
                ...buttonProps,
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($NByNW))),
                ref: ref,
                label: isPrivate ? formatMessage((0, $gbyoA.default).tooltipPrivate) : formatMessage((0, $gbyoA.default).tooltipWithName, {
                    name: name
                }),
                isLoading: showSpinner,
                spacing: "compact",
                ...(0, $6XJko.isVisualRefreshEnabled)() ? {
                    isTooltipDisabled: false,
                    tooltip: {
                        content: formatMessage((0, $gbyoA.default).moreActionsTooltip),
                        hideTooltipOnClick: true
                    }
                } : {}
            });
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($f8d83ff749884f9c$var$DropdownMenuWithAnalytics, {
            placement: "bottom-end",
            isOpen: isDropdownOpen,
            onOpenChange: onOpenChange,
            trigger: triggerFunction,
            shouldRenderToParent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aLJ1L.default), null, settingsItem, copyItem, moveItem, deleteItem));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2sLVw.default), {
        justifyContent: "end",
        xcss: $f8d83ff749884f9c$var$styles.container,
        testId: "boards-main.content.cells.actions.container"
    }, renderActions());
}
const $f8d83ff749884f9c$var$styles = {
    container: "_1rjcu2gc _19bvu2gc _u5f3utpp"
};

});



parcelRegister("71H9a", function(module, exports) {
$parcel$export(module.exports, "default", () => $043bb8f97d289159$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $7FCY1 = parcelRequire("7FCY1");

var $dsLPm = parcelRequire("dsLPm");
const $043bb8f97d289159$var$mapStateToProps = ()=>(state, ownProps)=>({
            location: (0, $7FCY1.getLocation)(state, ownProps.id)
        });
var $043bb8f97d289159$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($043bb8f97d289159$var$mapStateToProps, {})((0, $dsLPm.default));

});
parcelRegister("dsLPm", function(module, exports) {
$parcel$export(module.exports, "default", () => $3c630533678aa11a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $98kYt = parcelRequire("98kYt");
function $3c630533678aa11a$export$2e2bcd8739ae039(props) {
    const { location: location } = props;
    if (location) {
        const appearance = location.type === 'user' ? 'circle' : 'square';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $98kYt.default), {
            displayName: location.displayName,
            avatarUrl: location.avatarURI,
            appearance: appearance
        });
    }
    return null;
}

});


parcelRegister("2VDXD", function(module, exports) {
$parcel$export(module.exports, "default", () => $99dda29638d7be81$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $f1MUi = parcelRequire("f1MUi");

var $gvcGw = parcelRequire("gvcGw");

var $35Z6B = parcelRequire("35Z6B");
const $99dda29638d7be81$var$TitleCell = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $f1MUi.default), props, ({ isPrivate: isPrivate })=>isPrivate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gvcGw.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $35Z6B.default), props));
var $99dda29638d7be81$export$2e2bcd8739ae039 = $99dda29638d7be81$var$TitleCell;

});
parcelRegister("gvcGw", function(module, exports) {
$parcel$export(module.exports, "default", () => $3226cc3cc6a593f2$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $jdqdp = parcelRequire("jdqdp");

var $8nu6j = parcelRequire("8nu6j");
var $lmgo6 = parcelRequire("lmgo6");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $idGBm = parcelRequire("idGBm");

var $6XJko = parcelRequire("6XJko");

var $fyUbk = parcelRequire("fyUbk");
function $3226cc3cc6a593f2$var$Private(props) {
    const { intl: { formatMessage: formatMessage } } = props;
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3226cc3cc6a593f2$var$TooltipContent, null, formatMessage((0, $fyUbk.default).tooltip));
    if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lmgo6.default), {
        xcss: $3226cc3cc6a593f2$var$flexContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        isBold: true
    }, formatMessage((0, $fyUbk.default).lozenge))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $3226cc3cc6a593f2$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $jdqdp.default), {
        isBold: true
    }, formatMessage((0, $fyUbk.default).lozenge))));
}
var $3226cc3cc6a593f2$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $idGBm.injectIntlV2)($3226cc3cc6a593f2$var$Private);
const $3226cc3cc6a593f2$var$TooltipContent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_y3gn1h6o _p12f1llu",
            __cmplp.className
        ])
    });
});
const $3226cc3cc6a593f2$var$containerStyles = (0, $1DXK0.xcss)({
    paddingTop: 'space.150',
    paddingBottom: 'space.150'
});
const $3226cc3cc6a593f2$var$flexContainerStyles = (0, $1DXK0.xcss)({
    alignItems: 'center',
    height: "var(--ds-space-500, 40px)"
});

});
parcelRegister("fyUbk", function(module, exports) {
$parcel$export(module.exports, "default", () => $e24bd598aa46f2cc$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $e24bd598aa46f2cc$var$messages = (0, $7qGN1.defineMessages)({
    lozenge: {
        "id": "directories.boards-v2.main.content.cells.title.private.lozenge",
        "defaultMessage": "Private"
    },
    tooltip: {
        "id": "directories.boards-v2.main.content.cells.title.private.tooltip",
        "defaultMessage": "You don't have permission to view this board"
    }
});
var $e24bd598aa46f2cc$export$2e2bcd8739ae039 = $e24bd598aa46f2cc$var$messages;

});


parcelRegister("35Z6B", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c05c5bbcbb27839$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $cEgtp = parcelRequire("cEgtp");

var $6sjW5 = parcelRequire("6sjW5");


var $gnQAk = parcelRequire("gnQAk");

var $7FCY1 = parcelRequire("7FCY1");

var $a5yDt = parcelRequire("a5yDt");
const $1c05c5bbcbb27839$var$getNextGenBoardPrettyUrl = (state, id)=>{
    const location = (0, $7FCY1.getLocation)(state, id);
    // @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
    if (location && location.projectKey) // @ts-expect-error - TS2339 - Property 'projectKey' does not exist on type 'Location'.
    return `/jira/software/projects/${location.projectKey}/boards/${id}`;
    return null;
};
const $1c05c5bbcbb27839$export$505a9f131607d070 = (state, id)=>{
    if ((0, $7FCY1.getType)(state, id) === (0, $987928229d6d4941$export$aca095bc476d426f)) return $1c05c5bbcbb27839$var$getNextGenBoardPrettyUrl(state, id);
    return (0, $7FCY1.getRapidBoardUrlForSavedBoard)(state, id);
};
const $1c05c5bbcbb27839$var$mapStateToProps = ()=>(state, ownProps)=>({
            caption: (0, $7FCY1.getName)(state, ownProps.id),
            href: $1c05c5bbcbb27839$export$505a9f131607d070(state, ownProps.id),
            type: (0, $7FCY1.getType)(state, ownProps.id)
        });
var $1c05c5bbcbb27839$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $cEgtp.default)((state, ownProps)=>({
        attributes: {
            boardType: (0, $7FCY1.getType)(state, ownProps.id)
        }
    })), (0, $6sjW5.default)({
    onClick: 'board'
}), (0, $gnQAk.connect)($1c05c5bbcbb27839$var$mapStateToProps, {}))((0, $a5yDt.default));

});
parcelRegister("cEgtp", function(module, exports) {
$parcel$export(module.exports, "default", () => $c18f362441b2c495$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $LFmXM = parcelRequire("LFmXM");

var $e2B2h = parcelRequire("e2B2h");

var $gnQAk = parcelRequire("gnQAk");

var $a79Te = parcelRequire("a79Te");

var $qQaal = parcelRequire("qQaal");
const $c18f362441b2c495$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $eJOHy.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2B2h.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $LFmXM.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $qQaal.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $gnQAk.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $a79Te.default)(prevAttributes, nextAttributes) && (0, $a79Te.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $c18f362441b2c495$export$2e2bcd8739ae039 = $c18f362441b2c495$var$ReduxAnalyticsData;

});
parcelRegister("a79Te", function(module, exports) {
$parcel$export(module.exports, "default", () => $e3d69d10218447a3$export$2e2bcd8739ae039);
const $e3d69d10218447a3$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
// one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e3d69d10218447a3$var$isShallowEqualWithSafeStringSupport = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$e3d69d10218447a3$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $e3d69d10218447a3$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};
var $e3d69d10218447a3$export$2e2bcd8739ae039 = $e3d69d10218447a3$var$isShallowEqualWithSafeStringSupport;

});


parcelRegister("a5yDt", function(module, exports) {
$parcel$export(module.exports, "default", () => $e17a56115e11b42e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $bTsWb = parcelRequire("bTsWb");

var $9M9Yb = parcelRequire("9M9Yb");
const $e17a56115e11b42e$var$Public = ({ caption: caption, href: href, type: type, onClick: onClick })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $9M9Yb.TransitionComponent), {
        href: href,
        onClick: onClick
    }, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bTsWb.default), {
            ...props,
            caption: caption,
            "data-item-board-type": type
        }));
var $e17a56115e11b42e$export$2e2bcd8739ae039 = $e17a56115e11b42e$var$Public;

});
parcelRegister("bTsWb", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff8fef4b8456318c$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $gYvT9 = parcelRequire("gYvT9");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $k71qx = parcelRequire("k71qx");

var $6XJko = parcelRequire("6XJko");
function $ff8fef4b8456318c$export$2e2bcd8739ae039({ caption: caption, href: href, onClick: onClick, ...props }) {
    const content = (0, $eJOHy.useMemo)(()=>{
        const innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            paddingInline: "space.050"
        }, href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gYvT9.default), {
            href: href,
            onClick: onClick
        }, caption) : caption);
        if ((0, $6XJko.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $ff8fef4b8456318c$var$containerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
            xcss: $ff8fef4b8456318c$var$wrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: caption,
            isScreenReaderAnnouncementDisabled: true,
            delay: 1000,
            position: "bottom-start"
        }, innerContent)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($ff8fef4b8456318c$var$Container, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $k71qx.default), {
            content: caption,
            isScreenReaderAnnouncementDisabled: true,
            delay: 1000,
            position: "bottom-start"
        }, innerContent));
    }, [
        caption,
        href,
        onClick,
        props
    ]);
    return content;
}
const $ff8fef4b8456318c$var$containerStyles = (0, $1DXK0.xcss)({
    width: '100%',
    paddingBlock: 'space.100',
    flex: '1 1 auto',
    flexDirection: 'row',
    display: 'flex',
    height: '40px'
});
const $ff8fef4b8456318c$var$wrapperStyles = (0, $1DXK0.xcss)({
    paddingBlock: 'space.025',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $ff8fef4b8456318c$var$Container = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _1bsb1osq _o5721q9c _1bto1l2s _ca0qutpp _n3tdutpp",
            __cmplp.className
        ])
    });
});

});




parcelRegister("eepkg", function(module, exports) {
$parcel$export(module.exports, "default", () => $84b80d15401affbf$export$2e2bcd8739ae039);

var $5XIWy = parcelRequire("5XIWy");

var $gnQAk = parcelRequire("gnQAk");

var $d6NK2 = parcelRequire("d6NK2");

var $7FCY1 = parcelRequire("7FCY1");
const $84b80d15401affbf$var$mapStateToProps = (state, ownProps)=>{
    const board = (0, $7FCY1.getBoard)(state, ownProps.entityId);
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    if (board.isPrivate) throw new Error("Unexpected state: Private board can't be copied.");
    return {
        board: board
    };
};
const $84b80d15401affbf$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onInitialised: ownProps.onDialogShown,
        onBoardCopied: (board, copiedBoardSummary)=>{
            dispatch((0, $d6NK2.copied)(board, copiedBoardSummary));
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            ownProps.onUpdated();
        },
        onBoardCopyFailed: (board, reason)=>dispatch((0, $d6NK2.copyFailed)(board, reason)),
        onCancel: ownProps.onCancel
    });
var // @ts-expect-error - TS2345 - Argument of type 'typeof CopyModal' is not assignable to parameter of type 'Component<{ board: Board; } & { onInitialised: () => void; onBoardCopied: (board: PublicBoard, copiedBoardSummary: CopiedBoardSummary) => void; onBoardCopyFailed: (board: PublicBoard, reason: OperationFailureReason) => CopyFailedAction; onCancel: () => void; } & OperationModalProps<...>>'.
$84b80d15401affbf$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($84b80d15401affbf$var$mapStateToProps, $84b80d15401affbf$var$mapDispatchToProps)((0, $5XIWy.default));

});
parcelRegister("5XIWy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4fe6f853eaa7257a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $fGnU6 = parcelRequire("fGnU6");

var $fdpHV = parcelRequire("fdpHV");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");


var $9kxWz = parcelRequire("9kxWz");

var $5EfEa = parcelRequire("5EfEa");

var $oZSrh = parcelRequire("oZSrh");

var $3BCLR = parcelRequire("3BCLR");
// eslint-disable-next-line jira/react/no-class-components
class $4fe6f853eaa7257a$var$CopyModal extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onBoardCopied: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        this.props.onInitialised();
        this.store = (0, $oZSrh.default)((0, $9kxWz.default));
        this.store.dispatch((0, $5EfEa.setAppProps)(this.props));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            hasErrorBoundary: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGnU6.ReportErrors), {
            id: "unhandled",
            packageName: "jiraCopyBoardsModal",
            teamName: "keystone"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3BCLR.default), null))));
    }
}
var $4fe6f853eaa7257a$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('copyBoard', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa))($4fe6f853eaa7257a$var$CopyModal);

});
parcelRegister("9kxWz", function(module, exports) {
$parcel$export(module.exports, "default", () => $a1c34360e2ab2017$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $lMJt7 = parcelRequire("lMJt7");
var $a1c34360e2ab2017$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $lMJt7.default));

});
parcelRegister("lMJt7", function(module, exports) {
$parcel$export(module.exports, "default", () => $a0e96e71db573848$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("cBiei");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $jDJbB = parcelRequire("jDJbB");

var $5EfEa = parcelRequire("5EfEa");

var $keoyz = parcelRequire("keoyz");
const $a0e96e71db573848$var$copyBoardEpic = (action$, store)=>action$.ofType((0, $5EfEa.COPY_BOARD)).mergeMap(()=>{
        const state = store.getState();
        const board = (0, $keoyz.getBoard)(state);
        return (0, $7kixv.Observable).fromPromise((0, $jDJbB.default)(board.id)).mergeMap((copiedBoardSummary)=>{
            (0, $keoyz.getOnBoardCopied)(state)(board, copiedBoardSummary);
            return (0, $7kixv.Observable).of((0, $5EfEa.boardCopied)());
        }).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.boards-v2.copy-modal.ops.copy-board', error.message, error);
            const reason = error.statusCode === 404 ? 'board-not-found' : 'unknown';
            (0, $keoyz.getOnBoardCopyFailed)(state)(board, reason);
            return (0, $7kixv.Observable).of((0, $5EfEa.copyBoardFailed)({
                reason: reason
            }));
        });
    });
var $a0e96e71db573848$export$2e2bcd8739ae039 = $a0e96e71db573848$var$copyBoardEpic;

});
parcelRegister("jDJbB", function(module, exports) {
$parcel$export(module.exports, "default", () => $be3401dbba697fa2$export$2e2bcd8739ae039);

var $hgi0g = parcelRequire("hgi0g");
const $be3401dbba697fa2$var$copyBoard = (boardId)=>{
    const url = `/rest/greenhopper/1.0/rapidview/${boardId}/copy`;
    const options = {
        method: 'PUT'
    };
    return (0, $hgi0g.default)(url, options);
};
var $be3401dbba697fa2$export$2e2bcd8739ae039 = $be3401dbba697fa2$var$copyBoard;

});

parcelRegister("5EfEa", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $9db5dd7eed029337$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $9db5dd7eed029337$export$cfda7627848a58cd);
$parcel$export(module.exports, "COPY_BOARD", () => $9db5dd7eed029337$export$e4dd009772b7198e);
$parcel$export(module.exports, "copyBoard", () => $9db5dd7eed029337$export$12660397a6f72b4d);
$parcel$export(module.exports, "COPY_BOARD_FAILED", () => $9db5dd7eed029337$export$1afd87d9525e6a2d);
$parcel$export(module.exports, "copyBoardFailed", () => $9db5dd7eed029337$export$eba000c6ef05bd6a);
$parcel$export(module.exports, "BOARD_COPIED", () => $9db5dd7eed029337$export$f9a805c22e2247f3);
$parcel$export(module.exports, "boardCopied", () => $9db5dd7eed029337$export$fcf4bd3839096db);
const $9db5dd7eed029337$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $9db5dd7eed029337$export$cfda7627848a58cd = (payload)=>({
        type: $9db5dd7eed029337$export$8aefe701a6f431e0,
        payload: payload
    });
const $9db5dd7eed029337$export$e4dd009772b7198e = 'state.COPY_BOARD';
const $9db5dd7eed029337$export$12660397a6f72b4d = ()=>({
        type: $9db5dd7eed029337$export$e4dd009772b7198e
    });
const $9db5dd7eed029337$export$1afd87d9525e6a2d = 'state.COPY_BOARD_FAILED';
const $9db5dd7eed029337$export$eba000c6ef05bd6a = (payload)=>({
        type: $9db5dd7eed029337$export$1afd87d9525e6a2d,
        payload: payload
    });
const $9db5dd7eed029337$export$f9a805c22e2247f3 = 'state.BOARD_COPIED';
const $9db5dd7eed029337$export$fcf4bd3839096db = ()=>({
        type: $9db5dd7eed029337$export$f9a805c22e2247f3
    });

});

parcelRegister("keoyz", function(module, exports) {
$parcel$export(module.exports, "getBoard", () => $cb2a054000c055c6$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "getOnBoardCopied", () => $cb2a054000c055c6$export$3f4f5af9bb8916f0);
$parcel$export(module.exports, "getOnBoardCopyFailed", () => $cb2a054000c055c6$export$8c8fcdd1185d1774);
$parcel$export(module.exports, "getOnCancel", () => $cb2a054000c055c6$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isCopyInProgress", () => $cb2a054000c055c6$export$c4e95745078f70d6);
const $cb2a054000c055c6$export$2223f2dfcfd77cef = (state)=>state.appProps.board;
const $cb2a054000c055c6$export$3f4f5af9bb8916f0 = (state)=>state.appProps.onBoardCopied;
const $cb2a054000c055c6$export$8c8fcdd1185d1774 = (state)=>state.appProps.onBoardCopyFailed;
const $cb2a054000c055c6$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $cb2a054000c055c6$export$c4e95745078f70d6 = (state)=>state.isCopyInProgress;

});



parcelRegister("oZSrh", function(module, exports) {
$parcel$export(module.exports, "default", () => $d00d565b40fd3160$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $98TqI = parcelRequire("98TqI");
const $d00d565b40fd3160$var$createStore = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'directories/boards-v2/copy-modal',
        rootReducer: $98TqI.default,
        rootEpic: rootEpic
    });
var $d00d565b40fd3160$export$2e2bcd8739ae039 = $d00d565b40fd3160$var$createStore;

});
parcelRegister("98TqI", function(module, exports) {
$parcel$export(module.exports, "default", () => $1b6673e2c1462b14$export$2e2bcd8739ae039);

var $5EfEa = parcelRequire("5EfEa");
const $1b6673e2c1462b14$var$defaultState = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    isCopyInProgress: false
};
const $1b6673e2c1462b14$var$reducer = (state = $1b6673e2c1462b14$var$defaultState, action)=>{
    switch(action.type){
        case 0, $5EfEa.SET_APP_PROPS:
            return {
                ...$1b6673e2c1462b14$var$defaultState,
                appProps: action.payload
            };
        case 0, $5EfEa.COPY_BOARD:
            return {
                ...state,
                isCopyInProgress: true
            };
        case 0, $5EfEa.COPY_BOARD_FAILED:
            return {
                ...state,
                isCopyInProgress: false
            };
        case 0, $5EfEa.BOARD_COPIED:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $1b6673e2c1462b14$export$2e2bcd8739ae039 = $1b6673e2c1462b14$var$reducer;

});


parcelRegister("3BCLR", function(module, exports) {
$parcel$export(module.exports, "default", () => $cd8372192fad6a7c$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $5EfEa = parcelRequire("5EfEa");

var $keoyz = parcelRequire("keoyz");

var $7gQnq = parcelRequire("7gQnq");
const $cd8372192fad6a7c$var$mapStateToProps = (state)=>({
        board: (0, $keoyz.getBoard)(state),
        copyInProgress: (0, $keoyz.isCopyInProgress)(state),
        onCancel: (0, $keoyz.getOnCancel)(state)
    });
var $cd8372192fad6a7c$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($cd8372192fad6a7c$var$mapStateToProps, {
    onCopy: (0, $5EfEa.copyBoard)
})((0, $7gQnq.default));

});
parcelRegister("7gQnq", function(module, exports) {
$parcel$export(module.exports, "default", () => $a654857d3f4bfa8a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $guWba = parcelRequire("guWba");

var $4cTDP = parcelRequire("4cTDP");

var $fgJkD = parcelRequire("fgJkD");

var $4B7rn = parcelRequire("4B7rn");

var $lRq8t = parcelRequire("lRq8t");

var $d5uID = parcelRequire("d5uID");
function $a654857d3f4bfa8a$var$CopyBoardsModal(props) {
    const { board: board, copyInProgress: copyInProgress, onCancel: onCancel, onCopy: onCopy } = props;
    const { formatMessage: formatMessage } = (0, $lRq8t.default)();
    const onCancelOrNoop = !copyInProgress ? onCancel : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "copy-boards-modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: (0, $4cTDP.fg)('enghealth-modal-close-button-prevent-close-modal')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "warning"
    }, formatMessage((0, $d5uID.default).heading, {
        boardName: board.name
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $d5uID.default).settingsAndFilterInfoMessage, {
        boardName: board.name
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $d5uID.default).ownerMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "warning",
        onClick: onCopy,
        isDisabled: copyInProgress
    }, formatMessage((0, $d5uID.default).copyButtonCaption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: copyInProgress
    }, formatMessage((0, $d5uID.default).cancelButtonCaption)))));
}
$a654857d3f4bfa8a$var$CopyBoardsModal.defaultProps = {
    copyInProgress: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onCopy: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $a654857d3f4bfa8a$export$2e2bcd8739ae039 = $a654857d3f4bfa8a$var$CopyBoardsModal;

});
parcelRegister("d5uID", function(module, exports) {
$parcel$export(module.exports, "default", () => $73ce82084e930620$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $73ce82084e930620$var$messages = (0, $7qGN1.defineMessages)({
    heading: {
        "id": "directories.boards-v2.copy-modal.heading",
        "defaultMessage": "Copy {boardName}"
    },
    settingsAndFilterInfoMessage: {
        "id": "directories.boards-v2.copy-modal.settings-and-filter-info-message",
        "defaultMessage": "Your copied board will use the same settings and filter as {boardName}."
    },
    ownerMessage: {
        "id": "directories.boards-v2.copy-modal.owner-message",
        "defaultMessage": "As the owner, you can change these later."
    },
    copyButtonCaption: {
        "id": "directories.boards-v2.copy-modal.copy-button-caption",
        "defaultMessage": "Copy"
    },
    cancelButtonCaption: {
        "id": "directories.boards-v2.copy-modal.cancel-button-caption",
        "defaultMessage": "Cancel"
    }
});
var $73ce82084e930620$export$2e2bcd8739ae039 = $73ce82084e930620$var$messages;

});





parcelRegister("iFUx2", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf8c160d66501863$export$2e2bcd8739ae039);

var $9Wqfs = parcelRequire("9Wqfs");

var $gnQAk = parcelRequire("gnQAk");

var $d6NK2 = parcelRequire("d6NK2");

var $7FCY1 = parcelRequire("7FCY1");
const $bf8c160d66501863$var$mapStateToProps = (state, ownProps)=>({
        board: (0, $7FCY1.getBoard)(state, ownProps.entityId)
    });
const $bf8c160d66501863$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onInitialised: ownProps.onDialogShown,
        onBoardDeleted: (board)=>{
            dispatch((0, $d6NK2.deleted)(board));
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            ownProps.onUpdated();
        },
        onBoardDeleteFailed: (board, reason)=>dispatch((0, $d6NK2.deleteFailed)(board, reason)),
        onCancel: ownProps.onCancel
    });
var // @ts-expect-error – (2345) - Type 'undefined' is not assignable to type 'Board'
$bf8c160d66501863$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($bf8c160d66501863$var$mapStateToProps, $bf8c160d66501863$var$mapDispatchToProps)((0, $9Wqfs.default));

});
parcelRegister("9Wqfs", function(module, exports) {
$parcel$export(module.exports, "default", () => $c57a00c72036028f$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $fdpHV = parcelRequire("fdpHV");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");


var $55zw4 = parcelRequire("55zw4");

var $i6aaC = parcelRequire("i6aaC");

var $G61cz = parcelRequire("G61cz");

var $csIDH = parcelRequire("csIDH");
// eslint-disable-next-line jira/react/no-class-components
class $c57a00c72036028f$var$DeleteModal extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onInitialised: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onBoardDeleted: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $G61cz.default)((0, $55zw4.default));
        this.store.dispatch((0, $i6aaC.setAppProps)(this.props));
        this.store.dispatch((0, $i6aaC.getActiveSprints)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $csIDH.default), null)));
    }
}
var $c57a00c72036028f$export$2e2bcd8739ae039 = (0, $fdpHV.AnalyticsSource)('deleteBoard', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa))($c57a00c72036028f$var$DeleteModal);

});
parcelRegister("55zw4", function(module, exports) {
$parcel$export(module.exports, "default", () => $d935b7d2eddd5790$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $i5MPC = parcelRequire("i5MPC");

var $5KtTM = parcelRequire("5KtTM");
var // @ts-expect-error - TS2769 - No overload matches this call.
$d935b7d2eddd5790$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $i5MPC.default), (0, $5KtTM.default));

});
parcelRegister("i5MPC", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f34796173529b03$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");

var $eSnSE = parcelRequire("eSnSE");

var $jbabP = parcelRequire("jbabP");

var $i6aaC = parcelRequire("i6aaC");

var $4TMFo = parcelRequire("4TMFo");
const $0f34796173529b03$var$deleteBoardEpic = (action$, store)=>action$.ofType((0, $i6aaC.DELETE_BOARD)).mergeMap(()=>{
        const state = store.getState();
        const board = (0, $4TMFo.getBoard)(state);
        return (0, $jbabP.default)(board.id).mergeMap(()=>{
            (0, $4TMFo.getOnBoardDeleted)(state)(board);
            return (0, $7kixv.Observable).of((0, $i6aaC.boardDeleted)());
        }).catch((error)=>{
            (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.boards-v2.delete-modal.ops.delete-board', error.message, error);
            const reason = error.statusCode === 404 ? 'board-not-found' : 'unknown';
            (0, $4TMFo.getOnBoardDeleteFailed)(state)(board, reason);
            return (0, $7kixv.Observable).of((0, $i6aaC.deleteBoardFailed)({
                reason: reason
            }));
        });
    });
var $0f34796173529b03$export$2e2bcd8739ae039 = $0f34796173529b03$var$deleteBoardEpic;

});
parcelRegister("jbabP", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca52d1789fdf57e9$export$2e2bcd8739ae039);

var $aU4yQ = parcelRequire("aU4yQ");
const $ca52d1789fdf57e9$var$deleteBoard = (boardId)=>{
    const url = `/rest/agile/1.0/board/${boardId}`;
    const options = {
        method: 'delete'
    };
    return (0, $aU4yQ.default)(url, options);
};
var $ca52d1789fdf57e9$export$2e2bcd8739ae039 = $ca52d1789fdf57e9$var$deleteBoard;

});
parcelRegister("aU4yQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7f2fe0ad349c30f0$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("c1D7V");
parcelRequire("llumX");
parcelRequire("1o2WJ");
parcelRequire("6cJUr");

var $6uWhG = parcelRequire("6uWhG");

var $eBhI6 = parcelRequire("eBhI6");

var $iMEaK = parcelRequire("iMEaK");

var $14RSn = parcelRequire("14RSn");

var $gUVFX = parcelRequire("gUVFX");

var $kinkG = parcelRequire("kinkG");
const $7f2fe0ad349c30f0$var$noContentStatus = 204;
const $7f2fe0ad349c30f0$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $7f2fe0ad349c30f0$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$7f2fe0ad349c30f0$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $6uWhG.setMark)(`BEGIN_${key}`);
    }
    return (0, $7kixv.Observable).of(url).mergeMap(()=>fetch((0, $gUVFX.getReroutableURL)(url), (0, $iWqim.merge)((0, $iWqim.merge)((0, $eBhI6.defaultOptions), opts), (0, $kinkG.makeObservabilityHeaders)()))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $6uWhG.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $iMEaK.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $14RSn.default)(status, str, traceId);
                else throw new (0, $14RSn.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $7f2fe0ad349c30f0$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $7kixv.Observable).of(null);
        return response.json();
    });
}
var $7f2fe0ad349c30f0$export$2e2bcd8739ae039 = $7f2fe0ad349c30f0$var$fetchJson$;

});


parcelRegister("i6aaC", function(module, exports) {
$parcel$export(module.exports, "SET_APP_PROPS", () => $76e165d216c71d1e$export$8aefe701a6f431e0);
$parcel$export(module.exports, "setAppProps", () => $76e165d216c71d1e$export$cfda7627848a58cd);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS", () => $76e165d216c71d1e$export$590db52f99257537);
$parcel$export(module.exports, "getActiveSprints", () => $76e165d216c71d1e$export$2893b8608d2a6d6a);
$parcel$export(module.exports, "ACTIVE_SPRINTS_RETRIEVED", () => $76e165d216c71d1e$export$215dde409662413);
$parcel$export(module.exports, "activeSprintsRetrieved", () => $76e165d216c71d1e$export$12dcad2fd94d0a72);
$parcel$export(module.exports, "GET_ACTIVE_SPRINTS_FAILED", () => $76e165d216c71d1e$export$14cf35077b6f85f7);
$parcel$export(module.exports, "getActiveSprintsFailed", () => $76e165d216c71d1e$export$694c6ee523cd87cb);
$parcel$export(module.exports, "DELETE_BOARD", () => $76e165d216c71d1e$export$a68d619e7022f2c3);
$parcel$export(module.exports, "deleteBoard", () => $76e165d216c71d1e$export$fc0ef3a3a9b2b3cd);
$parcel$export(module.exports, "DELETE_BOARD_FAILED", () => $76e165d216c71d1e$export$8cad23f5fe7e6ff3);
$parcel$export(module.exports, "deleteBoardFailed", () => $76e165d216c71d1e$export$983279b2aa6031b0);
$parcel$export(module.exports, "BOARD_DELETED", () => $76e165d216c71d1e$export$aea8ac0fecc03cf6);
$parcel$export(module.exports, "boardDeleted", () => $76e165d216c71d1e$export$d6d2ce109de8e68b);
const $76e165d216c71d1e$export$8aefe701a6f431e0 = 'state.SET_APP_PROPS';
const $76e165d216c71d1e$export$cfda7627848a58cd = (payload)=>({
        type: $76e165d216c71d1e$export$8aefe701a6f431e0,
        payload: payload
    });
const $76e165d216c71d1e$export$590db52f99257537 = 'state.GET_ACTIVE_SPRINTS';
const $76e165d216c71d1e$export$2893b8608d2a6d6a = ()=>({
        type: $76e165d216c71d1e$export$590db52f99257537
    });
const $76e165d216c71d1e$export$215dde409662413 = 'state.ACTIVE_SPRINTS_RETRIEVED';
const $76e165d216c71d1e$export$12dcad2fd94d0a72 = (payload)=>({
        type: $76e165d216c71d1e$export$215dde409662413,
        payload: payload
    });
const $76e165d216c71d1e$export$14cf35077b6f85f7 = 'state.GET_ACTIVE_SPRINTS_FAILED';
const $76e165d216c71d1e$export$694c6ee523cd87cb = ()=>({
        type: $76e165d216c71d1e$export$14cf35077b6f85f7
    });
const $76e165d216c71d1e$export$a68d619e7022f2c3 = 'state.DELETE_BOARD';
const $76e165d216c71d1e$export$fc0ef3a3a9b2b3cd = ()=>({
        type: $76e165d216c71d1e$export$a68d619e7022f2c3
    });
const $76e165d216c71d1e$export$8cad23f5fe7e6ff3 = 'state.DELETE_BOARD_FAILED';
const $76e165d216c71d1e$export$983279b2aa6031b0 = (payload)=>({
        type: $76e165d216c71d1e$export$8cad23f5fe7e6ff3,
        payload: payload
    });
const $76e165d216c71d1e$export$aea8ac0fecc03cf6 = 'state.BOARD_DELETED';
const $76e165d216c71d1e$export$d6d2ce109de8e68b = ()=>({
        type: $76e165d216c71d1e$export$aea8ac0fecc03cf6
    });

});

parcelRegister("4TMFo", function(module, exports) {
$parcel$export(module.exports, "getBoard", () => $d78c44282fa01a48$export$2223f2dfcfd77cef);
$parcel$export(module.exports, "getOnInitialised", () => $d78c44282fa01a48$export$47263859bc15a8b8);
$parcel$export(module.exports, "getOnBoardDeleted", () => $d78c44282fa01a48$export$3efb56c7750e8ce1);
$parcel$export(module.exports, "getOnBoardDeleteFailed", () => $d78c44282fa01a48$export$311506722a7438bc);
$parcel$export(module.exports, "getOnCancel", () => $d78c44282fa01a48$export$2c6267c00ffc9906);
$parcel$export(module.exports, "isDeleteInProgress", () => $d78c44282fa01a48$export$906c0d65e4ece39d);
$parcel$export(module.exports, "getSprintInformation", () => $d78c44282fa01a48$export$4e64490e97fad74a);
const $d78c44282fa01a48$export$2223f2dfcfd77cef = (state)=>state.appProps.board;
const $d78c44282fa01a48$export$47263859bc15a8b8 = (state)=>state.appProps.onInitialised;
const $d78c44282fa01a48$export$3efb56c7750e8ce1 = (state)=>state.appProps.onBoardDeleted;
const $d78c44282fa01a48$export$311506722a7438bc = (state)=>state.appProps.onBoardDeleteFailed;
const $d78c44282fa01a48$export$2c6267c00ffc9906 = (state)=>state.appProps.onCancel;
const $d78c44282fa01a48$export$906c0d65e4ece39d = (state)=>state.isDeleteInProgress;
const $d78c44282fa01a48$export$4e64490e97fad74a = (state)=>state.sprintInformation;

});


parcelRegister("5KtTM", function(module, exports) {
$parcel$export(module.exports, "default", () => $c8af70837cc6bb8a$export$2e2bcd8739ae039);
parcelRequire("cBiei");
parcelRequire("9BkTq");
parcelRequire("c1D7V");
parcelRequire("6cJUr");

var $7kixv = parcelRequire("7kixv");


var $eSnSE = parcelRequire("eSnSE");

var $03Bz6 = parcelRequire("03Bz6");

var $i6aaC = parcelRequire("i6aaC");

var $4TMFo = parcelRequire("4TMFo");
const $c8af70837cc6bb8a$var$getActiveSprintsEpic = (action$, store)=>action$.ofType((0, $i6aaC.GET_ACTIVE_SPRINTS)).mergeMap(()=>{
        const state = store.getState();
        const board = (0, $4TMFo.getBoard)(state);
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2339 - Property 'type' does not exist on type 'Board'.
        const shouldSkipCheckingActiveSprints = board.isPrivate || board.type !== (0, $987928229d6d4941$export$b75edebf0c64f31e);
        if (shouldSkipCheckingActiveSprints) {
            (0, $4TMFo.getOnInitialised)(state)();
            return (0, $7kixv.Observable).of((0, $i6aaC.activeSprintsRetrieved)([]));
        }
        return (0, $7kixv.Observable).fromPromise((0, $03Bz6.default)(board.id)).mergeMap((sprints)=>{
            (0, $4TMFo.getOnInitialised)(state)();
            return (0, $7kixv.Observable).of((0, $i6aaC.activeSprintsRetrieved)(sprints));
        })// @ts-expect-error - TS2345 - Argument of type '(error: FetchError) => Observable<ActiveSprintsRetrievedAction> | Observable<GetActiveSprintsFailedAction>' is not assignable to parameter of type '(err: any, caught: Observable<ActiveSprintsRetrievedAction>) => ObservableInput<ActiveSprintsRetrievedAction>'.
        .catch((error)=>{
            if (error.statusCode === 404) return (0, $7kixv.Observable).of((0, $i6aaC.activeSprintsRetrieved)([]));
            (0, $eSnSE.default).safeErrorWithoutCustomerData('directories.boards-v2.delete-modal.ops.get-active-sprints', error.message, error);
            return (0, $7kixv.Observable).of((0, $i6aaC.getActiveSprintsFailed)());
        });
    });
var $c8af70837cc6bb8a$export$2e2bcd8739ae039 = $c8af70837cc6bb8a$var$getActiveSprintsEpic;

});
parcelRegister("03Bz6", function(module, exports) {
$parcel$export(module.exports, "default", () => $d389876c4ca627fe$export$2e2bcd8739ae039);

var $jje8P = parcelRequire("jje8P");
const $d389876c4ca627fe$var$getActiveSprints1 = async (boardId)=>{
    const activeSprints = await (0, $jje8P.default)(boardId);
    return activeSprints.values;
};
var $d389876c4ca627fe$export$2e2bcd8739ae039 = $d389876c4ca627fe$var$getActiveSprints1;

});
parcelRegister("jje8P", function(module, exports) {
$parcel$export(module.exports, "default", () => $48ce5890180dbcff$export$2e2bcd8739ae039);

var $b5RwB = parcelRequire("b5RwB");

var $hgi0g = parcelRequire("hgi0g");
const $48ce5890180dbcff$var$getActiveSprints = (boardId)=>{
    const params = (0, $b5RwB.stringify)({
        state: 'active'
    });
    return (0, $hgi0g.default)(`/rest/agile/1.0/board/${boardId}/sprint?${params}`);
};
var $48ce5890180dbcff$export$2e2bcd8739ae039 = $48ce5890180dbcff$var$getActiveSprints;

});




parcelRegister("G61cz", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb4652d616bdb8da$export$2e2bcd8739ae039);

var $gs6vs = parcelRequire("gs6vs");

var $dYsG4 = parcelRequire("dYsG4");
const $bb4652d616bdb8da$var$createStore = (rootEpic)=>(0, $gs6vs.default)({
        appName: 'directories/boards-v2/delete-modal',
        rootReducer: $dYsG4.default,
        rootEpic: rootEpic
    });
var $bb4652d616bdb8da$export$2e2bcd8739ae039 = $bb4652d616bdb8da$var$createStore;

});
parcelRegister("dYsG4", function(module, exports) {
$parcel$export(module.exports, "default", () => $07a380f8d34f3189$export$2e2bcd8739ae039);

var $i6aaC = parcelRequire("i6aaC");
const $07a380f8d34f3189$var$defaultState = {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    appProps: undefined,
    sprintInformation: undefined,
    isDeleteInProgress: false
};
const $07a380f8d34f3189$var$rootReducer = (state = $07a380f8d34f3189$var$defaultState, action)=>{
    switch(action.type){
        case 0, $i6aaC.SET_APP_PROPS:
            return {
                ...state,
                appProps: action.payload
            };
        case 0, $i6aaC.DELETE_BOARD:
            return {
                ...state,
                isDeleteInProgress: true
            };
        case 0, $i6aaC.DELETE_BOARD_FAILED:
            return {
                ...state,
                isDeleteInProgress: false
            };
        case 0, $i6aaC.ACTIVE_SPRINTS_RETRIEVED:
            return {
                ...state,
                sprintInformation: {
                    sprints: action.payload
                }
            };
        case 0, $i6aaC.GET_ACTIVE_SPRINTS_FAILED:
            return {
                ...state,
                sprintInformation: {
                    error: true
                }
            };
        case 0, $i6aaC.GET_ACTIVE_SPRINTS:
        case 0, $i6aaC.BOARD_DELETED:
            return state;
        default:
            {
                const _exhaustiveCheck = action;
                return state;
            }
    }
};
var $07a380f8d34f3189$export$2e2bcd8739ae039 = $07a380f8d34f3189$var$rootReducer;

});


parcelRegister("csIDH", function(module, exports) {
$parcel$export(module.exports, "default", () => $2de5a333ac8f356d$export$2e2bcd8739ae039);

var $eq3Hf = parcelRequire("eq3Hf");

var $idGBm = parcelRequire("idGBm");

var $gnQAk = parcelRequire("gnQAk");

var $i6aaC = parcelRequire("i6aaC");

var $4TMFo = parcelRequire("4TMFo");

var $2lKGI = parcelRequire("2lKGI");

var $dXndk = parcelRequire("dXndk");
const $2de5a333ac8f356d$var$mapStateToProps = (state)=>({
        Content: $2lKGI.default,
        board: (0, $4TMFo.getBoard)(state),
        sprintInformation: (0, $4TMFo.getSprintInformation)(state),
        deleteInProgress: (0, $4TMFo.isDeleteInProgress)(state),
        onCancel: (0, $4TMFo.getOnCancel)(state)
    });
var $2de5a333ac8f356d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $idGBm.injectIntlV2), (0, $gnQAk.connect)($2de5a333ac8f356d$var$mapStateToProps, {
    onDelete: (0, $i6aaC.deleteBoard)
}))(// @ts-expect-error - Argument of type 'typeof DeleteBoardsModal' is not assignable to parameter of type 'ComponentType<{ intl: IntlShapeV2 | IntlShape | undefined; }>'.
(0, $dXndk.default));

});
parcelRegister("2lKGI", function(module, exports) {
$parcel$export(module.exports, "default", () => $d8e63b2d91b7c97f$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $4TMFo = parcelRequire("4TMFo");

var $5EVym = parcelRequire("5EVym");
const $d8e63b2d91b7c97f$var$mapStateToProps = (state)=>({
        board: (0, $4TMFo.getBoard)(state),
        sprintInformation: (0, $4TMFo.getSprintInformation)(state)
    });
var // @ts-expect-error - Argument of type 'ComponentType<WithIntlProps<Props>>' is not assignable to parameter of type 'ComponentType<Matching<{ board: Board; sprintInformation: SprintInformation | undefined; } & {}, WithIntlProps<Props>>>'.
$d8e63b2d91b7c97f$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($d8e63b2d91b7c97f$var$mapStateToProps, {})((0, $5EVym.default));

});
parcelRegister("5EVym", function(module, exports) {
$parcel$export(module.exports, "default", () => $47b2d28127361a21$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $3cMgR = parcelRequire("3cMgR");

var $4cTDP = parcelRequire("4cTDP");

var $kDaaB = parcelRequire("kDaaB");

var $idGBm = parcelRequire("idGBm");

var $545Q1 = parcelRequire("545Q1");
// eslint-disable-next-line jira/react/no-class-components
class $47b2d28127361a21$var$Content extends (0, $eJOHy.Component) {
    renderContentForPrivateBoard() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).privateBoardMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).privateBoardMessage)));
    }
    renderLearnMoreLink(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "p"
        }, formatMessage((0, $545Q1.default).activeSprintsRecommendation, {
            boardName: board.name
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "p"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3cMgR.default), {
            as: "em"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
            href: "https://confluence.atlassian.com/jirasoftwarecloud/running-sprints-in-a-scrum-project-764478111.html"
        }, formatMessage((0, $545Q1.default).link)))));
    }
    renderContentForNoSprints(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).noSprintsMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).noSprintsMessage, {
            boardName: board.name
        })));
    }
    renderContentForSingleSprint(board, sprint) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), {
            ...(0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).singleSprintMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).singleSprintMessage,
            // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
            values: {
                sprintName: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
                    href: sprint.url
                }, sprint.name)
            }
        })), this.renderLearnMoreLink(board));
    }
    renderContentForMultipleSprints(board, sprints) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).multipleSprintsMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).multipleSprintsMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("ul", null, sprints.map(({ name: name, url: url }, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("li", {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
                href: url
            }, name)))), this.renderLearnMoreLink(board));
    }
    renderContentForSprintRetrievalError(board) {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, formatMessage((0, $4cTDP.fg)('jira-issue-terminology-update-m4') ? (0, $545Q1.default).retrievalFailedMessageIssueTerminologyRefreshM4 : (0, $545Q1.default).retrievalFailedMessage, {
            boardName: board.name
        })), this.renderLearnMoreLink(board));
    }
    render() {
        const { board: board, sprintInformation: sprintInformation } = this.props;
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
        if (board.isPrivate) return this.renderContentForPrivateBoard();
        // @ts-expect-error - TS2339 - Property 'error' does not exist on type 'SprintInformation'.
        if (sprintInformation.error) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForSprintRetrievalError(board);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length === 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForSingleSprint(board, sprintInformation.sprints[0]);
        // @ts-expect-error - TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        if (sprintInformation.sprints.length > 1) // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'. | TS2339 - Property 'sprints' does not exist on type 'SprintInformation'.
        return this.renderContentForMultipleSprints(board, sprintInformation.sprints);
        // @ts-expect-error - TS2345 - Argument of type 'Board' is not assignable to parameter of type 'PublicBoard'.
        return this.renderContentForNoSprints(board);
    }
}
var $47b2d28127361a21$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($47b2d28127361a21$var$Content);

});
parcelRegister("545Q1", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b94325d82a5ef70$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $5b94325d82a5ef70$var$messages = (0, $7qGN1.defineMessages)({
    singleSprintMessage: {
        "id": "directories.boards-v2.delete-modal.content.single-sprint-message",
        "defaultMessage": "This board contains issues from {sprintName}, and that sprint is currently active."
    },
    multipleSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.multiple-sprints-message",
        "defaultMessage": "This board contains issues from these active sprints:"
    },
    retrievalFailedMessage: {
        "id": "directories.boards-v2.delete-modal.content.retrieval-failed-message",
        "defaultMessage": "Just a heads up, we're having trouble getting information about active sprints. Issues on {boardName} might be part of one."
    },
    activeSprintsRecommendation: {
        "id": "directories.boards-v2.delete-modal.content.active-sprints-recommendation",
        "defaultMessage": "We recommend completing or deleting active sprints before deleting {boardName}."
    },
    noSprintsMessage: {
        "id": "directories.boards-v2.delete-modal.content.no-sprints-message",
        "defaultMessage": "Deleting {boardName} doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    privateBoardMessage: {
        "id": "directories.boards-v2.delete-modal.content.private-board-message",
        "defaultMessage": "Deleting this board doesn't affect the issues on the board. And, it won't complete or delete any active sprints."
    },
    link: {
        "id": "directories.boards-v2.delete-modal.content.link",
        "defaultMessage": "Learn more about running sprints."
    },
    singleSprintMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.single-sprint-message-issue-terminology-refresh-m4",
        "defaultMessage": "This board contains work items from {sprintName}, and that sprint is currently active."
    },
    multipleSprintsMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.multiple-sprints-message-issue-terminology-refresh-m4",
        "defaultMessage": "This board contains work items from these active sprints:"
    },
    retrievalFailedMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.retrieval-failed-message-issue-terminology-refresh-m4",
        "defaultMessage": "Just a heads up, we're having trouble getting information about active sprints. Work items on {boardName} might be part of one."
    },
    noSprintsMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.no-sprints-message-issue-terminology-refresh-m4",
        "defaultMessage": "Deleting {boardName} doesn't affect the work items on the board. And, it won't complete or delete any active sprints."
    },
    privateBoardMessageIssueTerminologyRefreshM4: {
        "id": "directories.boards-v2.delete-modal.content.private-board-message-issue-terminology-refresh-m4",
        "defaultMessage": "Deleting this board doesn't affect the work items on the board. And, it won't complete or delete any active sprints."
    }
});
var $5b94325d82a5ef70$export$2e2bcd8739ae039 = $5b94325d82a5ef70$var$messages;

});



parcelRegister("dXndk", function(module, exports) {
$parcel$export(module.exports, "default", () => $c40e6d7fd4cf37bf$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $bu8Y7 = parcelRequire("bu8Y7");

var $guWba = parcelRequire("guWba");

var $4cTDP = parcelRequire("4cTDP");

var $fgJkD = parcelRequire("fgJkD");

var $4B7rn = parcelRequire("4B7rn");

var $cHtIB = parcelRequire("cHtIB");

var $kqd31 = parcelRequire("kqd31");

var $fKOQa = parcelRequire("fKOQa");

var $kj7UG = parcelRequire("kj7UG");
function $c40e6d7fd4cf37bf$var$DeleteBoardsModal(props) {
    const { Content: Content, board: board, sprintInformation: sprintInformation, deleteInProgress: deleteInProgress, onCancel: onCancel, onDelete: onDelete } = props;
    const { intl: { formatMessage: formatMessage } } = props;
    const tenantId = (0, $cHtIB.useCloudId)();
    const { deleteBoard: deleteBoard } = (0, $fKOQa.useDeleteBoard)();
    if (!sprintInformation) return null;
    const onCancelOrNoop = !deleteInProgress ? onCancel : (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)));
    // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'.
    const heading = board.isPrivate ? formatMessage((0, $kj7UG.default).deletePrivateBoard) : // @ts-expect-error - TS2339 - Property 'name' does not exist on type 'Board'.
    formatMessage((0, $kj7UG.default).deleteBoard, {
        boardName: board.name
    });
    const handleDelete = ()=>{
        const boardARI = (0, $bu8Y7.JiraSoftwareBoardAri).create({
            siteId: tenantId,
            boardId: board.id.toString() ?? ''
        }).toString();
        const dataId = (0, $kqd31.default)({
            id: boardARI
        }, 'JiraBoard');
        onDelete();
        if (dataId) deleteBoard(dataId);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fgJkD.ModalDialog), {
        messageId: "delete-boards-modal.modal-dialog",
        messageType: "transactional",
        onClose: onCancelOrNoop
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
        hasCloseButton: (0, $4cTDP.fg)('enghealth-modal-close-button-prevent-close-modal')
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
        appearance: "danger"
    }, heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(Content, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "danger",
        onClick: handleDelete,
        isDisabled: deleteInProgress
    }, formatMessage((0, $kj7UG.default).deleteCaption)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
        appearance: "subtle-link",
        onClick: onCancelOrNoop,
        isDisabled: deleteInProgress
    }, formatMessage((0, $kj7UG.default).cancel)))));
}
$c40e6d7fd4cf37bf$var$DeleteBoardsModal.defaultProps = {
    deleteInProgress: false,
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
    onDelete: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
};
var $c40e6d7fd4cf37bf$export$2e2bcd8739ae039 = $c40e6d7fd4cf37bf$var$DeleteBoardsModal;

});
parcelRegister("fKOQa", function(module, exports) {
$parcel$export(module.exports, "useDeleteBoard", () => $310233bfb980cc12$export$abd16ada93ebfa6a);

var $j4oe4 = parcelRequire("j4oe4");
const $310233bfb980cc12$export$16ded94db5ddbcd7 = ({ environment: environment })=>{
    const deleteBoard = (boardDataId)=>{
        (0, $j4oe4.commitLocalUpdate)(environment, (store)=>{
            store.delete(boardDataId);
        });
    };
    return {
        deleteBoard: deleteBoard
    };
};
const $310233bfb980cc12$export$abd16ada93ebfa6a = ()=>{
    const environment = (0, $j4oe4.useRelayEnvironment)();
    return $310233bfb980cc12$export$16ded94db5ddbcd7({
        environment: environment
    });
};

});

parcelRegister("kj7UG", function(module, exports) {
$parcel$export(module.exports, "default", () => $575994af172f506a$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $575994af172f506a$var$messages = (0, $7qGN1.defineMessages)({
    deleteBoard: {
        "id": "directories.boards-v2.delete-modal.delete-board",
        "defaultMessage": "Delete {boardName}"
    },
    deletePrivateBoard: {
        "id": "directories.boards-v2.delete-modal.delete-private-board",
        "defaultMessage": "Delete board"
    },
    cancel: {
        "id": "directories.boards-v2.delete-modal.cancel",
        "defaultMessage": "Cancel"
    },
    deleteCaption: {
        "id": "directories.boards-v2.delete-modal.delete-caption",
        "defaultMessage": "Delete"
    }
});
var $575994af172f506a$export$2e2bcd8739ae039 = $575994af172f506a$var$messages;

});





parcelRegister("75BZg", function(module, exports) {
$parcel$export(module.exports, "default", () => $53b98ac999883a03$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $53b98ac999883a03$var$messages = (0, $7qGN1.defineMessages)({
    name: {
        "id": "directories.boards-v2.main.name",
        "defaultMessage": "Name"
    },
    type: {
        "id": "directories.boards-v2.main.type",
        "defaultMessage": "Type"
    },
    administrators: {
        "id": "directories.boards-v2.main.administrators",
        "defaultMessage": "Admin"
    },
    location: {
        "id": "directories.boards-v2.main.location",
        "defaultMessage": "Location"
    },
    emptyFilterResultMessage: {
        "id": "directories.boards-v2.main.empty-filter-result-message",
        "defaultMessage": "No boards were found that match your search"
    },
    tableAriaLabel: {
        "id": "directories.boards-v2.main.table-aria-label",
        "defaultMessage": "Boards details"
    },
    filterResultsAnnouncement: {
        "id": "directories.boards-v2.main.filter-results-announcement",
        "defaultMessage": "{itemCount, plural, =0 {No boards were found that match your search} one {{itemCount} board found} other {{itemCount} boards found}}"
    },
    aToZOrder: {
        "id": "directories.boards-v2.main.a-to-z-order",
        "defaultMessage": "Sort A to Z"
    },
    zToAOrder: {
        "id": "directories.boards-v2.main.z-to-a-order",
        "defaultMessage": "Sort Z to A"
    },
    // delete actions message when cleaning up isVisualRefreshEnabled FG
    actions: {
        "id": "directories.boards-v2.main.actions",
        "defaultMessage": "More actions"
    }
});
var $53b98ac999883a03$export$2e2bcd8739ae039 = $53b98ac999883a03$var$messages;

});

parcelRegister("j32Fj", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb2b3e2f23e2559$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $4aSRi = parcelRequire("4aSRi");

var $bbsz5 = parcelRequire("bbsz5");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $7cb2b3e2f23e2559$var$MoveModalWrapper = (props)=>{
    const returnFocusTarget = (0, $4aSRi.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $4aSRi.useModalDialogActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bbsz5.default), {
        ...props,
        returnFocusTarget: returnFocusTarget,
        setReturnFocusTo: setReturnFocusTo
    });
};
var $7cb2b3e2f23e2559$export$2e2bcd8739ae039 = $7cb2b3e2f23e2559$var$MoveModalWrapper;

});
parcelRegister("bbsz5", function(module, exports) {
$parcel$export(module.exports, "default", () => $297fc356ff17fbe5$export$2e2bcd8739ae039);

var $69k7P = parcelRequire("69k7P");

var $gnQAk = parcelRequire("gnQAk");

var $d6NK2 = parcelRequire("d6NK2");

var $7FCY1 = parcelRequire("7FCY1");

var $3cJgn = parcelRequire("3cJgn");
const $297fc356ff17fbe5$var$mapStateToProps = (state, ownProps)=>({
        board: (0, $7FCY1.getBoard)(state, ownProps.entityId),
        MoveSingleBoardDialog: $69k7P.default
    });
const $297fc356ff17fbe5$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onCancel: ownProps.onCancel,
        onBoardMoved: (board)=>{
            dispatch((0, $d6NK2.moved)(board));
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            ownProps.onUpdated();
        },
        onBoardMoveFailed: (board)=>dispatch((0, $d6NK2.moveFailed)(board)),
        onInitialDataFetchFailed: (board)=>{
            dispatch((0, $d6NK2.moveFailed)(board));
            ownProps.onDataRetrieveFailed();
        },
        onInitialDataFetched: ownProps.onDialogShown
    });
var // @ts-expect-error - TS2345 - Argument of type 'typeof MoveModal' is not assignable to parameter of type 'Component<{ board: Board; MoveSingleBoardDialog: typeof MoveSingleBoardDialogApp; } & { onCancel: () => void; onBoardMoved: (board: Board) => void; onBoardMoveFailed: (board: Board) => MoveFailedAction; onInitialDataFetchFailed: (board: Board) => void; onInitialDataFetched: () => void; } & Operation...'.
$297fc356ff17fbe5$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($297fc356ff17fbe5$var$mapStateToProps, $297fc356ff17fbe5$var$mapDispatchToProps)((0, $3cJgn.default));

});
parcelRegister("69k7P", function(module, exports) {
$parcel$export(module.exports, "default", () => $fff1913d1e595ca9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $7iHUq = parcelRequire("7iHUq");

var $aBC1l = parcelRequire("aBC1l");

var $5l0Ou = parcelRequire("5l0Ou");

var $feBqt = parcelRequire("feBqt");
class $fff1913d1e595ca9$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            onLocationSet: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onSetLocationError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onFetchDataError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onFetchDataSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            showErrorMessage: true,
            boardName: ''
        };
    }
    constructor(props){
        super(props);
        const { rapidViewId: rapidViewId, currentLocation: currentLocation, store: store } = this.props;
        // creates a separate store for each dialog instance
        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
        this.store = store || (0, $feBqt.default)();
        this.store.dispatch((0, $aBC1l.setContext)({
            rapidViewId: rapidViewId,
            currentLocation: currentLocation
        }));
    }
    render() {
        const { onLocationSet: onLocationSet, onCancel: onCancel, onSetLocationError: onSetLocationError, onFetchDataError: onFetchDataError, onFetchDataSuccess: onFetchDataSuccess, showErrorMessage: showErrorMessage, boardName: boardName } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            id: "move-single-board-dialog-app",
            teamName: "a4t-pandora",
            packageName: "jiraBoardLocationDialogsMoveSingle"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5l0Ou.default), {
            onLocationSet: onLocationSet,
            onCancel: onCancel,
            onSetLocationError: onSetLocationError,
            onFetchDataError: onFetchDataError,
            onFetchDataSuccess: onFetchDataSuccess,
            // @ts-expect-error - Property 'showErrorMessage' does not exist on props
            showErrorMessage: showErrorMessage,
            boardName: boardName
        }));
    }
}

});
parcelRegister("aBC1l", function(module, exports) {
$parcel$export(module.exports, "setContext", () => $efc87b8b08eaf308$export$2f04de43fe27971a);

const $efc87b8b08eaf308$export$2f04de43fe27971a = (context)=>({
        type: (0, $1f26fa3da4b9bda0$export$4bc4e62e7d72b94b),
        payload: context
    });

});
const $1f26fa3da4b9bda0$export$4bc4e62e7d72b94b = 'SET_CONTEXT';


parcelRegister("5l0Ou", function(module, exports) {
$parcel$export(module.exports, "default", () => $4df7725393530210$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $apXfY = parcelRequire("apXfY");

var $1q8Mp = parcelRequire("1q8Mp");

var $7qGN1 = parcelRequire("7qGN1");
var $6YFG2 = parcelRequire("6YFG2");

var $gnQAk = parcelRequire("gnQAk");

var $bppbs = parcelRequire("bppbs");

var $5YYyt = parcelRequire("5YYyt");

var $8BMll = parcelRequire("8BMll");

var $4UxQD = parcelRequire("4UxQD");

var $59nfH = parcelRequire("59nfH");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4df7725393530210$var$i18n = (0, $7qGN1.defineMessages)({
    cancel: {
        "id": "move-single-board.label-for-cancel-button",
        "defaultMessage": "Cancel"
    },
    setLocation: {
        "id": "move-single-board.label-for-set-location-button",
        "defaultMessage": "Set location"
    },
    title: {
        "id": "move-single-board.modal-title",
        "defaultMessage": "Move {boardName}"
    },
    location: {
        "id": "move-single-board.label-for-location",
        "defaultMessage": "New location"
    },
    selectLocation: {
        "id": "move-single-board.placeholder-for-location",
        "defaultMessage": "Select location"
    },
    description: {
        "id": "move-single-board.description",
        "defaultMessage": "Move the board to a different project or your profile. We'll notify the board's admins."
    },
    defaultBoardName: {
        "id": "move-single-board.default-board-name",
        "defaultMessage": "board"
    }
});
// eslint-disable-next-line jira/react/no-class-components
class $4df7725393530210$var$MoveSingleBoardDialogImpl extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            showErrorMessage: true,
            onFetchDataSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    render() {
        const { rapidViewId: rapidViewId, onCancel: onCancel, onConfirm: onConfirm, intl: intl, currentLocationName: currentLocationName, currentLocationAvatarUrl: currentLocationAvatarUrl, onFetchDataSuccess: onFetchDataSuccess } = this.props;
        if (!intl) return null;
        const boardName = this.props.boardName ? this.props.boardName : intl.formatMessage($4df7725393530210$var$i18n.defaultBoardName);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $apXfY.default), {
            isOpen: this.props.isOpen,
            rapidViewId: rapidViewId,
            onLocationSet: onConfirm,
            onLocationSetError: this.handleOnLocationSetError,
            onFetchDataError: this.handleFetchDataError,
            onFetchDataSuccess: onFetchDataSuccess,
            onProjectSelected: this.clearError,
            onUserSelected: this.clearError,
            errorElement: this.renderErrorMessage(),
            onCancel: onCancel,
            confirmActionText: intl.formatMessage($4df7725393530210$var$i18n.setLocation),
            cancelActionText: intl.formatMessage($4df7725393530210$var$i18n.cancel),
            locationPickerLabel: intl.formatMessage($4df7725393530210$var$i18n.location),
            locationPickerPlaceholder: intl.formatMessage($4df7725393530210$var$i18n.selectLocation),
            title: intl.formatMessage($4df7725393530210$var$i18n.title, {
                boardName: boardName
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", null, intl.formatMessage($4df7725393530210$var$i18n.description), currentLocationName && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8BMll.default), {
            locationName: currentLocationName,
            avatarUrl: currentLocationAvatarUrl
        })));
    }
    constructor(...args){
        super(...args), this.state = {
            error: false
        }, this.handleOnLocationSetError = ()=>{
            this.setState({
                error: true
            });
            this.props.onSetLocationError && this.props.onSetLocationError();
        }, this.handleFetchDataError = ()=>this.props.onFetchDataError && this.props.onFetchDataError(), this.clearError = ()=>this.setState({
                error: false
            }), // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.renderErrorMessage = ()=>this.state.error && this.props.showErrorMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1q8Mp.default), null) : null;
    }
}
const $4df7725393530210$export$9319c430b829d4fb = (0, $6YFG2.default)($4df7725393530210$var$MoveSingleBoardDialogImpl);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4df7725393530210$var$mapStateToProps = (state)=>({
        rapidViewId: (0, $bppbs.rapidViewIdSelector)(state),
        isOpen: (0, $59nfH.isOpenSelector)(state),
        currentLocationName: (0, $bppbs.currentLocationDisplayNameSelector)(state),
        currentLocationAvatarUrl: (0, $bppbs.currentLocationAvatarSelector)(state)
    });
const $4df7725393530210$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onCancel: ()=>{
            dispatch((0, $4UxQD.cancelDialog)());
            ownProps.onCancel && ownProps.onCancel();
        },
        onConfirm: (location)=>{
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            dispatch((0, $5YYyt.setLocationSuccess)(location));
            ownProps.onLocationSet && ownProps.onLocationSet(location);
        }
    });
var $4df7725393530210$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($4df7725393530210$var$mapStateToProps, $4df7725393530210$var$mapDispatchToProps)($4df7725393530210$export$9319c430b829d4fb);

});
parcelRegister("apXfY", function(module, exports) {
$parcel$export(module.exports, "default", () => $ea7a8441626ce0a5$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $7iHUq = parcelRequire("7iHUq");

var $3Wu5r = parcelRequire("3Wu5r");

var $aSJvy = parcelRequire("aSJvy");

var $bicC3 = parcelRequire("bicC3");
class $ea7a8441626ce0a5$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isOpen: false,
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onLocationSet: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onLocationSetError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onFetchDataError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onFetchDataSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onUserSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onProjectSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            errorElement: null,
            classicLocationless: false,
            boardId: null
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $aSJvy.default)();
        const { rapidViewId: rapidViewId } = this.props;
        this.store.dispatch((0, $3Wu5r.setContext)({
            rapidViewId: rapidViewId
        }));
        this.store.dispatch((0, $3Wu5r.fetchDataRequest)());
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            id: "single-board-frame-app",
            teamName: "a4t-pandora",
            packageName: "jiraBoardLocationDialogsCommon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $bicC3.default), {
            onCancel: this.props.onCancel,
            isOpen: this.props.isOpen,
            title: this.props.title,
            onLocationSet: this.props.onLocationSet,
            onLocationSetError: this.props.onLocationSetError,
            onFetchDataError: this.props.onFetchDataError,
            onFetchDataSuccess: this.props.onFetchDataSuccess,
            onUserSelected: this.props.onUserSelected,
            onProjectSelected: this.props.onProjectSelected,
            confirmActionText: this.props.confirmActionText,
            cancelActionText: this.props.cancelActionText,
            locationPickerLabel: this.props.locationPickerLabel,
            locationPickerPlaceholder: this.props.locationPickerPlaceholder,
            errorElement: this.props.errorElement,
            classicLocationless: this.props.classicLocationless,
            boardId: this.props.boardId
        }, this.props.children));
    }
}

});
parcelRegister("3Wu5r", function(module, exports) {
$parcel$export(module.exports, "initDialog", () => $881b2f1511b6d4e0$export$10e19ed2936eea31);
$parcel$export(module.exports, "selectLocation", () => $881b2f1511b6d4e0$export$7c999b8dd6b194a1);
$parcel$export(module.exports, "unselectLocation", () => $881b2f1511b6d4e0$export$7da9e132cacfc4b7);
$parcel$export(module.exports, "setContext", () => $881b2f1511b6d4e0$export$2f04de43fe27971a);
$parcel$export(module.exports, "fetchDataRequest", () => $881b2f1511b6d4e0$export$d94427b1b5a072d2);
$parcel$export(module.exports, "fetchLocationsDataSuccess", () => $881b2f1511b6d4e0$export$16dcf042ca32eda8);
$parcel$export(module.exports, "fetchDataFailure", () => $881b2f1511b6d4e0$export$56f344f43f493ad5);
$parcel$export(module.exports, "setNewLocation", () => $881b2f1511b6d4e0$export$3c46cf2539fd14d7);
$parcel$export(module.exports, "setLocationSuccess", () => $881b2f1511b6d4e0$export$5daab09d8e3809e0);
$parcel$export(module.exports, "setLocationFailure", () => $881b2f1511b6d4e0$export$e97c62ad868ad2c3);
$parcel$export(module.exports, "cancelDialog", () => $881b2f1511b6d4e0$export$d8e990c7994e01bd);

const $881b2f1511b6d4e0$export$10e19ed2936eea31 = ()=>({
        type: $6dcbd3c1b323ae4b$export$10b25390e6826dd4
    });
const $881b2f1511b6d4e0$export$7c999b8dd6b194a1 = (payload)=>({
        type: $6dcbd3c1b323ae4b$export$478424fe4f82b403,
        payload: payload
    });
const $881b2f1511b6d4e0$export$7da9e132cacfc4b7 = ()=>({
        type: $6dcbd3c1b323ae4b$export$be0eb6a22c665151
    });
const $881b2f1511b6d4e0$export$2f04de43fe27971a = (payload)=>({
        type: $6dcbd3c1b323ae4b$export$4bc4e62e7d72b94b,
        payload: payload
    });
const $881b2f1511b6d4e0$export$d94427b1b5a072d2 = ()=>({
        type: $6dcbd3c1b323ae4b$export$8caa30ec786cd60b
    });
const $881b2f1511b6d4e0$export$16dcf042ca32eda8 = (payload)=>({
        type: $6dcbd3c1b323ae4b$export$a3e42002fa3c8d45,
        payload: payload
    });
const $881b2f1511b6d4e0$export$56f344f43f493ad5 = ()=>({
        type: $6dcbd3c1b323ae4b$export$ce1f7e009152c20f
    });
const $881b2f1511b6d4e0$export$3c46cf2539fd14d7 = (payload, analyticsEvent)=>({
        type: $6dcbd3c1b323ae4b$export$7811c5a6339c0d38,
        payload: payload,
        meta: {
            analytics: analyticsEvent
        }
    });
const $881b2f1511b6d4e0$export$5daab09d8e3809e0 = ()=>({
        type: $6dcbd3c1b323ae4b$export$9d8d4e6ce2e6a21
    });
const $881b2f1511b6d4e0$export$e97c62ad868ad2c3 = ()=>({
        type: $6dcbd3c1b323ae4b$export$e2872d87ddcb5b4a
    });
const $881b2f1511b6d4e0$export$d8e990c7994e01bd = ()=>({
        type: $6dcbd3c1b323ae4b$export$b58c79b7f2d0f102
    });

});
const $6dcbd3c1b323ae4b$export$10b25390e6826dd4 = 'single-board-frame/INIT_DIALOG';
const $6dcbd3c1b323ae4b$export$4bc4e62e7d72b94b = 'single-board-frame/SET_CONTEXT';
const $6dcbd3c1b323ae4b$export$478424fe4f82b403 = 'single-board-frame/SELECT_LOCATION';
const $6dcbd3c1b323ae4b$export$be0eb6a22c665151 = 'single-board-frame/UNSELECT_LOCATION';
const $6dcbd3c1b323ae4b$export$8caa30ec786cd60b = 'single-board-frame/FETCH_DATA_REQUEST';
const $6dcbd3c1b323ae4b$export$a3e42002fa3c8d45 = 'single-board-frame/FETCH_LOCATIONS_DATA_SUCCESS';
const $6dcbd3c1b323ae4b$export$ce1f7e009152c20f = 'single-board-frame/FETCH_DATA_FAILURE';
const $6dcbd3c1b323ae4b$export$7811c5a6339c0d38 = 'single-board-frame/SET_NEW_LOCATION';
const $6dcbd3c1b323ae4b$export$9d8d4e6ce2e6a21 = 'single-board-frame/SET_LOCATION_SUCCESS';
const $6dcbd3c1b323ae4b$export$e2872d87ddcb5b4a = 'single-board-frame/SET_LOCATION_FAILURE';
const $6dcbd3c1b323ae4b$export$b58c79b7f2d0f102 = 'single-board-frame/CANCEL_DIALOG';


parcelRegister("aSJvy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4238a796f4359dcb$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $4tM8k = parcelRequire("4tM8k");

var $kqAfW = parcelRequire("kqAfW");

var $2P35J = parcelRequire("2P35J");

var $bL8Ja = parcelRequire("bL8Ja");

var $ccHCJ = parcelRequire("ccHCJ");
const $4238a796f4359dcb$var$createStore1 = (initialState = (0, $2P35J.defaultState))=>(0, $7HHI1.createStore)((0, $ccHCJ.default), initialState, (0, $kqAfW.default)({
        name: 'SingleBoardFrame'
    })((0, $7HHI1.applyMiddleware)((0, $4tM8k.createEpicMiddleware)((0, $bL8Ja.default)))));
var $4238a796f4359dcb$export$2e2bcd8739ae039 = $4238a796f4359dcb$var$createStore1;

});
parcelRegister("2P35J", function(module, exports) {
$parcel$export(module.exports, "defaultState", () => $5cc92d7e53cca90c$export$49d5fc8cba920a0);
const $5cc92d7e53cca90c$export$49d5fc8cba920a0 = {
    isLocationSet: false,
    errorOnLocationSet: false,
    errorOnFetchData: false,
    selectedLocation: {},
    context: undefined,
    locations: {},
    recentProjects: 5,
    isSettingLocation: false
};

});

parcelRegister("bL8Ja", function(module, exports) {
$parcel$export(module.exports, "default", () => $ca018dbb7cf462ff$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $edLNR = parcelRequire("edLNR");

var $7V6UP = parcelRequire("7V6UP");
var $ca018dbb7cf462ff$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $edLNR.default), (0, $7V6UP.default));

});
parcelRegister("edLNR", function(module, exports) {
$parcel$export(module.exports, "default", () => $6174c702208ce57e$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("1o2WJ");
parcelRequire("c1D7V");
parcelRequire("d2zWP");

var $dAcYQ = parcelRequire("dAcYQ");

var $3Wu5r = parcelRequire("3Wu5r");


var $6R3kk = parcelRequire("6R3kk");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6174c702208ce57e$var$fetchLocationsData = (action$, store)=>action$.ofType((0, $6dcbd3c1b323ae4b$export$8caa30ec786cd60b)).switchMap(()=>{
        const state = store.getState();
        return (0, $dAcYQ.default)((0, $6R3kk.recentProjectsSelector)(state)).map((0, $3Wu5r.fetchLocationsDataSuccess))// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        .catch((anotherError)=>(0, $7kixv.Observable).of((0, $3Wu5r.fetchDataFailure)(anotherError)));
    });
var $6174c702208ce57e$export$2e2bcd8739ae039 = $6174c702208ce57e$var$fetchLocationsData;

});
parcelRegister("dAcYQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $49d5b29ca7ca02cd$export$2e2bcd8739ae039);
parcelRequire("1o2WJ");

var $aU4yQ = parcelRequire("aU4yQ");
const $49d5b29ca7ca02cd$var$getEndPointUrl = (numberOfRecentProjects)=>{
    const sortByRecent = numberOfRecentProjects ? `sortByRecent=${numberOfRecentProjects}` : '';
    return `/rest/greenhopper/1.0/boardLocation.json?${sortByRecent}`;
};
const $49d5b29ca7ca02cd$var$getLocations$ = (numberOfRecentProjects)=>(0, $aU4yQ.default)($49d5b29ca7ca02cd$var$getEndPointUrl(numberOfRecentProjects)).map((payload)=>({
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            projects: payload.projects,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            user: payload.user
        }));
var $49d5b29ca7ca02cd$export$2e2bcd8739ae039 = $49d5b29ca7ca02cd$var$getLocations$;

});

parcelRegister("6R3kk", function(module, exports) {
$parcel$export(module.exports, "selectedLocationSelector", () => $d673fd998f4152c6$export$ec884117f79a7081);
$parcel$export(module.exports, "rapidViewIdSelector", () => $d673fd998f4152c6$export$718e830000b27a0e);
$parcel$export(module.exports, "isPendingSelector", () => $d673fd998f4152c6$export$74ce67c99a85589);
$parcel$export(module.exports, "locationsSelector", () => $d673fd998f4152c6$export$650f111025ecf6fd);
$parcel$export(module.exports, "selectedLocationIdSelector", () => $d673fd998f4152c6$export$98d0273890cef57c);
$parcel$export(module.exports, "selectedLocationTypeSelector", () => $d673fd998f4152c6$export$eb3d83c6cfc0f640);
$parcel$export(module.exports, "errorOnLocationSetSelector", () => $d673fd998f4152c6$export$c0952aa2d9e55812);
$parcel$export(module.exports, "errorOnFetchDataSelector", () => $d673fd998f4152c6$export$487bc5acf30eeb6f);
$parcel$export(module.exports, "recentProjectsSelector", () => $d673fd998f4152c6$export$465e3de95c2a60e2);
$parcel$export(module.exports, "isLocationSetSelector", () => $d673fd998f4152c6$export$5ec69d4f3270587b);
$parcel$export(module.exports, "isSettingLocationSelector", () => $d673fd998f4152c6$export$29381c1563c40ad);

var $ahm5r = parcelRequire("ahm5r");

var $8dH3d = parcelRequire("8dH3d");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $d673fd998f4152c6$var$contextSelector = (state)=>state.context;
const $d673fd998f4152c6$export$ec884117f79a7081 = (state)=>state.selectedLocation;
const $d673fd998f4152c6$export$718e830000b27a0e = (0, $ahm5r.createSelector)($d673fd998f4152c6$var$contextSelector, (context)=>context.rapidViewId);
const $d673fd998f4152c6$export$74ce67c99a85589 = (state)=>(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(state.locations);
const $d673fd998f4152c6$export$650f111025ecf6fd = (state)=>state.locations;
const $d673fd998f4152c6$export$98d0273890cef57c = (0, $ahm5r.createSelector)($d673fd998f4152c6$export$ec884117f79a7081, (selectedLocation)=>selectedLocation?.location.id);
const $d673fd998f4152c6$export$eb3d83c6cfc0f640 = (0, $ahm5r.createSelector)($d673fd998f4152c6$export$ec884117f79a7081, (selectedLocation)=>selectedLocation?.type);
const $d673fd998f4152c6$export$c0952aa2d9e55812 = (state)=>state.errorOnLocationSet;
const $d673fd998f4152c6$export$487bc5acf30eeb6f = (state)=>state.errorOnFetchData;
const $d673fd998f4152c6$export$465e3de95c2a60e2 = (state)=>state.recentProjects;
const $d673fd998f4152c6$export$5ec69d4f3270587b = (state)=>state.isLocationSet;
const $d673fd998f4152c6$export$29381c1563c40ad = (state)=>state.isSettingLocation;

});


parcelRegister("7V6UP", function(module, exports) {
$parcel$export(module.exports, "default", () => $5da26562a4b91cec$export$2e2bcd8739ae039);

var $7kixv = parcelRequire("7kixv");
parcelRequire("9BkTq");
parcelRequire("1o2WJ");
parcelRequire("c1D7V");
parcelRequire("d2zWP");

var $7Y1Sx = parcelRequire("7Y1Sx");

var $g10GX = parcelRequire("g10GX");

var $3Wu5r = parcelRequire("3Wu5r");


var $6R3kk = parcelRequire("6R3kk");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $5da26562a4b91cec$var$setNewLocation = (action$, store)=>// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    action$.ofType((0, $6dcbd3c1b323ae4b$export$7811c5a6339c0d38)).switchMap((action)=>{
        const state = store.getState();
        const selectedlocationType = (0, $6R3kk.selectedLocationTypeSelector)(state);
        const selectedLocationId = (0, $6R3kk.selectedLocationIdSelector)(state);
        const boardId = (0, $6R3kk.rapidViewIdSelector)(state);
        const data = {
            rapidViewId: boardId,
            locationType: selectedlocationType
        };
        if (selectedlocationType === 'project') // @ts-expect-error - TS2339 - Property 'locationId' does not exist on type '{ rapidViewId: any; locationType: any; }'.
        data.locationId = selectedLocationId;
        return(// @ts-expect-error - TS2345 - Argument of type '{ rapidViewId: any; locationType: any; }' is not assignable to parameter of type 'string'.
        (0, $g10GX.default)(data).map(()=>{
            // @ts-expect-error - TS2345 - Argument of type '{ objectId: any; objectType: string; containerType: any; containerId: any; actionSubjectId: any; attributes: { boardId: any; updatedItems: { name: string; newValId: any; newValName: any; }[]; }; }' is not assignable to parameter of type 'Readonly<Readonly<{ name?: string | undefined; containerId?: string | undefined; containers?: Containers | undefined; containerType?: string | undefined; objectType?: string | undefined; objectId?: string | undefined; readonly tags?: readonly string[] | undefined; attributes?: Readonly<...> | undefined; }> & { ...; }>'.
            (0, $7Y1Sx.fireTrackAnalytics)(action.meta.analytics, {
                objectId: boardId,
                objectType: 'board',
                containerType: selectedlocationType,
                containerId: selectedLocationId,
                actionSubjectId: boardId,
                attributes: {
                    boardId: boardId,
                    updatedItems: [
                        {
                            name: 'boardLocation',
                            newValId: selectedLocationId,
                            newValName: selectedlocationType
                        }
                    ]
                }
            });
            return (0, $3Wu5r.setLocationSuccess)();
        })// @ts-expect-error - TS2554 - Expected 0 arguments, but got 1.
        .catch((anotherError)=>(0, $7kixv.Observable).of((0, $3Wu5r.setLocationFailure)(anotherError))));
    });
var $5da26562a4b91cec$export$2e2bcd8739ae039 = $5da26562a4b91cec$var$setNewLocation;

});
parcelRegister("g10GX", function(module, exports) {
$parcel$export(module.exports, "default", () => $eeed64dee03b3fe7$export$2e2bcd8739ae039);

var $aU4yQ = parcelRequire("aU4yQ");
const $eeed64dee03b3fe7$var$getEndPointUrl = ()=>'/rest/greenhopper/1.0/rapidviewconfig/boardLocation';
const $eeed64dee03b3fe7$var$putNewLocation$ = (data)=>{
    const options = {
        method: 'PUT',
        body: JSON.stringify(data)
    };
    return (0, $aU4yQ.default)($eeed64dee03b3fe7$var$getEndPointUrl(), options);
};
var $eeed64dee03b3fe7$export$2e2bcd8739ae039 = $eeed64dee03b3fe7$var$putNewLocation$;

});



parcelRegister("ccHCJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $7553ff7bff6eca3c$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");


var $2P35J = parcelRequire("2P35J");
// @ts-expect-error - TS7031 - Binding element 'type' implicitly has an 'any' type. | TS7031 - Binding element 'payload' implicitly has an 'any' type.
const $7553ff7bff6eca3c$var$reducer = (state = (0, $2P35J.defaultState), { type: type, payload: payload })=>{
    switch(type){
        case $6dcbd3c1b323ae4b$export$10b25390e6826dd4:
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            return (0, $iWqim.assoc)(state, (0, $2P35J.defaultState));
        case $6dcbd3c1b323ae4b$export$4bc4e62e7d72b94b:
            return (0, $iWqim.assocIn)(state, [
                'context'
            ], payload);
        case $6dcbd3c1b323ae4b$export$478424fe4f82b403:
            return (0, $iWqim.merge)(state, {
                errorOnLocationSet: false,
                isLocationSet: false,
                selectedLocation: payload
            });
        case $6dcbd3c1b323ae4b$export$be0eb6a22c665151:
            return (0, $iWqim.chain)(state).assoc('errorOnLocationSet', false).assoc('isLocationSet', false).assoc('selectedLocation', {}).value();
        case $6dcbd3c1b323ae4b$export$a3e42002fa3c8d45:
            return (0, $iWqim.assocIn)(state, [
                'locations'
            ], payload);
        case $6dcbd3c1b323ae4b$export$9d8d4e6ce2e6a21:
            return (0, $iWqim.merge)(state, {
                errorOnLocationSet: false,
                isLocationSet: true,
                isSettingLocation: false
            });
        case $6dcbd3c1b323ae4b$export$e2872d87ddcb5b4a:
            return (0, $iWqim.merge)(state, {
                errorOnLocationSet: true,
                isLocationSet: false,
                isSettingLocation: false
            });
        case $6dcbd3c1b323ae4b$export$ce1f7e009152c20f:
            return (0, $iWqim.merge)(state, {
                errorOnFetchData: true
            });
        case $6dcbd3c1b323ae4b$export$b58c79b7f2d0f102:
            return (0, $iWqim.chain)(state).assoc('errorOnLocationSet', false).assoc('isLocationSet', false).assoc('selectedLocation', {}).value();
        case $6dcbd3c1b323ae4b$export$7811c5a6339c0d38:
            return (0, $iWqim.merge)(state, {
                errorOnLocationSet: false,
                isLocationSet: false,
                isSettingLocation: true
            });
        default:
            break;
    }
    return state;
};
var $7553ff7bff6eca3c$export$2e2bcd8739ae039 = $7553ff7bff6eca3c$var$reducer;

});


parcelRegister("bicC3", function(module, exports) {
$parcel$export(module.exports, "default", () => $9af6a6588d642fd1$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eq3Hf = parcelRequire("eq3Hf");

var $8dH3d = parcelRequire("8dH3d");

var $12DRg = parcelRequire("12DRg");

var $4J0ad = parcelRequire("4J0ad");

var $goZPP = parcelRequire("goZPP");

var $ik0CA = parcelRequire("ik0CA");
var $kseeK = parcelRequire("kseeK");
var $2qG7I = parcelRequire("2qG7I");
var $5a9Ro = parcelRequire("5a9Ro");

var $7ep4S = parcelRequire("7ep4S");

var $lJKII = parcelRequire("lJKII");

var $fdpHV = parcelRequire("fdpHV");

var $guWba = parcelRequire("guWba");

var $4B7rn = parcelRequire("4B7rn");

var $kDaaB = parcelRequire("kDaaB");


var $gnQAk = parcelRequire("gnQAk");

var $4cTDP = parcelRequire("4cTDP");

var $838MG = parcelRequire("838MG");

var $gjsks = parcelRequire("gjsks");

var $82pLh = parcelRequire("82pLh");

var $6BRb2 = parcelRequire("6BRb2");

var $lwjs2 = parcelRequire("lwjs2");

var $3Wu5r = parcelRequire("3Wu5r");

var $6R3kk = parcelRequire("6R3kk");

var $drG0e = parcelRequire("drG0e");
class $9af6a6588d642fd1$export$63d5de293e655f86 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            initDialog: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onLocationSet: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onLocationSetError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onFetchDataError: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onFetchDataSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onProjectSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            onUserSelected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            errorElement: null,
            // @ts-expect-error - TS2322 - Type '{ initDialog: (...args: any[]) => void; onCancel: (...args: any[]) => void; onConfirm: (...args: any[]) => void; onLocationSet: (...args: any[]) => void; onLocationSetError: (...args: any[]) => void; onFetchDataError: (...args: any[]) => void; ... 6 more ...; isSettingLocation: boolean; }' is not assignable to type 'DefaultProps'.
            selectedLocation: null,
            errorOnFetchData: false,
            isSettingLocation: false,
            classicLocationless: false,
            boardId: null
        };
    }
    componentDidMount() {
        this.props.initDialog();
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.isLocationSet && !this.props.isLocationSet) this.props.onLocationSet(this.props.selectedLocation);
        if (nextProps.errorOnLocationSet && !this.props.errorOnLocationSet) this.props.onLocationSetError();
        if (nextProps.errorOnFetchData && !this.props.errorOnFetchData) this.props.onFetchDataError();
        if (!nextProps.isPending && this.props.isPending) this.props.onFetchDataSuccess();
    }
    render() {
        if (this.props.isPending) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $82pLh.default), null);
        return this.props.isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $4B7rn.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $lJKII.JiraModal), {
            messageId: "board-location-dialogs-common.apps.single-board-frame.modal-dialog",
            messageType: "transactional",
            testId: "board-location-dialogs-common.apps.single-board-frame.modal-dialog",
            width: "medium",
            onClose: this.props.onCancel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2qG7I.default), {
            hasCloseButton: (0, $4cTDP.fg)('jira-pandora-modal-ads-close-button') ? true : undefined
        }, this.renderHeader()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $ik0CA.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gjsks.default), null, this.props.children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6BRb2.default), {
            recentProjectsLimit: this.props.recentProjectsLimit,
            label: this.props.locationPickerLabel,
            placeholder: this.props.locationPickerPlaceholder,
            locations: this.props.locations,
            onProjectSelected: this.handleOnProjectSelected,
            onUserSelected: this.handleOnUserSelected,
            onItemUnselected: this.handleOnItemUnselected
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kDaaB.default), (0, $lwjs2.default).classicLocationlessActionPromptText))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $guWba.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kseeK.default), null, this.renderButtons())));
    }
    constructor(...args){
        super(...args), this.handleOnProjectSelected = (location)=>{
            const selectedLocation = {
                location: location,
                type: 'project'
            };
            this.props.onProjectSelected(selectedLocation);
        }, this.handleOnUserSelected = (location)=>{
            const selectedLocation = {
                location: location,
                type: 'user'
            };
            this.props.onUserSelected(selectedLocation);
        }, this.handleOnItemUnselected = ()=>{
            this.props.onLocationUnselected();
        }, this.handleOnCancel = ()=>{
            this.props.onCancel();
        }, this.renderHeader = ()=>{
            const { errorElement: errorElement } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5a9Ro.default), {
                appearance: "warning"
            }, this.props.title, errorElement);
        }, this.renderButtons = ()=>{
            const { onConfirm: onConfirm, confirmActionText: confirmActionText, cancelActionText: cancelActionText, selectedLocation: selectedLocation, isSettingLocation: isSettingLocation } = this.props;
            const spinner = isSettingLocation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
                size: "small"
            }) : null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $838MG.default), {
                spinner: spinner,
                secondaryButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    appearance: "subtle-link",
                    onClick: this.handleOnCancel,
                    isDisabled: isSettingLocation
                }, cancelActionText),
                primaryButton: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $goZPP.default), {
                    appearance: "warning",
                    onClick: ()=>onConfirm(event, {
                            classicLocationless: this.props.classicLocationless,
                            selectedLocation: selectedLocation,
                            boardId: this.props.boardId
                        }),
                    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(selectedLocation) || isSettingLocation
                }, confirmActionText)
            });
        };
    }
}
const $9af6a6588d642fd1$var$mapStateToProps = (state)=>({
        locations: (0, $6R3kk.locationsSelector)(state),
        recentProjectsLimit: (0, $6R3kk.recentProjectsSelector)(state),
        isPending: (0, $6R3kk.isPendingSelector)(state),
        isLocationSet: (0, $6R3kk.isLocationSetSelector)(state),
        selectedLocation: (0, $6R3kk.selectedLocationSelector)(state),
        errorOnLocationSet: (0, $6R3kk.errorOnLocationSetSelector)(state),
        errorOnFetchData: (0, $6R3kk.errorOnFetchDataSelector)(state),
        isSettingLocation: (0, $6R3kk.isSettingLocationSelector)(state)
    });
const $9af6a6588d642fd1$var$mapDispatchToProps = (dispatch, ownProps)=>({
        initDialog: ()=>{
            dispatch((0, $3Wu5r.initDialog)());
        },
        onConfirm: (event1, classicLocationlessData, analyticsEvent)=>{
            const { classicLocationless: classicLocationless } = classicLocationlessData ?? {};
            if (classicLocationless) {
                const redirectUrl = classicLocationlessData && (0, $drG0e.getClassicLocationlessRedirectUrl)(classicLocationlessData);
                if (redirectUrl && typeof window !== 'undefined') window.location.href = redirectUrl;
            }
            dispatch((0, $3Wu5r.setNewLocation)({}, analyticsEvent));
        },
        onCancel: ()=>{
            dispatch((0, $3Wu5r.cancelDialog)());
            ownProps.onCancel && ownProps.onCancel();
        },
        onProjectSelected: (location)=>{
            dispatch((0, $3Wu5r.selectLocation)(location));
            ownProps.onProjectSelected && ownProps.onProjectSelected(location);
        },
        onUserSelected: (location)=>{
            dispatch((0, $3Wu5r.selectLocation)(location));
            ownProps.onUserSelected && ownProps.onUserSelected(location);
        },
        onLocationUnselected: ()=>dispatch((0, $3Wu5r.unselectLocation)())
    });
const $9af6a6588d642fd1$export$2480db8408930187 = (0, $gnQAk.connect)($9af6a6588d642fd1$var$mapStateToProps, $9af6a6588d642fd1$var$mapDispatchToProps)($9af6a6588d642fd1$export$63d5de293e655f86);
var $9af6a6588d642fd1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eq3Hf)))((0, $4J0ad.default)({
    onConfirm: {
        action: 'updated'
    }
}), (0, $gnQAk.connect)($9af6a6588d642fd1$var$mapStateToProps, $9af6a6588d642fd1$var$mapDispatchToProps), (0, $fdpHV.AnalyticsSource)('moveBoard', (0, $aa42ce8e355d58fa$export$1171103ea9083ffa)), (0, $fdpHV.AnalyticsSubject)('board'))($9af6a6588d642fd1$export$63d5de293e655f86);

});
parcelRegister("838MG", function(module, exports) {
$parcel$export(module.exports, "default", () => $a2bef0f4ffb16742$export$2e2bcd8739ae039);
/* action-buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");
const $a2bef0f4ffb16742$var$ActionButtons = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a2bef0f4ffb16742$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a2bef0f4ffb16742$var$SpinnerWrapper, null, props.spinner), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: $a2bef0f4ffb16742$var$cancelButtonWrapperStyles
    }, props.secondaryButton), props.primaryButton);
var $a2bef0f4ffb16742$export$2e2bcd8739ae039 = $a2bef0f4ffb16742$var$ActionButtons;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a2bef0f4ffb16742$var$SpinnerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_2hwxpxbi _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $a2bef0f4ffb16742$var$ButtonWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _1bahesu3 _otyru2gc _19pku2gc",
            __cmplp.className
        ])
    });
});
const $a2bef0f4ffb16742$var$cancelButtonWrapperStyles = (0, $1DXK0.xcss)({
    marginRight: 'space.050'
});

});

parcelRegister("gjsks", function(module, exports) {
$parcel$export(module.exports, "default", () => $3de5243ff2cb42fa$export$2e2bcd8739ae039);
/* content-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3de5243ff2cb42fa$var$ContentWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $eJOHy.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});
var $3de5243ff2cb42fa$export$2e2bcd8739ae039 = $3de5243ff2cb42fa$var$ContentWrapper;

});

parcelRegister("82pLh", function(module, exports) {
$parcel$export(module.exports, "default", () => $2b5e4c3f1b75b8fe$export$2e2bcd8739ae039);
/* loading-screen.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5Lo0w = parcelRequire("5Lo0w");

var $7ep4S = parcelRequire("7ep4S");
const $2b5e4c3f1b75b8fe$var$LoadingScreen = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b5e4c3f1b75b8fe$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5Lo0w.default), {
        isTinted: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2b5e4c3f1b75b8fe$var$SpinnerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7ep4S.default), {
        size: "medium"
    })));
var $2b5e4c3f1b75b8fe$export$2e2bcd8739ae039 = $2b5e4c3f1b75b8fe$var$LoadingScreen;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $2b5e4c3f1b75b8fe$var$SpinnerWrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_kqsw1n9t _1ltv1ssb _19pkxncg",
            __cmplp.className
        ])
    });
});
const $2b5e4c3f1b75b8fe$var$Wrapper = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_4t3i1osq _1ltvidpf _kqsw1n9t _154iidpf _1bsb1osq _1pbybfng",
            __cmplp.className
        ])
    });
});

});

parcelRegister("6BRb2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d6ce4e784e6a29ac$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8dH3d = parcelRequire("8dH3d");

var $12DRg = parcelRequire("12DRg");

var $7iHUq = parcelRequire("7iHUq");

var $gwC3z = parcelRequire("gwC3z");

var $8kEJP = parcelRequire("8kEJP");

var $a2Tps = parcelRequire("a2Tps");
class $d6ce4e784e6a29ac$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            placeholder: '',
            label: '',
            onItemUnselected: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
        };
    }
    constructor(props){
        super(props);
        this.store = (0, $8kEJP.default)();
        const { locations: locations, recentProjectsLimit: recentProjectsLimit } = this.props;
        this.store.dispatch((0, $gwC3z.setContext)({
            recentProjectsLimit: recentProjectsLimit
        }));
        (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(locations) || (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(locations.projects) && (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(locations.user) ? this.store.dispatch((0, $gwC3z.fetchDataRequest)()) : this.store.dispatch((0, $gwC3z.fetchDataSuccess)(locations));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
            store: this.store,
            id: "location-picker-app",
            teamName: "a4t-pandora",
            packageName: "jiraBoardLocationDialogsCommon"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $a2Tps.default), {
            onProjectSelected: this.props.onProjectSelected,
            onUserSelected: this.props.onUserSelected,
            onItemUnselected: this.props.onItemUnselected,
            label: this.props.label,
            placeholder: this.props.placeholder
        }));
    }
}

});
parcelRegister("gwC3z", function(module, exports) {
$parcel$export(module.exports, "fetchDataRequest", () => $44cf3b8b27cfc47e$export$d94427b1b5a072d2);
$parcel$export(module.exports, "fetchDataSuccess", () => $44cf3b8b27cfc47e$export$f2604acf0d813dfd);
$parcel$export(module.exports, "fetchDataFailure", () => $44cf3b8b27cfc47e$export$56f344f43f493ad5);
$parcel$export(module.exports, "setContext", () => $44cf3b8b27cfc47e$export$2f04de43fe27971a);

const $44cf3b8b27cfc47e$export$d94427b1b5a072d2 = ()=>({
        type: $3d0086e2dbda9a45$export$8caa30ec786cd60b
    });
const $44cf3b8b27cfc47e$export$f2604acf0d813dfd = (payload)=>({
        type: $3d0086e2dbda9a45$export$f133dd62d8438ea6,
        payload: payload
    });
const $44cf3b8b27cfc47e$export$56f344f43f493ad5 = ()=>({
        type: $3d0086e2dbda9a45$export$ce1f7e009152c20f
    });
const $44cf3b8b27cfc47e$export$2f04de43fe27971a = (payload)=>({
        type: $3d0086e2dbda9a45$export$4bc4e62e7d72b94b,
        payload: payload
    });
const $44cf3b8b27cfc47e$export$d8e990c7994e01bd = ()=>({
        type: $3d0086e2dbda9a45$export$b58c79b7f2d0f102
    });

});
const $3d0086e2dbda9a45$export$8caa30ec786cd60b = 'location-picker/FETCH_DATA_REQUEST';
const $3d0086e2dbda9a45$export$f133dd62d8438ea6 = 'location-picker/FETCH_DATA_SUCCESS';
const $3d0086e2dbda9a45$export$ce1f7e009152c20f = 'location-picker/FETCH_DATA_FAILURE';
const $3d0086e2dbda9a45$export$4bc4e62e7d72b94b = 'location-picker/SET_CONTEXT';
const $3d0086e2dbda9a45$export$b58c79b7f2d0f102 = 'location-picker/CANCEL_DIALOG';


parcelRegister("8kEJP", function(module, exports) {
$parcel$export(module.exports, "default", () => $b1c90bcdd65006a5$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $4tM8k = parcelRequire("4tM8k");

var $kqAfW = parcelRequire("kqAfW");

var $fjluK = parcelRequire("fjluK");

var $eypLB = parcelRequire("eypLB");

var $aXopy = parcelRequire("aXopy");
const $b1c90bcdd65006a5$var$createStore1 = (initialState = (0, $fjluK.defaultState))=>{
    const store = (0, $7HHI1.createStore)((0, $aXopy.default), initialState, (0, $kqAfW.default)({
        name: 'LocationPicker'
    })((0, $7HHI1.applyMiddleware)((0, $4tM8k.createEpicMiddleware)((0, $eypLB.default)))));
    return store;
};
var $b1c90bcdd65006a5$export$2e2bcd8739ae039 = $b1c90bcdd65006a5$var$createStore1;

});
parcelRegister("fjluK", function(module, exports) {
$parcel$export(module.exports, "defaultState", () => $dec80241e7f9777a$export$49d5fc8cba920a0);
const $dec80241e7f9777a$export$49d5fc8cba920a0 = {
    locations: {
        projects: [],
        // @ts-expect-error - TS2739 - Type '{}' is missing the following properties from type 'Location': displayName, name, id, avatar
        user: {}
    },
    context: {
        recentProjectsLimit: 0
    }
};

});

parcelRegister("eypLB", function(module, exports) {
$parcel$export(module.exports, "default", () => $90fa869ed62299c2$export$2e2bcd8739ae039);
parcelRequire("9BkTq");
parcelRequire("d2zWP");
parcelRequire("1o2WJ");
parcelRequire("c1D7V");

var $7kixv = parcelRequire("7kixv");

var $dAcYQ = parcelRequire("dAcYQ");

var $gwC3z = parcelRequire("gwC3z");


var $cvH20 = parcelRequire("cvH20");
const $90fa869ed62299c2$var$rootEpic = (action$, store)=>// @ts-expect-error - TS2741 - Property 'ofType' is missing in type 'Observable<FetchDataSuccessAction | FetchDataFailureAction>' but required in type 'ActionsObservable<Action>'.
    action$.ofType((0, $3d0086e2dbda9a45$export$8caa30ec786cd60b)).switchMap(()=>{
        const state = store.getState();
        return (0, $dAcYQ.default)((0, $cvH20.recentProjectsLimitSelector)(state));
    }).map((0, $gwC3z.fetchDataSuccess)).catch(()=>(0, $7kixv.Observable).of((0, $gwC3z.fetchDataFailure)()));
var $90fa869ed62299c2$export$2e2bcd8739ae039 = $90fa869ed62299c2$var$rootEpic;

});
parcelRegister("cvH20", function(module, exports) {
$parcel$export(module.exports, "userSelector", () => $8511a2e4743655ff$export$210c0a88ec4709b);
$parcel$export(module.exports, "projectsSelector", () => $8511a2e4743655ff$export$7be58ee3880dbd5c);
$parcel$export(module.exports, "isPendingSelector", () => $8511a2e4743655ff$export$74ce67c99a85589);
$parcel$export(module.exports, "recentProjectsLimitSelector", () => $8511a2e4743655ff$export$e86bc093bee44a9a);

var $ahm5r = parcelRequire("ahm5r");
const $8511a2e4743655ff$var$contextSelector = (state)=>state.context;
const $8511a2e4743655ff$var$locationsSelector = (state)=>state.locations;
const $8511a2e4743655ff$export$210c0a88ec4709b = (0, $ahm5r.createSelector)($8511a2e4743655ff$var$locationsSelector, (locations)=>locations.user);
const $8511a2e4743655ff$export$7be58ee3880dbd5c = (0, $ahm5r.createSelector)($8511a2e4743655ff$var$locationsSelector, (locations)=>locations.projects);
const $8511a2e4743655ff$export$74ce67c99a85589 = (0, $ahm5r.createSelector)($8511a2e4743655ff$export$7be58ee3880dbd5c, (projects)=>!projects || projects.length <= 0);
const $8511a2e4743655ff$export$e86bc093bee44a9a = (0, $ahm5r.createSelector)($8511a2e4743655ff$var$contextSelector, (context)=>context.recentProjectsLimit);

});


parcelRegister("aXopy", function(module, exports) {
$parcel$export(module.exports, "default", () => $855eb7c2c56df0a2$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");


var $fjluK = parcelRequire("fjluK");
const $855eb7c2c56df0a2$var$rootReducer = (state = (0, $fjluK.defaultState), action)=>{
    switch(action.type){
        case $3d0086e2dbda9a45$export$f133dd62d8438ea6:
            return (0, $iWqim.assocIn)(state, [
                'locations'
            ], action.payload);
        case $3d0086e2dbda9a45$export$4bc4e62e7d72b94b:
            return (0, $iWqim.assocIn)(state, [
                'context'
            ], action.payload);
        case $3d0086e2dbda9a45$export$b58c79b7f2d0f102:
            return (0, $iWqim.assocIn)(state, [
                'locations'
            ], {});
        default:
            break;
    }
    return state;
};
var $855eb7c2c56df0a2$export$2e2bcd8739ae039 = $855eb7c2c56df0a2$var$rootReducer;

});


parcelRegister("a2Tps", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c8d5f3cdccaa5d5$export$2e2bcd8739ae039);

var $gnQAk = parcelRequire("gnQAk");

var $cvH20 = parcelRequire("cvH20");

var $jHifq = parcelRequire("jHifq");
const $0c8d5f3cdccaa5d5$var$mapStateToProps = (state)=>({
        isPending: (0, $cvH20.isPendingSelector)(state),
        projects: (0, $cvH20.projectsSelector)(state),
        user: (0, $cvH20.userSelector)(state),
        recentProjectsLimit: (0, $cvH20.recentProjectsLimitSelector)(state)
    });
var $0c8d5f3cdccaa5d5$export$2e2bcd8739ae039 = (0, $gnQAk.connect)($0c8d5f3cdccaa5d5$var$mapStateToProps, {})((0, $jHifq.default));

});
parcelRegister("jHifq", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f59688724114d40$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $5FdZg = parcelRequire("5FdZg");

var $8dH3d = parcelRequire("8dH3d");

var $5DgXR = parcelRequire("5DgXR");

var $6svxr = parcelRequire("6svxr");
var $fKXve = parcelRequire("fKXve");

var $c4OV1 = parcelRequire("c4OV1");

var $9CGHC = parcelRequire("9CGHC");

var $6YFG2 = parcelRequire("6YFG2");

var $7oih0 = parcelRequire("7oih0");
const $2f59688724114d40$var$key = Symbol('item-context');
const $2f59688724114d40$var$ITEM_LIMIT = 30;
const $2f59688724114d40$var$MENU_CONTEXT = 'menu';
const $2f59688724114d40$var$filterProjects = (projects, value)=>projects.filter((project)=>(0, $9CGHC.default)(project.displayName, value));
const $2f59688724114d40$var$projectsToItems = (projects)=>projects.map((project)=>({
            [$2f59688724114d40$var$key]: 'project',
            value: project.id,
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
                size: "small",
                appearance: "square",
                src: project.avatar
            }),
            content: project.displayName
        })); // @ts-expect-error - TS7031 - Binding element 'context' implicitly has an 'any' type.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2f59688724114d40$var$formatOptionLabel = (option, { context: context })=>{
    if (context === $2f59688724114d40$var$MENU_CONTEXT) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f59688724114d40$var$OptionContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
        size: "small",
        appearance: option.type === 'project' ? 'square' : 'circle',
        src: option.avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f59688724114d40$var$OptionLabel, null, option.label));
    return option.label;
};
// eslint-disable-next-line jira/react/no-class-components
class $2f59688724114d40$var$LocationPicker extends (0, $eJOHy.Component) {
    getProjectsGroup() {
        const { projects: projects } = this.props;
        const { filterValue: filterValue } = this.state;
        const items = $2f59688724114d40$var$projectsToItems($2f59688724114d40$var$filterProjects(projects, filterValue));
        return {
            heading: this.props.intl.formatMessage(this.shouldLimitItems() ? (0, $7oih0.default).recentProjectsSelectGroup : (0, $7oih0.default).projectsSelectGroup),
            items: items.slice(0, this.shouldLimitItems() ? Math.min(this.props.recentProjectsLimit, $2f59688724114d40$var$ITEM_LIMIT) : $2f59688724114d40$var$ITEM_LIMIT)
        };
    }
    getUserGroup() {
        const { id: id, displayName: displayName, avatar: avatar } = this.props.user;
        return {
            heading: this.props.intl.formatMessage((0, $7oih0.default).userSelectGroup),
            items: [
                {
                    [$2f59688724114d40$var$key]: 'user',
                    value: id,
                    elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
                        size: "small",
                        appearance: "circle",
                        src: avatar
                    }),
                    content: displayName
                }
            ]
        };
    }
    getProjectOptions() {
        const { projects: projects } = this.props;
        const { filterValue: filterValue } = this.state;
        const options = $2f59688724114d40$var$filterProjects(projects, filterValue).map((project)=>({
                label: project.displayName,
                value: project.id,
                avatar: project.avatar,
                type: 'project'
            }));
        return {
            label: this.props.intl.formatMessage(this.shouldLimitItems() ? (0, $7oih0.default).recentProjectsSelectGroup : (0, $7oih0.default).projectsSelectGroup),
            options: options.slice(0, this.shouldLimitItems() ? Math.min(this.props.recentProjectsLimit, $2f59688724114d40$var$ITEM_LIMIT) : $2f59688724114d40$var$ITEM_LIMIT)
        };
    }
    getUserOptions() {
        const { id: id, displayName: displayName, avatar: avatar } = this.props.user;
        return {
            label: this.props.intl.formatMessage((0, $7oih0.default).userSelectGroup),
            options: [
                {
                    label: displayName,
                    value: id,
                    avatar: avatar,
                    type: 'user'
                }
            ]
        };
    }
    getOptions() {
        const { user: user } = this.props;
        return user && (0, $9CGHC.default)(user.displayName, this.state.filterValue) ? [
            this.getProjectOptions(),
            this.getUserOptions()
        ] : [
            this.getProjectOptions()
        ];
    }
    getItems() {
        const { user: user } = this.props;
        return user && (0, $9CGHC.default)(user.displayName, this.state.filterValue) ? [
            this.getProjectsGroup(),
            this.getUserGroup()
        ] : [
            this.getProjectsGroup()
        ];
    }
    shouldLimitItems() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(this.state.filterValue) && Boolean(this.props.recentProjectsLimit);
    }
    anyItemContentMatch(textToMatch) {
        return Boolean((0, (/*@__PURE__*/$parcel$interopDefault($5FdZg)))(this.getItems(), 'items').find((item)=>item.content === textToMatch));
    }
    render() {
        const { isPending: isPending, label: label, placeholder: placeholder } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($2f59688724114d40$var$FieldWidthControl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
            name: "board-location-picker",
            label: label,
            isRequired: false,
            testId: "board-location-dialogs-common.apps.location-picker.location-picker.location-picker"
        }, ({ fieldProps: { id: id, ...inputProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $c4OV1.default), {
                ...inputProps,
                required: true,
                autoFocus: true,
                isDisabled: isPending,
                placeholder: placeholder,
                options: this.getOptions(),
                formatOptionLabel: $2f59688724114d40$var$formatOptionLabel,
                onChange: this.onChange,
                onInputChange: this.handleOnFilterChange,
                inputId: id,
                label: label ? undefined : 'Board Location',
                menuPortalTarget: document.body,
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: 9999
                        })
                }
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fKXve.HelperMessage), null, this.props.intl.formatMessage((0, $7oih0.default).userSelectHelperText)));
    }
    constructor(...args){
        super(...args), this.state = {
            selectedItem: {},
            filterValue: ''
        } // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.onChange = (item)=>{
            this.setState({
                selectedItem: item
            });
            if (item.type === 'user') this.props.onUserSelected(this.props.user);
            else {
                const projectLocation = this.props.projects.find((project)=>project.id === item.value);
                if (projectLocation) this.props.onProjectSelected(projectLocation);
            }
        }, this.handleOnFilterChange = (value)=>{
            if (!value || value === '' || !this.anyItemContentMatch(value)) {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($8dH3d)))(this.state.selectedItem)) {
                    this.props.onItemUnselected && this.props.onItemUnselected();
                    this.setState({
                        selectedItem: {}
                    });
                }
            }
            this.setState({
                filterValue: value
            });
        };
    }
}
var $2f59688724114d40$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $6YFG2.default)($2f59688724114d40$var$LocationPicker);
const $2f59688724114d40$var$OptionContainer = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f59688724114d40$var$OptionLabel = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_19bvu2gc _n3tdidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2f59688724114d40$var$FieldWidthControl = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_dw4e1ssb",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9CGHC", function(module, exports) {
$parcel$export(module.exports, "default", () => $c6fa478636f905bf$export$2e2bcd8739ae039);
const $c6fa478636f905bf$var$isSubstringFound = (haystack, needle)=>{
    if (!needle) return true;
    if (!haystack) return false;
    const haystackLowerCase = haystack.toLocaleLowerCase();
    const needleLowerCase = needle.toLocaleLowerCase();
    return haystackLowerCase.includes(needleLowerCase);
};
var $c6fa478636f905bf$export$2e2bcd8739ae039 = $c6fa478636f905bf$var$isSubstringFound;

});

parcelRegister("7oih0", function(module, exports) {
$parcel$export(module.exports, "default", () => $f53243195de2b299$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $f53243195de2b299$var$messages = (0, $7qGN1.defineMessages)({
    projectsSelectGroup: {
        "id": "board-location-dialogs.common.location-picker.projects-select-group",
        "defaultMessage": "Projects"
    },
    recentProjectsSelectGroup: {
        "id": "board-location-dialogs.common.location-picker.recent-projects-select-group",
        "defaultMessage": "Recent projects"
    },
    userSelectGroup: {
        "id": "board-location-dialogs.common.location-picker.user-select-group",
        "defaultMessage": "Your profile"
    },
    userSelectHelperText: {
        "id": "board-location-dialogs.common.location-picker.user-select-group-input-helper",
        "defaultMessage": "The board\u2019s URL will change to match this location."
    },
    projectsSelectGroupGalaxia: {
        "id": "board-location-dialogs.common.location-picker.projects-select-group-galaxia",
        "defaultMessage": "Spaces"
    },
    recentProjectsSelectGroupGalaxia: {
        "id": "board-location-dialogs.common.location-picker.recent-projects-select-group-galaxia",
        "defaultMessage": "Recent spaces"
    }
});
var $f53243195de2b299$export$2e2bcd8739ae039 = $f53243195de2b299$var$messages;

});




parcelRegister("lwjs2", function(module, exports) {
$parcel$export(module.exports, "default", () => $d75a5abb5fff4999$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $d75a5abb5fff4999$var$messages = (0, $7qGN1.defineMessages)({
    classicLocationlessActionPromptText: {
        "id": "board-location-dialogs.common.location-picker.update-url-info",
        "defaultMessage": " This update will redirect you to a new URL for this board. Update any existing bookmarks, resources, or references to make sure they reflect this change."
    }
});
var $d75a5abb5fff4999$export$2e2bcd8739ae039 = $d75a5abb5fff4999$var$messages;

});

parcelRegister("drG0e", function(module, exports) {
$parcel$export(module.exports, "getClassicLocationlessRedirectUrl", () => $155a6cefadf817e5$export$f6606f55b4e17f5e);
const $155a6cefadf817e5$export$f6606f55b4e17f5e = (classicLocationlessData)=>{
    const { classicLocationless: classicLocationless, selectedLocation: selectedLocation, boardId: boardId } = classicLocationlessData ?? {};
    if (classicLocationless && (selectedLocation?.location?.key || selectedLocation?.location?.name) && boardId) {
        const relUrl = selectedLocation.type === 'project' ? `/jira/software/c/projects/${selectedLocation.location.key}/boards/${boardId}` : `/jira/people/${selectedLocation.location.name}/boards/${boardId}`;
        return typeof window !== 'undefined' ? window.location.origin + relUrl : '';
    }
    return null;
};

});



parcelRegister("1q8Mp", function(module, exports) {
$parcel$export(module.exports, "default", () => $75a330f84b7d1438$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $eJ9f5 = parcelRequire("eJ9f5");

var $fAoiP = parcelRequire("fAoiP");

var $4cTDP = parcelRequire("4cTDP");

var $7qGN1 = parcelRequire("7qGN1");
var $lRq8t = parcelRequire("lRq8t");
const $75a330f84b7d1438$var$i18n = (0, $7qGN1.defineMessages)({
    title: {
        "id": "locationless-dialog-v2.error-message-secondary-text",
        "defaultMessage": "Something went wrong setting the location"
    },
    message: {
        "id": "locationless-dialog-v2.error-message-text",
        "defaultMessage": "You can try again or get help "
    },
    here: {
        "id": "locationless-dialog-v2.error-message-here-link-text",
        "defaultMessage": "here"
    }
});
function $75a330f84b7d1438$var$ErrorMessage() {
    const intl = (0, $lRq8t.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fAoiP.default), {
        title: intl.formatMessage($75a330f84b7d1438$var$i18n.title),
        appearance: "error"
    }, intl.formatMessage($75a330f84b7d1438$var$i18n.message), (0, $4cTDP.fg)('replace-anchor-with-link__a4t-pandora') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJ9f5.default), {
        href: "https://support.atlassian.com/contact/",
        rel: "noopener noreferrer",
        target: "_blank"
    }, intl.formatMessage($75a330f84b7d1438$var$i18n.here)) : // eslint-disable-next-line @atlaskit/design-system/no-html-anchor
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("a", {
        href: "https://support.atlassian.com/contact/",
        rel: "noopener noreferrer",
        target: "_blank"
    }, intl.formatMessage($75a330f84b7d1438$var$i18n.here)), ".");
}
var $75a330f84b7d1438$export$2e2bcd8739ae039 = $75a330f84b7d1438$var$ErrorMessage;

});
parcelRegister("fAoiP", function(module, exports) {
$parcel$export(module.exports, "default", () => $bf8ea374b58ea243$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");

var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $k0ahr = parcelRequire("k0ahr");

var $gl2vi = parcelRequire("gl2vi");

var $eGOwo = parcelRequire("eGOwo");

var $kJsb4 = parcelRequire("kJsb4");

var $8IeH1 = parcelRequire("8IeH1");
var $6djmC = parcelRequire("6djmC");
var $46R8N = parcelRequire("46R8N");
var $3cMgR = parcelRequire("3cMgR");

var $1x0fM = parcelRequire("1x0fM");
const $bf8ea374b58ea243$var$styles = {
    contentStyles: "_bozg1ejb _y4ti1ejb _1q51pxbi _85i5pxbi",
    heightAndWidthConstraints: "_1reo1wug _18m91wug _p12flti4 _c71llti4",
    rootStyles: "_1e0c1o8l _p12f1osq _1yyu1kum _y2mv1w7i",
    pressableStyles: "_11c82smr _1rjcze3t _18zrze3t _1e0c116y _bfhk1w7a _syazazsu _o5721q9c _kqswh2mm _4cvr1q9y _p12f1osq _4t3i1wug _1bsb1wug _s7n418uv _9oik18uv _1bnx8stv _jf4cnqa1"
};
const $bf8ea374b58ea243$var$iconColor = {
    connectivity: "_x5v91r2e",
    confirmation: "_x5v91fgg",
    info: "_x5v913wx",
    warning: "_x5v9f6ss",
    error: "_x5v9k8x7"
};
/**
 * __Inline message__
 *
 * An inline message lets users know when important information is available or when an action is required.
 *
 * - [Examples](https://atlassian.design/components/inline-message/examples)
 * - [Code](https://atlassian.design/components/inline-message/code)
 * - [Usage](https://atlassian.design/components/inline-message/usage)
 *
 * @example
 *
 * ```jsx
 * const Component = () => (
 *   <InlineMessage
 *    title="Inline Message Title Example"
 *    secondaryText="Secondary Text"
 *   >
 *    <p>Some text that would be inside the open dialog and otherwise hidden.</p>
 *   </InlineMessage>
 * );
 * ```
 */ const $bf8ea374b58ea243$var$InlineMessage = ({ placement: placement = 'bottom-start', secondaryText: secondaryText = '', title: title = '', appearance: appearance = 'connectivity', spacing: spacing = 'spacious', children: children, testId: testId, iconLabel: iconLabel, fallbackPlacements: fallbackPlacements })=>{
    const [isOpen, setIsOpen] = (0, $eJOHy.useState)(false);
    const id = (0, $gl2vi.useId)();
    const toggleDialog = (0, $eJOHy.useCallback)(()=>{
        setIsOpen((oldState)=>!oldState);
    }, [
        setIsOpen
    ]);
    const onCloseDialog = (0, $eJOHy.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("div", {
        "data-testid": testId,
        className: (0, $hcewu.default)([
            $bf8ea374b58ea243$var$styles.rootStyles,
            $bf8ea374b58ea243$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)((0, $kJsb4.default), {
            onClose: onCloseDialog,
            content: ()=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $8IeH1.default), {
                    xcss: (0, $k0ahr.cx)($bf8ea374b58ea243$var$styles.contentStyles, (0, $eGOwo.fg)('add-max-width-and-height-to-inline-message') && $bf8ea374b58ea243$var$styles.heightAndWidthConstraints),
                    children: children
                }),
            isOpen: isOpen,
            placement: placement,
            testId: testId && `${testId}--popup`,
            fallbackPlacements: fallbackPlacements,
            shouldRenderToParent: true,
            role: "dialog",
            titleId: id,
            trigger: ({ ref: ref, ...triggerProps })=>/*#__PURE__*/ (0, $gt9Am.jsx)((0, $46R8N.default), {
                    ...triggerProps,
                    ref: ref,
                    id: id,
                    "data-ds--inline-message--button": true,
                    onClick: toggleDialog,
                    testId: testId && `${testId}--button`,
                    xcss: $bf8ea374b58ea243$var$styles.pressableStyles,
                    "aria-expanded": isOpen,
                    children: /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                        as: "span",
                        space: "space.050",
                        alignBlock: "center",
                        children: [
                            /*#__PURE__*/ (0, $gt9Am.jsx)((0, $1x0fM.default), {
                                isOpen: isOpen,
                                appearance: appearance,
                                label: iconLabel,
                                spacing: spacing
                            }),
                            /*#__PURE__*/ (0, $gt9Am.jsxs)((0, $6djmC.default), {
                                as: "span",
                                space: "space.100",
                                children: [
                                    title && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                        weight: "medium",
                                        testId: testId && `${testId}--title`,
                                        children: title
                                    }),
                                    secondaryText && /*#__PURE__*/ (0, $gt9Am.jsx)((0, $3cMgR.default), {
                                        weight: "medium",
                                        color: "color.text.subtlest",
                                        maxLines: 1,
                                        testId: testId && `${testId}--text`,
                                        children: secondaryText
                                    })
                                ]
                            })
                        ]
                    })
                })
        })
    });
};
var $bf8ea374b58ea243$export$2e2bcd8739ae039 = $bf8ea374b58ea243$var$InlineMessage;

});
parcelRegister("1x0fM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cb94fc6b1082a95$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $gt9Am = parcelRequire("gt9Am");
parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");

var $juHFo = parcelRequire("juHFo");
const $7cb94fc6b1082a95$var$iconColor = {
    connectivity: "_1b3i1c86",
    confirmation: "_1b3icdx1",
    info: "_1b3ige5s",
    warning: "_1b3i1n6p",
    error: "_1b3i1378"
};
const $7cb94fc6b1082a95$var$iconWrapperStyles = null;
const $7cb94fc6b1082a95$var$iconColorStyles = null;
/**
 * __Selected icon__
 *
 * The selected icon is used as the primary interactive element for the dialog.
 * Can be used with or without supporting text.
 */ const $7cb94fc6b1082a95$var$SelectedIcon = ({ appearance: appearance, isOpen: isOpen, label: label, spacing: spacing })=>{
    const { [appearance]: { icon: Icon, defaultLabel: defaultLabel } } = (0, $juHFo.typesMapping);
    return /*#__PURE__*/ (0, $gt9Am.jsx)("span", {
        "data-ds--inline-message--icon": true,
        className: (0, $hcewu.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _4cvr1h6o _syazkr0v",
            isOpen && "_syaz1kum",
            $7cb94fc6b1082a95$var$iconColor[appearance]
        ]),
        children: /*#__PURE__*/ (0, $gt9Am.jsx)(Icon, {
            testId: "inline-message-icon",
            label: label || defaultLabel,
            color: "currentColor",
            LEGACY_size: "medium",
            spacing: spacing
        })
    });
};
var $7cb94fc6b1082a95$export$2e2bcd8739ae039 = $7cb94fc6b1082a95$var$SelectedIcon;

});
parcelRegister("juHFo", function(module, exports) {
$parcel$export(module.exports, "typesMapping", () => $2b5bcc4386586ca5$export$4d111645c0b39d5d);

var $1NG86 = parcelRequire("1NG86");

var $i4Iw4 = parcelRequire("i4Iw4");

var $3TFuO = parcelRequire("3TFuO");

var $jkYbX = parcelRequire("jkYbX");
const $2b5bcc4386586ca5$export$4d111645c0b39d5d = {
    connectivity: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))),
        defaultLabel: 'connectivity inline message'
    },
    confirmation: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3TFuO))),
        defaultLabel: 'confirmation inline message'
    },
    info: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($i4Iw4))),
        defaultLabel: 'info inline message'
    },
    warning: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jkYbX))),
        defaultLabel: 'warning inline message'
    },
    error: {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($1NG86))),
        defaultLabel: 'error inline message'
    }
};

});




parcelRegister("bppbs", function(module, exports) {
$parcel$export(module.exports, "contextSelector", () => $38c1a9f03286292d$export$c420c9f40402ab6d);
$parcel$export(module.exports, "rapidViewIdSelector", () => $38c1a9f03286292d$export$718e830000b27a0e);
$parcel$export(module.exports, "currentLocationDisplayNameSelector", () => $38c1a9f03286292d$export$90e89131c1f4a0b5);
$parcel$export(module.exports, "currentLocationAvatarSelector", () => $38c1a9f03286292d$export$c10e6fd65df617c0);

var $ahm5r = parcelRequire("ahm5r");
const $38c1a9f03286292d$export$c420c9f40402ab6d = (state)=>state.context;
const $38c1a9f03286292d$export$718e830000b27a0e = (0, $ahm5r.createSelector)($38c1a9f03286292d$export$c420c9f40402ab6d, (context)=>context.rapidViewId);
const $38c1a9f03286292d$export$996988dd55f5a8cd = (0, $ahm5r.createSelector)($38c1a9f03286292d$export$c420c9f40402ab6d, (context)=>context.currentLocation);
const $38c1a9f03286292d$export$90e89131c1f4a0b5 = (0, $ahm5r.createSelector)($38c1a9f03286292d$export$996988dd55f5a8cd, (location)=>location.displayName);
const $38c1a9f03286292d$export$c10e6fd65df617c0 = (0, $ahm5r.createSelector)($38c1a9f03286292d$export$996988dd55f5a8cd, (location)=>location.avatar);

});

parcelRegister("5YYyt", function(module, exports) {
$parcel$export(module.exports, "setLocationSuccess", () => $b197344499b1527a$export$5daab09d8e3809e0);

const $b197344499b1527a$export$e97c62ad868ad2c3 = (payload)=>({
        type: (0, $67551aabb4234f1d$export$e2872d87ddcb5b4a),
        payload: payload
    });
const $b197344499b1527a$export$5daab09d8e3809e0 = (payload, analyticsEvent)=>({
        type: (0, $67551aabb4234f1d$export$9d8d4e6ce2e6a21),
        payload: payload,
        meta: {
            analytics: analyticsEvent
        }
    });

});
const $67551aabb4234f1d$export$9d8d4e6ce2e6a21 = 'move-single-board-dialog/SET_LOCATION_SUCCESS';
const $67551aabb4234f1d$export$e2872d87ddcb5b4a = 'move-single-board-dialog/SET_LOCATION_FAILURE';


parcelRegister("8BMll", function(module, exports) {
$parcel$export(module.exports, "default", () => $d90260480d78025a$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5DgXR = parcelRequire("5DgXR");

var $6svxr = parcelRequire("6svxr");

var $idGBm = parcelRequire("idGBm");

var $cdUwp = parcelRequire("cdUwp");

var $j5aQa = parcelRequire("j5aQa");
function $d90260480d78025a$var$CurrentLocation(props) {
    const { avatarUrl: avatarUrl, locationName: locationName, intl: { formatMessage: formatMessage } } = props;
    const label = formatMessage((0, $cdUwp.default).label);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j5aQa.FieldWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6svxr.default), {
        name: label,
        label: label,
        isRequired: false
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j5aQa.AvatarItem), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5DgXR.default), {
            size: "small",
            appearance: "square",
            src: avatarUrl
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $j5aQa.LocationName), null, locationName))));
}
var $d90260480d78025a$export$2e2bcd8739ae039 = (0, $idGBm.injectIntlV2)($d90260480d78025a$var$CurrentLocation);

});
parcelRegister("cdUwp", function(module, exports) {
$parcel$export(module.exports, "default", () => $75dca1c860d149b4$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $75dca1c860d149b4$var$messages = (0, $7qGN1.defineMessages)({
    label: {
        "id": "move-single-board.current-location.label",
        "defaultMessage": "Current location"
    }
});
var $75dca1c860d149b4$export$2e2bcd8739ae039 = $75dca1c860d149b4$var$messages;

});

parcelRegister("j5aQa", function(module, exports) {
$parcel$export(module.exports, "AvatarItem", () => $802526b6c267d71b$export$15f08c141eda7939);
$parcel$export(module.exports, "LocationName", () => $802526b6c267d71b$export$3f15bfb412e8d6df);
$parcel$export(module.exports, "FieldWrapper", () => $802526b6c267d71b$export$6a00f65eec6002a6);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $eJOHy = parcelRequire("eJOHy");

var $hcewu = parcelRequire("hcewu");
const $802526b6c267d71b$export$15f08c141eda7939 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($802526b6c267d71b$var$AvatarItemComponent, props);
const $802526b6c267d71b$export$3f15bfb412e8d6df = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($802526b6c267d71b$var$LocationNameComponent, props);
const $802526b6c267d71b$export$6a00f65eec6002a6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($802526b6c267d71b$var$FieldWrapperComponent, props);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $802526b6c267d71b$var$LocationNameComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_18u0u2gc",
            __cmplp.className
        ])
    });
});
const $802526b6c267d71b$var$AvatarItemComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $802526b6c267d71b$var$FieldWrapperComponent = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hcewu.default)([
            "_1bchv47k",
            __cmplp.className
        ])
    });
});

});


parcelRegister("4UxQD", function(module, exports) {
$parcel$export(module.exports, "cancelDialog", () => $b4cf838b8d5f499e$export$d8e990c7994e01bd);
$parcel$export(module.exports, "initDialog", () => $b4cf838b8d5f499e$export$10e19ed2936eea31);

const $b4cf838b8d5f499e$export$d8e990c7994e01bd = ()=>({
        type: (0, $1645190aa25af60a$export$b58c79b7f2d0f102)
    });
const $b4cf838b8d5f499e$export$10e19ed2936eea31 = ()=>({
        type: (0, $1645190aa25af60a$export$10b25390e6826dd4)
    });

});
const $1645190aa25af60a$export$b58c79b7f2d0f102 = 'move-single-board-dialog/CANCEL_DIALOG';
const $1645190aa25af60a$export$10b25390e6826dd4 = 'move-single-board-dialog/INIT_DIALOG';


parcelRegister("59nfH", function(module, exports) {
$parcel$export(module.exports, "isOpenSelector", () => $322773b1ff17ddf5$export$eacfcc6aba3b8af4);

var $ahm5r = parcelRequire("ahm5r");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $322773b1ff17ddf5$var$dialogSelector = (state)=>state.dialog;
const $322773b1ff17ddf5$export$eacfcc6aba3b8af4 = (0, $ahm5r.createSelector)($322773b1ff17ddf5$var$dialogSelector, (dialog)=>dialog.isOpen);

});


parcelRegister("feBqt", function(module, exports) {
$parcel$export(module.exports, "default", () => $145419c3b92c761a$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $4tM8k = parcelRequire("4tM8k");

var $kqAfW = parcelRequire("kqAfW");

var $bbRcz = parcelRequire("bbRcz");

var $4MR6M = parcelRequire("4MR6M");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $145419c3b92c761a$var$createStore1 = (initialState)=>(0, $7HHI1.createStore)(// @ts-expect-error - TS2345 - Argument of type '(state: { context: undefined; dialog: undefined; newLocation: undefined; } | undefined, action: any) => unknown' is not assignable to parameter of type 'Reducer<{ context: undefined; dialog: undefined; newLocation: undefined; } | undefined>'.
    (0, $4MR6M.default), initialState, (0, $kqAfW.default)({
        name: 'Move Single Board'
    })((0, $7HHI1.applyMiddleware)((0, $4tM8k.createEpicMiddleware)((0, $bbRcz.default)))));
var $145419c3b92c761a$export$2e2bcd8739ae039 = $145419c3b92c761a$var$createStore1;

});
parcelRegister("bbRcz", function(module, exports) {
$parcel$export(module.exports, "default", () => $f3ab50f5176004ff$export$2e2bcd8739ae039);

var $4tM8k = parcelRequire("4tM8k");

var $43MuK = parcelRequire("43MuK");
var $f3ab50f5176004ff$export$2e2bcd8739ae039 = (0, $4tM8k.combineEpics)((0, $43MuK.default));

});
parcelRegister("43MuK", function(module, exports) {
$parcel$export(module.exports, "default", () => $e1ec2332f4aa38bf$export$2e2bcd8739ae039);
parcelRequire("llumX");
parcelRequire("1o2WJ");
parcelRequire("7La6O");
parcelRequire("8yIb3");

var $ig3FA = parcelRequire("ig3FA");

var $kDo0p = parcelRequire("kDo0p");
// @ts-expect-error - TS7031 - Binding element 'type' implicitly has an 'any' type. | TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ "move-single-board-dialog/SET_LOCATION_SUCCESS": (state: any) => { eventNameSuffix: string; eventData: { selectedId: any; selectedType: any; rapidViewId: any; }; }; "move-single-board-dialog/SET_LOCATION_FAILURE": (state: any) => { ...; }; "move-single-board-dialog/INIT_DIALOG": (state: any) => { ...; }; "move-sin...'.
const $e1ec2332f4aa38bf$var$shouldActionTriggerAnalytics = ({ type: type })=>(0, $ig3FA.default)[type] !== undefined;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e1ec2332f4aa38bf$var$getAnalyticsForAction = (state, action)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type '{ "move-single-board-dialog/SET_LOCATION_SUCCESS": (state: any) => { eventNameSuffix: string; eventData: { selectedId: any; selectedType: any; rapidViewId: any; }; }; "move-single-board-dialog/SET_LOCATION_FAILURE": (state: any) => { ...; }; "move-single-board-dialog/INIT_DIALOG": (state: any) => { ...; }; "move-sin...'.
    (0, $ig3FA.default)[action.type](state, action);
// @ts-expect-error - TS7031 - Binding element 'eventNameSuffix' implicitly has an 'any' type. | TS7031 - Binding element 'eventData' implicitly has an 'any' type.
const $e1ec2332f4aa38bf$var$triggerAnalyticsForAction = ({ eventNameSuffix: eventNameSuffix, eventData: eventData })=>(0, $kDo0p.default)(eventNameSuffix, eventData);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $e1ec2332f4aa38bf$var$analytics = (action$, store)=>action$.filter($e1ec2332f4aa38bf$var$shouldActionTriggerAnalytics)// @ts-expect-error - TS7006 - Parameter 'action' implicitly has an 'any' type.
    .map((action)=>$e1ec2332f4aa38bf$var$getAnalyticsForAction(store.getState(), action)).do($e1ec2332f4aa38bf$var$triggerAnalyticsForAction).ignoreElements();
var $e1ec2332f4aa38bf$export$2e2bcd8739ae039 = $e1ec2332f4aa38bf$var$analytics;

});
parcelRegister("ig3FA", function(module, exports) {
$parcel$export(module.exports, "default", () => $da9c79ff35f02e17$export$2e2bcd8739ae039);

var $bppbs = parcelRequire("bppbs");



var $ks2GE = parcelRequire("ks2GE");
const $da9c79ff35f02e17$var$actionAnalyticsMap = {
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $67551aabb4234f1d$export$9d8d4e6ce2e6a21)]: (state)=>({
            eventNameSuffix: 'move.single.dialog.location.success',
            eventData: {
                selectedId: (0, $ks2GE.newLocationIdSelector)(state),
                selectedType: (0, $ks2GE.newLocationTypeSelector)(state),
                rapidViewId: (0, $bppbs.rapidViewIdSelector)(state)
            }
        }),
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $67551aabb4234f1d$export$e2872d87ddcb5b4a)]: (state)=>({
            eventNameSuffix: 'move.single.dialog.location.failure',
            eventData: {
                selectedId: (0, $ks2GE.newLocationIdSelector)(state),
                selectedType: (0, $ks2GE.newLocationTypeSelector)(state),
                rapidViewId: (0, $bppbs.rapidViewIdSelector)(state)
            }
        }),
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $1645190aa25af60a$export$10b25390e6826dd4)]: (state)=>({
            eventNameSuffix: 'move.single.dialog.init',
            eventData: {
                rapidViewId: (0, $bppbs.rapidViewIdSelector)(state)
            }
        }),
    // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
    [(0, $1645190aa25af60a$export$b58c79b7f2d0f102)]: (state)=>({
            eventNameSuffix: 'move.single.dialog.cancel',
            eventData: {
                rapidViewId: (0, $bppbs.rapidViewIdSelector)(state)
            }
        })
};
var $da9c79ff35f02e17$export$2e2bcd8739ae039 = $da9c79ff35f02e17$var$actionAnalyticsMap;

});
parcelRegister("ks2GE", function(module, exports) {
$parcel$export(module.exports, "newLocationIdSelector", () => $c97c17d6d6927d53$export$3af701c7c04e58e8);
$parcel$export(module.exports, "newLocationTypeSelector", () => $c97c17d6d6927d53$export$6401b954c59e37f8);

var $ahm5r = parcelRequire("ahm5r");
const $c97c17d6d6927d53$export$763518cb81f5c458 = (state)=>state.newLocation;
const $c97c17d6d6927d53$export$3af701c7c04e58e8 = (0, $ahm5r.createSelector)($c97c17d6d6927d53$export$763518cb81f5c458, (newLocation)=>newLocation.location.id);
const $c97c17d6d6927d53$export$6401b954c59e37f8 = (0, $ahm5r.createSelector)($c97c17d6d6927d53$export$763518cb81f5c458, (newLocation)=>newLocation.type);

});


parcelRegister("kDo0p", function(module, exports) {
$parcel$export(module.exports, "default", () => $71a33eec8a6ddcec$export$2e2bcd8739ae039);
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $71a33eec8a6ddcec$var$triggerAnalyticsForApp = (_eventNameSuffix, _eventData)=>{}; // 'MoveSingleBoardDialog' was the app name
var /**
 * @deprecated GasV2 has been cleaned up, and it has not been logging any events since July. Please replace implementation with sending GasV3 analytics: go/gasv3
 */ $71a33eec8a6ddcec$export$2e2bcd8739ae039 = $71a33eec8a6ddcec$var$triggerAnalyticsForApp;

});



parcelRegister("4MR6M", function(module, exports) {
$parcel$export(module.exports, "default", () => $89ae935fd2d68112$export$2e2bcd8739ae039);

var $7HHI1 = parcelRequire("7HHI1");

var $iWqim = parcelRequire("iWqim");

var $1zQza = parcelRequire("1zQza");

var $2JQOY = parcelRequire("2JQOY");

var $kBoMm = parcelRequire("kBoMm");
const $89ae935fd2d68112$var$initialState = (0, $iWqim.freeze)({
    context: undefined,
    dialog: undefined,
    newLocation: undefined
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $89ae935fd2d68112$var$rootReducer = (state = $89ae935fd2d68112$var$initialState, action)=>(0, $iWqim.freeze)((0, $7HHI1.combineReducers)({
        context: (0, $1zQza.default),
        newLocation: (0, $kBoMm.default),
        dialog: (0, $2JQOY.default)
    })(// @ts-expect-error - Argument of type '{ context: undefined; dialog: undefined; newLocation: undefined; }' is not assignable to parameter of type 'CombinedState<{ context: any; newLocation: any; dialog: { isOpen: boolean; }; }>'.
    state, action));
var $89ae935fd2d68112$export$2e2bcd8739ae039 = $89ae935fd2d68112$var$rootReducer;

});
parcelRegister("1zQza", function(module, exports) {
$parcel$export(module.exports, "default", () => $3f621963d10165e5$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

const $3f621963d10165e5$var$initialState = (0, $iWqim.freeze)({
    rapidViewId: undefined,
    currentLocation: undefined
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $3f621963d10165e5$var$contextReducer = (state = $3f621963d10165e5$var$initialState, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $1f26fa3da4b9bda0$export$4bc4e62e7d72b94b:
            return (0, $iWqim.freeze)(payload);
        default:
            return state;
    }
};
var $3f621963d10165e5$export$2e2bcd8739ae039 = $3f621963d10165e5$var$contextReducer;

});

parcelRegister("2JQOY", function(module, exports) {
$parcel$export(module.exports, "default", () => $a05981049fd1bdd6$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");


const $a05981049fd1bdd6$var$initialState = (0, $iWqim.freeze)({
    isOpen: true
});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a05981049fd1bdd6$var$dialogReducer = (state = $a05981049fd1bdd6$var$initialState, action)=>{
    const { type: type } = action;
    switch(type){
        case 0, $1645190aa25af60a$export$10b25390e6826dd4:
            return (0, $iWqim.assocIn)(state, [
                'isOpen'
            ], true);
        case 0, $1645190aa25af60a$export$b58c79b7f2d0f102:
        case 0, $67551aabb4234f1d$export$9d8d4e6ce2e6a21:
            return (0, $iWqim.assocIn)(state, [
                'isOpen'
            ], false);
        default:
            return state;
    }
};
var $a05981049fd1bdd6$export$2e2bcd8739ae039 = $a05981049fd1bdd6$var$dialogReducer;

});

parcelRegister("kBoMm", function(module, exports) {
$parcel$export(module.exports, "default", () => $46101b815e14891d$export$2e2bcd8739ae039);

var $iWqim = parcelRequire("iWqim");

const $46101b815e14891d$var$initialState = (0, $iWqim.freeze)({});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $46101b815e14891d$var$newLocationReducer = (state = $46101b815e14891d$var$initialState, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case 0, $67551aabb4234f1d$export$9d8d4e6ce2e6a21:
        case 0, $67551aabb4234f1d$export$e2872d87ddcb5b4a:
            return (0, $iWqim.merge)(state, payload);
        default:
            return state;
    }
};
var $46101b815e14891d$export$2e2bcd8739ae039 = $46101b815e14891d$var$newLocationReducer;

});




parcelRegister("3cJgn", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4bda56a6f554283$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $hcewu = parcelRequire("hcewu");

var $eJOHy = parcelRequire("eJOHy");
const $a4bda56a6f554283$var$styles = {
    show: "_1e0c1kw7",
    hide: "_1e0cglyw"
};
class $a4bda56a6f554283$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    componentWillUnmount() {
        const { returnFocusTarget: returnFocusTarget, setReturnFocusTo: setReturnFocusTo } = this.props;
        setTimeout(()=>{
            if (returnFocusTarget && returnFocusTarget.current && setReturnFocusTo) {
                returnFocusTarget.current.focus();
                setReturnFocusTo(null);
            }
        }, 0);
    }
    render() {
        const { MoveSingleBoardDialog: MoveSingleBoardDialog, board: board, onCancel: onCancel } = this.props;
        const { showDialog: showDialog } = this.state;
        const rapidViewId = parseInt(board.id, 10);
        const currentLocation = board.location ? {
            avatar: board.location.avatarURI,
            displayName: board.location.displayName
        } : {};
        // @ts-expect-error - TS2339 - Property 'isPrivate' does not exist on type 'Board'. | TS2339 - Property 'name' does not exist on type 'Board'.
        const boardName = board.isPrivate ? undefined : board.name;
        const dialog = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(MoveSingleBoardDialog, {
            rapidViewId: rapidViewId,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            currentLocation: currentLocation,
            onLocationSet: this.onLocationSet,
            onCancel: onCancel,
            onSetLocationError: this.onSetLocationError,
            onFetchDataError: this.onFetchDataError,
            onFetchDataSuccess: this.onFetchDataSuccess,
            showErrorMessage: false,
            boardName: boardName
        });
        if (showDialog) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                $a4bda56a6f554283$var$styles.show
            ])
        }, dialog);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("div", {
            className: (0, $hcewu.default)([
                $a4bda56a6f554283$var$styles.hide
            ])
        }, dialog);
    }
    constructor(...args){
        super(...args), this.state = {
            showDialog: false
        }, this.onLocationSet = ()=>{
            this.props.onBoardMoved(this.props.board);
        }, this.onSetLocationError = ()=>{
            this.props.onBoardMoveFailed(this.props.board);
        }, this.onFetchDataError = ()=>{
            this.props.onInitialDataFetchFailed(this.props.board);
        }, this.onFetchDataSuccess = ()=>{
            this.setState({
                showDialog: true
            });
            this.props.onInitialDataFetched();
        };
    }
}

});






parcelRegister("jmZ1P", function(module, exports) {
$parcel$export(module.exports, "default", () => $da2d9f30e9958f2e$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $eJOHy = parcelRequire("eJOHy");

var $7iHUq = parcelRequire("7iHUq");

var $aP411 = parcelRequire("aP411");

var $faqts = parcelRequire("faqts");
const $da2d9f30e9958f2e$var$CreateButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $7iHUq.default), {
        id: "directories.boards-v2.create-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $aP411.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $faqts.default), null)));
var $da2d9f30e9958f2e$export$2e2bcd8739ae039 = $da2d9f30e9958f2e$var$CreateButton;

});
parcelRegister("faqts", function(module, exports) {
$parcel$export(module.exports, "default", () => $51402bdb47fd2dca$export$2e2bcd8739ae039);

var $giQZR = parcelRequire("giQZR");

var $9pzQA = parcelRequire("9pzQA");

var $4JZ04 = parcelRequire("4JZ04");

var $8q1tm = parcelRequire("8q1tm");
var $51402bdb47fd2dca$export$2e2bcd8739ae039 = (0, $giQZR.default)({
    CreateDialogLoader: $9pzQA.default,
    StatelessButton: $4JZ04.default
})((0, $8q1tm.default));

});
parcelRegister("8q1tm", function(module, exports) {
$parcel$export(module.exports, "default", () => $765aefe47f8e6ed9$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
const $765aefe47f8e6ed9$var$CreateBoardsButton = ({ CreateDialogLoader: CreateDialogLoader, StatelessButton: StatelessButton })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateDialogLoader, null, (load, isLoading)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(StatelessButton, {
            onClick: load,
            isDisabled: isLoading
        }));
var $765aefe47f8e6ed9$export$2e2bcd8739ae039 = $765aefe47f8e6ed9$var$CreateBoardsButton;

});



parcelRegister("coT0B", function(module, exports) {
$parcel$export(module.exports, "default", () => $395bd9f1d86787f0$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $gHI4w = parcelRequire("gHI4w");

var $3nL89 = parcelRequire("3nL89");

var $6XJko = parcelRequire("6XJko");

var $lavtR = parcelRequire("lavtR");
const $395bd9f1d86787f0$var$BoardsPage = (props)=>{
    const { CreateButton: CreateButton, BoardsDirectory: BoardsDirectory, intl: { formatMessage: formatMessage }, ...boardsDirectoryProps } = props;
    const actions = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(CreateButton, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3nL89.DocumentTitle), {
        title: formatMessage((0, $lavtR.default).pageTitle)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        xcss: (0, $6XJko.isVisualRefreshEnabled)() ? $395bd9f1d86787f0$var$pageHeaderStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gHI4w.default), {
        truncateTitle: true,
        actions: actions
    }, formatMessage((0, $lavtR.default).pageTitle))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(BoardsDirectory, boardsDirectoryProps));
};
const $395bd9f1d86787f0$var$pageHeaderStyles = (0, $1DXK0.xcss)({
    marginBottom: 'space.negative.050'
});
var $395bd9f1d86787f0$export$2e2bcd8739ae039 = $395bd9f1d86787f0$var$BoardsPage;

});
parcelRegister("3nL89", function(module, exports) {
$parcel$export(module.exports, "DocumentTitle", () => $8eb9deaadd9d6be8$export$dd5ad0b65cf665da);

var $19u1t = parcelRequire("19u1t");
const $8eb9deaadd9d6be8$export$dd5ad0b65cf665da = (0, $19u1t.DocumentTitleHelper);

});

parcelRegister("lavtR", function(module, exports) {
$parcel$export(module.exports, "default", () => $39c7efb3a8a54941$export$2e2bcd8739ae039);

var $7qGN1 = parcelRequire("7qGN1");
const $39c7efb3a8a54941$var$messages = (0, $7qGN1.defineMessages)({
    pageTitle: {
        "id": "directories.boards-v2.page.page-title",
        "defaultMessage": "Boards"
    }
});
var $39c7efb3a8a54941$export$2e2bcd8739ae039 = $39c7efb3a8a54941$var$messages;

});



parcelRegister("jUHqr", function(module, exports) {
$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $0aba41a6ca8ce346$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $0aba41a6ca8ce346$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $0aba41a6ca8ce346$export$9b3029ee6188a41f);

var $eJOHy = parcelRequire("eJOHy");

var $2gvG4 = parcelRequire("2gvG4");

var $6whQo = parcelRequire("6whQo");

var $kVpZx = parcelRequire("kVpZx");

var $ioEQd = parcelRequire("ioEQd");

var $fRC66 = parcelRequire("fRC66");

var $CkF8u = parcelRequire("CkF8u");

var $iAPDN = parcelRequire("iAPDN");

var $4WwFo = parcelRequire("4WwFo");

var $cllya = parcelRequire("cllya");
const $0aba41a6ca8ce346$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $0aba41a6ca8ce346$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $0aba41a6ca8ce346$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $4WwFo.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $iAPDN.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $cllya.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2gvG4.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $6whQo.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $CkF8u.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $kVpZx.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fRC66.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $0aba41a6ca8ce346$export$9b3029ee6188a41f = $0aba41a6ca8ce346$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("6whQo", function(module, exports) {
$parcel$export(module.exports, "getBm3Timings", () => $3708d872c36dd1bb$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $3708d872c36dd1bb$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $3708d872c36dd1bb$export$d93d677ef2f33c5c);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $3708d872c36dd1bb$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    (0, $eJOHy.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $3708d872c36dd1bb$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $kVpZx.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $2QO3b.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $3708d872c36dd1bb$export$f02972da195a43bb(marks, timingsConfig);
        (0, $2QO3b.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("fRC66", function(module, exports) {
$parcel$export(module.exports, "StopBrowserMetrics3", () => $7986e193b27b5912$export$575e93c0f9905999);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $k04JP = parcelRequire("k04JP");

var $6uWhG = parcelRequire("6uWhG");

var $2HxHL = parcelRequire("2HxHL");

var $iEXnd = parcelRequire("iEXnd");

var $lOI8W = parcelRequire("lOI8W");

var $9DwQv = parcelRequire("9DwQv");

const $7986e193b27b5912$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $lOI8W.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $9DwQv.isAutomaticExposureCollectionEnabled)()) (0, $2HxHL.stopLowPriorityEventDelay)();
};
class $7986e193b27b5912$export$575e93c0f9905999 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $k04JP.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_END');
        (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $6uWhG.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMark)((0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                (0, $6uWhG.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $fcc2379b1f384e36$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $7986e193b27b5912$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $lOI8W.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $iEXnd.PRODUCT_START_MARK), true);
            $7986e193b27b5912$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});
const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("CkF8u", function(module, exports) {
$parcel$export(module.exports, "StopUfo", () => $f04c01c7c6bf4310$export$d91154f099475c5);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $ioEQd = parcelRequire("ioEQd");
class $f04c01c7c6bf4310$export$d91154f099475c5 extends (0, $eJOHy.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $ioEQd.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $ioEQd.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $7aoMz.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("iAPDN", function(module, exports) {
$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $4d28fc5eaea80e10$export$bf239ac2bfb04967);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");
function $4d28fc5eaea80e10$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("4WwFo", function(module, exports) {
$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $3d02e80116d345ab$export$e63862cd888fe05a);

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $ioEQd = parcelRequire("ioEQd");
var $8tVkR = parcelRequire("8tVkR");
async function $3d02e80116d345ab$export$e63862cd888fe05a() {
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $ioEQd.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $8tVkR.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $2QO3b.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("cllya", function(module, exports) {
$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $eaa2e9e24133f900$export$f00f1e874ce869e9);

var $kVpZx = parcelRequire("kVpZx");

var $j500r = parcelRequire("j500r");

var $4cTDP = parcelRequire("4cTDP");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $eaa2e9e24133f900$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $eaa2e9e24133f900$export$7b4abba432e57989 = (value)=>$eaa2e9e24133f900$var$isString(value) && $eaa2e9e24133f900$var$startsAsObject(value) || $eaa2e9e24133f900$var$isObject(value);
const $eaa2e9e24133f900$export$fcc03ee4c944962f = (featureFlagValue)=>$eaa2e9e24133f900$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $eaa2e9e24133f900$export$d2818866b4acbea4 = new Map();
const $eaa2e9e24133f900$export$f00f1e874ce869e9 = (metric)=>{
    if ((0, $4cTDP.fg)('jfp-magma-remove-ld-client')) return;
    const interactionId = (0, $kVpZx.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $j500r.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $eaa2e9e24133f900$export$fcc03ee4c944962f(value);
            $eaa2e9e24133f900$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("gWu57", function(module, exports) {
$parcel$export(module.exports, "ScrollablePage", () => $3970ca9ce19c6445$export$8d7a30196b47fe34);
$parcel$export(module.exports, "PageLayout", () => $3970ca9ce19c6445$export$6d1402fb58384e4f);

var $eJOHy = parcelRequire("eJOHy");

var $8nu6j = parcelRequire("8nu6j");
var $1DXK0 = parcelRequire("1DXK0");

var $4cTDP = parcelRequire("4cTDP");
const $3970ca9ce19c6445$export$8d7a30196b47fe34 = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.scrollable-page',
        xcss: $3970ca9ce19c6445$var$scrollablePageStyles,
        paddingBlock: "space.0",
        paddingInline: "space.300"
    }, children);
const $3970ca9ce19c6445$export$6d1402fb58384e4f = ({ children: children, hideMargin: hideMargin, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8nu6j.default), {
        testId: rest['data-testid'] || 'spa-apps-page-layout.page.page-layout',
        xcss: [
            hideMargin ? $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles : $3970ca9ce19c6445$var$pageLayoutWithMarginStyles,
            (0, $4cTDP.fg)('global_rovo_button_in_jira') && $3970ca9ce19c6445$var$additionalPaddingForGlobalRovoButtonStyles
        ]
    }, children);
};
const $3970ca9ce19c6445$var$scrollablePageStyles = (0, $1DXK0.xcss)({
    minWidth: '800px',
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithoutMarginStyles = (0, $1DXK0.xcss)({
    margin: 'space.0'
});
const $3970ca9ce19c6445$var$pageLayoutWithMarginStyles = (0, $1DXK0.xcss)({
    marginBlock: '0',
    marginInline: 'space.300'
});
const $3970ca9ce19c6445$var$additionalPaddingForGlobalRovoButtonStyles = (0, $1DXK0.xcss)({
    paddingBottom: 'space.500'
});

});

parcelRegister("ddqcW", function(module, exports) {
$parcel$export(module.exports, "boardsDirectoryPageLoad", () => $23b110da272bd94e$export$e959f3b40b7337e1);

var $hqYEY = parcelRequire("hqYEY");
const $23b110da272bd94e$export$e959f3b40b7337e1 = (0, $hqYEY.metrics).pageLoad({
    key: 'boards-directory',
    ssr: {
        doneAsFmp: true
    }
});

});





//# sourceMappingURL=async-boards-directory.dfeba913.js.map
